export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A type representing a clickstream payload as a JSON string */
  AnalyticsPayload: any;
  /** Built-in java.math.BigDecimal */
  BigDecimal: any;
  /** A type representing a Locale such as en_US or fr_FR */
  Locale: any;
  /** A type representing a full protocol, host and path */
  URL: any;
  /** A type representing a formatted java.util.UUID */
  UUID: any;
}





/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  /** Action to pop auth window */
  AUTHWINDOW = 'AUTHWINDOW',
  /** Action to close a dropdown option */
  CLOSE = 'CLOSE',
  /** Action to copy contents to clipboard */
  COPY = 'COPY',
  /** Action to open the date picker */
  DATEPICKER = 'DATEPICKER',
  /** Action to open an external link off */
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  /** Action to display free lx message */
  FREE_LX = 'FREE_LX',
  /** Action to open a link off */
  OPEN = 'OPEN',
  /** Action to display term and conditions */
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS'
}


export enum ActionType {
  OPEN = 'Open',
  OPENPRICECHANGEALERT = 'OpenPriceChangeAlert',
  DOWNLOADDPREPORT = 'DownloadDPReport'
}

/** Indicates the coupon's active state */
export enum ActiveState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN',
  USED = 'USED'
}


/** Provide criteria needed to perform an activities search */
export interface ActivitiySearchCriteriaInput {
  primary: PrimaryActivitySearchCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}












export enum ActivityAvailabilityPriceTextTheme {
  POSITIVE = 'POSITIVE'
}


export enum ActivityBadgeType {
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}


/** Activity banner type */
export enum ActivityBannerType {
  ALERT = 'ALERT',
  INFO = 'INFO',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}




export enum ActivityCancellationType {
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CANCELLATION = 'NO_CANCELLATION'
}















export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = 'ADULTS_ONLY_SHOWS',
  ADVENTURES = 'ADVENTURES',
  ADVENTURE_OUTDOOR = 'ADVENTURE_OUTDOOR',
  AIRBOAT_TOURS = 'AIRBOAT_TOURS',
  AIRPLANE_RIDES = 'AIRPLANE_RIDES',
  AIRPLANE_TOURS = 'AIRPLANE_TOURS',
  AIRPORT_GROUND_TRANSPORTATION = 'AIRPORT_GROUND_TRANSPORTATION',
  AIRPORT_LOUNGES = 'AIRPORT_LOUNGES',
  AIRPORT_TO_AIRPORT_TRANSFERS = 'AIRPORT_TO_AIRPORT_TRANSFERS',
  AIR_BALLOON_HELICOPTER_TOURS = 'AIR_BALLOON_HELICOPTER_TOURS',
  AIR_HELICOPTER_BALLOON_TOURS = 'AIR_HELICOPTER_BALLOON_TOURS',
  AMUSEMENT_THEME_PARKS = 'AMUSEMENT_THEME_PARKS',
  ARCHITECTURE_TOURS = 'ARCHITECTURE_TOURS',
  ART_CLASSES = 'ART_CLASSES',
  ART_CULTURE_HISTORY_TOURS = 'ART_CULTURE_HISTORY_TOURS',
  ART_MUSIC_LITERARYTOURS = 'ART_MUSIC_LITERARYTOURS',
  ATTRACTIONS = 'ATTRACTIONS',
  ATTRACTION_TICKETS = 'ATTRACTION_TICKETS',
  BALLOON_RIDES = 'BALLOON_RIDES',
  BALLOON_TOURS = 'BALLOON_TOURS',
  BAR_PUB_TOURS = 'BAR_PUB_TOURS',
  BEER_BREWERY_TOURS = 'BEER_BREWERY_TOURS',
  BEYOND_THE_CITY = 'BEYOND_THE_CITY',
  BIKE_MOUNTAIN_BIKE_TOURS = 'BIKE_MOUNTAIN_BIKE_TOURS',
  BIKE_RENTALS = 'BIKE_RENTALS',
  BOAT_RENTAL = 'BOAT_RENTAL',
  BOAT_TOURS = 'BOAT_TOURS',
  BOAT_TOURS_CRUISES = 'BOAT_TOURS_CRUISES',
  BRUNCHC_RUISES = 'BRUNCHC_RUISES',
  BUNGEE_JUMPING_SKYDIVING = 'BUNGEE_JUMPING_SKYDIVING',
  BUS_MINIVAN_TOURS = 'BUS_MINIVAN_TOURS',
  CABARET = 'CABARET',
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  CASTLE_PALACE_TOURS = 'CASTLE_PALACE_TOURS',
  CHAUFFER_SERVICES = 'CHAUFFER_SERVICES',
  CHRISTMAS = 'CHRISTMAS',
  CIRQUE = 'CIRQUE',
  CIRQUE_DU_SOLEIL = 'CIRQUE_DU_SOLEIL',
  CIRQUE_DU_SOLEILSHOWS = 'CIRQUE_DU_SOLEILSHOWS',
  CITY_AND_ATTRACTION_TRANSFERS = 'CITY_AND_ATTRACTION_TRANSFERS',
  CITY_ATTRACTION_TRANSFERS = 'CITY_ATTRACTION_TRANSFERS',
  CITY_TOURS = 'CITY_TOURS',
  CITY_TOURS_PACKAGES = 'CITY_TOURS_PACKAGES',
  CLASSES_WORKSHOPS = 'CLASSES_WORKSHOPS',
  CLUB_AND_PARTY_BUS_TOURS = 'CLUB_AND_PARTY_BUS_TOURS',
  CLUB_PARTY_BUS_TOURS = 'CLUB_PARTY_BUS_TOURS',
  COFFEE_TEA_TOURS = 'COFFEE_TEA_TOURS',
  COMEDY_SHOWS = 'COMEDY_SHOWS',
  CONCERTS_SPECIAL_EVENTS = 'CONCERTS_SPECIAL_EVENTS',
  COOKING_CLASSES = 'COOKING_CLASSES',
  CRUISES_BOAT_TOURS = 'CRUISES_BOAT_TOURS',
  CRUISES_WATER_TOURS = 'CRUISES_WATER_TOURS',
  CULTURAL_HERITAGE_EXPERIENCES = 'CULTURAL_HERITAGE_EXPERIENCES',
  CUSTOM_PRIVATE_TOURS = 'CUSTOM_PRIVATE_TOURS',
  DANCE_CLASSES = 'DANCE_CLASSES',
  DAY_OF_THE_DEAD = 'DAY_OF_THE_DEAD',
  DAY_SPAS = 'DAY_SPAS',
  DAY_TRIPS = 'DAY_TRIPS',
  DAY_TRIPS_EXCURSIONS = 'DAY_TRIPS_EXCURSIONS',
  DINING_EXPERIENCES = 'DINING_EXPERIENCES',
  DINNER_CRUISES = 'DINNER_CRUISES',
  DINNER_THEATER = 'DINNER_THEATER',
  DISNEY = 'DISNEY',
  DISNEY_PARKS = 'DISNEY_PARKS',
  DOLPHIN_WHALE_WATCHING = 'DOLPHIN_WHALE_WATCHING',
  DOSE_OF_CULTURE = 'DOSE_OF_CULTURE',
  DUCK_TOURS = 'DUCK_TOURS',
  EASTER = 'EASTER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FASHION_SHOWS_TOURS = 'FASHION_SHOWS_TOURS',
  FISHING_CHARTERS_TOURS = 'FISHING_CHARTERS_TOURS',
  FISHING_TOURS_AND_CHARTERS = 'FISHING_TOURS_AND_CHARTERS',
  FOOD_DRINK = 'FOOD_DRINK',
  FOOD_DRINK_NIGHTLIFE = 'FOOD_DRINK_NIGHTLIFE',
  FOOD_TOURS = 'FOOD_TOURS',
  FUN_FOR_FOODIES = 'FUN_FOR_FOODIES',
  FUN_ON_THE_WATER = 'FUN_ON_THE_WATER',
  GALLERIES_MUSEUMS = 'GALLERIES_MUSEUMS',
  GAMES_SHOWS_SPECIAL_EVENTS = 'GAMES_SHOWS_SPECIAL_EVENTS',
  GETTING_AROUND = 'GETTING_AROUND',
  GOLF_TEE_TIMES = 'GOLF_TEE_TIMES',
  GOLF_TOURS_TEE_TIMES = 'GOLF_TOURS_TEE_TIMES',
  HALLOWEEN = 'HALLOWEEN',
  HAMMAMS_TURKISH_BATHS = 'HAMMAMS_TURKISH_BATHS',
  HELICOPTER_RIDES = 'HELICOPTER_RIDES',
  HELICOPTER_TOURS = 'HELICOPTER_TOURS',
  HIGH_SPEED_DRIVING = 'HIGH_SPEED_DRIVING',
  HIGH_SPEED_RIDES = 'HIGH_SPEED_RIDES',
  HIKING_CAMPING = 'HIKING_CAMPING',
  HISTORICAL_TOURS = 'HISTORICAL_TOURS',
  HISTORY_CULTURE = 'HISTORY_CULTURE',
  HOLIDAY_SEASONAL_TOURS = 'HOLIDAY_SEASONAL_TOURS',
  HONEYMOON_PACKAGE = 'HONEYMOON_PACKAGE',
  HONEYMOON_PACKAGES = 'HONEYMOON_PACKAGES',
  HOP_ON_HOP_OFF = 'HOP_ON_HOP_OFF',
  HOP_ON_HOP_OFF_TOURS = 'HOP_ON_HOP_OFF_TOURS',
  HORSE_CARRIAGE_RIDES = 'HORSE_CARRIAGE_RIDES',
  HOT_SPRINGS_THERMAL_SPAS = 'HOT_SPRINGS_THERMAL_SPAS',
  INTERESTS = 'INTERESTS',
  KAYAKING_CANOEING = 'KAYAKING_CANOEING',
  LATEST_GREATEST = 'LATEST_GREATEST',
  LIFT_TICKETS = 'LIFT_TICKETS',
  LIKELY_TO_SELL_OUT = 'LIKELY_TO_SELL_OUT',
  LITERARY_ART_MUSIC_TOURS = 'LITERARY_ART_MUSIC_TOURS',
  LOCAL_EXPERT_PICKS = 'LOCAL_EXPERT_PICKS',
  LUNCH_CRUISES = 'LUNCH_CRUISES',
  MOTORCYCLE_SCOOTER_TOURS = 'MOTORCYCLE_SCOOTER_TOURS',
  MOVIE_TV_TOURS = 'MOVIE_TV_TOURS',
  MULTIDAY_CRUISES = 'MULTIDAY_CRUISES',
  MULTI_DAY_EXTENDED_TOURS = 'MULTI_DAY_EXTENDED_TOURS',
  MUSEUM_TICKETS = 'MUSEUM_TICKETS',
  MUSEUM_TICKETS_PASSES = 'MUSEUM_TICKETS_PASSES',
  MUST_SEE_SIGHTS = 'MUST_SEE_SIGHTS',
  NA = 'NA',
  NATIONAL_HOLIDAYS = 'NATIONAL_HOLIDAYS',
  NEW = 'NEW',
  NEWY_EARS = 'NEWY_EARS',
  NIGHTLIFE = 'NIGHTLIFE',
  NIGHTLIFE_PASSES = 'NIGHTLIFE_PASSES',
  NIGHT_CRUISES = 'NIGHT_CRUISES',
  NIGHT_TOURS = 'NIGHT_TOURS',
  ONSENS = 'ONSENS',
  OTHER_ANIMALS_ACTIVITIES = 'OTHER_ANIMALS_ACTIVITIES',
  OTHER_ANIMAL_ACTIVITIES = 'OTHER_ANIMAL_ACTIVITIES',
  OTHER_CLASSES = 'OTHER_CLASSES',
  OTHER_OUTDOOR_ACTIVITIES = 'OTHER_OUTDOOR_ACTIVITIES',
  OTHER_SEASONAL_EVENTS = 'OTHER_SEASONAL_EVENTS',
  OTHER_TOURS = 'OTHER_TOURS',
  OTHER_TRANSFERS = 'OTHER_TRANSFERS',
  OTHER_TRANSPORTATION = 'OTHER_TRANSPORTATION',
  OTHER_WATER_ACTIVITIES = 'OTHER_WATER_ACTIVITIES',
  PHOTOGRAPHY_TOURS = 'PHOTOGRAPHY_TOURS',
  PORT_TRANSFERS = 'PORT_TRANSFERS',
  PRIVATE_CUSTOM_TOURS = 'PRIVATE_CUSTOM_TOURS',
  PRIVATE_DAY_TRIPS = 'PRIVATE_DAY_TRIPS',
  PRIVATE_TOURS = 'PRIVATE_TOURS',
  PRIVATE_TRANSFERS = 'PRIVATE_TRANSFERS',
  PURE_ROMANCE = 'PURE_ROMANCE',
  RELIGIOUS_SPIRITUAL_TOURS = 'RELIGIOUS_SPIRITUAL_TOURS',
  RIVER_HARBOUR_CRUISES = 'RIVER_HARBOUR_CRUISES',
  ROMAN_STAYCATION = 'ROMAN_STAYCATION',
  SAFARIS = 'SAFARIS',
  SAILING_TRIPS = 'SAILING_TRIPS',
  SCOOTER_RENTALS = 'SCOOTER_RENTALS',
  SEGWAY_TOURS = 'SEGWAY_TOURS',
  SHARED_TRANSFERS = 'SHARED_TRANSFERS',
  SHARK_DIVING = 'SHARK_DIVING',
  SHOPPING_FASHION = 'SHOPPING_FASHION',
  SHOPPING_PASSES_OFFERS = 'SHOPPING_PASSES_OFFERS',
  SHOPPING_TOURS = 'SHOPPING_TOURS',
  SHORE_EXCURIONS = 'SHORE_EXCURIONS',
  SHOWS_CONCERTS = 'SHOWS_CONCERTS',
  SHOW_SPORT_TICKETS = 'SHOW_SPORT_TICKETS',
  SIGHTSEEING_ATTRACTION_PASSES = 'SIGHTSEEING_ATTRACTION_PASSES',
  SIGHTSEEING_CITY_PASSES = 'SIGHTSEEING_CITY_PASSES',
  SIGHTSEEING_PASSES = 'SIGHTSEEING_PASSES',
  SKIING_RENTALS = 'SKIING_RENTALS',
  SKIP_THE_LINE_TOURS = 'SKIP_THE_LINE_TOURS',
  SNORKELING_SCUBA_DIVING = 'SNORKELING_SCUBA_DIVING',
  SNOWBOARDING_RENTALS = 'SNOWBOARDING_RENTALS',
  SNOWMOBILE_TOURS = 'SNOWMOBILE_TOURS',
  SNOWSHOEING = 'SNOWSHOEING',
  SPA = 'SPA',
  SPA_WELLNESS = 'SPA_WELLNESS',
  SPEED_BOATS_JET_SKIS = 'SPEED_BOATS_JET_SKIS',
  SPORTING_EVENTS_PACKAGES = 'SPORTING_EVENTS_PACKAGES',
  SPORTS_PACKAGES = 'SPORTS_PACKAGES',
  STAY_ACTIVE = 'STAY_ACTIVE',
  SUBMARINE_TOURS = 'SUBMARINE_TOURS',
  SUNSET_CRUISES = 'SUNSET_CRUISES',
  SUPERNATURAL_TOURS = 'SUPERNATURAL_TOURS',
  SUSTAINABLE_TOURS = 'SUSTAINABLE_TOURS',
  SWIM_WITH_DOLPHINS = 'SWIM_WITH_DOLPHINS',
  THEATER_SHOWS_MUSICALS = 'THEATER_SHOWS_MUSICALS',
  THEME_PARKS = 'THEME_PARKS',
  THEME_PARK_TICKETS_TOURS = 'THEME_PARK_TICKETS_TOURS',
  THE_GREAT_OUTDOORS = 'THE_GREAT_OUTDOORS',
  THRILL_SEEKER = 'THRILL_SEEKER',
  TICKETS = 'TICKETS',
  TOURS_ACTIVITIES = 'TOURS_ACTIVITIES',
  TOURS_SIGHTSEEING = 'TOURS_SIGHTSEEING',
  TRANSPORTATION_SERVICES = 'TRANSPORTATION_SERVICES',
  TREAT_YOURSELF = 'TREAT_YOURSELF',
  TUBING = 'TUBING',
  UNIVERSAL_THEME_PARKS = 'UNIVERSAL_THEME_PARKS',
  VALENTINES_DAY = 'VALENTINES_DAY',
  WALKING_BIKE_TOURS = 'WALKING_BIKE_TOURS',
  WALKING_TOURS = 'WALKING_TOURS',
  WATERSKIING_WAKEBOARDING = 'WATERSKIING_WAKEBOARDING',
  WATER_ACTIVITIES = 'WATER_ACTIVITIES',
  WATER_PARKS = 'WATER_PARKS',
  WEDDING_CEREMONIES = 'WEDDING_CEREMONIES',
  WEDDING_HONEYMOON = 'WEDDING_HONEYMOON',
  WEDDING_PACKAGES = 'WEDDING_PACKAGES',
  WEDDING_SHONEYMOONS = 'WEDDING_SHONEYMOONS',
  WHAT_TO_DO_WITH_GROUPS = 'WHAT_TO_DO_WITH_GROUPS',
  WHAT_TO_DO_WITH_KIDS = 'WHAT_TO_DO_WITH_KIDS',
  WHITE_WATER_RAFTING = 'WHITE_WATER_RAFTING',
  WILDLIFE_NATURE = 'WILDLIFE_NATURE',
  WINE_TASTING_WINERY_TOURS = 'WINE_TASTING_WINERY_TOURS',
  WINTER_ACTIVITIES = 'WINTER_ACTIVITIES',
  YOGA_CLASS = 'YOGA_CLASS',
  YOGA_CLASSES = 'YOGA_CLASSES',
  ZOO_TICKETS = 'ZOO_TICKETS',
  ZOO_TICKETS_PASSES = 'ZOO_TICKETS_PASSES'
}


export enum ActivityCategoryType {
  ACTIVITIES = 'ACTIVITIES',
  CATEGORIES = 'CATEGORIES',
  DEALS_PROMOTIONS = 'DEALS_PROMOTIONS',
  NA = 'NA',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  TOURS = 'TOURS',
  TRANSPORTATION = 'TRANSPORTATION'
}








export interface ActivityDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}



/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: Maybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: Maybe<Scalars['String']>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: Maybe<Scalars['String']>;
  /** Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: Maybe<Scalars['String']>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: Maybe<Scalars['String']>;
}

/** Details view options that are not filters */
export enum ActivityDetailViewOptions {
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  THIRD_PARTY_REVIEWS = 'THIRD_PARTY_REVIEWS'
}






export enum ActivityDiscountType {
  AIR_ATTACH_MIP = 'AIR_ATTACH_MIP',
  AIR_HOTEL_ATTACH_MIP = 'AIR_HOTEL_ATTACH_MIP',
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  FREE_ACTIVITY = 'FREE_ACTIVITY',
  GUEST = 'GUEST',
  HOTEL_ATTACH_MIP = 'HOTEL_ATTACH_MIP',
  MIP = 'MIP',
  MOD = 'MOD',
  STRIKE_OUT = 'STRIKE_OUT'
}















export enum ActivityGroupType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_MESSAGE = 'ACTIVITY_MESSAGE',
  AVAILABLE_TODAY = 'AVAILABLE_TODAY',
  CATEGORY = 'CATEGORY',
  FILTERED_ACTIVITIES = 'FILTERED_ACTIVITIES',
  INTERESTS = 'INTERESTS',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MORE_ACTIVITIES = 'MORE_ACTIVITIES',
  NEIGHBOURHOOD = 'NEIGHBOURHOOD',
  PINNED_ACTIVITY = 'PINNED_ACTIVITY',
  POI = 'POI',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  SLIM_CATEGORY = 'SLIM_CATEGORY',
  SUB_CATEGORIES = 'SUB_CATEGORIES',
  SUB_CATEGORY = 'SUB_CATEGORY',
  SWP_SORT_SECTION = 'SWP_SORT_SECTION',
  TOP_ACTIVITIES = 'TOP_ACTIVITIES',
  TRIPS_ACTIVITY_LIST = 'TRIPS_ACTIVITY_LIST',
  XSELL_RECOMMENDATIONS = 'XSELL_RECOMMENDATIONS'
}

export enum ActivityGroupViewType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_SPANNED_TILE_LIST = 'ACTIVITY_SPANNED_TILE_LIST',
  ACTIVITY_TILES_CAROUSEL = 'ACTIVITY_TILES_CAROUSEL',
  CATEGORY_TILES_CAROUSEL = 'CATEGORY_TILES_CAROUSEL',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MESSAGE = 'MESSAGE',
  SLIM_CATEGORY_TILES_CAROUSEL = 'SLIM_CATEGORY_TILES_CAROUSEL',
  TEXT = 'TEXT'
}
























export enum ActivityMapGroupType {
  POI = 'POI'
}



/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: Maybe<Scalars['Int']>;
  /** field which identifies sem channel */
  sem?: Maybe<Scalars['String']>;
  /** field which identifies semdtl value */
  semdtl?: Maybe<Scalars['String']>;
}









/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = 'ADDON',
  EARN_2X_REWARD_POINTS = 'EARN_2X_REWARD_POINTS',
  GIFTING_LX_BANNER = 'GIFTING_LX_BANNER',
  LOGIN = 'LOGIN',
  SOURCED_CAMPAIGN = 'SOURCED_CAMPAIGN',
  SUMMER_CAMPAIGN_PRIMARY = 'SUMMER_CAMPAIGN_PRIMARY',
  SUMMER_CAMPAIGN_SECONDARY = 'SUMMER_CAMPAIGN_SECONDARY'
}







/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: Scalars['String'];
  productToken: Scalars['String'];
}











export interface ActivityOfferFilterInput {
  selections?: Maybe<Array<ActivitySelectedValueInput>>;
  tickets?: Maybe<Array<ActivityTicketInput>>;
}







/** Data used to retrieve details about an activity product */
export interface ActivityOfferNaturalKeyInput {
  /** Offer Product Natural Key for offer entity which uniquely determines bookable offer of activity. This includes, site id, Offer id, Offer dates, offer locale, total travelers selected to uniquely identify an offer */
  offerProductNaturalKey: Scalars['String'];
}


















export enum ActivityOfferUdsToken {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}













/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export enum ActivityPageMetaTagType {
  HTTP_EQUIV = 'HTTP_EQUIV',
  NAME = 'NAME',
  PROPERTY = 'PROPERTY'
}


/** Activity Page Type - infosite */
export enum ActivityPageType {
  ACTIVITY_INFO = 'ACTIVITY_INFO'
}















/** Activity Price types */
export enum ActivityPriceType {
  GROUP = 'GROUP',
  NORMAL = 'NORMAL',
  VOLUME_BASED = 'VOLUME_BASED'
}








export enum ActivityRedemptionType {
  PRINT = 'PRINT',
  VOUCHER_LESS = 'VOUCHER_LESS'
}









export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST'
}







/** Allow to define a period of time to search for activities */
export interface ActivitySearchCriteriaDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}

/** Region information for an activity search */
export interface ActivitySearchCriteriaLocationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: Maybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: Maybe<Scalars['String']>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: Maybe<Scalars['String']>;
  /** Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: Maybe<Scalars['String']>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: Maybe<Scalars['String']>;
}


/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: Maybe<Scalars['String']>;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: Maybe<Scalars['String']>;
  /**
   * Value selected by the user
   *     E.g.
   *     1. 'sort':'RECOMMENDED'
   *     2. 'slimSearchKeyword':'<KEYWORD ENTERED BY USER>'
   *     4. 'categories': 'ToursSightseeing'
   */
  selections?: Maybe<Array<ActivitySelectedValueInput>>;
}




/** Search options that are not filters */
export enum ActivitySearchOptions {
  CATEGORY = 'CATEGORY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER = 'GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER',
  GIFTING_ACTIVITIES = 'GIFTING_ACTIVITIES',
  GUEST_PROMO = 'GUEST_PROMO',
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER'
}




/** Search view options that are not filters */
export enum ActivitySearchViewOptions {
  DISTANCE_FROM_HOTEL_TO_ACTIVITY = 'DISTANCE_FROM_HOTEL_TO_ACTIVITY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  NEARBY_ACTIVITIES = 'NEARBY_ACTIVITIES',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER',
  THIRD_PARTY_REVIEWS = 'THIRD_PARTY_REVIEWS',
  TRAVEL_DISTANCE_FROM_HOTEL = 'TRAVEL_DISTANCE_FROM_HOTEL'
}





export interface ActivitySelectedValueInput {
  id: Scalars['String'];
  value: Scalars['String'];
}





/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  DISTANCE_FROM_HOTEL = 'DISTANCE_FROM_HOTEL',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED'
}















export enum ActivityTextAlignment {
  CENTRE = 'CENTRE',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}


export enum ActivityTextSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}




export interface ActivityTicketInput {
  code: Scalars['String'];
  count: Scalars['Int'];
}






/** Details of traveler with a specific age. Age will be used to derive the traveler type in package bookings */
export interface ActivityTravelerDetailsInput {
  /** Age of the traveler. Traveler type(adult/infant/youth) can be derived from age */
  age: Scalars['Int'];
  /** Number of travelers with specified age */
  count: Scalars['Int'];
}

/** Container of traveler information */
export interface ActivityTravelerInfoInput {
  /** number of adults from Hotel PDP */
  numberOfAdults: Scalars['Int'];
  /** number of children from Hotel PDP */
  numberOfChildren: Scalars['Int'];
  /** number of infants from Hotel PDP */
  numberOfInfants: Scalars['Int'];
}



export enum ActivityUdsToken {
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  MULTI_SELECT_RANGE = 'MULTI_SELECT_RANGE',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT = 'TEXT'
}

/** Input to update the activity in the session */
export interface ActivityUpdateInput {
  newActivity: ActivityNaturalKeyInput;
  oldActivity: ActivityNaturalKeyInput;
}



export interface AddInsuranceRequestInput {
  /** CountryCode from residency selection of user */
  countryCode?: Maybe<Scalars['String']>;
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars['String']>;
  /** RegionCode from residency selection of user */
  regionCode?: Maybe<Scalars['String']>;
  /** The user selection for the Insurance product(s) */
  removeInsuranceProductIds?: Maybe<Array<Scalars['String']>>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars['String'];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars['String'];
}

export interface AddInsuranceRequestOldInput {
  insuranceSearchId: Scalars['String'];
  offerTypeId: Scalars['Int'];
}



/** Represents values for add ons */
export enum AddOnRequested {
  CB1 = 'CB1',
  COB = 'COB',
  SC = 'SC'
}

/** Represents the additional change query params */
export interface AdditionalChangeQueryParamsInput {
  /** Represents the intended itinerary number to change */
  itineraryNumber?: Maybe<Scalars['String']>;
  /** Represents the virtual agent token which is used for exchange of information */
  opaqueToken?: Maybe<Scalars['String']>;
}








export interface AdditionalOnboardingContextInput {
  cmsToken?: Maybe<Scalars['String']>;
  isFirstAppLaunch?: Maybe<Scalars['Boolean']>;
  originUrl?: Maybe<Scalars['String']>;
  scenario?: Maybe<Scalars['String']>;
}

export interface AdditionalOnboardingOperationContextInput {
  cmsToken?: Maybe<Scalars['String']>;
  originUrl?: Maybe<Scalars['String']>;
}

export enum AdditionalShoppedAncillaries {
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG'
}

export enum AdditionalShopping {
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG'
}













/** Represents client input to decide if and how the stripe toolbar will be displayed on the traveller sites */
export interface AffiliatesClientContextInput {
  lineOfBusiness: LineOfBusinessDomain;
  pageId?: Maybe<Scalars['String']>;
  pageLocation: PageLocation;
}










/** Represents the createAffiliateLink mutation request and response types */
export interface AffiliatesCreateLinkRequestInput {
  propertyContext?: Maybe<AffiliatesPropertyContextInput>;
  targetUrl: Scalars['String'];
}



/** Represents the createAffiliateVanityLink mutation request */
export interface AffiliatesCreateVanityLinkRequestInput {
  propertyContext?: Maybe<AffiliatesPropertyContextInput>;
  targetUrl: Scalars['String'];
  userText: Scalars['String'];
}































/** Represents information used to identify contextual property */
export interface AffiliatesPropertyContextInput {
  /** Represents eg property Id */
  egPropertyId?: Maybe<Scalars['String']>;
  /** Represents hotels property Id */
  hotelsPropertyId?: Maybe<Scalars['String']>;
}













/** Represents the affiliatesStats query request */
export interface AffiliatesStatsRequestInput {
  propertyContext?: Maybe<AffiliatesPropertyContextInput>;
}















export enum AgencyBusinessModel {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT'
}



export interface AgencyDestinationInput {
  coordinates?: Maybe<CoordinatesInput>;
  pinnedPropertyId?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['String']>;
}





















export interface AgencyPropertySearchFiltersInput {
  guest_rating?: Maybe<Scalars['String']>;
  payment_and_cancellation?: Maybe<Array<Scalars['String']>>;
  point_of_interest?: Maybe<Scalars['String']>;
  price?: Maybe<PriceFilterInput>;
  property_type?: Maybe<Array<Scalars['String']>>;
  star_rating?: Maybe<Array<Scalars['String']>>;
}









export interface AgencyQuoteBuilderPropertyRateCardInput {
  businessModelType?: Maybe<BusinessModelType>;
  checkIn: DateInput;
  checkOut: DateInput;
  inventoryType: InventoryType;
  packageRate: Scalars['Boolean'];
  pricePerNight: Scalars['String'];
  priceTotal: Scalars['String'];
  propertyDestination: Scalars['String'];
  propertyId: Scalars['String'];
  propertyName: Scalars['String'];
  propertyType: Scalars['String'];
  ratePlanId: Scalars['String'];
  roomTypeDescription: Scalars['String'];
  roomTypeId: Scalars['String'];
  rooms: Array<PropertyRoomInput>;
  starRating?: Maybe<Scalars['Float']>;
}


export interface AgencyQuoteBuilderRateCardInput {
  propertyInput: AgencyQuoteBuilderPropertyRateCardInput;
}


export interface AgencyQuoteBuilderRemoveInput {
  all: Scalars['Boolean'];
  index?: Maybe<Scalars['Int']>;
}


/** Input for deleting quotes */
export interface AgencyQuoteDeleteInput {
  /** List of quote ids to delete */
  quoteIds: Array<Scalars['String']>;
}


/** Status of quotes delete */
export interface AgencyQuoteDeleteStatusInput {
  deletedCount: Scalars['Int'];
  isSuccessful: Scalars['Boolean'];
}










export interface AgencyQuoteListInput {
  /** Status and number of quotes deleted. */
  deleteStatus?: Maybe<AgencyQuoteDeleteStatusInput>;
  /** Page index */
  paginationIndex?: Maybe<Scalars['Int']>;
  /** Search string if we want to filter the agency quote list records */
  searchCriteria?: Maybe<Scalars['String']>;
  /** Information of the tab */
  selectedTab?: Maybe<Scalars['String']>;
  /** Field Id for sort */
  sortContentId?: Maybe<Scalars['String']>;
  /** Sort direction (ascending, descending) */
  sortType?: Maybe<AgencyQuoteListSortType>;
}






/** Parameters for header cells for the records to be sorted in ascending, descending or to be unsorted manner */
export enum AgencyQuoteListSortType {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
  NOT_SORTED = 'NOT_SORTED'
}


export interface AgencyQuoteNaturalKeyInput {
  lodgingType: Scalars['String'];
  packageRates?: Maybe<Scalars['Boolean']>;
  propertyDestination: Scalars['String'];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}


export interface AgencyQuoteSaveAgencyDetailInput {
  /** Address of the agency, line 1 */
  address1?: Maybe<Scalars['String']>;
  /** Address of the agency line 2 */
  address2?: Maybe<Scalars['String']>;
  /** Email of the agent */
  email: Scalars['String'];
  /** Name of the Agency */
  name?: Maybe<Scalars['String']>;
  /** Phone number associated with the agency */
  phone: Scalars['String'];
}

export interface AgencyQuoteSaveCardInput {
  /** Destination of the travel */
  destination: Scalars['String'];
  /** Indicates state for hiding cancellation policy */
  hideCancellationState: Scalars['Boolean'];
  /** Indicates state for hiding price details */
  hidePriceState: Scalars['Boolean'];
  /** Expedia's line of businesses */
  lob: ExpLineOfBusiness;
  /** Natural key for input validation */
  naturalKey: AgencyQuoteNaturalKeyInput;
  /** Total price for the quote */
  totalPrice?: Maybe<Scalars['String']>;
}


export interface AgencyQuoteSaveInput {
  /** Agency details pulled from database */
  agencyInfo: AgencyQuoteSaveAgencyDetailInput;
  /** Message from the agent, to be added by the agent */
  agentMessage?: Maybe<Scalars['String']>;
  /** Details of the trip on quote, pulled from database */
  quoteCards: Array<AgencyQuoteSaveCardInput>;
  /** Autogenerated Unique Identifier for each quote. Could be Null for saving a quote after Update */
  quoteId?: Maybe<Scalars['String']>;
  /** Name of the quote, to be added by the agent */
  quoteName: Scalars['String'];
  /** Name of the Traveler, to be added by the agent */
  travelerName: Scalars['String'];
}







export interface AgencyShoppingContextInput {
  bookingDate: Scalars['String'];
  checkin: Scalars['String'];
  checkout: Scalars['String'];
  countryCode: Scalars['String'];
  currency: Scalars['String'];
  language: Scalars['String'];
  occupancy: Array<Scalars['String']>;
}












export interface AgentQuoteNaturalKeyInput {
  packageRates?: Maybe<Scalars['Boolean']>;
  propertyDestination: Scalars['String'];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}





export interface AgentStateInput {
  agentPresenceUri: Scalars['String'];
  localizedText?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: AgentStateType;
}

export enum AgentStateType {
  NOTREADY = 'NotReady',
  OFFLINE = 'Offline',
  READY = 'Ready'
}







/** Airport location type chosen in flight search. */
export enum AirportLocationType {
  AIRPORT = 'AIRPORT',
  METROCODE = 'METROCODE',
  UNSPECIFIED = 'UNSPECIFIED'
}


export enum Alignment {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}






/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  /** Localization messages will be replaced with their namespace and loc key. */
  DEBUG = 'DEBUG',
  /** None of the ALTER experiments will be used when resolving localization messages. */
  NONE = 'NONE',
  /** Both released and draft ALTER experiments will be used when resolving localization messages. */
  PREVIEW = 'PREVIEW',
  /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
  RELEASED = 'RELEASED'
}









export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BARBECUE = 'BARBECUE',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BREAKFAST_INCLUDED = 'BREAKFAST_INCLUDED',
  BREAKFAST_NOT_AVAILABLE = 'BREAKFAST_NOT_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FIRE_PLACE = 'FIRE_PLACE',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCEL = 'FREE_CANCEL',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FREE_WIRED_INTERNET = 'FREE_WIRED_INTERNET',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  INTERNET_NOT_AVAILABLE = 'INTERNET_NOT_AVAILABLE',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  ON_PRIVATE_BEACH = 'ON_PRIVATE_BEACH',
  ON_THE_BEACH = 'ON_THE_BEACH',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESERVE_NOW_PAY_DEPOSIT = 'RESERVE_NOW_PAY_DEPOSIT',
  RESERVE_NOW_PAY_LATER = 'RESERVE_NOW_PAY_LATER',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WASHER = 'WASHER',
  WATERSLIDE = 'WATERSLIDE',
  WIFI_SURCHARGE = 'WIFI_SURCHARGE',
  WIRED_INTERNET_SURCHARGE = 'WIRED_INTERNET_SURCHARGE'
}

export enum AmenityFilter {
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  INVALID = 'INVALID',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}

/** represents the bag template analytics keys */
export enum AnalyticsKey {
  /** Represents the analytics key for number of bags per traveller */
  NUMBER_OF_BAGS = 'NUMBER_OF_BAGS',
  /** Represents the analytics key for piece or weight selling model criteria analytics per traveller */
  PIECE_OR_WEIGHT_CONCEPT = 'PIECE_OR_WEIGHT_CONCEPT',
  /** Represents the analytics key for quantity of bags per traveller (NONE/SOME/ALL) */
  QUANTITY_OF_BAGS = 'QUANTITY_OF_BAGS'
}


/** Represents per journey ancillary selection */
export interface AncillaryJourneySelectionsInput {
  /** Represents the journey index for which the selection is applicable */
  journeyIndex: Scalars['Int'];
  /** Represents flight journey status */
  journeyStatus?: Maybe<FlightJourneyStatus>;
  /** Represents the list of per traveller selection */
  travellerAncillarySelections: Array<TravellerAncillarySelectionInput>;
}

/** Represents path plus page for where ancillaries will be shopped. */
export enum AncillaryShoppingPath {
  PACKAGE_INFOSITE = 'PACKAGE_INFOSITE',
  PACKAGE_TRIPS = 'PACKAGE_TRIPS',
  STANDALONE_INFOSITE = 'STANDALONE_INFOSITE',
  STANDALONE_TRIPS = 'STANDALONE_TRIPS'
}



export interface ArithmeticOperationsCriteriaInput {
  /** Represents the input numbers to be operated upon */
  inputNumbers: Array<Scalars['Float']>;
  /** The operation to be performed */
  operation: Operation;
}

/** Possible aspect ratios of EGDS images */
export enum AspectRatio {
  /** Aspect ratio 4:1 */
  FOUR_ONE = 'FOUR_ONE',
  /** Aspect ratio 4:3 */
  FOUR_THREE = 'FOUR_THREE',
  /** Aspect ratio 1:1 */
  ONE_ONE = 'ONE_ONE',
  /** Aspect ratio 16:9 */
  SIXTEEN_NINE = 'SIXTEEN_NINE',
  /** Aspect ratio 3:4 */
  THREE_FOUR = 'THREE_FOUR',
  /** Aspect ratio 3:2 */
  THREE_TWO = 'THREE_TWO',
  /** Aspect ratio 21:9 */
  TWENTY_ONE_NINE = 'TWENTY_ONE_NINE'
}

/** Represents authentication configuration */
export interface AuthenticationConfigInput {
  /** Represents a JWT token retrieved from the IAM Token API */
  authToken?: Maybe<Scalars['String']>;
  /** Represents a unique channel origin id per chat experience */
  channelOriginId?: Maybe<Scalars['String']>;
}

export enum AuthenticationState {
  ANONYMOUS = 'ANONYMOUS',
  AUTHENTICATED = 'AUTHENTICATED',
  IDENTIFIED = 'IDENTIFIED'
}










export enum BadgeIcon {
  ACCESS_TIME = 'ACCESS_TIME',
  ADD = 'ADD',
  BUNDLED_SAVINGS_PLUS = 'BUNDLED_SAVINGS_PLUS',
  EXP29639_ORB = 'EXP29639_ORB',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO_OUTLINE = 'INFO_OUTLINE',
  LOB_DEALS = 'LOB_DEALS',
  LOCAL_OFFER = 'LOCAL_OFFER',
  MOD = 'MOD',
  SMARTPHONE = 'SMARTPHONE'
}


/** Represents the quantity of bags to be sent in analytics none/some/all */
export enum BagsSelectionType {
  ALL = 'ALL',
  NONE = 'NONE',
  SOME = 'SOME'
}

export enum BannerDisplayType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARN = 'WARN'
}


export enum BannerTheme {
  BRAND_PROMO_PRIMARY = 'BRAND_PROMO_PRIMARY',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}















export interface BookingChangeFlightInput {
  /** Represents the air record locator for the flight that needs to be changed */
  airRecordLocator?: Maybe<Scalars['String']>;
  /** Represents the virtual agent domain or Web domain */
  client?: Maybe<BookingServicingClient>;
  /** ConversationId for virtual agent */
  conversationId?: Maybe<Scalars['String']>;
  /** Represents the new flight search criteria */
  flightSearchCriteria?: Maybe<FlightSearchCriteriaInput>;
  /** opaqueId for virtual agent */
  opaqueId?: Maybe<Scalars['String']>;
  /** Represents the old flight and traveler selection that needs to be changed */
  selectedChanges?: Maybe<Array<BookingServicingChangeSelectionInput>>;
  /** Represents the tripId for the flight that needs to be changed */
  tripId: Scalars['String'];
  /** Represents the trip item id for the flight that needs to be changed */
  tripItemId?: Maybe<Scalars['String']>;
  /** Represents the trip view id for the flight that needs to be changed */
  tripViewId?: Maybe<Scalars['String']>;
}





/** Represents criteria input containing info about trip for cancel query */
export interface BookingServicingCancelCriteriaInput {
  /** Represents the cancel query input */
  flightsCriteriaInput: BookingServicingCancelFlightInput;
}

/** Represents info about trip for cancel query input */
export interface BookingServicingCancelFlightInput {
  /** Represents the air record locator for the cancel query input */
  airRecordLocator: Scalars['String'];
  /** Represents the type of cancellation being performed by the traveler */
  cancelType: BookingServicingCancelType;
  /** Represents the tripId for the cancel query input */
  tripId: Scalars['String'];
  /** Represents the tripItemId for the cancel query input */
  tripItemId?: Maybe<Scalars['String']>;
  /** Represents the tripViewId for the cancel query input */
  tripViewId?: Maybe<Scalars['String']>;
}




/** The path for cancellation that will be performed by the traveler */
export enum BookingServicingCancelType {
  /** Represents the type for Involuntary/ASC Cancel */
  INVOLUNTARY = 'INVOLUNTARY',
  /** Represents the type for Voluntary Cancel */
  VOLUNTARY = 'VOLUNTARY'
}







/** Represents the information about the flight and traveler selections that need to be changed  */
export interface BookingServicingChangeCriteriaInput {
  /** Represents the information about the flight  and traveler selections that need to be changed  */
  flightsInput?: Maybe<BookingChangeFlightInput>;
}


export interface BookingServicingChangeLodgingInput {
  orderLineGuid: Scalars['String'];
  orderNumber: Scalars['String'];
  tripId: Scalars['String'];
}





export interface BookingServicingChangeSelectionInput {
  /** Represents the name of the change flight(eg old flight/traveler) */
  name: Scalars['String'];
  /** Represents the value of the change flight(eg old flight/traveler) */
  value: Scalars['String'];
}



export enum BookingServicingClient {
  /** Represents virtual agent domain */
  VIRTUAL_AGENT = 'VIRTUAL_AGENT',
  /** Represents web domain */
  WEB = 'WEB'
}






















/** Target of the Link when clicked */
export enum BookingServicingLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL'
}











export enum BookingServicingQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}













/** Booking servicing toolbar navigation type */
export enum BookingServicingToolbarNavigationType {
  /** Represents the toolbar with a back button */
  BACK = 'BACK',
  /** Represents the toolbar with a close button */
  CLOSE = 'CLOSE',
  /** Represents the toolbar with a expand less button */
  EXPAND_LESS = 'EXPAND_LESS',
  /** Represents the toolbar with a expand up button */
  EXPAND_UP = 'EXPAND_UP'
}

/** Booking servicing toolbar type */
export enum BookingServicingToolbarType {
  /** Represents the standard type */
  STANDARD = 'STANDARD',
  /** Represents the transparent type */
  TRANSPARENT = 'TRANSPARENT'
}


/** Represents the traveler details input */
export interface BookingServicingTravelerDetailsInput {
  accessibility: Array<Scalars['String']>;
  bedTypeId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  smoking?: Maybe<Scalars['String']>;
}


export enum BookingServicingTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT'
}

/** The type of input validation that will be performed on the traveler input */
export enum BookingServicingTravelerValidationType {
  /** Represents the type of validation when a child is traveling alone without an adult */
  CHILD_TRAVELING_ALONE = 'CHILD_TRAVELING_ALONE'
}








export enum BooleanEnum {
  FALSE = 'FALSE',
  TRUE = 'TRUE'
}


/** Type used during a product search to specify a given boolean value like the fact customer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: Scalars['String'];
  value: Scalars['Boolean'];
}










/** Represents the base product price */
export interface BrandedDealProductPriceInput {
  base: MoneyInput;
  taxesAndFees: MoneyInput;
}




export enum BulletStyle {
  DEFAULT = 'DEFAULT',
  ICON_ALTERNATE = 'ICON_ALTERNATE',
  ICON_STANDARD = 'ICON_STANDARD',
  NO_BULLET = 'NO_BULLET',
  UNRECOGNIZED = 'UNRECOGNIZED'
}


/** Indicate the business model type of a given offer */
export enum BusinessModelType {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT'
}

export interface CdfFeedbackInput {
  context: Array<GraphQlPairInput>;
  formValues: Array<GraphQlPairInput>;
}











export enum CdfPageDisplayConditionType {
  BOOL = 'BOOL',
  NONE = 'NONE',
  PATTERN = 'PATTERN',
  TEXT = 'TEXT'
}










export enum CampaignOfferBadgeType {
  DEFAULT = 'DEFAULT',
  DISCOUNT = 'DISCOUNT'
}


export interface CampaignParametersInput {
  campaignId: Scalars['String'];
  contentPagination?: Maybe<ContentPaginationInput>;
  propertyParameters?: Maybe<CampaignPropertyParametersInput>;
}

export enum CampaignProductType {
  ACTIVITY = 'ACTIVITY',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE'
}

export interface CampaignPropertyParametersInput {
  guestRating?: Maybe<Scalars['Float']>;
  propertyId: Scalars['String'];
  starRating?: Maybe<Scalars['Float']>;
  type?: Maybe<PropertyDetailsPropertyType>;
}


export interface CancellationWaiverDeclineRequestContext {
  bookingItemId: Scalars['String'];
  serviceRequestId: Scalars['String'];
  reason: Scalars['String'];
  message?: Maybe<Scalars['String']>;
}


export enum CarAccessorySelectionState {
  NOT_SELECTED = 'NOT_SELECTED',
  SELECTED = 'SELECTED'
}


export enum CarActionType {
  /** Apply loyalty points to offer */
  APPLY_LOYALTY_POINTS = 'APPLY_LOYALTY_POINTS',
  /** Click map marker */
  CAR_MAP_MARKER = 'CAR_MAP_MARKER',
  /** Change Search */
  CHANGE_SEARCH = 'CHANGE_SEARCH',
  /** Dismisses a dialog */
  DISMISS = 'DISMISS',
  /** Click to filter car sales */
  FILTER_SALE_OFFER = 'FILTER_SALE_OFFER',
  /** Submit content to server */
  FORM_SUBMISSION = 'FORM_SUBMISSION',
  /** Go back to search page to see all cars */
  GO_BACK_TO_SEARCH = 'GO_BACK_TO_SEARCH',
  /** Open cancellation policy link */
  GO_TO_CANCELLATION_POLICY = 'GO_TO_CANCELLATION_POLICY',
  /** Continues to the standalone details page */
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  /** Open dialog to see cleaning and safety practices */
  GO_TO_CLEANLINESS_DIALOG = 'GO_TO_CLEANLINESS_DIALOG',
  /** Continues to the standalone details page */
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  /** Continues to the packages path */
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  /** Open recommended sort FAQ page */
  GO_TO_RECOMMENDED_SORT_FAQ = 'GO_TO_RECOMMENDED_SORT_FAQ',
  /** Continues to the user sign in page */
  GO_TO_SIGNIN = 'GO_TO_SIGNIN',
  /** Continues to the user sign up page */
  GO_TO_SIGNUP = 'GO_TO_SIGNUP',
  /** Click to sign in and unlock car sales */
  GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES = 'GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES',
  /** Open Walmart plus member trial page */
  GO_TO_WPLUS_MEMBER_TRIAL_LINK = 'GO_TO_WPLUS_MEMBER_TRIAL_LINK',
  /** Load more results to search page */
  LOAD_MORE = 'LOAD_MORE',
  /** Change Search */
  OFF_AIRPORT_CHANGE_SEARCH = 'OFF_AIRPORT_CHANGE_SEARCH',
  /** Opens a dialog */
  OPEN_DIALOG = 'OPEN_DIALOG',
  /** Open merchant rules in iframe */
  OPEN_DOC = 'OPEN_DOC',
  /** Open ground transfers page */
  OPEN_GROUND_TRANSFERS = 'OPEN_GROUND_TRANSFERS',
  /** Opens the inline time wizard */
  OPEN_INLINE_TIME_WIZARD = 'OPEN_INLINE_TIME_WIZARD',
  /** Opens the inline search wizard */
  OPEN_INLINE_WIZARD = 'OPEN_INLINE_WIZARD',
  /** Opens a new tab */
  OPEN_NEW_TAB = 'OPEN_NEW_TAB',
  /** Opens on current tab */
  OPEN_ON_CURRENT_TAB = 'OPEN_ON_CURRENT_TAB',
  /** Open vendor rules from domain rules */
  OPEN_RULE = 'OPEN_RULE',
  /** Used to open Telephone Link */
  OPEN_TEL = 'OPEN_TEL',
  /** Refreshes the current page */
  REFRESH = 'REFRESH',
  /** Remove loyalty points to offer */
  REMOVE_LOYALTY_POINTS = 'REMOVE_LOYALTY_POINTS',
  /** Click see cars on map marker item card */
  SEE_CARS_AT_MAP_MARKER = 'SEE_CARS_AT_MAP_MARKER',
  /** Open share feedback form */
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  /** Show offers with AARP Exclusive benefits */
  SHOW_AARP_EXCLUSIVE_OFFERS = 'SHOW_AARP_EXCLUSIVE_OFFERS',
  /** Show offers with free cancellations */
  SHOW_FREE_CANCELLATION_OFFERS = 'SHOW_FREE_CANCELLATION_OFFERS',
  /** Click to unlock car sales */
  UNLOCK_CAR_SALES = 'UNLOCK_CAR_SALES'
}












export interface CarDetailContextInput {
  carOfferToken: Scalars['String'];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: Maybe<Scalars['String']>;
  optionAction?: Maybe<CarAccessorySelectionState>;
  optionToken?: Maybe<Scalars['String']>;
  principalToken?: Maybe<Scalars['String']>;
  rewardPointsSelection?: Maybe<RewardsPointSelectionEnum>;
  selectedAccessories?: Maybe<Array<Scalars['String']>>;
}







export enum CarFormatStyle {
  IFRAME = 'IFRAME',
  LIST = 'LIST'
}














export enum CarMapMarkerType {
  CARMARKER = 'CarMarker',
  PLACEMARKER = 'PlaceMarker'
}





/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: Scalars['String'];
  specialEquipments?: Maybe<Array<SpecialEquipment>>;
}



























/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: Maybe<Scalars['String']>;
  coordinates?: Maybe<CoordinatesInput>;
  isExactLocationSearch?: Maybe<Scalars['Boolean']>;
  regionId?: Maybe<Scalars['String']>;
  searchTerm?: Maybe<Scalars['String']>;
}






export enum CarRouteType {
  ONEWAY = 'ONEWAY',
  ROUNDTRIP = 'ROUNDTRIP'
}


export interface CarRulesAndRestrictionsCriteriaInput {
  carOfferToken?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  useEgtpPath?: Maybe<Scalars['Boolean']>;
}




/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}








/** Represents name and code for each car brand. */
export enum CarSearchFormPreferredBrand {
  AC = 'AC',
  AD = 'AD',
  AL = 'AL',
  EP = 'EP',
  ET = 'ET',
  EY = 'EY',
  FX = 'FX',
  MW = 'MW',
  NU = 'NU',
  RO = 'RO',
  SC = 'SC',
  SV = 'SV',
  SX = 'SX',
  ZA = 'ZA',
  ZD = 'ZD',
  ZE = 'ZE',
  ZI = 'ZI',
  ZL = 'ZL',
  ZR = 'ZR',
  ZT = 'ZT'
}



























export enum CardActions {
  DISMISS = 'DISMISS'
}


export enum CardSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export enum CardTheme {
  GLOBAL_LOYALTY_EXTRAHIGH = 'GLOBAL_LOYALTY_EXTRAHIGH',
  GLOBAL_LOYALTY_HIGH = 'GLOBAL_LOYALTY_HIGH',
  GLOBAL_LOYALTY_LOW = 'GLOBAL_LOYALTY_LOW',
  GLOBAL_LOYALTY_MIDDLE = 'GLOBAL_LOYALTY_MIDDLE',
  GLOBAL_LOYALTY_STANDARD = 'GLOBAL_LOYALTY_STANDARD',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}




/** Enum class to represent the type of carry on bag */
export enum CarryOnBagType {
  CARRY_ON_BAG = 'CARRY_ON_BAG'
}




export enum CarsDialogType {
  LIMITED_RESULTS = 'LIMITED_RESULTS',
  LIMITED_RESULTS_WITHOUT_TURO = 'LIMITED_RESULTS_WITHOUT_TURO',
  LIMITED_RESULTS_WITH_TURO = 'LIMITED_RESULTS_WITH_TURO'
}

export interface CarsDomainRequestContextInput {
  partnerContext: PartnerContextInput;
  principalJWT: Scalars['String'];
}



export enum CarsRichTextStyle {
  BOLD = 'BOLD',
  BULLET = 'BULLET',
  ITALICIZE = 'ITALICIZE'
}






/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}


export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: Scalars['String'];
  /** The list of rooms that user searched for */
  rooms: Array<PropertyRoomInput>;
}


export enum CartTtl {
  FIVE_MINUTES = 'FIVE_MINUTES',
  SEVEN_DAYS = 'SEVEN_DAYS',
  TWELVE_HOURS = 'TWELVE_HOURS'
}








export enum ChannelType {
  VIRTUAL_AGENT = 'VIRTUAL_AGENT'
}

/** Indicates the type of intent. */
export enum ChatBotIntentType {
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
  VIEW_BOOKING = 'VIEW_BOOKING'
}

/** Indicates the type of product. */
export enum ChatBotProductType {
  FLIGHT = 'FLIGHT'
}

/** Indicates the waiver redemption state. */
export enum ChatBotWaiverRedemptionState {
  CREDIT_REDEMPTION = 'CREDIT_REDEMPTION'
}


/** Supported capabilities of chatbot VAC. */
export enum ChatbotCapabilities {
  CLICKSTREAM = 'CLICKSTREAM',
  GLASSBOX = 'GLASSBOX'
}




/** Key-Value pair of intent attributes for chatbot initialization example itineraryNumber, orderLineId */
export interface ChatbotIntentValueInput {
  /** Key to define intent attributes for chatbot initialization example itineraryNumber, orderLineId */
  id: Scalars['String'];
  /** Value for intent attributes for chatbot initialization example of attributes itineraryNumber, orderLineId */
  value: Scalars['String'];
}


/** Supported versions of chatbot. */
export enum ChatbotVersionId {
  V1 = 'V1',
  V2 = 'V2'
}

export enum CheckinValidityWithReason {
  /** the associated date is not valid for checkin due to an unknown reason */
  INVALID = 'INVALID',
  /** the associated date is not valid for checkin due to being in the past */
  INVALID_DUE_TO_BEING_IN_PAST = 'INVALID_DUE_TO_BEING_IN_PAST',
  /** the associated date is not valid for checkin because checkin was prohibited on that specific date */
  INVALID_DUE_TO_CHANGEOVER_EXCLUSION = 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
  /** the associated date is not valid for checkin because it is too far in the future */
  INVALID_DUE_TO_MAX_FUTURE_BOOKING = 'INVALID_DUE_TO_MAX_FUTURE_BOOKING',
  /** the associated date is not valid for checkin because checking in on this date would not meet the owner's minimum prior notification requirements */
  INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION = 'INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION',
  /** the associated date is not valid for checkin because checking in on this date does not satisfy the minimum stay duration */
  INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE = 'INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE',
  /** the associated date is not valid for checkin because it falls on a day of the week that checkin is prohibited */
  INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK = 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
  /** the associated date is not valid for checkin because it is not available (ie. the date is already reserved) */
  INVALID_DUE_TO_NOT_AVAILABLE = 'INVALID_DUE_TO_NOT_AVAILABLE',
  /** the associated date is not valid for checkin because there is not an associated checkout date that would allow the stay to satisfy stay constraints */
  INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS = 'INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS',
  /** the associated date is valid for checkin */
  VALID = 'VALID'
}




export interface CheckoutDomainInfoInput {
  name: Scalars['String'];
  refId: Scalars['String'];
}




/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;
  value: Scalars['String'];
}

/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  FENCING_ATTRIBUTES = 'FENCING_ATTRIBUTES',
  HOTEL_BUSINESS_MODEL = 'HOTEL_BUSINESS_MODEL',
  HOTEL_MARKETING_CHANNEL = 'HOTEL_MARKETING_CHANNEL',
  META_DEEPLINK = 'META_DEEPLINK',
  PROPERTY_UPSELL_AMOUNT = 'PROPERTY_UPSELL_AMOUNT',
  RATE_UPGRADE_ELIGIBLE = 'RATE_UPGRADE_ELIGIBLE',
  RATE_UPSELL = 'RATE_UPSELL',
  RATE_UPSELL_AMOUNT = 'RATE_UPSELL_AMOUNT',
  ROOM_UPGRADE_ELIGIBLE = 'ROOM_UPGRADE_ELIGIBLE',
  ROOM_UPSELL = 'ROOM_UPSELL',
  SHOPPING_DEAL_BADGE_PERCENTAGE = 'SHOPPING_DEAL_BADGE_PERCENTAGE',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  TAAP_PACKAGE_RATES = 'TAAP_PACKAGE_RATES'
}




export interface CheckoutSessionInfoInput {
  sessionId: Scalars['UUID'];
  sessionToken: Scalars['UUID'];
}


export enum CheckoutValidityWithReason {
  /** the associated date's is not valid for checkout for an unknown reason */
  INVALID = 'INVALID',
  /** the associated date is not valid for checkout because checkout was prohibited on that specific date */
  INVALID_DUE_TO_CHANGEOVER_EXCLUSION = 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
  /** the associated date is not valid for checkout because it falls on a day of the week that checkout is prohibited */
  INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK = 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
  /** the associated date is valid for checkout */
  VALID = 'VALID'
}


/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: Scalars['Int'];
}

export enum ChronoUnit {
  CENTURIES = 'CENTURIES',
  DAYS = 'DAYS',
  DECADES = 'DECADES',
  ERAS = 'ERAS',
  FOREVER = 'FOREVER',
  HALFDAYS = 'HALFDAYS',
  HOURS = 'HOURS',
  MICROS = 'MICROS',
  MILLENNIA = 'MILLENNIA',
  MILLIS = 'MILLIS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  NANOS = 'NANOS',
  SECONDS = 'SECONDS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum CleaningAndSafetyPractice {
  ENHANCED_CLEANING = 'ENHANCED_CLEANING'
}






/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: Scalars['String'];
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: Maybe<Scalars['String']>;
}


/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: Array<HttpHeaderInput>;
  /** Remote address of HTTP Request */
  remoteAddress: Scalars['String'];
  /** URL of HTTP Request */
  url: Scalars['String'];
}










/** The closed bounding type of the date period. (Boundaries are always included) */
export enum ClosedPeriodBounding {
  LOWER = 'LOWER',
  UPPER = 'UPPER'
}













export enum CoachingTipsView {
  STANDALONE_MINIMAL = 'STANDALONE_MINIMAL',
  STANDALONE_SUGGESTED = 'STANDALONE_SUGGESTED',
  OPPY_HUB = 'OPPY_HUB'
}







/** Context of pagination and max number of elements. If not defined, the default set of elements are provided. */
export interface CollectionPaginationContextInput {
  /** Indicates the maximum number of items to be shown in the module. */
  maxPageSize?: Maybe<Scalars['Int']>;
  /** Indicates the pagination offset. */
  offset?: Maybe<Scalars['Int']>;
  /** Indicates the initial number of items to be shown in the module and how many more items will be fetched by pagination. */
  pageSize?: Maybe<Scalars['Int']>;
}


/** The type of the collection */
export enum CollectionType {
  FLIGHT = 'FLIGHT',
  GEOGRAPHY = 'GEOGRAPHY',
  LODGING = 'LODGING'
}


export enum CommissionTier {
  BASIC = 'BASIC',
  BASIC_PLUS = 'BASIC_PLUS',
  PREMIUM = 'PREMIUM',
  PREMIUM_PLUS = 'PREMIUM_PLUS'
}










/** Represents left or right alignment of a specific messages in the conversation View */
export enum CommunicationCenterMessageAlignment {
  /** Represents left Alignment */
  LEFT = 'LEFT',
  /** Represents Right Alignment */
  RIGHT = 'RIGHT'
}



/** Represents the state of message preview */
export enum CommunicationCenterMessagePreviewState {
  /** Represents read state */
  READ = 'READ',
  /** Represents unread state */
  UNREAD = 'UNREAD'
}






/** The display type of the Customer notification message */
export enum CommunicationCenterNotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum CommunicationCenterNotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of info for the message */
  INFO = 'INFO',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}


/** Represents the state of notification or message */
export enum CommunicationCenterNotificationState {
  /** Represents read state */
  READ = 'READ',
  /** Represents seen state - equivalents as unread */
  SEEN = 'SEEN',
  /** Represents invalid state */
  UNKNOWN = 'UNKNOWN',
  /** Represents unseen state - initial state of notification */
  UNSEEN = 'UNSEEN'
}

/** Represents the type of the notification */
export enum CommunicationCenterNotificationType {
  /** Represents coupon notification */
  COUPON_CAMPAIGN = 'COUPON_CAMPAIGN',
  /** Represents default type of notification */
  DEFAULT = 'DEFAULT'
}


/** Represents the type of user actions of the notification. */
export enum CommunicationCenterNotificationUserActionType {
  /** Represents the action of deleting a notification */
  DELETE = 'DELETE',
  /** Represents the action of marking a notification as read */
  MARK_AS_READ = 'MARK_AS_READ',
  /** Represents the action of marking a notification as unread */
  MARK_AS_UNREAD = 'MARK_AS_UNREAD'
}


/** Represents the status of query/mutation response */
export enum CommunicationCenterOperationStatus {
  /** Represents the status of failure response for generic or unknown reasons */
  GENERIC_FAILURE = 'GENERIC_FAILURE',
  /** Represents the status of failure response for invalid input */
  INVALID_INPUT = 'INVALID_INPUT',
  /** Represents the status of failure response for service errors */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** Represents the status of successful response */
  SUCCESS = 'SUCCESS'
}




export enum CommunicationChannel {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS'
}








export enum CommunicationPreferencesOptionsType {
  ACCOUNT_SUPPORT = 'ACCOUNT_SUPPORT',
  COMMUNICATION_PREFERENCES_EXPEDIA = 'COMMUNICATION_PREFERENCES_EXPEDIA',
  COMMUNICATION_PREFERENCES_HOTELS = 'COMMUNICATION_PREFERENCES_HOTELS',
  COMMUNICATION_PREFERENCES_VRBO = 'COMMUNICATION_PREFERENCES_VRBO',
  CONFIRMATION_AND_CRITICAL_UPDATES = 'CONFIRMATION_AND_CRITICAL_UPDATES',
  DEFAULT = 'DEFAULT',
  MANAGE_EMAIL_PREFERENCE = 'MANAGE_EMAIL_PREFERENCE',
  OFFERS_AND_INSPIRATION = 'OFFERS_AND_INSPIRATION',
  ONE_KEY = 'ONE_KEY',
  ONE_KEY_MONTHLY_STATEMENTS = 'ONE_KEY_MONTHLY_STATEMENTS',
  PARTNERS_OFFERS_WITH_US = 'PARTNERS_OFFERS_WITH_US',
  PERSONALIZED_TRIP_RECOMMENDATIONS = 'PERSONALIZED_TRIP_RECOMMENDATIONS',
  PRIVACY_STATEMENT = 'PRIVACY_STATEMENT',
  REVIEWS = 'REVIEWS',
  SURVEYS = 'SURVEYS',
  THE_TRAVEL_EDIT = 'THE_TRAVEL_EDIT',
  TRIP_BOARD_ACTIVITY = 'TRIP_BOARD_ACTIVITY',
  TRIP_PLANNING_ASSISTANCE = 'TRIP_PLANNING_ASSISTANCE',
  UNSUB_ALL = 'UNSUB_ALL',
  UNSUB_OTHER_EMAILS = 'UNSUB_OTHER_EMAILS'
}




export enum CompetitiveSetProductType {
  LODGING = 'LODGING'
}









/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = 'CAP',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  NA = 'NA'
}









export interface ContactUsFormContentInput {
  /** Customer Selected category from dropdown */
  category: Scalars['String'];
  /** Customer selected intent from dropdown */
  intent: Scalars['String'];
  /** Customer Entered Itinerary Number */
  itineraryNumber: Scalars['String'];
  /** Customer Entered Phone Number */
  phoneNumber: Scalars['String'];
}


export enum ContactUsOptionType {
  CALL_BACK_WITH_AGENT = 'CALL_BACK_WITH_AGENT',
  CALL_TO_AGENT = 'CALL_TO_AGENT',
  CHAT_BACK_WITH_AGENT = 'CHAT_BACK_WITH_AGENT',
  CHAT_WITH_AGENT = 'CHAT_WITH_AGENT',
  SEND_EMAIL_AGENT = 'SEND_EMAIL_AGENT'
}




/** Represents Email Us Sheet Request */
export interface ContactUsSendEmailRequestInput {
  /** Email of customer */
  customerEmail: Scalars['String'];
  /** Name of customer */
  customerName: Scalars['String'];
  /** Message of email */
  message: Scalars['String'];
  /** subject of email */
  subject: Scalars['String'];
}









/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export enum ContainerTheme {
  DEFAULT = 'DEFAULT',
  IMPORTANT = 'IMPORTANT'
}


export interface ContentPaginationInput {
  pageNumber: Scalars['Int'];
  pageSize?: Maybe<Scalars['Int']>;
}



/** The input BEX context used for identifying users, sites and other platform functions. See the platform-expsite docs for more info: https://docweb.prod.expedia.com/expsite */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: Maybe<ClientInfoInput>;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: Maybe<Scalars['String']>;
  /** Debugging context, such as Abacus overrides */
  debugContext?: Maybe<DebugContextInput>;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: Maybe<Scalars['Int']>;
  /**
   * DEPRECATED: Optional Client/user information. Used for input only. Please send the DUIAD header instead.
   * We no longer rely on identity for user determination.
   * User determination is now based upon passed headers. Soon this will be made nullable and later removed.
   * Will be replaced by JWTs when available.
   */
  identity?: Maybe<IdentityInput>;
  /** The context locale, e.g. en_US */
  locale: Scalars['Locale'];
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: Maybe<PrivacyTrackingState>;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: Scalars['Int'];
  /** The legacy TravelProductID */
  tpid?: Maybe<Scalars['Int']>;
}



/** Represents any relevant attributes of a conversation */
export interface ConversationAttributesInput {
  /** Represents the URL of the page where the current conversation is taking place */
  currentPageUrl?: Maybe<Scalars['String']>;
}

/** Represents the context of a conversation */
export interface ConversationContextInput {
  /** Represents any relevant attributes of a conversation, such as the current pages's URL */
  attributes?: Maybe<ConversationAttributesInput>;
  /** Represents the conversation ID, used to route messages */
  conversationId?: Maybe<Scalars['String']>;
  /** Represents the participant ID, used to identify the author of a message or the actor of an event */
  participantId?: Maybe<Scalars['String']>;
}


/** Represents any relevant configs of a conversation */
export interface ConversationInitializationConfigsInput {
  /** Represents any relevant attributes of a conversation, such as the current page URL */
  attributes?: Maybe<ConversationAttributesInput>;
  /** Represents config to create a new conversation */
  forceNewConversation?: Maybe<Scalars['Boolean']>;
  /** Represents mode of conversation - create, join, resume, etc. */
  mode: ConversationMode;
  /** Represents input data related to a participant */
  participant?: Maybe<ParticipantInput>;
}


export enum ConversationMode {
  CREATE_CONVERSATION = 'CREATE_CONVERSATION'
}




/** A latitude/longitude pair */
export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: Scalars['Float'];
  /** The longitude of the point in degrees */
  longitude: Scalars['Float'];
}













export interface CouponIdentifierInput {
  type: CouponIdentifierType;
  value: Scalars['String'];
}

export enum CouponIdentifierType {
  CODE = 'CODE',
  INSTANCE_ID = 'INSTANCE_ID'
}








































export enum CreditCardApplicationFormOperation {
  EQ = 'EQ',
  GE = 'GE',
  GT = 'GT',
  LE = 'LE',
  LT = 'LT',
  NE = 'NE'
}



export interface CreditCardApplicationFormQueryInput {
  /** The deeplink that potentially triggered the Application Form opening. */
  deeplinkUrl?: Maybe<Scalars['String']>;
  /** The page the traveler is instantiating the Application Form from. */
  sourcePage: CreditCardSourcePage;
}












export interface CreditCardApplicationThankYouInput {
  /** First name of the applicant for the Credit Card */
  applicantFirstName: Scalars['String'];
  /** Application ID of the Credit Card application process */
  applicationID: Scalars['String'];
  /** Application token of the Credit Card application process */
  applicationToken: Scalars['String'];
  /** Enum to request either the Thank you pending or approved screen */
  screenType: CreditCardThankYouScreenType;
}





export enum CreditCardApplyButtonActionType {
  EMBEDDED = 'EMBEDDED',
  EXTERNAL = 'EXTERNAL'
}





export enum CreditCardEncodingType {
  BASE64 = 'Base64'
}



export enum CreditCardSourcePage {
  /** The traveler initiated the application journey from the Application (A.K.A. Pillar) Page. */
  APPLICATION = 'APPLICATION',
  /** The traveler initiated the application journey from a Checkout Page. */
  CHECKOUT = 'CHECKOUT',
  /** The traveler initiated the application journey from a page external to EG websites, such as a marketing email. */
  EXTERNAL = 'EXTERNAL'
}


export enum CreditCardThankYouScreenType {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING'
}

/** Enum class to represent the type of credit eligible filter */
export enum CreditEligibleFilterType {
  CREDIT_ELIGIBLE = 'CREDIT_ELIGIBLE'
}














export interface CrossLinksParameterInput {
  name: Scalars['String'];
  value: Scalars['String'];
}








export enum CrossSellProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL'
}




/** Represent the current location of the User so we can propose an origin for the flights */
export interface CrossSellUserLocationInput {
  /** The city of User's current location. ex: SANJOSE */
  city: Scalars['String'];
  /** The continent code of User's current location. ex: NA */
  continent: Scalars['String'];
  /** The country code of User's current location. ex: US */
  country: Scalars['String'];
  /** The region or state code of User's current location. ex: CA */
  region: Scalars['String'];
}




/** Amenities on a sailing */
export interface CruiseAmenitiesListInput {
  /** Amenities items to display. */
  amenities: Array<CruiseAmenityInfoInput>;
}





/** Amenity on a sailing */
export interface CruiseAmenityInfoInput {
  /** Category of amenity */
  a11yCategory?: Maybe<Scalars['String']>;
  /** Amenity description */
  a11yDescription: Scalars['String'];
  /** Category of amenity */
  category?: Maybe<Scalars['String']>;
  /** Amenity description */
  description: Scalars['String'];
  /** Icon of amenity */
  icon: CruiseOrderSummaryRatesPromotionIconInfoInput;
}


export enum CruiseBadgeTheme {
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  VIP = 'VIP'
}











/** A guest over the age of 2 */
export interface CruiseChildInput {
  /** The child's age in years */
  age: Scalars['Int'];
}






/** Duration of cruise to perform a cruise search */
export interface CruiseDurationRangeInput {
  max: Scalars['Int'];
  min: Scalars['Int'];
}



export enum CruiseFeature {
  LIVE_SHOPPING_USING_MSC_ADAPTER = 'LIVE_SHOPPING_USING_MSC_ADAPTER',
  MEMBER_DEALS = 'MEMBER_DEALS',
  MEMBER_DEALS_FOR_NON_MEMBERS = 'MEMBER_DEALS_FOR_NON_MEMBERS'
}

export enum CruiseFilterType {
  /** cabin experience - eg. Suite  */
  CABIN = 'CABIN',
  /** departure port */
  DEPARTURE = 'DEPARTURE',
  /** use for filtering by the destination */
  DESTINATION = 'DESTINATION',
  /** length of cruise nights 1-2, 3-5, 6-9 , 10-14, 15+ */
  LENGTH = 'LENGTH',
  /** use for filtering by the cruise line name */
  NAME = 'NAME',
  /** default not set value */
  NOT_SET = 'NOT_SET',
  /** ship type */
  SHIP = 'SHIP',
  /** use for ocean cruise */
  THEME_OCEAN = 'THEME_OCEAN',
  /** use for river cruise */
  THEME_RIVER = 'THEME_RIVER'
}










/** Cruise line policy */
export interface CruiseLinePolicyInput {
  /** Link to the policy page */
  link?: Maybe<Scalars['String']>;
}















/** Represents the promotion details */
export interface CruiseOrderSummaryPromotionDetailsInput {
  /** Amenity associated with a promotion */
  amenityInfo: CruiseAmenityInfoInput;
  /** Cruise line cancellation policy */
  cancellationPolicy?: Maybe<CruiseLinePolicyInput>;
  /** Instructions with a promotion */
  cruiseOrderSummaryPromotionInstruction?: Maybe<CruiseOrderSummaryPromotionInstructionInput>;
  /** Policies with a promotion */
  cruiseOrderSummaryPromotionPolicy?: Maybe<CruiseOrderSummaryPromotionPolicyInput>;
}



/** Expando showing already included amenities */
export interface CruiseOrderSummaryPromotionExpandoInput {
  /** Represents the amenities in the sailing */
  amenitiesList?: Maybe<CruiseAmenitiesListInput>;
}



/** Represents the promotion instruction */
export interface CruiseOrderSummaryPromotionInstructionInput {
  /** Code of the promotion */
  promotionCode: Scalars['String'];
  /** Name of the promotion */
  promotionName: Scalars['String'];
  /** Details about the promotion instruction */
  text: Scalars['String'];
  /** Title of the promotion instruction */
  title: Scalars['String'];
}



/** Represents the promotion policy */
export interface CruiseOrderSummaryPromotionPolicyInput {
  /** Description of the promotion policy */
  text: Scalars['String'];
  /** Title of the promotion policy */
  title: Scalars['String'];
}




/** Promotion details side sheet in the Order Summary page */
export interface CruiseOrderSummaryPromotionSideSheetInput {
  /** List of promotion details */
  cruiseOrderSummaryPromotionDetails: Array<CruiseOrderSummaryPromotionDetailsInput>;
  /** Already included amenities expando */
  expando: CruiseOrderSummaryPromotionExpandoInput;
  /** Terms and conditions link */
  termsAndConditions?: Maybe<CruiseOrderSummaryPromotionTermsAndConditionsInput>;
  /** Description of the promotions */
  text?: Maybe<Array<Scalars['String']>>;
}



/** Promotion details side sheet in the Order Summary page */
export interface CruiseOrderSummaryPromotionTermsAndConditionsInput {
  /** Terms and conditions link */
  link?: Maybe<CruiseOrderSummaryRatesUiLinkActionInfoInput>;
}



export interface CruiseOrderSummaryRatesInfoInput {
  /** Offer token */
  offerToken: Scalars['String'];
  /** Price Info */
  price: CruiseOrderSummaryRatesPriceInput;
  /** Promotion details side sheet */
  promotionDetails?: Maybe<CruiseOrderSummaryPromotionSideSheetInput>;
  /** Promotions Info */
  promotions: Array<CruiseOrderSummaryRatesPromotionInfoInput>;
  /** Update info */
  updateInfo?: Maybe<CruiseOrderSummaryRatesUpdateInfoInput>;
}


export interface CruiseOrderSummaryRatesInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Cabin experience */
  cabinExperience: Scalars['String'];
  /** Cabin type */
  cabinType: Scalars['String'];
  /** children ages */
  childAges?: Maybe<Array<CruiseChildInput>>;
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
  /** Lead in price shown to the user in infosite sidesheet */
  leadInPrice?: Maybe<Scalars['Float']>;
  /** Sailing token */
  sailingToken: Scalars['String'];
}



export interface CruiseOrderSummaryRatesPageDataInput {
  /** Info about rates displayed on the page. */
  ratesInfo: Array<CruiseOrderSummaryRatesInfoInput>;
  /** Index of the rate selected by the user */
  selectedRateIndex: Scalars['Int'];
}


export interface CruiseOrderSummaryRatesPriceChangeMessageInput {
  /** New price */
  newPrice: Scalars['String'];
  /** Old price */
  oldPrice: Scalars['String'];
  /** Type of change, increase/decrease */
  type: Scalars['String'];
}


export interface CruiseOrderSummaryRatesPriceInput {
  /** Base fare Info */
  baseFare?: Maybe<CurrencyTypeInput>;
  /** Cabin category title */
  cabinCategoryTitle: Scalars['String'];
  /** Cruise line code */
  cruiseLineCode?: Maybe<Scalars['String']>;
  /** Sold out rate flag */
  isSoldOut: Scalars['Boolean'];
  /** Member pricing Info */
  memberPricing: MemberPricingInput;
  /** Price Info */
  price?: Maybe<CurrencyAmountTypeInput>;
}


export interface CruiseOrderSummaryRatesPromotionIconInfoInput {
  /** Description of the Icon */
  description: Scalars['String'];
  /** Id of the Icon */
  id: Scalars['String'];
  /** Token of the Icon */
  token: Scalars['String'];
}


export interface CruiseOrderSummaryRatesPromotionInfoInput {
  /** Full Name of the promotion */
  fullName: Scalars['String'];
  /** Icon of the promotion */
  icon: CruiseOrderSummaryRatesPromotionIconInfoInput;
}




export interface CruiseOrderSummaryRatesUiLinkActionInfoInput {
  /** Url link */
  url: Scalars['String'];
}




export interface CruiseOrderSummaryRatesUpdateInfoInput {
  /** Price change message to display on the rate */
  priceChangeMessage?: Maybe<CruiseOrderSummaryRatesPriceChangeMessageInput>;
}
















export interface CruiseRequestContextInput {
  /** Cruise features enum to be passed down to cruise supply services as a header value */
  cruiseFeatures?: Maybe<Array<CruiseFeature>>;
  /** Default current to be used. If not set, cruise api will fall back to USD */
  defaultCurrency?: Maybe<Scalars['String']>;
  /** Inventory is striped by an optional franchise model key. More info here: https://confluence.expedia.biz/display/EWECruise/Design%3A+Franchise+Model+Key+Management */
  franchiseModelKey?: Maybe<Scalars['String']>;
  /** Flag that is set when the user is shopping as an agent from Partner Central */
  isAgent?: Maybe<Scalars['Boolean']>;
}




export interface CruiseSailingCabinCategoriesInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Cabin experience */
  cabinExperience: Scalars['String'];
  /** children ages */
  childAges?: Maybe<Array<CruiseChildInput>>;
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
}




/** Property criteria needed to perform a cruise search */
export interface CruiseSearchCriteriaInput {
  primary: PrimaryCruiseCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}



export interface CruiseSearchFiltersInput {
  /** 1 or more cruise line codes separated by ',' delimiter  */
  cruiseLines?: Maybe<Scalars['String']>;
  /** 1 or more port codes separated by ',' delimiter  */
  departureLocations?: Maybe<Scalars['String']>;
  /** 1 or more deeplink destination names separated by ',' delimiter  */
  destinationNames?: Maybe<Scalars['String']>;
  /** Earliest departure date */
  earliestDeptDate?: Maybe<Scalars['String']>;
  /** CruiseFilterType enum name to describe the primary function of the SearchFilter */
  filterType: CruiseFilterType;
  /** Latest departure date */
  latestDeptDate?: Maybe<Scalars['String']>;
  /** Max length of sailing */
  maxLength?: Maybe<Scalars['String']>;
  /** Return sailings with member only offer */
  memberOnlyOffer?: Maybe<Scalars['Boolean']>;
  /** Min length of sailing */
  minLength?: Maybe<Scalars['String']>;
  /** 1 or more promotion codes separated by ',' delimiter  */
  promotionCode?: Maybe<Scalars['String']>;
  /** ocean or river */
  sailingVarieties?: Maybe<Scalars['String']>;
  /** 1 or more ship codes separated by ',' delimiter  */
  ships?: Maybe<Scalars['String']>;
  /** Cabin type filter. One of the ANY, INSIDE, OCEAN_VIEW, BALCONY or SUITE */
  superCategoryCode?: Maybe<Scalars['String']>;
}



/**
 * Values : popularity - sorts by Popularity
 * price - sorts by the offer price within all sailings returned
 * length - sorts by the sailing itinerary length, in days
 * departureDate - sorts by sailing departure/embarkation date
 * cruiseLine - sorts by cruise line name
 */
export interface CruiseSearchOptionsInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
  /** Limit of how many results will be returned. - Default is 20 */
  limit: Scalars['Int'];
  /** Limit of how many results will be skipped. - Default is 0 */
  offset?: Maybe<Scalars['Int']>;
  /** Field to sort results by - Default is departure-date */
  sortBy?: Maybe<Scalars['String']>;
}












export interface CurrencyAmountTypeInput {
  /** Amount in the currency. */
  amount?: Maybe<Scalars['Float']>;
  /** Currency code. */
  currencyCode?: Maybe<Scalars['String']>;
}




export interface CurrencyTypeInput {
  /** Default currency amount info */
  defaultCurrencyAmount?: Maybe<CurrencyAmountTypeInput>;
  /** Supply currency amount info */
  supplyCurrencyAmount?: Maybe<CurrencyAmountTypeInput>;
}










/** Gender of the customer */
export enum CustomerGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  UNKNOWN = 'UNKNOWN'
}











/** The button type of the Customer notification submit button */
export enum CustomerNotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  /** Type of primary button */
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  /** Type of secondary button */
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  /** Type of tertiary button */
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}




/** Represents the target of the link */
export enum CustomerNotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB'
}

/** Represents the link type */
export enum CustomerNotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}



/** The display type of the Customer notification message */
export enum CustomerNotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum CustomerNotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}

export enum CustomerNotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = 'INVALID_INPUT',
  /** SERVICE_ERROR message */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** SUCCESS message */
  SUCCESS = 'SUCCESS'
}


/** Represents the attributes on a notification that could be changed after an interaction */
export interface CustomerNotificationModifiableAttributesInput {
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars['Boolean']>;
  /** Notification id */
  id?: Maybe<Scalars['String']>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars['Boolean']>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars['Boolean']>;
  /** Set to true when notification is starred */
  star?: Maybe<Scalars['Boolean']>;
}

/** Optional information to get a better contextual customer notification */
export interface CustomerNotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: Maybe<Scalars['String']>;
  /** list of journey criteria items */
  journeyCriterias?: Maybe<Array<CustomerNotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: Maybe<Scalars['URL']>;
  /** regionId number */
  regionId?: Maybe<Scalars['String']>;
  /** list of GAIA regionIds */
  regionIds?: Maybe<Array<Scalars['String']>>;
  /** trip folder id */
  tripFolderId?: Maybe<Scalars['String']>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: Maybe<DateRangeInput>;
  /** destination information */
  destination?: Maybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
  /** origin information */
  origin?: Maybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: Maybe<Scalars['String']>;
  /** property id */
  propertyId?: Maybe<Scalars['String']>;
  /** regionId number */
  regionId?: Maybe<Scalars['String']>;
}



/** The style to apply to phrase links */
export enum CustomerNotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}


/** The text style to apply to strings */
export enum CustomerNotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}








export enum CustomerNotificationType {
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  CITI_COBRAND = 'CITI_COBRAND',
  CITI_COBRAND_VERTICAL = 'CITI_COBRAND_VERTICAL',
  CLEANLINESS = 'CLEANLINESS',
  GDPR = 'GDPR',
  GENERIC = 'GENERIC',
  HEADER = 'HEADER',
  INBOX = 'INBOX',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  OSANO = 'OSANO',
  TAKEOVER = 'TAKEOVER',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY'
}

/** Represents the the user input for customer notification mutation */
export interface CustomerNotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<CustomerNotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface CustomerNotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars['String'];
  /** Represents the value of customer notification user input */
  value: Scalars['String'];
}





export enum DamageLiability {
  COF = 'COF',
  RDD = 'RDD'
}

export enum DashboardType {
  DEFERRED_PAYMENT = 'DEFERRED_PAYMENT',
  PERFORMANCE = 'PERFORMANCE'
}

/**
 * Used to identify the downstream data source.
 * ENTITY: A stateful data service driven by the owning domain
 * CART: Cart Service
 * OFFER: Offer Service
 * ORDER: Ordering Service
 * CHECKOUT: Core Checkout Identifying Service
 */
export enum DataSourceType {
  CART = 'CART',
  CHECKOUT = 'CHECKOUT',
  ENTITY = 'ENTITY',
  OFFER = 'OFFER',
  ORDER = 'ORDER'
}


/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: Scalars['Int'];
  /** The numeric month, e.g. `1` for January */
  month: Scalars['Int'];
  /** The four-digit year e.g. `1999` */
  year: Scalars['Int'];
}



/** A generic period of date, not tied to a checkin/out status. */
export interface DatePeriodInput {
  /** The bounding type of period, if defined, otherwise interpreted as a degenerate interval */
  bound?: Maybe<ClosedPeriodBounding>;
  /** The length of period */
  length: Scalars['Int'];
  /** The unit of period */
  unit: DatePeriodUnit;
}

/** The unit of date period */
export enum DatePeriodUnit {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  WEEKEND = 'WEEKEND'
}


/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}


/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: Scalars['Int'];
  /** The hour of the datetime */
  hour: Scalars['Int'];
  /** The minute of the hour */
  minute: Scalars['Int'];
  /** The numeric month of the date */
  month: Scalars['Int'];
  /** The second of the minute */
  second: Scalars['Int'];
  /** The four-digit year of the date */
  year: Scalars['Int'];
}




/** Type used during a product search to specify a given date. Usually this date would not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: Scalars['String'];
  value: DateInput;
}


export enum DealType {
  AARP = 'AARP',
  POINTS_PROMOTION = 'POINTS_PROMOTION'
}


/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: Array<ExposureInput>;
  /** ALTER mode */
  alterMode?: Maybe<AlterMode>;
}

export enum DeeplinkType {
  HSR = 'HSR',
  PDP = 'PDP'
}
























export interface DestinationHeadingCriteriaInput {
  /** Max number of images for the given destination. */
  imageLimit?: Maybe<Scalars['Int']>;
  /** Id of the destination. */
  placeId: Scalars['String'];
}


export interface DestinationImageDimensionsInput {
  height: Scalars['Int'];
  width: Scalars['Int'];
}


/** Contains detailed geographic information like the Gaia region id as well as the property ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: Maybe<CoordinatesInput>;
  /** List of coordinates of the map's bounding box. */
  mapBounds?: Maybe<Array<CoordinatesInput>>;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: Maybe<Scalars['String']>;
  /** List of property IDs to return search information for. */
  propertyIds?: Maybe<Array<Scalars['String']>>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: Maybe<Scalars['String']>;
}










/** Inputs for the destinationGroup query */
export interface DestinationRecommendationCriteriaInput {
  /** Max amount of cards to show */
  maxCards?: Maybe<Scalars['Int']>;
  /** Min amount of cards to show */
  minCards?: Maybe<Scalars['Int']>;
  /** Id of the origin destination */
  referencePlaceId: Scalars['String'];
  /** Strategy for place relationship */
  strategy: DestinationRecommendationStrategy;
  /** Type of destinations in the output */
  type: DestinationRecommendationPlaceType;
}





export enum DestinationRecommendationPlaceType {
  CITY = 'CITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI = 'POI'
}

/** Strategy to select the relationship of the output destinations and the origin */
export enum DestinationRecommendationStrategy {
  NEARBY = 'NEARBY',
  SIMILAR = 'SIMILAR',
  TOP = 'TOP'
}





/** Input for travelGuideRecommendation query */
export enum DestinationTravelGuidePolicy {
  PERSONALIZED = 'PERSONALIZED',
  USER_LOCATION = 'USER_LOCATION'
}





/** Device information */
export interface DeviceInput {
  type: DeviceType;
}

/** Valid device types */
export enum DeviceType {
  APP_PHONE = 'APP_PHONE',
  APP_TABLET = 'APP_TABLET',
  CHAT_APP = 'CHAT_APP',
  DESKTOP = 'DESKTOP',
  MOBILE_PHONE = 'MOBILE_PHONE',
  MOBILE_TABLET = 'MOBILE_TABLET',
  VOICE_APP = 'VOICE_APP'
}


export enum DialogButtonActionType {
  CLOSE_DIALOG = 'CLOSE_DIALOG',
  CREATE_TRACKING_MUTATION = 'CREATE_TRACKING_MUTATION',
  DISABLE_TRACKING_MUTATION = 'DISABLE_TRACKING_MUTATION',
  UPDATE_TRACKING_MUTATION = 'UPDATE_TRACKING_MUTATION'
}



/** Dimensions for a presentation object i.e. image or icon */
export interface DimensionsInput {
  density: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
}


















export enum DirectFeedbackPageDisplayConditionType {
  BOOL = 'BOOL',
  NONE = 'NONE',
  PATTERN = 'PATTERN',
  TEXT = 'TEXT'
}









export interface DirectFeedbackValuesInput {
  context: Array<GraphQlPairInput>;
  formValues: Array<GraphQlPairInput>;
}


/** A reference place or property for which to show directions to */
export interface DirectionsReferenceInput {
  /** The id of the reference place or property. */
  id: Scalars['String'];
  /** The type of reference, e.g. place, property, etc. */
  type: EgdsMapFeatureType;
}





/** Used as input value to let the server knows what data needs to be populated in a card. */
export enum DiscoveryCardContentSize {
  ABBREVIATED = 'ABBREVIATED',
  FOUNDATION = 'FOUNDATION',
  LONG_FORM = 'LONG_FORM',
  SHORT_FORM = 'SHORT_FORM',
  UBER_ABBREVIATED = 'UBER_ABBREVIATED',
  UBER_ABBREVIATED_PRICE = 'UBER_ABBREVIATED_PRICE',
  UBER_ABBREVIATED_RATING = 'UBER_ABBREVIATED_RATING'
}



export enum DiscoveryContainerType {
  CAROUSEL = 'CAROUSEL',
  EXPANDO = 'EXPANDO'
}

/** Represent the context for a destination (eg. information in a landing page). */
export interface DiscoveryDestinationContextInput {
  placeId?: Maybe<DiscoveryPlaceIdInput>;
}






/** Represent the context for lodging (eg. information in a PDP) */
export interface DiscoveryLodgingContextInput {
  checkin?: Maybe<DateInput>;
  checkout?: Maybe<DateInput>;
  propertyId?: Maybe<Scalars['String']>;
  rooms?: Maybe<Array<DiscoveryRoomInput>>;
  searchCriteria?: Maybe<ShoppingSearchCriteriaInput>;
}



/** List of all the managed offering types. */
export enum DiscoveryOfferingType {
  DESTINATION = 'DESTINATION',
  PRODUCT = 'PRODUCT'
}


/** Identifier for a destination, it can contains also the type of a destination (neighborhood, city, airport, etc...) */
export interface DiscoveryPlaceIdInput {
  id: Scalars['String'];
  type?: Maybe<Scalars['String']>;
}

export interface DiscoveryRecentActivityContextInput {
  lodging?: Maybe<DiscoveryLodgingContextInput>;
  marketingChannelTypeCode?: Maybe<Scalars['Int']>;
  outputLineOfBusiness: LineOfBusinessDomain;
}

/** Context values a client can/should fill as input of the recommendations. */
export interface DiscoveryRecommendationContextInput {
  destination?: Maybe<DiscoveryDestinationContextInput>;
  lodging?: Maybe<DiscoveryLodgingContextInput>;
  orderId?: Maybe<Scalars['String']>;
  outputLineOfBusiness?: Maybe<LineOfBusinessDomain>;
}

/** Used to select which parameters should be used to run the inference. */
export enum DiscoveryRecommendationInputContext {
  /** Uses the 'destination' section from the context object. */
  DESTINATION = 'DESTINATION',
  /** Uses the 'orderId' section from the context object. */
  ORDER = 'ORDER',
  /** Uses the 'product' section from the context object. */
  PRODUCT = 'PRODUCT',
  /** Personalize the recommendations using the latest products a user saw. */
  RECENTLY_VIEWED_PRODUCT = 'RECENTLY_VIEWED_PRODUCT',
  /** Personalize the recommendations using the recent searches of the user. */
  RECENT_SEARCHES = 'RECENT_SEARCHES',
  /** Base the recommendations on the user location. */
  USER_LOCATION = 'USER_LOCATION'
}

/** List of all the managed recommendations strategies. */
export enum DiscoveryRecommendationStrategy {
  ALTERNATIVE = 'ALTERNATIVE',
  NEARBY = 'NEARBY',
  POPULAR = 'POPULAR',
  SIMILAR = 'SIMILAR'
}

/** Represent a room for lodging. */
export interface DiscoveryRoomInput {
  adults: Scalars['Int'];
  children?: Maybe<Array<Scalars['Int']>>;
}





/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = 'KILOMETER',
  MILE = 'MILE'
}







/** Different types of duration span input validations. */
export enum DurationSpanValidationType {
  /** Used to validate that a maximum input value is greater than a minimum input value. */
  MAXIMUM_GREATER_THAN_MINIMUM = 'MAXIMUM_GREATER_THAN_MINIMUM',
  /** Used to validate that the user input is less than or equal to some specified value. Example: Maximum 10 nights. */
  MAXIMUM_VALUE = 'MAXIMUM_VALUE',
  /** Used to validate that a minimum input value is less than a maximum input value. */
  MINIMUM_LESS_THAN_MAXIMUM = 'MINIMUM_LESS_THAN_MAXIMUM',
  /** Used to validate that the user input is greater than or equal to some specified value. Example: Minimum 2 nights. */
  MINIMUM_VALUE = 'MINIMUM_VALUE',
  /** Used to validate that the user input has a value. */
  REQUIRED_VALUE = 'REQUIRED_VALUE'
}





































/** Styles established in EGDS design docs. https://www.figma.com/file/bbPtPOgPN4sttR3BzDaTZc/Buttons */
export enum EgdsButtonStyle {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}



/**
 * Represents the variations of a card. Can be used with EGDSCard union members.
 * https://www.figma.com/file/M3udFrUojCRwrcoAiPnQ3Yaw/Card?node-id=11143%3A833&t=blroVUeSfs4Eqnoj-0
 */
export enum EgdsCardThemes {
  BORDERED = 'BORDERED',
  PADDED = 'PADDED'
}







/** Defines how checkbox state should be displayed on client. */
export enum EgdsCheckBoxState {
  CHECKED = 'CHECKED',
  INDETERMINATE = 'INDETERMINATE',
  UNCHECKED = 'UNCHECKED'
}













/** Represents the label theme for the date range result. */
export enum EgdsDateRangeResultTheme {
  LINK = 'LINK',
  POSITIVE = 'POSITIVE'
}

/** Represents short day name. */
export enum EgdsDayName {
  FRI = 'FRI',
  MON = 'MON',
  SAT = 'SAT',
  SUN = 'SUN',
  THU = 'THU',
  TUE = 'TUE',
  WED = 'WED'
}

/** Represents the type of decorative in the text element. e.g. superscript */
export enum EgdsDecorativeText {
  /** Renders with a line through the text */
  LINE_THROUGH = 'LINE_THROUGH',
  /** Renders as a subscript at the bottom of the text line */
  SUBSCRIPT = 'SUBSCRIPT',
  /** Renders as a superscript at the top of the text line */
  SUPERSCRIPT = 'SUPERSCRIPT',
  /** Renders with a line under the text */
  UNDERLINE = 'UNDERLINE'
}






















/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSHeading or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EgdsHeadingStyle {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  H7 = 'H7',
  H8 = 'H8'
}

/** Represents where the icon should be places in a EGDS Standard Link */
export enum EgdsIconPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}






/** Option for selecting an infant seat on a plane. */
export enum EgdsInfantSeat {
  IN_SEAT = 'IN_SEAT',
  ON_LAP = 'ON_LAP'
}









/** Represents the size of the text in a EGDS Standard Link */
export enum EgdsLinkSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}











/** The type of feature - PLACE OR PROPERTY */
export enum EgdsMapFeatureType {
  PLACE = 'PLACE',
  PROPERTY = 'PROPERTY'
}

/** The initial viewport to use for the map when markers have been pushed and just before they are rendered */
export enum EgdsMapInitialViewport {
  /** To use bounds value as initial viewport */
  BOUNDS = 'BOUNDS',
  /** To compute a bound from a set of options with a specified center */
  CENTERED_COMPUTED_BOUNDS = 'CENTERED_COMPUTED_BOUNDS',
  /** To use zoom and center values as initial viewport */
  CENTER_AND_ZOOM = 'CENTER_AND_ZOOM',
  /** To compute a bound from a set of options */
  COMPUTED_BOUNDS = 'COMPUTED_BOUNDS',
  /** Will center the map to show all markers pushed to the map */
  FIT_MARKERS = 'FIT_MARKERS'
}


/** Marker pin style based on the applied filter and inventory - AVAILABLE, FILTERED, SOLD_OUT or UNKNOWN */
export enum EgdsMapMarkerStatus {
  AVAILABLE = 'AVAILABLE',
  FILTERED = 'FILTERED',
  SOLD_OUT = 'SOLD_OUT',
  UNKNOWN = 'UNKNOWN'
}

/** 'zoomAndCenter' (requires zoom + center) or 'fitBounds' (map will include all rendered markers) */
export enum EgdsMapPositionMode {
  FIT_BOUNDS = 'FIT_BOUNDS',
  ZOOM_AND_CENTER = 'ZOOM_AND_CENTER'
}

/** type of maps that can be used */
export enum EgdsMapProvider {
  GOOGLE = 'GOOGLE',
  MAPBOX = 'MAPBOX',
  MAPKIT = 'MAPKIT'
}

export enum EgdsMark {
  AARP = 'AARP',
  AARP_MEMBER_BENEFITS = 'AARP_MEMBER_BENEFITS',
  ADDON = 'ADDON',
  AIR_NEW_ZEALAND = 'AIR_NEW_ZEALAND',
  APPLE = 'APPLE',
  APPLE_MAPS = 'APPLE_MAPS',
  APP_CTX = 'APP_CTX',
  APP_EBOOK = 'APP_EBOOK',
  APP_EXP = 'APP_EXP',
  APP_HOTWIRE = 'APP_HOTWIRE',
  APP_ORB = 'APP_ORB',
  APP_TVLY = 'APP_TVLY',
  APP_WOTIF = 'APP_WOTIF',
  BONUS_EBOOK = 'BONUS_EBOOK',
  COMMISSION_TIER_FOUR = 'COMMISSION_TIER_FOUR',
  COMMISSION_TIER_ONE = 'COMMISSION_TIER_ONE',
  COMMISSION_TIER_THREE = 'COMMISSION_TIER_THREE',
  COMMISSION_TIER_TWO = 'COMMISSION_TIER_TWO',
  FACEBOOK = 'FACEBOOK',
  FLAGS__AR = 'FLAGS__AR',
  FLAGS__AS = 'FLAGS__AS',
  FLAGS__AT = 'FLAGS__AT',
  FLAGS__AU = 'FLAGS__AU',
  FLAGS__BE = 'FLAGS__BE',
  FLAGS__BO = 'FLAGS__BO',
  FLAGS__BR = 'FLAGS__BR',
  FLAGS__BZ = 'FLAGS__BZ',
  FLAGS__CA = 'FLAGS__CA',
  FLAGS__CH = 'FLAGS__CH',
  FLAGS__CL = 'FLAGS__CL',
  FLAGS__CN = 'FLAGS__CN',
  FLAGS__CO = 'FLAGS__CO',
  FLAGS__CR = 'FLAGS__CR',
  FLAGS__CZ = 'FLAGS__CZ',
  FLAGS__DE = 'FLAGS__DE',
  FLAGS__DK = 'FLAGS__DK',
  FLAGS__EC = 'FLAGS__EC',
  FLAGS__EE = 'FLAGS__EE',
  FLAGS__EG = 'FLAGS__EG',
  FLAGS__ES = 'FLAGS__ES',
  FLAGS__EU = 'FLAGS__EU',
  FLAGS__FI = 'FLAGS__FI',
  FLAGS__FR = 'FLAGS__FR',
  FLAGS__GR = 'FLAGS__GR',
  FLAGS__GT = 'FLAGS__GT',
  FLAGS__GY = 'FLAGS__GY',
  FLAGS__HK = 'FLAGS__HK',
  FLAGS__HN = 'FLAGS__HN',
  FLAGS__HR = 'FLAGS__HR',
  FLAGS__HU = 'FLAGS__HU',
  FLAGS__ID = 'FLAGS__ID',
  FLAGS__IE = 'FLAGS__IE',
  FLAGS__IL = 'FLAGS__IL',
  FLAGS__IN = 'FLAGS__IN',
  FLAGS__IS = 'FLAGS__IS',
  FLAGS__IT = 'FLAGS__IT',
  FLAGS__JP = 'FLAGS__JP',
  FLAGS__KR = 'FLAGS__KR',
  FLAGS__L1 = 'FLAGS__L1',
  FLAGS__LT = 'FLAGS__LT',
  FLAGS__LV = 'FLAGS__LV',
  FLAGS__MX = 'FLAGS__MX',
  FLAGS__MY = 'FLAGS__MY',
  FLAGS__NI = 'FLAGS__NI',
  FLAGS__NL = 'FLAGS__NL',
  FLAGS__NO = 'FLAGS__NO',
  FLAGS__NZ = 'FLAGS__NZ',
  FLAGS__PA = 'FLAGS__PA',
  FLAGS__PE = 'FLAGS__PE',
  FLAGS__PH = 'FLAGS__PH',
  FLAGS__PL = 'FLAGS__PL',
  FLAGS__PT = 'FLAGS__PT',
  FLAGS__PY = 'FLAGS__PY',
  FLAGS__RU = 'FLAGS__RU',
  FLAGS__SA = 'FLAGS__SA',
  FLAGS__SE = 'FLAGS__SE',
  FLAGS__SG = 'FLAGS__SG',
  FLAGS__SK = 'FLAGS__SK',
  FLAGS__SR = 'FLAGS__SR',
  FLAGS__SV = 'FLAGS__SV',
  FLAGS__TH = 'FLAGS__TH',
  FLAGS__TR = 'FLAGS__TR',
  FLAGS__TW = 'FLAGS__TW',
  FLAGS__UA = 'FLAGS__UA',
  FLAGS__UAE = 'FLAGS__UAE',
  FLAGS__UK = 'FLAGS__UK',
  FLAGS__US = 'FLAGS__US',
  FLAGS__UY = 'FLAGS__UY',
  FLAGS__VE = 'FLAGS__VE',
  FLAGS__VN = 'FLAGS__VN',
  FLAGS__WW = 'FLAGS__WW',
  FLAGS__ZA = 'FLAGS__ZA',
  GOOGLE = 'GOOGLE',
  GOOGLE_LOGO = 'GOOGLE_LOGO',
  GOOGLE_MAP = 'GOOGLE_MAP',
  GOOGLE_TRANSLATED = 'GOOGLE_TRANSLATED',
  HAWAIIAN = 'HAWAIIAN',
  HOTWIRE_HOTRATE_CIRCLE = 'HOTWIRE_HOTRATE_CIRCLE',
  LINE = 'LINE',
  LOYALTY_HOTELS__HIGH_TIER = 'LOYALTY_HOTELS__HIGH_TIER',
  LOYALTY_HOTELS__LOW_TIER = 'LOYALTY_HOTELS__LOW_TIER',
  LOYALTY_HOTELS__MIDDLE_TIER = 'LOYALTY_HOTELS__MIDDLE_TIER',
  LOYALTY_HOTELS__REWARDS = 'LOYALTY_HOTELS__REWARDS',
  LOYALTY_HOTELS__STAMP_EMPTY = 'LOYALTY_HOTELS__STAMP_EMPTY',
  LOYALTY_HOTELS__STAMP_PENDING = 'LOYALTY_HOTELS__STAMP_PENDING',
  LOYALTY_HOTELS__STAMP_SEARCHED = 'LOYALTY_HOTELS__STAMP_SEARCHED',
  LOYALTY_TVLY = 'LOYALTY_TVLY',
  MAPBOX = 'MAPBOX',
  MIP_PRIMARY = 'MIP_PRIMARY',
  MIP_REVERSE = 'MIP_REVERSE',
  MIP_SECONDARY = 'MIP_SECONDARY',
  MOD_CTX = 'MOD_CTX',
  MOD_EBOOK = 'MOD_EBOOK',
  MOD_EXP = 'MOD_EXP',
  MOD_HOTELS = 'MOD_HOTELS',
  MOD_ORB = 'MOD_ORB',
  MOD_TVLY = 'MOD_TVLY',
  MOD_WOTIF = 'MOD_WOTIF',
  NAVER = 'NAVER',
  ONEKEY__ABRITEL = 'ONEKEY__ABRITEL',
  ONEKEY__BLUE = 'ONEKEY__BLUE',
  ONEKEY__BOOKABACH = 'ONEKEY__BOOKABACH',
  ONEKEY__CASH = 'ONEKEY__CASH',
  ONEKEY__EXPEDIA = 'ONEKEY__EXPEDIA',
  ONEKEY__FEWODIREKT = 'ONEKEY__FEWODIREKT',
  ONEKEY__GOLD = 'ONEKEY__GOLD',
  ONEKEY__HOTELS__CHINESE = 'ONEKEY__HOTELS__CHINESE',
  ONEKEY__HOTELS__ENGLISH = 'ONEKEY__HOTELS__ENGLISH',
  ONEKEY__HOTELS__PORTUGUESE = 'ONEKEY__HOTELS__PORTUGUESE',
  ONEKEY__HOTELS__SPANISH = 'ONEKEY__HOTELS__SPANISH',
  ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT = 'ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT',
  ONEKEY__PLATINUM = 'ONEKEY__PLATINUM',
  ONEKEY__SILVER = 'ONEKEY__SILVER',
  ONEKEY__STANDARD = 'ONEKEY__STANDARD',
  ONEKEY__STANDARD__ALWAYS_LIGHT = 'ONEKEY__STANDARD__ALWAYS_LIGHT',
  ONEKEY__STAYZ = 'ONEKEY__STAYZ',
  ONEKEY__VRBO = 'ONEKEY__VRBO',
  ONEKEY__WORDMARK = 'ONEKEY__WORDMARK',
  ONEKEY__WORDMARK__ALWAYS_LIGHT = 'ONEKEY__WORDMARK__ALWAYS_LIGHT',
  PAYMENT__7_ELEVEN = 'PAYMENT__7_ELEVEN',
  PAYMENT__AFFIRM = 'PAYMENT__AFFIRM',
  PAYMENT__AIRPLUS = 'PAYMENT__AIRPLUS',
  PAYMENT__ALIPAY = 'PAYMENT__ALIPAY',
  PAYMENT__AMEX = 'PAYMENT__AMEX',
  PAYMENT__APPLEPAY = 'PAYMENT__APPLEPAY',
  PAYMENT__CHASE = 'PAYMENT__CHASE',
  PAYMENT__CLICKTOPAY = 'PAYMENT__CLICKTOPAY',
  PAYMENT__DINERS_CLUB_INTERNATIONAL = 'PAYMENT__DINERS_CLUB_INTERNATIONAL',
  PAYMENT__DISCOVER = 'PAYMENT__DISCOVER',
  PAYMENT__GOOGLE_PAY = 'PAYMENT__GOOGLE_PAY',
  PAYMENT__IDEAL = 'PAYMENT__IDEAL',
  PAYMENT__JAPAN_CREDIT_BUREAU = 'PAYMENT__JAPAN_CREDIT_BUREAU',
  PAYMENT__KLARNA = 'PAYMENT__KLARNA',
  PAYMENT__MAESTRO = 'PAYMENT__MAESTRO',
  PAYMENT__MASTERCARD = 'PAYMENT__MASTERCARD',
  PAYMENT__MASTERPASS = 'PAYMENT__MASTERPASS',
  PAYMENT__PAYPAL = 'PAYMENT__PAYPAL',
  PAYMENT__SAMSUNG_CARD = 'PAYMENT__SAMSUNG_CARD',
  PAYMENT__UATP = 'PAYMENT__UATP',
  PAYMENT__UNION_PAY = 'PAYMENT__UNION_PAY',
  PAYMENT__VISA = 'PAYMENT__VISA',
  PLUS_CIRCLE = 'PLUS_CIRCLE',
  PLUS_CIRCLE_CTX = 'PLUS_CIRCLE_CTX',
  PLUS_CIRCLE_EBOOK = 'PLUS_CIRCLE_EBOOK',
  PLUS_CIRCLE_ORB = 'PLUS_CIRCLE_ORB',
  PLUS_CIRCLE_TVLY = 'PLUS_CIRCLE_TVLY',
  PLUS_CIRCLE_WOTIF = 'PLUS_CIRCLE_WOTIF',
  PREMIUM_TVLY = 'PREMIUM_TVLY',
  REWARDS_ORB = 'REWARDS_ORB',
  TRIPADVISOR = 'TRIPADVISOR',
  TRIVAGO = 'TRIVAGO',
  VAP_HOTELS__HIGH_TIER = 'VAP_HOTELS__HIGH_TIER',
  VAP_HOTELS__LOW_TIER = 'VAP_HOTELS__LOW_TIER',
  VAP_HOTELS__MIDDLE_TIER = 'VAP_HOTELS__MIDDLE_TIER',
  VIP_BEX = 'VIP_BEX',
  VIP_CIRCLE_BEX = 'VIP_CIRCLE_BEX',
  VIP_CIRCLE_EBOOKERS = 'VIP_CIRCLE_EBOOKERS',
  VIP_CIRCLE_HOTELS = 'VIP_CIRCLE_HOTELS',
  VIP_CIRCLE_ORBITZ = 'VIP_CIRCLE_ORBITZ',
  VIP_EBOOKERS = 'VIP_EBOOKERS',
  VIP_ORBITZ = 'VIP_ORBITZ',
  VIRGIN_AU = 'VIRGIN_AU',
  VRBO = 'VRBO'
}





















/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSParagraph or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EgdsParagraphStyle {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3'
}


/** The type of path for directions */
export enum EgdsPathType {
  CYCLING = 'CYCLING',
  DRIVING = 'DRIVING',
  FLYING = 'FLYING',
  TRANSIT = 'TRANSIT',
  WALKING = 'WALKING'
}

/** Possible camera movement for the photosphere image */
export enum EgdsPhotosphereCameraMovement {
  AUTO_PAN = 'AUTO_PAN',
  DISABLED = 'DISABLED',
  FULL_MOVE = 'FULL_MOVE'
}






































/** Type of EGDSSheet */
export enum EgdsSheetType {
  BOTTOM = 'BOTTOM',
  CENTERED = 'CENTERED',
  FULLSCREEN = 'FULLSCREEN',
  POPOVER = 'POPOVER',
  SIDE = 'SIDE'
}

































export enum EgdsTextListItemStyle {
  DEFAULT = 'DEFAULT',
  EMPHASIS = 'EMPHASIS',
  LOYALTY = 'LOYALTY',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}


/** https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export enum EgdsTextListSize {
  LIST_1 = 'LIST_1',
  LIST_2 = 'LIST_2',
  LIST_3 = 'LIST_3'
}

/**
 * This represents UI variations of EGDS List
 *        figma: https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857
 */
export enum EgdsTextListType {
  BULLET = 'BULLET',
  ICON = 'ICON',
  NO_BULLET = 'NO_BULLET',
  NUMBER = 'NUMBER'
}

















/** Represents different type of travelers validation. */
export enum EgdsTravelersValidationType {
  /** Used to validate child age required. */
  CHILD_AGE_REQUIRED = 'CHILD_AGE_REQUIRED',
  /** Used to validate maximum number of allowed infants in seat. */
  MANY_INFANT_IN_SEAT = 'MANY_INFANT_IN_SEAT',
  /** Used to validate maximum number of allowed infants on lap. */
  MANY_INFANT_ON_LAP = 'MANY_INFANT_ON_LAP',
  /** Used to validate maximum allowed travelers for search. */
  MAX_TRAVELERS = 'MAX_TRAVELERS'
}



/** Defines how typeahead results should be displayed on client. */
export enum EgdsTypeaheadRenderType {
  ADAPTIVE = 'ADAPTIVE',
  DIALOG = 'DIALOG',
  MENU = 'MENU'
}



/**
 * Used to specify event type for an interaction.
 * See https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/referrer.json#L26
 */
export enum EgReferrerEventType {
  /** Used to track a click on a UI component. */
  CLICK = 'CLICK',
  /** Used to track an impression of a UI component. */
  IMPRESSION = 'IMPRESSION'
}












































export enum EmptyStateType {
  ENABLE_PUSH = 'ENABLE_PUSH',
  EXPLORE_TRIPS = 'EXPLORE_TRIPS',
  SIGN_IN = 'SIGN_IN'
}








/**
 * "The `EssentialInfoItemInput` contains essentialInfoItemId along with bookingItemID separated by -. eg. 1-4020303
 * essentialInfoItemId identifies which essential info to render and bookingItemID is used as an parameter to lodgingDemandReservationService's getVrStayEssentialInfo API
 */
export interface EssentialInfoItemInput {
  itemId: Scalars['String'];
}


export enum EventType {
  DELETETRIPALERTPRESENTED = 'DeleteTripAlertPresented',
  DELETETRIPDIALOGPRESENTED = 'DeleteTripDialogPresented',
  DELETETRIPERRORTOASTPRESENTED = 'DeleteTripErrorToastPresented',
  DELETETRIPFAILED = 'DeleteTripFailed',
  DELETETRIPSUCCEEDED = 'DeleteTripSucceeded',
  DELETETRIPSUCCESSTOASTPRESENTED = 'DeleteTripSuccessToastPresented',
  HEROMODULECAMPAIGN = 'HeroModuleCampaign',
  HEROMODULECOLDSTART = 'HeroModuleColdStart',
  ITINACTIVECAR = 'ItinActiveCar',
  ITINACTIVECRUISE = 'ItinActiveCruise',
  ITINACTIVEFLIGHT = 'ItinActiveFlight',
  ITINACTIVEGT = 'ItinActiveGT',
  ITINACTIVEHOTEL = 'ItinActiveHotel',
  ITINACTIVELX = 'ItinActiveLX',
  ITINACTIVEPACKAGEFH = 'ItinActivePackageFH',
  ITINACTIVERAIL = 'ItinActiveRail',
  ITINCANCELLATION = 'ItinCancellation',
  MOVEITEMDRAWERPRESENTED = 'MoveItemDrawerPresented',
  MOVEITEMERRORTOASTPRESENTED = 'MoveItemErrorToastPresented',
  MOVEITEMSUBMITTED = 'MoveItemSubmitted',
  MOVEITEMSUCCESSTOASTPRESENTED = 'MoveItemSuccessToastPresented',
  MOVEITEMSUCEEDED = 'MoveItemSuceeded',
  MOVELINKEDITEMSDIALOGPRESENTED = 'MoveLinkedItemsDialogPresented',
  REMOVEITEMDIALOGPRESENTED = 'RemoveItemDialogPresented',
  TRIPITEMMENUPRESENTED = 'TripItemMenuPresented',
  TRIPSIGNINDIALOGPRESENTED = 'TripSignInDialogPresented',
  TRIPSCOLLABINVITECONFIRMATIONVIEWED = 'TripsCollabInviteConfirmationViewed',
  TRIPSCOLLABINVITEFAILUREVIEWED = 'TripsCollabInviteFailureViewed',
  TRIPSCOLLABINVITESUCCEEDED = 'TripsCollabInviteSucceeded',
  TRIPSCOLLABJOINGROUPFAILED = 'TripsCollabJoinGroupFailed',
  TRIPSCOLLABJOINGROUPSUCCEEDED = 'TripsCollabJoinGroupSucceeded',
  TRIPSCOLLABJOINTRIPCONFIRMATIONVIEWED = 'TripsCollabJoinTripConfirmationViewed',
  TRIPSCOLLABJOINTRIPERRORTOASTPRESENTED = 'TripsCollabJoinTripErrorToastPresented',
  TRIPSCOLLABLANDINGSCREENREDIRECTTOTRIPOVERVIEW = 'TripsCollabLandingScreenRedirectToTripOverView',
  TRIPSCOLLABLANDINGSCREENVIEWED = 'TripsCollabLandingScreenViewed',
  TRIPSCOLLABMANAGEGROUPVIEWED = 'TripsCollabManageGroupViewed',
  TRIPSCOLLABVIEWPRESENTEDACTIVITIES = 'TripsCollabViewPresentedActivities',
  TRIPSCOLLABVIEWPRESENTEDCARS = 'TripsCollabViewPresentedCars',
  TRIPSCOLLABVIEWPRESENTEDCRUISE = 'TripsCollabViewPresentedCruise',
  TRIPSCOLLABVIEWPRESENTEDFLIGHT = 'TripsCollabViewPresentedFlight',
  TRIPSCOLLABVIEWPRESENTEDHOTEL = 'TripsCollabViewPresentedHotel',
  TRIPSCOLLABVIEWPRESENTEDVACATIONRENTAL = 'TripsCollabViewPresentedVacationRental',
  TRIPSEDITITEMSUCCEEDED = 'TripsEditItemSucceeded',
  TRIPSEDITTRIPERRORTOASTPRESENTED = 'TripsEditTripErrorToastPresented',
  TRIPSEDITTRIPPRESENTED = 'TripsEditTripPresented',
  TRIPSEDITTRIPSUBMITTED = 'TripsEditTripSubmitted',
  TRIPSEDITTRIPSUCCESSTOASTPRESENTED = 'TripsEditTripSuccessToastPresented',
  TRIPSFLIGHTSCHEDULECHANGEBANNERDISPLAYED = 'TripsFlightScheduleChangeBannerDisplayed',
  TRIPSHEROMODULECURRENTTRIP = 'TripsHeroModuleCurrentTrip',
  TRIPSHEROMODULEPOSSIBLEACTIVITYTRIP = 'TripsHeroModulePossibleActivityTrip',
  TRIPSHEROMODULEPOSSIBLEAIRTRIP = 'TripsHeroModulePossibleAirTrip',
  TRIPSHEROMODULEPOSSIBLECARTRIP = 'TripsHeroModulePossibleCarTrip',
  TRIPSHEROMODULEPOSSIBLEHOTELTRIP = 'TripsHeroModulePossibleHotelTrip',
  TRIPSHEROMODULEPOSSIBLEPACKAGEHFTRIP = 'TripsHeroModulePossiblePackageHFTrip',
  TRIPSHEROMODULEPOSSIBLETRIP = 'TripsHeroModulePossibleTrip',
  TRIPSHEROMODULEPOTENTIALTRIP = 'TripsHeroModulePotentialTrip',
  TRIPSHEROMODULEUPCOMINGTRIP = 'TripsHeroModuleUpcomingTrip',
  TRIPSITEMDETAILVIEWED = 'TripsItemDetailViewed',
  TRIPSLISTVIEWED = 'TripsListViewed',
  TRIPSMODULEDESTINATIONGUIDE = 'TripsModuleDestinationGuide',
  TRIPSMODULERECOMMENDEDACTIVITY = 'TripsModuleRecommendedActivity',
  TRIPSMODULERECOMMENDEDCAR = 'TripsModuleRecommendedCar',
  TRIPSMODULERECOMMENDEDHOTEL = 'TripsModuleRecommendedHotel',
  TRIPSOVERVIEWVIEWED = 'TripsOverviewViewed',
  TRIPSTRAVELPLANNERITINNUMBERPRESENT = 'TripsTravelPlannerItinNumberPresent',
  UNKNOWN = 'Unknown'
}



export enum ExpLineOfBusiness {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  HOTEL = 'HOTEL',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED'
}



/** Specifies the position of the trigger icon  */
export enum ExpandoTriggerPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}















/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: Scalars['Int'];
  /** The numeric Abacus ID for an experiment */
  id: Scalars['String'];
}

export interface FopItemInput {
  id: Scalars['String'];
  paymentContextualInfo?: Maybe<PaymentContextualInfoInput>;
  paymentMethod: PaymentMethodType;
  state: Scalars['String'];
}

export enum FacetType {
  BUTTON = 'BUTTON',
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO',
  SLIDER = 'SLIDER'
}






















/** Represents the state of the fare */
export enum FareState {
  /** Fare is selected on meta search, but it has unselected visual state */
  META_UNSELECTED = 'META_UNSELECTED',
  /** Fare is selected */
  SELECTED = 'SELECTED',
  /** Fare is selected with PMP */
  SELECTED_PMP_SELECTED = 'SELECTED_PMP_SELECTED',
  /** Fare is unselected */
  UNSELECTED = 'UNSELECTED',
  /** Fare is unselected with PMP */
  UNSELECTED_PMP_SELECTED = 'UNSELECTED_PMP_SELECTED'
}







export enum FeeType {
  CARD_ON_FILE_DAMAGE_LIABILITY = 'CARD_ON_FILE_DAMAGE_LIABILITY',
  DEFAULT = 'DEFAULT',
  DEFAULT_SUPPLIER_COLLECTED = 'DEFAULT_SUPPLIER_COLLECTED',
  GROUPED_MANDATORY_FEES = 'GROUPED_MANDATORY_FEES',
  L26_TAX_BREAKOUT = 'L26_TAX_BREAKOUT',
  NORMAL = 'NORMAL',
  OTHER = 'OTHER',
  PER_PERSON_PER_NIGHT = 'PER_PERSON_PER_NIGHT',
  PROPERTY = 'PROPERTY',
  REFUNDABLE_DAMAGE_DEPOSIT = 'REFUNDABLE_DAMAGE_DEPOSIT',
  RESORT = 'RESORT'
}















/** The filter placement for the map view */
export enum FilterPlacement {
  /** Display the filters on the bottom, over the map */
  OVERLAY_BOTTOM = 'OVERLAY_BOTTOM',
  /** Display the filters on the top, over the map */
  OVERLAY_TOP = 'OVERLAY_TOP',
  /** Display the filters in the toolbar */
  TOOLBAR = 'TOOLBAR'
}

/** Enum class to represent the type of flexible change policies */
export enum FilterPolicyType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE'
}

/** Enum class to represent the type of travel and baggage */
export enum FilterTravelAndBaggageType {
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}









export enum FlavorType {
  DEMO = 'DEMO',
  INT = 'INT',
  LAB = 'LAB',
  PROD = 'PROD',
  SANDBOX = 'SANDBOX'
}

/** Controls the alignment along the cross axis. */
export enum FlexAlignItems {
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
  STRETCH = 'STRETCH'
}

/** The direction children items are placed inside the flex container, it determines the direction of the main axis (and the cross axis, perpendicular to the main axis). */
export enum FlexDirection {
  ROW = 'ROW'
}

/** Controls the alignment along the main axis. */
export enum FlexJustifyContent {
  CENTER = 'CENTER',
  END = 'END',
  SPACE_AROUND = 'SPACE_AROUND',
  SPACE_BETWEEN = 'SPACE_BETWEEN',
  START = 'START'
}

/** Controls whether the flex container is single-line or multi-line, and the direction of the cross axis. */
export enum FlexWrap {
  NOWRAP = 'NOWRAP'
}


/** The core criteria needed for a flex search */
export interface FlexibleSearchCriteriaInput {
  /** The raw flexibility of the search */
  flexibility?: Maybe<Array<DatePeriodInput>>;
  flexibleSearchMonths?: Maybe<Array<Scalars['Int']>>;
  flexibleSearchTripDurationType?: Maybe<FlexibleSearchTripDurationType>;
  numFlexibleDays?: Maybe<Scalars['Int']>;
  /** The search range for the flexible search */
  searchRange?: Maybe<Array<DateRangeInput>>;
}

/** The trip duration type for the flex search */
export enum FlexibleSearchTripDurationType {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  WEEKEND = 'WEEKEND'
}



export interface FlightAncillaryBagSelectionInput {
  /** Represents count of options available for corresponding bag */
  availableOptionsCount?: Maybe<Scalars['Int']>;
  /** Represents index of the selected bag */
  selectedBagIndex: Scalars['Int'];
  /** Represents the price of selected bag */
  selectedBagPrice?: Maybe<Scalars['Float']>;
}


/** Represents details of air ancillary selections for a journey */
export interface FlightAncillaryJourneySelectionInput {
  /** Represents the state of `apply same ancillaries for all travellers` checkbox */
  applySameAncillaryForAllTravellers: Scalars['Boolean'];
  /** It's contains the count of included checked bag */
  checkedBagIncluded?: Maybe<Scalars['Int']>;
  /** Represents list of selected ancillaries for each traveller */
  flightAncillaryTravelerSelections: Array<FlightAncillaryTravelerSelectionInput>;
  /** Represents index of the journey */
  journeyIndex: Scalars['Int'];
}


/** Represents list of selected ancillaries for a traveller */
export interface FlightAncillaryTravelerSelectionInput {
  /** Represents sequence index of the combined ancillaries in cache */
  combinedAncillaryIndex?: Maybe<Scalars['Int']>;
  /** Represents list of selected bags */
  flightAncillaryBagSelections: Array<FlightAncillaryBagSelectionInput>;
  /** Represents index of the traveller */
  travelerIndex: Scalars['Int'];
}


export enum FlightCabinClassInfo {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}

/** Flight cabin class */
export enum FlightClass {
  BUSINESS = 'BUSINESS',
  ECONOMY = 'ECONOMY',
  FIRST_CLASS = 'FIRST_CLASS',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}


/** Represents cross sell product types that will be displayed */
export enum FlightCrossSellProductType {
  CAR = 'CAR',
  HOTEL = 'HOTEL'
}






/** Represents the enum for flight journey status */
export enum FlightJourneyStatus {
  /** Represents that the segment status as failure */
  FAILURE = 'FAILURE',
  /** Represents that the segment status as success */
  SUCCESS = 'SUCCESS'
}



/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: Scalars['String'];
  productTokens: Array<Scalars['String']>;
  travelers: Array<TravelerDetailsInput>;
}




/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}









/** Represent Type for the values of FlightSelectableAncillaryOption */
export enum FlightSelectableAncillaryOptionValuesType {
  /** Represents NONE value */
  NONE = 'NONE',
  /** Represents a Valid value | eg: upto 15 kg */
  VALID = 'VALID'
}
















/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  /** Checkbox. Example: To add Price Match Promise */
  CHECKBOX = 'CHECKBOX',
  /** Primary action. Example: 'Add Hotel Now' button, 'Retry' button */
  PRIMARY = 'PRIMARY',
  /** Radio Button. Example: To choose seats for a particular traveler */
  RADIO_BUTTON = 'RADIO_BUTTON',
  /** Secondary action. */
  SECONDARY = 'SECONDARY',
  /** Switch toggle action. Example: price alerts subscription toggle */
  SWITCH = 'SWITCH',
  /** Tertiary action. Example: 'No Thanks' */
  TERTIARY = 'TERTIARY',
  /** Toggle action. Example: seat button in seat map */
  TOGGLE = 'TOGGLE'
}


/** Available action types an actionable element */
export enum FlightsActionType {
  /** Add Price Match Promise to the seleted fare */
  ADD_PRICE_MATCH_PROMISE = 'ADD_PRICE_MATCH_PROMISE',
  /** User has selected seat(s) for all passengers in that leg */
  ALL_SEATS_SELECTED_FOR_A_LEG = 'ALL_SEATS_SELECTED_FOR_A_LEG',
  /** Selects the chosen fare and reloads dynamic elements */
  APPLY_FARE = 'APPLY_FARE',
  /** Highlights the fare chosen by the user */
  CHOOSE_FARE = 'CHOOSE_FARE',
  /** Dialog Box used when customer clicks the 'Next Flight' Button before selecting seats for Current Flight */
  CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG = 'CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG',
  /** Dialog Box used when customer clicks the 'Continue Booking' Button before selecting all the seats */
  CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG = 'CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG',
  /** Go to coupon credit page */
  COUPON_CREDIT = 'COUPON_CREDIT',
  /** Dismisses a dialog */
  DISMISS = 'DISMISS',
  /** Activates the suggested filter */
  ENABLE_SUGGESTED_FILTER = 'ENABLE_SUGGESTED_FILTER',
  /** Fetch more search listings */
  FETCH_SEARCH_LISTINGS = 'FETCH_SEARCH_LISTINGS',
  /** Redirect used when customer clicks signin/signup page/module option from 'you might have credits module listing' */
  GO_TO_AUTH = 'GO_TO_AUTH',
  /** Go to Checkout page */
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  /** Continues to the standalone details page */
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  /** Continues to the next set of journey results */
  GO_TO_NEXT_JOURNEY = 'GO_TO_NEXT_JOURNEY',
  /** Continues to the packages path */
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  /** Redirects to flights search page */
  GO_TO_SEARCH = 'GO_TO_SEARCH',
  /** Redirects back to storefront */
  GO_TO_STOREFRONT = 'GO_TO_STOREFRONT',
  /** Opens a dialog for to display cross sell information */
  LOAD_CROSS_SELL_DIALOG = 'LOAD_CROSS_SELL_DIALOG',
  /** open amenities tray and upsell options for standard offer flight listings */
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = 'LOAD_STANDARD_OFFER_FARE_RULE_MODULE',
  /** Opens a dialog to display tax breakdown information */
  LOAD_TAX_BREAKDOWN_DIALOG = 'LOAD_TAX_BREAKDOWN_DIALOG',
  /** User has not selected seat(s) for any passengers in that leg */
  NO_SEATS_SELECTED_FOR_A_LEG = 'NO_SEATS_SELECTED_FOR_A_LEG',
  /** Opens bags selection alert dialog on clicking on checkout button on FIS */
  OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT = 'OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT',
  /** Opens sidesheet for bags selection */
  OPEN_BAGS_SELECTION_SHEET = 'OPEN_BAGS_SELECTION_SHEET',
  /** Opens a dialog to to go to Airlines Site for Booking */
  OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG = 'OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG',
  /** Dialog Box used when customer clicks the 'Select credit' or 'Change Credit' option from 'you might have credits module listing' */
  OPEN_CREDIT_DIALOG = 'OPEN_CREDIT_DIALOG',
  /** Open Fare Seat information when clicked on required seat button */
  OPEN_FARE_SEAT_MAP_SEAT_SHEET = 'OPEN_FARE_SEAT_MAP_SEAT_SHEET',
  /** Open Fare Seat view to preview the seat map */
  OPEN_FARE_SEAT_MAP_VIEW = 'OPEN_FARE_SEAT_MAP_VIEW',
  /** Open Fare Seat view to select the seat */
  OPEN_FARE_SEAT_SELECT_VIEW = 'OPEN_FARE_SEAT_SELECT_VIEW',
  /** Open Flight leg drop down in seat map view */
  OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG = 'OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG',
  /** Open Legend info sheet in bottom in case of mobile */
  OPEN_LEGEND_INFO_SHEET_MOBILE = 'OPEN_LEGEND_INFO_SHEET_MOBILE',
  /** Open price summary */
  OPEN_PRICE_SUMMARY = 'OPEN_PRICE_SUMMARY',
  /** Opens seat selection alert dialog on clicking on checkout button on FIS */
  OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT = 'OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT',
  /** Redirects to Airlines Site for Booking */
  REDIRECT_TO_AIRLINES_FOR_BOOKING = 'REDIRECT_TO_AIRLINES_FOR_BOOKING',
  /** Refreshes the current page */
  REFRESH = 'REFRESH',
  /** Actionable item to add a journey */
  SEARCH_FORM_ADD_JOURNEY = 'SEARCH_FORM_ADD_JOURNEY',
  /** Closes the expanded Search Form */
  SEARCH_FORM_CLOSE_BUTTON = 'SEARCH_FORM_CLOSE_BUTTON',
  /** Actionable item to remove a journey */
  SEARCH_FORM_REMOVE_JOURNEY = 'SEARCH_FORM_REMOVE_JOURNEY',
  /** Dialog Box used when customer clicks the 'Close' Button before selecting all the seats */
  SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG = 'SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG',
  /** Continues to flight details page after selecting seats for all flights */
  SEAT_MAP_CONTINUE_BOOKING = 'SEAT_MAP_CONTINUE_BOOKING',
  /** Closes the current flight seat selection page and continues for next flight */
  SEAT_MAP_GO_TO_NEXT_FLIGHT = 'SEAT_MAP_GO_TO_NEXT_FLIGHT',
  /** Go to next flight section for selecting seats */
  SEAT_MAP_NEXT_FLIGHT = 'SEAT_MAP_NEXT_FLIGHT',
  /** Saves user's seat preferences and redirects to FIS */
  SEAT_MAP_SAVE_AND_EXIT = 'SEAT_MAP_SAVE_AND_EXIT',
  /** Stays at Page displaying Seat Map when selected by user */
  SEAT_MAP_STAY_HERE = 'SEAT_MAP_STAY_HERE',
  /** Continues to stay on the current flight seat selection page */
  SEAT_MAP_STAY_ON_THIS_PAGE = 'SEAT_MAP_STAY_ON_THIS_PAGE',
  /** Allows User to Continue Booking from the Seat Selection Dialog Box */
  SEAT_SELECT_DIALOG_CONTINUE_BOOKING = 'SEAT_SELECT_DIALOG_CONTINUE_BOOKING',
  /** Displays seat map preview corresponding to each traveler */
  SEAT_SELECT_PREVIEW_FOR_TRAVELER = 'SEAT_SELECT_PREVIEW_FOR_TRAVELER',
  /** Select Flight leg in seat map drop down menu */
  SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG = 'SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG',
  /** Select the seat */
  SELECT_SEAT = 'SELECT_SEAT',
  /** Open Opinion Lab Share Feedback dialogue */
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  /** Open a modal showing details of the free Price Match Promise product */
  SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS = 'SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS',
  /** Open a modal showing details of the Price Match Promise product */
  SHOW_PRICE_MATCH_PROMISE_DETAILS = 'SHOW_PRICE_MATCH_PROMISE_DETAILS',
  /** User has selected seat(s) for at least 1 passenger but not all passengers in that leg */
  SOME_SEATS_SELECTED_FOR_A_LEG = 'SOME_SEATS_SELECTED_FOR_A_LEG',
  /** Subscribe to emails */
  SUBSCRIBE_TO_EMAILS = 'SUBSCRIBE_TO_EMAILS',
  /** Subscribe/Unsubscribes from price alerts */
  TOGGLE_PRICE_ALERTS = 'TOGGLE_PRICE_ALERTS',
  /** Unselect the selected seat */
  UNSELECT_SEAT = 'UNSELECT_SEAT',
  /** Opens FIS sidesheet and highlights next fare to upgrade */
  UPGRADE_TO_NEXT_FARE = 'UPGRADE_TO_NEXT_FARE'
}




/** Possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = 'NONSTOP',
  REFUNDABLE = 'REFUNDABLE'
}

/** Represents details of air ancillary selection request */
export interface FlightsAirAncillarySelectionDetailInput {
  /** Represents index of each traveler. Example: '1' */
  travelerIndex: Scalars['Int'];
  /** Represents details of flight, ancillaries in encoded form mapped to each traveler. */
  unselectedAirAncillaryProductToken: Scalars['String'];
}




/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: Scalars['String'];
}








/** Ancillary summary criteria for the selected fare */
export interface FlightsAncillaryCriteriaInput {
  /** Represents ancillaryID to signify whether ancillaries were selected, null when no ancillaries were selected. */
  ancillaryId?: Maybe<Scalars['String']>;
  /** Represents the list of per segment(seats)/per product(bags) selections */
  ancillaryJourneySelections?: Maybe<Array<AncillaryJourneySelectionsInput>>;
  /** Represents path plus page for where ancillaries will be shopped. */
  ancillaryShoppingPath?: Maybe<AncillaryShoppingPath>;
  /** Represents the ancillary requested in the summary */
  ancillaryType: FlightsAncillaryType;
  /** Represents details of selected ancillaries for each journey */
  flightAncillaryJourneySelections?: Maybe<Array<FlightAncillaryJourneySelectionInput>>;
  /** Represents identifier of a journey for a traveler. For Standalone shopping path its decodable string whereas for post purchase its trip Id. */
  journeyContinuationId: Scalars['String'];
  /** Represents Air Offer Token of the selected flight, null for first call on page load */
  selectedOfferToken?: Maybe<Scalars['String']>;
}





/** Enum class to represent the ancillary display action */
export enum FlightsAncillaryDisplayAction {
  NONE = 'NONE',
  PREFETCH = 'PREFETCH'
}










/** Accessibility message types to be announced post selection */
export enum FlightsAncillarySelectionAccessibilityMsgType {
  /** Ancillary Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Ancillary Selection Success */
  SELECTION_SUCCESS = 'SELECTION_SUCCESS'
}

/** Error types which can occur during ancillary selection */
export enum FlightsAncillarySelectionErrorType {
  /** Baggage Details loaded call failed */
  BAGGAGE_DETAILS_LOADED_FAILED = 'BAGGAGE_DETAILS_LOADED_FAILED',
  /** Ancillary details loading failed */
  DETAILS_LOADING_FAILED = 'DETAILS_LOADING_FAILED',
  /** Ancillary Pre-Selection Unavailable */
  PRE_SELECTION_FAILED = 'PRE_SELECTION_FAILED',
  /** Ancillary Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Ancillary Selection Unavailable */
  SELECTION_UNAVAILABLE = 'SELECTION_UNAVAILABLE'
}









/** Type of ancillaries supported */
export enum FlightsAncillaryType {
  BAGS = 'BAGS',
  BAGS_V2 = 'BAGS_V2',
  SEATS = 'SEATS'
}










/** Represents the theme values for a Badge */
export enum FlightsBadgeTheme {
  BRAND = 'BRAND',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  VIEWED = 'VIEWED',
  VIP = 'VIP'
}




















/** Represents the button width in the UI */
export enum FlightsButtonWidth {
  /** Button will take the width it needs */
  DEFAULT = 'DEFAULT',
  /** Button will take the full width of the content */
  FULL_WIDTH = 'FULL_WIDTH'
}

/** Cabin class chosen in flight */
export enum FlightsCabinClass {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}




/** Represents the value associated with travel and baggage filter - carry on bag */
export interface FlightsCarryOnBagBasedFilterValueInput {
  carryOnBag: CarryOnBagType;
  displayToast?: Maybe<Scalars['Boolean']>;
}








/** Represents the value associated with travel and baggage filter - checked bag */
export interface FlightsCheckedBagBasedFilterValueInput {
  displayToast?: Maybe<Scalars['Boolean']>;
  numOfCheckedBags: Scalars['Int'];
}











/** Represents the value credit eligible filter */
export interface FlightsCreditEligibleFilterValueInput {
  creditEligible: CreditEligibleFilterType;
}













/** Represents an individual cross sort parameter */
export interface FlightsCrossSortOptionInput {
  /** Enumeration of the parameter type for the accompanying weight */
  type: FlightsCrossSortType;
  /** The current weight of the individual cross sort parameter */
  weight: Scalars['Int'];
}


/** User specified parameters for cross sort */
export interface FlightsCrossSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOption: Array<FlightsCrossSortOptionInput>;
}



/** Enum class to represent cross sort types */
export enum FlightsCrossSortType {
  CABIN_CLASS = 'CABIN_CLASS',
  CANCELLATION = 'CANCELLATION',
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  CHANGE_ALLOWED = 'CHANGE_ALLOWED',
  CHECKED_BAG = 'CHECKED_BAG',
  DURATION = 'DURATION',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PRICE = 'PRICE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}


/** Represents criteria for continue booking for selecting ancillaries on flight information page */
export interface FlightsDetailAncillaryUpdateCriteriaInput {
  /** Represents details of air ancillary selection request */
  airAncillaryDetails: Array<FlightsAirAncillarySelectionDetailInput>;
  /** Represents the list of per segment(seats)/per product(bags) selections */
  ancillaryJourneySelections?: Maybe<Array<AncillaryJourneySelectionsInput>>;
  /** Represents the ancillary type for update */
  ancillaryType?: Maybe<FlightsAncillaryType>;
  /** Represents details of selected ancillaries for each journey */
  flightAncillaryJourneySelections?: Maybe<Array<FlightAncillaryJourneySelectionInput>>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars['String'];
}

/** Represents criteria for flights information page. */
export interface FlightsDetailComponentsCriteriaInput {
  /** Represents FlightsSearchContext of the selected flight */
  flightsSearchContext: FlightsSearchContextInput;
  /** Represents FlightsJourneyCriteria of the selected flight */
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars['String'];
  /** Represents Price of the selected flight */
  originalPrice?: Maybe<MoneyInput>;
  /** Represents QueryParams of the selected flight */
  queryParams?: Maybe<Array<GraphQlPairInput>>;
  /** Represents FlightsSearchPreferences of the selected flight */
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  /** Represents FlightsTravelerDetails of the selected flight */
  travelerDetails: Array<FlightsTravelerDetailsInput>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars['String']>;
}


/** Represents criteria for flights information page. */
export interface FlightsDetailCriteriaInput {
  /** This will contain the list of ancillaries for which auto shopping is complete. */
  additionalShoppedAncillaries?: Maybe<Array<AdditionalShoppedAncillaries>>;
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: Maybe<Scalars['String']>;
  /** Represents the type of the channel for example VirtualAgent */
  channelType?: Maybe<ChannelType>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: Maybe<Scalars['String']>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars['String']>;
}








/** Represents the information of the user device */
export interface FlightsDevicePermissionsInput {
  /** Represents the array of all the notifications enabled for the user device */
  pushNotificationsEnabled: Array<NotificationsType>;
}


/** Represents flights dialog actions */
export enum FlightsDialogAction {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN',
  TOGGLE = 'TOGGLE'
}

/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = 'FADE',
  NONE = 'NONE'
}




/** Represents IDs for flights dialogs */
export enum FlightsDialogId {
  /** Represents the Airlines credit dialog */
  AIRLINE_CREDITS = 'AIRLINE_CREDITS',
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  BAGGAGE_CLOSE_COMPLETE_DIALOG = 'BAGGAGE_CLOSE_COMPLETE_DIALOG',
  /** Represents the Close button dialog for the baggage details */
  BAGGAGE_CLOSE_DIALOG = 'BAGGAGE_CLOSE_DIALOG',
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  BAGGAGE_CLOSE_INCOMPLETE_DIALOG = 'BAGGAGE_CLOSE_INCOMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  BAGGAGE_CONTINUE_BOOKING = 'BAGGAGE_CONTINUE_BOOKING',
  /** Represents the dialog ID for Baggage details */
  BAGGAGE_DETAILS_DIALOG = 'BAGGAGE_DETAILS_DIALOG',
  /** Represents the bags popup dialog on checkout button */
  BAGS_POPUP_ON_CHECKOUT = 'BAGS_POPUP_ON_CHECKOUT',
  /** Represents the check credits dialog for users coming from MCC and VA */
  CHECK_CREDITS_DIALOG = 'CHECK_CREDITS_DIALOG',
  /** Represents the Flights Details and Fares dialog */
  FLIGHTS_DETAILS_AND_FARES = 'FLIGHTS_DETAILS_AND_FARES',
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FORCED_CHOICE_MODAL = 'FORCED_CHOICE_MODAL',
  /** Represents the How Airlines Work dialog inside Select Credits */
  HOW_CREDITS_WORK = 'HOW_CREDITS_WORK',
  /** Represents the Leave This Page dialog inside Select Credits */
  LEAVE_TO_COUPONS = 'LEAVE_TO_COUPONS',
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  PAID_BAGS_DIALOG = 'PAID_BAGS_DIALOG',
  /** Represents the Info dialog for Price Match Promise Selected Card */
  PMP_INFO_DIALOG = 'PMP_INFO_DIALOG',
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  PMP_REMOVE_DIALOG = 'PMP_REMOVE_DIALOG',
  /** Represents the seats popup dialog on checkout button */
  SEATS_POPUP_ON_CHECKOUT = 'SEATS_POPUP_ON_CHECKOUT',
  /** Represents the Close button dialog for the seat details */
  SEAT_CLOSE_COMPLETE_DIALOG = 'SEAT_CLOSE_COMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  SEAT_CONTINUE_BOOKING = 'SEAT_CONTINUE_BOOKING',
  /** Represents the dialog ID for seat legends dialog */
  SEAT_LEGEND_DIALOG = 'SEAT_LEGEND_DIALOG',
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  SEAT_SELECTION_DIALOG = 'SEAT_SELECTION_DIALOG',
  /** Represents the dialog on traveler mismatch for credits offer */
  TRAVELER_MISMATCH_DIALOG = 'TRAVELER_MISMATCH_DIALOG'
}


/** Represents a pre action in flights dialog trigger */
export enum FlightsDialogPreAction {
  CLOSE_ALL_DIALOGS = 'CLOSE_ALL_DIALOGS'
}










/** Represents flights component */
export enum FlightsDisplayComponent {
  SMART_NFF_ALTERNATE_SUGGESTION = 'SMART_NFF_ALTERNATE_SUGGESTION'
}


/** Represents display count of a component within a session e.g How many time NFF shows consecutively   */
export interface FlightsDisplayComponentCountingValueInput {
  /** Represents display count of a flights component */
  displayCount: Scalars['Int'];
  flightsDisplayComponent: FlightsDisplayComponent;
}


/** Represents flights component display values */
export interface FlightsDisplayComponentValuesInput {
  /** Represents counting values of flights display component */
  displayCountingValues?: Maybe<Array<FlightsDisplayComponentCountingValueInput>>;
}


/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: Scalars['Int'];
}
















/** Css class names for datepicker cell content. */
export enum FlightsFareCalendarPriceTheme {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  UNDEFINED = 'UNDEFINED'
}






/** Represent the fares needs to be present in listing results */
export enum FlightsFaresSeparationType {
  BASE_AND_UPSELL = 'BASE_AND_UPSELL',
  NONSTOP_BASE_AND_UPSELL = 'NONSTOP_BASE_AND_UPSELL',
  NONSTOP_ONLY_BASE = 'NONSTOP_ONLY_BASE',
  NONSTOP_ONLY_UPSELL = 'NONSTOP_ONLY_UPSELL',
  ONLY_BASE = 'ONLY_BASE',
  ONLY_UPSELL = 'ONLY_UPSELL'
}









/** Enum class to represent the available filter types */
export enum FlightsFilterType {
  ARRIVAL_AIRPORT = 'ARRIVAL_AIRPORT',
  ARRIVAL_TIME = 'ARRIVAL_TIME',
  ARRIVAL_TIME_SLIDER = 'ARRIVAL_TIME_SLIDER',
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  CHECKED_BAG = 'CHECKED_BAG',
  CREDIT_ELIGIBLE = 'CREDIT_ELIGIBLE',
  DEPARTURE_AIRPORT = 'DEPARTURE_AIRPORT',
  DEPARTURE_TIME = 'DEPARTURE_TIME',
  DEPARTURE_TIME_SLIDER = 'DEPARTURE_TIME_SLIDER',
  DURATION = 'DURATION',
  FLEXIBLE_CHANGE_POLICIES = 'FLEXIBLE_CHANGE_POLICIES',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PREFERRED_AIRLINE = 'PREFERRED_AIRLINE',
  SEAT_CHOICE = 'SEAT_CHOICE',
  TRAVEL_AND_BAGGAGE = 'TRAVEL_AND_BAGGAGE'
}




/** Represents the value associated with flexible change policies filter */
export interface FlightsFlexibleChangePolicyBasedFilterValueInput {
  policyName: FilterPolicyType;
}

/** Represents the flexible grid type */
export enum FlightsFlexibleGridType {
  /** Flex Search type shown for OW */
  FLEX_SEARCH = 'FLEX_SEARCH',
  /** Flex Search Grid type shown for RT Outbound */
  FLEX_SEARCH_GRID = 'FLEX_SEARCH_GRID',
  /** No Flex Search variant shown */
  FLEX_SEARCH_NOT_APPLICABLE = 'FLEX_SEARCH_NOT_APPLICABLE'
}







/** Represent flexible search header cell theme */
export enum FlightsFlexibleSearchHeaderCellTheme {
  /** Theme to represent an outbound or inbound departureDate header */
  DEFAULT = 'DEFAULT',
  /** Theme to represent an outbound or inbound departureDate that was searched on */
  SEARCHED_DATE_HEADER = 'SEARCHED_DATE_HEADER'
}


/** Represent flexible search legend cell theme */
export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = 'DEFAULT'
}






/** Represent flexible search result cell theme */
export enum FlightsFlexibleSearchResultCellTheme {
  /** Default theme */
  DEFAULT_PRICE = 'DEFAULT_PRICE',
  /** Theme to represent highest priced cells in the matrix */
  HIGHEST_PRICE = 'HIGHEST_PRICE',
  /** Theme to represent the lowest price displayed in the matrix */
  LOWEST_PRICE = 'LOWEST_PRICE',
  /** Theme to represent when no price is available, 'Search' */
  NO_PRICE = 'NO_PRICE',
  /** Theme to represent the price corresponding to the flight on the input departureDate */
  SEARCHED_DATE = 'SEARCHED_DATE',
  /** Theme to represent a cell that corresponds to the input departureDate and is also lowest price displayed in the matrix */
  SEARCHED_DATE_LOWEST_PRICE = 'SEARCHED_DATE_LOWEST_PRICE',
  /** Theme to represent a cell that corresponds to the input departureDate and is also the price is not available */
  SEARCHED_DATE_NO_PRICE = 'SEARCHED_DATE_NO_PRICE',
  /** Theme to represent a cell that corresponds to the input departureDate and flights dont fly on the given departureDate */
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = 'SEARCHED_DATE_UNAVAILABLE_FLIGHTS',
  /** Theme to represent the price is unavailable because flights don't fly for the given departureDate and route, 'No Flights' */
  UNAVAILABLE_FLIGHTS = 'UNAVAILABLE_FLIGHTS'
}











/** Represents the position of the icon */
export enum FlightsIconPosition {
  /** Icon will be rendered at the beginning of the content */
  LEADING = 'LEADING',
  /** Icon will be rendered at the end of the content */
  TRAILING = 'TRAILING'
}






















/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Arrival date of the flight */
  arrivalDate?: Maybe<DateInput>;
  /** Departure date of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: Scalars['String'];
  /** Location type of the destination airport */
  destinationAirportLocationType?: Maybe<AirportLocationType>;
  /** # Deprecated: Please use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: Maybe<FlightsCabinClass>;
  /** Three letter code of the origin airport */
  origin: Scalars['String'];
  /** Location type of the origin airport */
  originAirportLocationType?: Maybe<AirportLocationType>;
}


























/** Target of the Link when clicked */
export enum FlightsLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL'
}









/** Represents page load type of FSR */
export enum FlightsListingsViewType {
  MIXED = 'MIXED',
  SINGLE = 'SINGLE'
}

























/** Metrics names */
export enum FlightsMetricName {
  LISTINGS_SUPPLY_RESPONSE_TIME = 'LISTINGS_SUPPLY_RESPONSE_TIME'
}







/** Represents the value associated with travel and baggage filter - no cancel fee */
export interface FlightsNoCancelFeeBasedFilterValueInput {
  noCancelFee: NoCancelFeeType;
}


/** Represents the value associated with travel and baggage filter - no change name */
export interface FlightsNoChangeFeeBasedFilterValueInput {
  noChangeFee: NoChangeFeeType;
}





























/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}



/** Represents an object to be used to differentiate the type of Placards(Ex : Placards to be shown immediately vs those which are shown during server error */
export enum FlightsPlacardDisplayType {
  /** Represents the placard type to be shown immediately */
  IMMEDIATE = 'IMMEDIATE',
  /** Represents the placard type to be shown during server error of sort and filter action */
  SORT_FILTERS_SERVER_ERROR = 'SORT_FILTERS_SERVER_ERROR'
}


/** Represents a type of placards the client can request for */
export enum FlightsPlacardType {
  /** Represents the placard of type free cancellation */
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  /** Represents the placard of type hotel attach */
  HOTEL_ATTACH = 'HOTEL_ATTACH',
  /** Represents the placard of type loyalty reward */
  LOYALTY_REWARD = 'LOYALTY_REWARD',
  /** Represents the placard of type no change fees */
  NO_CHANGE_FEES = 'NO_CHANGE_FEES',
  /** Represents the placard of type passport */
  PASSPORT = 'PASSPORT',
  /** Represents the placard of type price change */
  PRICE_CHANGE = 'PRICE_CHANGE',
  /** Represents the placard of type split ticket */
  SPLIT_TICKET = 'SPLIT_TICKET'
}


/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: Scalars['String'];
}













/** Represents the display of progress bar when the results are loading */
export enum FlightsProgressBarDisplay {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

/** Represents the state the client wants to query */
export enum FlightsQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}















/** Enum class to represent the id associated with the rewards option */
export enum FlightsRewardsOptionId {
  ALTAIR = 'ALTAIR',
  AVION = 'AVION',
  NONAVION = 'NONAVION'
}



export interface FlightsSearchComponentCriteriaInput {
  /** Parameter to recognize that traffic source is meta search */
  isMetaTraffic?: Maybe<Scalars['Boolean']>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier?: Maybe<Scalars['String']>;
  /** Represents Unresolved list of params for meta. Like MDPCID, etc. */
  queryParams?: Maybe<Array<GraphQlPairInput>>;
}


/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represents that the user is intending to redeem credits (i.e. coming from My Coupons and Credits or Virtual Agent) */
  hasCreditRedemptionIntent?: Maybe<Scalars['Boolean']>;
  /** Represent the continuation identifier for spinner to deduce which all journeys have been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: Maybe<Scalars['String']>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: Maybe<Scalars['String']>;
  /** Represents the flights user selected for each segment when the user proceeded to FIS.This node will be populated on the search response only if customer is returning to FSR from FIS. */
  previousFlightSelections?: Maybe<Array<JourneyFlightSelectionInput>>;
  /** Represents the previously selected credit's originalBookingId to correctly render the toast when credits are changed */
  previousOriginalBookingId?: Maybe<Scalars['String']>;
  /** Represents the mismatched search criteria between the current search and servicing need */
  searchCriteriaMismatch?: Maybe<Array<FlightsSearchCriteriaMismatch>>;
  /** Trip type in search */
  tripType: FlightsTripType;
}


/** Represents the mismatched criterion between the current search and servicing need */
export enum FlightsSearchCriteriaMismatch {
  TRAVELER = 'TRAVELER'
}



/** Represents an element of the list which the client needs to send back to the server as part of the request. This will be part of each FilterItem so client need not apply any logic on filter selection but simply add this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: Maybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: Maybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Arrival Time Slider filter. */
  arrivalTimeSliderFilterValue?: Maybe<FlightsSliderFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - carry on bag. */
  carryOnBagBasedFilterValue?: Maybe<FlightsCarryOnBagBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - checked bag. */
  checkedBagBasedFilterValue?: Maybe<FlightsCheckedBagBasedFilterValueInput>;
  /** Represents the value associated with credit eligible filter */
  creditEligibleFilterValue?: Maybe<FlightsCreditEligibleFilterValueInput>;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: Maybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: Maybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Departure Time Slider filter. */
  departureTimeSliderFilterValue?: Maybe<FlightsSliderFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: Maybe<FlightsDurationBasedFilterValueInput>;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: Maybe<FlightsFlexibleChangePolicyBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no cancel fee. */
  noCancelFeeBasedFilterValue?: Maybe<FlightsNoCancelFeeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no change fee. */
  noChangeFeeBasedFilterValue?: Maybe<FlightsNoChangeFeeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: Maybe<FlightsStopBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: Maybe<FlightsPreferredAirlineFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - seat choice. */
  seatChoiceBasedFilterValue?: Maybe<FlightsSeatChoiceBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter. */
  travelAndBaggageBasedFilterValue?: Maybe<FlightsTravelAndBaggageBasedFilterValueInput>;
}








export enum FlightsSearchFormErrorType {
  /** Age of child is missing */
  CHILD_AGE_MISSING = 'CHILD_AGE_MISSING',
  /** Date before previous date - Multi-dest */
  DATE_BEFORE_PREVIOUS_DATE = 'DATE_BEFORE_PREVIOUS_DATE',
  /** Date must be between a range */
  DATE_NOT_IN_VALID_RANGE = 'DATE_NOT_IN_VALID_RANGE',
  /** Dates must be greater than or equal to default date/checkin date. */
  DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE = 'DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE',
  /** Age of infant is missing */
  INFANT_AGE_MISSING = 'INFANT_AGE_MISSING',
  /** Date must be in the correct format */
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  /** Total traveler count must be equal or lower than max */
  INVALID_TRAVELER_COUNT = 'INVALID_TRAVELER_COUNT',
  /** At least 1 traveler required in a booking */
  LESS_THAN_MINIMUM_ADULT = 'LESS_THAN_MINIMUM_ADULT',
  /** Location must not be blank */
  LOCATION_EMPTY = 'LOCATION_EMPTY',
  /** Origin and destination location must not be the same */
  LOCATION_SAME = 'LOCATION_SAME',
  /** Dates must be no more than 26 days apart */
  MAX_STAY_DURATION_ERROR = 'MAX_STAY_DURATION_ERROR',
  /** Origin and Destination city cannot be same */
  SAME_CITY = 'SAME_CITY',
  /** Special characters are not allowed */
  SPECIAL_CHARACTER_NOT_ALLOWED = 'SPECIAL_CHARACTER_NOT_ALLOWED',
  /** Enter at least 3 characters of the airport name */
  TOO_SHORT_AIRPORT_STRING = 'TOO_SHORT_AIRPORT_STRING',
  /** Number of infant in lap must be equal or lower than number of adults */
  UNATTENDED_INFANT_IN_LAP = 'UNATTENDED_INFANT_IN_LAP',
  /** There can't be more than 2 infants per traveler (age 12+) in a booking */
  UNATTENDED_INFANT_IN_SEAT = 'UNATTENDED_INFANT_IN_SEAT'
}


















/** Primary flights criteria part of the search wizard that have an impact on the first results set.It's different from the side filter part of the secondary search criteria that are filtering on top of it. The side filter should be using a server driven approach. */
export interface FlightsSearchPreferencesInput {
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: Maybe<Array<FlightsAdvancedFilterType>>;
  airline?: Maybe<Scalars['String']>;
  cabinClass: FlightsCabinClass;
}












/** Represents the enum to handle different styles for the card */
export enum FlightsSeatCardStyles {
  /** Represents that the card should have border */
  BORDER = 'BORDER',
  /** Represents that the card should not have a border */
  WITHOUT_BORDER = 'WITHOUT_BORDER'
}



/** Represents the value associated with travel and baggage filter - seat choice */
export interface FlightsSeatChoiceBasedFilterValueInput {
  displayToast?: Maybe<Scalars['Boolean']>;
  seatChoice: SeatChoiceType;
}





/** Represents criteria for flights seat map. */
export interface FlightsSeatMapCriteriaInput {
  /** Represents which offer seat map to be shown. This will be decoded and used to create seat map service request */
  offerIdentifier: Scalars['String'];
  /** Represents pricing construct containing price related information. Ex: '[AA.QNNF00S7:SEADEL][AA.QNNF00S7CH:SEADEL][AA.QNNF00S7CH:SEADEL]{BFSDiag}{FC}11JUL21SEA AA X/LON BA DEL M318.00NUC318.00END ROE1.000000{/FC}{DollarAfc}{/DollarAfc}{/BFSDiag}{Published}' */
  pricingConstruct?: Maybe<Scalars['String']>;
  /** Represents list of segments for which seat map for selection is to be shown. */
  seatSegments?: Maybe<Array<SeatSegmentInput>>;
  /** RepreArraysents list of segments for which seat map is to be shown. This will identify the segments from the decoded offer identifier and request seat map downstream. */
  segmentIdentifiers: Array<Scalars['String']>;
}














/** Enum class to represent the seat type variant. */
export enum FlightsSeatMapSeatVariant {
  ACCESSIBLE = 'ACCESSIBLE',
  AISLE = 'AISLE',
  AVAILABLE = 'AVAILABLE',
  COLUMN = 'COLUMN',
  EXIT = 'EXIT',
  GALLEY = 'GALLEY',
  PREFERRED = 'PREFERRED',
  RESTROOM = 'RESTROOM',
  ROW = 'ROW',
  SELECTED = 'SELECTED',
  UNAVAILABLE = 'UNAVAILABLE'
}







/** Error types which can occur during seat selection */
export enum FlightsSeatSelectionErrorType {
  /** Seat Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Seat Selection Unavailable */
  SELECTION_UNAVAILABLE = 'SELECTION_UNAVAILABLE'
}





/** Represents the enum for handling whether new seats experience should be enabled or not */
export enum FlightsSeatsExperienceType {
  /** Represents frontend to show old seats experience */
  CURRENT_SEATS_EXPERIENCE = 'CURRENT_SEATS_EXPERIENCE',
  /** Represents frontend to show new seats experience */
  NEW_SEATS_EXPERIENCE = 'NEW_SEATS_EXPERIENCE'
}










/** Represents criteria for flights servicing confirmation page. */
export interface FlightsServicingConfirmationCriteriaInput {
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId?: Maybe<Scalars['String']>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId: Scalars['String'];
  /** Represents the trip id */
  tripId?: Maybe<Scalars['String']>;
}


/** Represents criteria for flights servicing page. */
export interface FlightsServicingCriteriaInput {
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: Maybe<Scalars['String']>;
  /** Represents the identifier to deduce change order flow */
  isResumeChange?: Maybe<Scalars['Boolean']>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: Maybe<Scalars['String']>;
  /** Represents the trip id */
  tripId?: Maybe<Scalars['String']>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars['String']>;
}








/** Represents the min and max values associated with slider filters, like DepartureTime or ArrivalTime slider filter */
export interface FlightsSliderFilterValueInput {
  max: Scalars['Int'];
  min: Scalars['Int'];
}






/** Represents the button width in the UI */
export enum FlightsSmartShoppingButtonWidth {
  /** Button will take the width it needs */
  DEFAULT = 'DEFAULT',
  /** Button will take the full width of the content */
  FULL_WIDTH = 'FULL_WIDTH'
}




/** Represents flights dialog actions */
export enum FlightsSmartShoppingDialogAction {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN',
  TOGGLE = 'TOGGLE'
}

/** Represents IDs for flights dialogs */
export enum FlightsSmartShoppingDialogId {
  /** Represents the Airlines credit dialog */
  AIRLINE_CREDITS = 'AIRLINE_CREDITS',
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  BAGGAGE_CLOSE_COMPLETE_DIALOG = 'BAGGAGE_CLOSE_COMPLETE_DIALOG',
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  BAGGAGE_CLOSE_INCOMPLETE_DIALOG = 'BAGGAGE_CLOSE_INCOMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  BAGGAGE_CONTINUE_BOOKING = 'BAGGAGE_CONTINUE_BOOKING',
  /** Represents the dialog ID for Baggage details */
  BAGGAGE_DETAILS_DIALOG = 'BAGGAGE_DETAILS_DIALOG',
  /** Represents the bags popup dialog on checkout button */
  BAGS_POPUP_ON_CHECKOUT = 'BAGS_POPUP_ON_CHECKOUT',
  /** Represents the check credits dialog for users coming from MCC and VA */
  CHECK_CREDITS_DIALOG = 'CHECK_CREDITS_DIALOG',
  /** Represents the Flights Details and Fares dialog */
  FLIGHTS_DETAILS_AND_FARES = 'FLIGHTS_DETAILS_AND_FARES',
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FORCED_CHOICE_MODAL = 'FORCED_CHOICE_MODAL',
  /** Represents the How Airlines Work dialog inside Select Credits */
  HOW_CREDITS_WORK = 'HOW_CREDITS_WORK',
  /** Represents the Leave This Page dialog inside Select Credits */
  LEAVE_TO_COUPONS = 'LEAVE_TO_COUPONS',
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  PAID_BAGS_DIALOG = 'PAID_BAGS_DIALOG',
  /** Represents the Info dialog for Price Match Promise Selected Card */
  PMP_INFO_DIALOG = 'PMP_INFO_DIALOG',
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  PMP_REMOVE_DIALOG = 'PMP_REMOVE_DIALOG',
  /** Represents the seats popup dialog on checkout button */
  SEATS_POPUP_ON_CHECKOUT = 'SEATS_POPUP_ON_CHECKOUT',
  /** Represents the Close button dialog for the seat details */
  SEAT_CLOSE_COMPLETE_DIALOG = 'SEAT_CLOSE_COMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  SEAT_CONTINUE_BOOKING = 'SEAT_CONTINUE_BOOKING',
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  SEAT_SELECTION_DIALOG = 'SEAT_SELECTION_DIALOG',
  /** Represents the dialog on traveler mismatch for credits offer */
  TRAVELER_MISMATCH_DIALOG = 'TRAVELER_MISMATCH_DIALOG'
}




/** Represents the position of the icon */
export enum FlightsSmartShoppingIconPosition {
  /** Icon will be rendered at the beginning of the content */
  LEADING = 'LEADING',
  /** Icon will be rendered at the end of the content */
  TRAILING = 'TRAILING'
}

/** Target of the Link when clicked */
export enum FlightsSmartShoppingLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL'
}


















/** Traveler details for flights search */
export interface FlightsSmartShoppingTravelerDetailsInput {
  /** Age for each traveler */
  ages?: Maybe<Array<Scalars['Int']>>;
  /** Traveler count */
  count: Scalars['Int'];
  /** Traveler type */
  travelerType: TravelerDetailsType;
}









/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOptionList?: Maybe<Array<FlightsCrossSortOptionInput>>;
  crossSortOptionType?: Maybe<FlightsCrossSortOptionTypeInput>;
  sortOrder: FlightsSortOrder;
  sortType: FlightsSortType;
}

/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = 'DECREASING',
  INCREASING = 'INCREASING'
}


/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = 'ARRIVAL',
  BEST_BETS = 'BEST_BETS',
  BEST_SORT = 'BEST_SORT',
  CROSS_SORT = 'CROSS_SORT',
  DEPARTURE = 'DEPARTURE',
  DURATION = 'DURATION',
  NONSTOP = 'NONSTOP',
  PRICE = 'PRICE',
  RECOMMENDED = 'RECOMMENDED'
}







/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}

/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = 'EQUAL',
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL'
}


/** Represents the stop related info for each number of stops based filter value. Combination of the number of stops and an operation.Ex. 2+ would be represented by {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: Scalars['Int'];
  stopFilterOperation: FlightsStopFilterOperation;
}














/** This represents a decorator that can be applied to a section */
export enum FlightsTextSectionDecorator {
  /** This represents a separator that renders after the text section */
  BOTTOMSEPARATOR = 'BOTTOMSEPARATOR',
  /** This represents a separator that renders above the text section */
  TOPSEPARATOR = 'TOPSEPARATOR'
}


/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}

/** Enum representing the various time slots in a day  */
export enum FlightsTimeOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}

export enum FlightsTimePeriodOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}



/** Represents the value associated with travel and baggage filter */
export interface FlightsTravelAndBaggageBasedFilterValueInput {
  travelAndBaggageName: FilterTravelAndBaggageType;
}



/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: Maybe<Array<Scalars['Int']>>;
  /** Traveler count */
  count: Scalars['Int'];
  /** Traveler type */
  travelerType: FlightsTravelerType;
}

/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}





/** Trip type chosen in flight search */
export enum FlightsTripType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}





export enum FooterButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}










export enum FooterSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE'
}







/** Represents all the common information in the journey review block on FIS  */
export enum FreeCancellationApplicability {
  ALL_JOURNEYS = 'ALL_JOURNEYS',
  CURRENT_JOUNRNEY = 'CURRENT_JOUNRNEY',
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}




export enum FunnelLocation {
  CHECKOUT = 'CHECKOUT',
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  CONFIRMATION = 'CONFIRMATION',
  DETAILS = 'DETAILS',
  ENTRY = 'ENTRY',
  FEATURES = 'FEATURES',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  POST_BOOKING = 'POST_BOOKING',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}



/** Possible direction types for ground transfers */
export enum GeoType {
  AIRPORT = 'AIRPORT',
  DESTINATION = 'DESTINATION',
  PROPERTY = 'PROPERTY'
}




/** Line of business that is querying the global navigation elements. */
export enum GlobalNavigationLineOfBusiness {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
  UNKNOWN = 'UNKNOWN'
}


/**
 * An object with simple key/value combination. This can be used to represent generic input where you do not know all the values that can be provided.
 *
 * It should be avoided in favor of a strict type with set fields, but can be useful in specific situations.
 */
export interface GraphQlPairInput {
  key: Scalars['String'];
  value: Scalars['String'];
}





export enum GroundTransfersBadgeTheme {
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}








/** Possible direction types for ground transfers */
export enum GroundTransfersDirection {
  FROM_AIRPORT = 'FROM_AIRPORT',
  ROUNDTRIP = 'ROUNDTRIP',
  TO_AIRPORT = 'TO_AIRPORT'
}






export enum GroundTransfersGroupViewType {
  CARDS_LIST = 'CARDS_LIST'
}


/** Provides the ground transfers criteria for each part of the journey. For instance, round-trip journey will comprise 2 parts, airport(origin) to hotel(destination) and hotel(origin) to airport(destination). */
export interface GroundTransfersJourneyCriteriaInput {
  dateTime: DateTimeInput;
  destination: GroundTransfersLocationInput;
  origin: GroundTransfersLocationInput;
}



/** Provides the ground transfers location information for destination, airport and hotel */
export interface GroundTransfersLocationInput {
  coordinates?: Maybe<CoordinatesInput>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type: GeoType;
}




export enum GroundTransfersMapTransitOption {
  BUS = 'BUS',
  NONE = 'NONE',
  TRAIN = 'TRAIN'
}

export enum GroundTransfersMapTravelMode {
  DRIVING = 'DRIVING',
  TRANSIT = 'TRANSIT'
}






/** The ground transfers natural key that contains an offer token */
export interface GroundTransfersNaturalKeyInput {
  offerToken: Scalars['String'];
}









export interface GroundTransfersSearchCriteriaInput {
  primary: PrimaryGroundTransfersCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}




export enum GroundTransfersSectionStyle {
  BULLETED = 'BULLETED',
  STANDARD = 'STANDARD'
}




/** Text style to apply to text */
export enum GroundTransfersStyle {
  /** Bold styling */
  EMPHASISED = 'EMPHASISED',
  /** Loyalty messages styling */
  LOYALTY = 'LOYALTY',
  /** Green text styling */
  POSITIVE = 'POSITIVE',
  /** Regular text with no styling, default Value */
  STANDARD = 'STANDARD'
}





/** Represents the traveler details */
export interface GroundTransfersTravelerDetailsInput {
  count: Scalars['Int'];
  type: GroundTransfersTravelerDetailsType;
}

/** Possible traveler details types */
export enum GroundTransfersTravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT'
}






/** Header section alignment of elements to either the start or end of the section container. */
export enum HeaderAlignment {
  END = 'END',
  START = 'START'
}



/** Determines the type of button to display.  Primary or tertiary. */
export enum HeaderButtonType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}


/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export enum HeaderItemPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

/** Header layout. */
export enum HeaderLayout {
  DEFAULT = 'DEFAULT',
  MINIMAL = 'MINIMAL',
  SIMPLIFIED = 'SIMPLIFIED'
}






/** Used to pass certain marketing details to the header for google ad awareness */
export interface HeaderMarketingInput {
  googleClickIdentifier?: Maybe<Scalars['String']>;
  metaDistributionPartnersDetails?: Maybe<Scalars['String']>;
}
















/** Inserts a separator in header menus. */
export enum HeaderSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE'
}







/** Type of text.  Heading or subheading. */
export enum HeaderTextType {
  HEADING = 'HEADING',
  SUBHEADING = 'SUBHEADING'
}

/** Different viewport sizes to display the header. */
export enum HeaderViewSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export enum HelpAndFeedbackOptionsType {
  BRAND_CALL = 'BRAND_CALL',
  CHAT_NOW = 'CHAT_NOW',
  CREDIT_CARD = 'CREDIT_CARD',
  RATE_OUR_APP = 'RATE_OUR_APP',
  SHARE_YOUR_FEEDBACK = 'SHARE_YOUR_FEEDBACK',
  VISIT_HELP_CENTER = 'VISIT_HELP_CENTER'
}

























/** Browse request to get articles */
export interface HelpArticlesSearchRequestInput {
  /** Specify specific category from product to retrieve articles */
  category?: Maybe<Scalars['String']>;
  /** Specify article id to get article data */
  helpArticleId?: Maybe<Scalars['String']>;
  /** Specify search term to get articles suggestions */
  helpArticlesSearchTerm?: Maybe<Scalars['String']>;
  /** Specify specific product from homepage to retrieve articles */
  product?: Maybe<Scalars['String']>;
  /** Specify specific product id from homepage to retrieve articles */
  productId?: Maybe<Scalars['String']>;
}























export enum HistoryType {
  ACTIVITY_DETAIL = 'ACTIVITY_DETAIL',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  CAR_DETAIL = 'CAR_DETAIL',
  CAR_SEARCH = 'CAR_SEARCH',
  CRUISE_SEARCH = 'CRUISE_SEARCH',
  FLIGHT_DETAIL = 'FLIGHT_DETAIL',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  PACKAGE_SEARCH = 'PACKAGE_SEARCH',
  PROPERTY_DETAIL = 'PROPERTY_DETAIL',
  PROPERTY_SEARCH = 'PROPERTY_SEARCH'
}







export interface HttpHeaderInput {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
}

export enum HttpStatus {
  ACCEPTED = 'ACCEPTED',
  ALREADY_REPORTED = 'ALREADY_REPORTED',
  BAD_GATEWAY = 'BAD_GATEWAY',
  BAD_REQUEST = 'BAD_REQUEST',
  BANDWIDTH_LIMIT_EXCEEDED = 'BANDWIDTH_LIMIT_EXCEEDED',
  CHECKPOINT = 'CHECKPOINT',
  CONFLICT = 'CONFLICT',
  CONTINUE = 'CONTINUE',
  CREATED = 'CREATED',
  DESTINATION_LOCKED = 'DESTINATION_LOCKED',
  EXPECTATION_FAILED = 'EXPECTATION_FAILED',
  FAILED_DEPENDENCY = 'FAILED_DEPENDENCY',
  FORBIDDEN = 'FORBIDDEN',
  FOUND = 'FOUND',
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
  GONE = 'GONE',
  HTTP_VERSION_NOT_SUPPORTED = 'HTTP_VERSION_NOT_SUPPORTED',
  IM_USED = 'IM_USED',
  INSUFFICIENT_SPACE_ON_RESOURCE = 'INSUFFICIENT_SPACE_ON_RESOURCE',
  INSUFFICIENT_STORAGE = 'INSUFFICIENT_STORAGE',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  I_AM_A_TEAPOT = 'I_AM_A_TEAPOT',
  LENGTH_REQUIRED = 'LENGTH_REQUIRED',
  LOCKED = 'LOCKED',
  LOOP_DETECTED = 'LOOP_DETECTED',
  METHOD_FAILURE = 'METHOD_FAILURE',
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
  MOVED_PERMANENTLY = 'MOVED_PERMANENTLY',
  MOVED_TEMPORARILY = 'MOVED_TEMPORARILY',
  MULTIPLE_CHOICES = 'MULTIPLE_CHOICES',
  MULTI_STATUS = 'MULTI_STATUS',
  NETWORK_AUTHENTICATION_REQUIRED = 'NETWORK_AUTHENTICATION_REQUIRED',
  NON_AUTHORITATIVE_INFORMATION = 'NON_AUTHORITATIVE_INFORMATION',
  NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
  NOT_EXTENDED = 'NOT_EXTENDED',
  NOT_FOUND = 'NOT_FOUND',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  NOT_MODIFIED = 'NOT_MODIFIED',
  NO_CONTENT = 'NO_CONTENT',
  OK = 'OK',
  PARTIAL_CONTENT = 'PARTIAL_CONTENT',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PERMANENT_REDIRECT = 'PERMANENT_REDIRECT',
  PRECONDITION_FAILED = 'PRECONDITION_FAILED',
  PRECONDITION_REQUIRED = 'PRECONDITION_REQUIRED',
  PROCESSING = 'PROCESSING',
  PROXY_AUTHENTICATION_REQUIRED = 'PROXY_AUTHENTICATION_REQUIRED',
  REQUESTED_RANGE_NOT_SATISFIABLE = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  REQUEST_ENTITY_TOO_LARGE = 'REQUEST_ENTITY_TOO_LARGE',
  REQUEST_HEADER_FIELDS_TOO_LARGE = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
  REQUEST_URI_TOO_LONG = 'REQUEST_URI_TOO_LONG',
  RESET_CONTENT = 'RESET_CONTENT',
  SEE_OTHER = 'SEE_OTHER',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  SWITCHING_PROTOCOLS = 'SWITCHING_PROTOCOLS',
  TEMPORARY_REDIRECT = 'TEMPORARY_REDIRECT',
  TOO_EARLY = 'TOO_EARLY',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNAVAILABLE_FOR_LEGAL_REASONS = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
  UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE',
  UPGRADE_REQUIRED = 'UPGRADE_REQUIRED',
  URI_TOO_LONG = 'URI_TOO_LONG',
  USE_PROXY = 'USE_PROXY',
  VARIANT_ALSO_NEGOTIATES = 'VARIANT_ALSO_NEGOTIATES'
}











/** supported sizes of icons */
export enum IconSize {
  EXTRA_SMALL = 'EXTRA_SMALL',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  MEDIUM_LARGE = 'MEDIUM_LARGE',
  SMALL = 'SMALL',
  XLARGE = 'XLARGE'
}

/** Supported themes of spotlights. See the prop definitions here: https://www.figma.com/file/Cq6XtgvVIEriWmWmVIMPzNOE/Icons?node-id=6402%3A115 */
export enum IconSpotLight {
  INFO = 'INFO',
  POSITIVE = 'POSITIVE',
  STANDARD = 'STANDARD',
  WARNING = 'WARNING'
}

/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export enum IconTheme {
  DEFAULT = 'default',
  EMPHASIS = 'emphasis',
  NEGATIVE = 'negative',
  POSITIVE = 'positive'
}


/** Enum to specify the type for inputId */
export enum IdentifierType {
  CART_ID = 'CART_ID',
  ENTITY_ID = 'ENTITY_ID',
  OFFER_ID = 'OFFER_ID',
  ORDER_ID = 'ORDER_ID',
  PROPERTY_ID = 'PROPERTY_ID'
}


export enum IdentityAccountCreationState {
  INVALID = 'INVALID',
  NOT_UPGRADED = 'NOT_UPGRADED',
  UPGRADED = 'UPGRADED'
}

export enum IdentityAccountCreationType {
  INVALID = 'INVALID',
  REGISTERED = 'REGISTERED',
  UNREGISTERED = 'UNREGISTERED'
}



export interface IdentityAccountTakeOverDeviceInput {
  payload: Scalars['String'];
  type: IdentityAccountTakeOverDeviceType;
}

export enum IdentityAccountTakeOverDeviceType {
  TRUST_WIDGET = 'TRUST_WIDGET'
}

/** EG Universal Login AccountTakeOver input from client */
export interface IdentityAccountTakeOverInput {
  inputs: Array<GraphQlPairInput>;
  type: Scalars['String'];
}


export interface IdentityAccountTakeOverShieldInput {
  accountTakeOverTokens?: Maybe<Array<IdentityAccountTakeOverTokenInput>>;
  crossSiteRequestForgeryData: IdentityCrossSiteRequestForgeryInput;
  devices?: Maybe<Array<IdentityAccountTakeOverDeviceInput>>;
  placement?: Maybe<Scalars['String']>;
}


export interface IdentityAccountTakeOverTokenInput {
  name: Scalars['String'];
  value: Scalars['String'];
}

export enum IdentityAccountTakeOverType {
  CAPTCHA_SAFETYNET_ANDROID = 'CAPTCHA_SAFETYNET_ANDROID',
  CSRF = 'CSRF',
  DEVICE_CHECK = 'DEVICE_CHECK',
  TRUST_WIDGET = 'TRUST_WIDGET'
}











export enum IdentityChannelType {
  ANDROID = 'ANDROID',
  DESKTOP = 'DESKTOP',
  IOS = 'IOS'
}

/** EG Universal Login input for IdentityClientInfo query and mutation */
export interface IdentityClientInfoInput {
  appName: Scalars['String'];
  appVersion: Scalars['String'];
  channelType: IdentityChannelType;
  deviceOS: Scalars['String'];
  deviceType: DeviceType;
}





/** EG Identity Creation Account Request */
export interface IdentityCreateAccountRequestInput {
  accountTakeOverShield: IdentityAccountTakeOverShieldInput;
  channelType?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phoneDetails?: Maybe<IdentityPhoneDetailsInput>;
  rememberMe?: Maybe<Scalars['Boolean']>;
}



export interface IdentityCrossSiteRequestForgeryInput {
  token: Scalars['String'];
}










/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: Maybe<AuthenticationState>;
  /** The device ID (DUAID) */
  duaid: Scalars['UUID'];
  /** The Expedia User ID */
  expUserId?: Maybe<Scalars['String']>;
  /** The user TUID */
  tuid?: Maybe<Scalars['String']>;
}

export enum IdentityLayout {
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  GET_SEND_OTP_ATO = 'GET_SEND_OTP_ATO',
  GET_SET_PASSWORD_ATO = 'GET_SET_PASSWORD_ATO',
  GET_SIGN_IN_ATO = 'GET_SIGN_IN_ATO',
  GET_SIGN_IN_VERIFY_OTP_ATO = 'GET_SIGN_IN_VERIFY_OTP_ATO',
  GET_SIGN_UP_VERIFY_OTP_ATO = 'GET_SIGN_UP_VERIFY_OTP_ATO',
  GET_USER_DETAILS_ATO = 'GET_USER_DETAILS_ATO',
  LAUNCH_ONE_IDENTITY = 'LAUNCH_ONE_IDENTITY',
  RESET_PASSWORD = 'RESET_PASSWORD',
  SIGNIN = 'SIGNIN',
  SIGNUP = 'SIGNUP'
}





export interface IdentityPhoneDetailsInput {
  countryCode: Scalars['String'];
  locale: Scalars['String'];
  phoneNumber: Scalars['String'];
}
















export enum IdentitySocialButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export interface IdentitySocialInput {
  nonce: Scalars['String'];
  socialType: IdentitySocialType;
  token: Scalars['String'];
  tokenType: IdentitySocialTokenType;
}



export enum IdentitySocialTokenType {
  ACCESS = 'Access',
  AUTHCODE = 'AuthCode',
  ID = 'ID'
}

export enum IdentitySocialType {
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

/** EG Universal Login spacing definition */
export enum IdentitySpaceSize {
  S0X = 'S0X',
  S0XH = 'S0XH',
  S10X = 'S10X',
  S11X = 'S11X',
  S12X = 'S12X',
  S14X = 'S14X',
  S16X = 'S16X',
  S18X = 'S18X',
  S1X = 'S1X',
  S2X = 'S2X',
  S3X = 'S3X',
  S4X = 'S4X',
  S5X = 'S5X',
  S6X = 'S6X',
  S8X = 'S8X'
}


/** EG Universal Login input for IdentityFormSubmit mutation */
export interface IdentitySubmitRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  context: Scalars['String'];
  input: Array<GraphQlPairInput>;
  socialInput?: Maybe<IdentitySocialInput>;
}



export enum IdentitySuccessType {
  ONE_KEY_ONBOARDING = 'ONE_KEY_ONBOARDING',
  ORIGIN = 'ORIGIN'
}





















































/** Input type for fetching the Inquiry form. */
export interface InquiryFormInput {
  petsIncluded?: Maybe<Scalars['Boolean']>;
  primaryPropertyCriteriaInput?: Maybe<PrimaryPropertyCriteriaInput>;
}




export enum InquiryProminence {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

/** Input type for submitting a new Inquiry request. */
export interface InquiryRequestInput {
  inquirerPhoneCountryCode?: Maybe<Scalars['String']>;
  inquirerPhoneNumber?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  optInForMarketing?: Maybe<Scalars['Boolean']>;
  petsIncluded?: Maybe<Scalars['Boolean']>;
  primaryPropertyCriteriaInput: PrimaryPropertyCriteriaInput;
}




/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: Maybe<Scalars['String']>;
  /** Gaia region id of the location */
  regionId?: Maybe<Scalars['String']>;
}












/** GraphQL request for benefit details */
export interface InsuranceBenefitDetailsQueryRequestInput {
  /** Benefit Id for which the details are requested */
  benefitId: Scalars['String'];
  /** email src to collect analytics when it's true  */
  isEmailSrc?: Maybe<Scalars['Boolean']>;
  /** LOB of the booking */
  lob?: Maybe<Scalars['String']>;
  /** Order Id of the booking */
  orderNumber?: Maybe<Scalars['String']>;
  /** Trip Id of the booking */
  tripId?: Maybe<Scalars['String']>;
}


export interface InsuranceBookingCancellationRequestInput {
  orderId: Scalars['String'];
  orderLineId: Scalars['String'];
}



export interface InsuranceBookingOverviewRequestInput {
  /** LOB of the booking */
  lob?: Maybe<Scalars['String']>;
  /** Order Id of the booking */
  orderNumber?: Maybe<Scalars['String']>;
  /** Trip Id of the booking */
  tripId?: Maybe<Scalars['String']>;
}


/** GraphQL request for Insurance Claim Details */
export interface InsuranceClaimDetailsRequestInput {
  /** Order Id of the booking */
  orderNumber?: Maybe<Scalars['String']>;
}




/** Represents criteria for insurance. */
export interface InsuranceCriteriaInput {
  /** Represents free price match promise marketing placement */
  freePmpCustomerPlacement?: Maybe<Scalars['String']>;
  /** offer token for insurance product */
  insuranceOfferToken?: Maybe<Scalars['String']>;
  /** Represents PMP up-funnel selection */
  selectedProductId?: Maybe<Scalars['String']>;
}


export interface InsuranceDetailPrimingForCarInput {
  /** Identifier token for car inventory */
  carOfferToken: Scalars['String'];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: Maybe<Scalars['String']>;
  /** Drop-off location for car */
  dropOffLocation?: Maybe<InsuranceLocationInput>;
  /** Pick-up location for car */
  pickUpLocation: InsuranceLocationInput;
  /** Reward point selection on  Car offer */
  rewardPointsSelection?: Maybe<InsuranceRewardsPointSelectionEnum>;
  /** List of accessories added with Car */
  selectedAccessories?: Maybe<Array<Scalars['String']>>;
}

export interface InsuranceDetailPrimingRequestInput {
  /** Car request for insurance priming */
  carRequest: InsuranceDetailPrimingForCarInput;
}




export interface InsuranceFileAClaimRequestInput {
  benefitId: Scalars['String'];
  /** email src to collect analytics when it's true  */
  isEmailSrc?: Maybe<Scalars['Boolean']>;
  /** LOB of the booking */
  lob?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  tripId?: Maybe<Scalars['String']>;
}









export enum InsuranceListLayout {
  SINGLE_COLUMN = 'SINGLE_COLUMN'
}

export enum InsuranceListType {
  ORDERED = 'ORDERED',
  UNORDERED = 'UNORDERED'
}

export enum InsuranceListTypeOld {
  ICON = 'ICON',
  NUMBERED = 'NUMBERED'
}


export interface InsuranceLocationInput {
  /** Region id */
  regionId: Scalars['String'];
  /** Search term */
  searchTerm: Scalars['String'];
}


export enum InsuranceMessageType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING'
}


export enum InsuranceMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

export enum InsuranceMutationType {
  ADD_INSURANCE = 'ADD_INSURANCE',
  REMOVE_INSURANCE = 'REMOVE_INSURANCE'
}










export enum InsurancePhrasePartStyle {
  /** Green */
  COLOR_GREEN = 'COLOR_GREEN',
  /** Red */
  COLOR_RED = 'COLOR_RED',
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}







export enum InsuranceRewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS'
}


export interface InsuranceSelectionDetailsInput {
  /** Insurance id of already added insurance */
  existingInsuranceProductIds?: Maybe<Array<Scalars['String']>>;
}

export interface InsuranceShoppingRequestInput {
  /** Country code of user's residency - to be passed if akamai headers not present */
  countryCode?: Maybe<Scalars['String']>;
  /** Details of already added insurance */
  insuranceSelectionDetails?: Maybe<InsuranceSelectionDetailsInput>;
  /** Region code of user's residency - to be passed if akamai headers not present */
  regionCode?: Maybe<Scalars['String']>;
  /** TripId */
  tripId: Scalars['UUID'];
  /** In order to ignore the caching at client level and make an actual shopping call version hash is changed in subsequent requests */
  versionHash?: Maybe<Scalars['String']>;
}













export interface InsuranceTripMutationRequestInput {
  action: InsuranceMutationType;
  insuranceSearchId?: Maybe<Scalars['String']>;
  offerTypeId?: Maybe<Scalars['Int']>;
}











/** Client Id Possibilities */
export enum InsurtechClientId {
  CAR_INFO_SITE = 'CAR_INFO_SITE',
  EG_CHECKOUT = 'EG_CHECKOUT',
  FCR_CHECKOUT = 'FCR_CHECKOUT'
}

















/** Status Possibilities */
export enum InsurtechMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}


/** State represents teh status whether offer is already added, not added or some different offer is added */
export enum InsurtechOfferState {
  CHANGED_OFFER = 'CHANGED_OFFER',
  NOT_SELECTED = 'NOT_SELECTED',
  UNCHANGED_OFFER = 'UNCHANGED_OFFER'
}




export interface InsurtechPrimingCardRequestInput {
  /** Identifier offer for car inventory */
  offer: OfferIdentityInput;
}















/** Interaction to publish an event for */
export enum InteractionEventName {
  BOOK = 'BOOK',
  CHECKOUT_PAGE_LOAD = 'CHECKOUT_PAGE_LOAD',
  CONFIRMATION_PAGE_LOAD = 'CONFIRMATION_PAGE_LOAD'
}



/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: Maybe<Scalars['String']>;
  /** Name of interest */
  name?: Maybe<Scalars['String']>;
}


/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AICTRAVELGROUP = 'AICTRAVELGROUP',
  AMOMA = 'AMOMA',
  ANA = 'ANA',
  BESTBUYHOTEL = 'BESTBUYHOTEL',
  BONOTEL = 'BONOTEL',
  CNTRAVEL = 'CNTRAVEL',
  CTRIP = 'CTRIP',
  DESPEGAR = 'DESPEGAR',
  DIDATRAVEL = 'DIDATRAVEL',
  DIRECT_AGENCY = 'DIRECT_AGENCY',
  EUROPLAYAS = 'EUROPLAYAS',
  EXCITEHOLIDAYS = 'EXCITEHOLIDAYS',
  EZZEGO_1 = 'EZZEGO_1',
  GETAROOM = 'GETAROOM',
  HOME_AWAY = 'HOME_AWAY',
  HOTELDOBESTDAYTRAVEL = 'HOTELDOBESTDAYTRAVEL',
  HOTEL_BEDS = 'HOTEL_BEDS',
  HRS = 'HRS',
  JAC_TRAVEL = 'JAC_TRAVEL',
  JAL = 'JAL',
  JALAN = 'JALAN',
  JTB = 'JTB',
  JUMBOTOURS = 'JUMBOTOURS',
  MAGICROOMS = 'MAGICROOMS',
  MERCHANT = 'MERCHANT',
  MGBEDBANK = 'MGBEDBANK',
  MIKI = 'MIKI',
  MTS = 'MTS',
  NTA = 'NTA',
  NUITEE = 'NUITEE',
  OPAQUE = 'OPAQUE',
  OSTROVOK = 'OSTROVOK',
  PEGASUS = 'PEGASUS',
  RAKUTEN = 'RAKUTEN',
  RESTEL = 'RESTEL',
  ROOMER = 'ROOMER',
  SMYROOMS = 'SMYROOMS',
  SUNHOTELS = 'SUNHOTELS',
  THOMASCOOK_EUR = 'THOMASCOOK_EUR',
  THOMASCOOK_UK = 'THOMASCOOK_UK',
  TOURICO = 'TOURICO',
  TRAVELLANDA = 'TRAVELLANDA',
  TRAVELREPUBLIC = 'TRAVELREPUBLIC',
  VENERE = 'VENERE',
  VRBO = 'VRBO',
  WELCOME_BEDS = 'WELCOME_BEDS',
  WOORI = 'WOORI',
  WORLDHOTELLINK = 'WORLDHOTELLINK',
  WORLDSPAN = 'WORLDSPAN',
  WOTIF = 'WOTIF',
  YOUTRAVEL = 'YOUTRAVEL',
  ZUMATA = 'ZUMATA'
}













/** Represents a pair of segment order as index and the flight identifier as value */
export interface JourneyFlightSelectionInput {
  /** Represents the segment index. */
  journeyIndex: Scalars['Int'];
  /** Represents the flight combination the customer previously selected for the indexed segment. This will be used to highlight the previously selected offer for pinned listing. */
  offerIdentifier: Scalars['String'];
}








export enum KeyPhrasesClientType {
  DEFAULT = 'DEFAULT',
  FILTER = 'FILTER',
  SNIPPET = 'SNIPPET'
}






/** PWA ONLY: Input that is sent directly from the URL value. These inputs can not be parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: Maybe<Array<Scalars['String']>>;
  /** Maps to ReviewScoreRange */
  guestRating?: Maybe<Scalars['String']>;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: Maybe<Array<Scalars['String']>>;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: Maybe<Array<Scalars['Int']>>;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: Maybe<PrivacyTrackingState>;
  /** Maps to PropertySort */
  sort?: Maybe<Scalars['String']>;
  /** Maps to starList */
  stars?: Maybe<Scalars['String']>;
  /** Maps to StructureType */
  structureTypes?: Maybe<Array<Scalars['String']>>;
}














/** Line of business in request */
export enum LineOfBusiness {
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL'
}

/** Line of business */
export enum LineOfBusinessDomain {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  LODGING = 'LODGING',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED'
}

/** ADs related property search options  */
export enum Listings {
  /** Only return travelAds */
  ADS_ONLY = 'ADS_ONLY'
}




export enum LiveAnnouncePoliteness {
  ASSERTIVE = 'ASSERTIVE',
  OFF = 'OFF',
  POLITE = 'POLITE'
}
















/** Data type for AdaptEx testing. Contains a list of traveler states on UI to provide consistent experience. For more info, read https://github.expedia.biz/lodging-experience/experience-api-lodging-schema-reviews/blob/master/proposals/property-comparison-tool-adaptex/PROPOSAL.md */
export interface LodgingAdaptExContextInput {
  /** Contains a list of AdaptEx states */
  state: Array<LodgingAdaptExStateInput>;
}


/** Data type for AdaptEx testing. Contains a state of a traveler on UI to provide consistent experience. For example, it can indicate if user has seen a popup. */
export interface LodgingAdaptExStateInput {
  /** Name of the state. For example, 'userSawPrompt' */
  name: Scalars['String'];
  /** Value of the state. For example, 'true' */
  value: Scalars['String'];
}




























































/** Describes the type of product (line of business) that is being sold */
export enum LodgingCrossSellProductType {
  CAR = 'CAR'
}




























export enum LodgingFormMethod {
  GET = 'GET',
  POST = 'POST'
}










export enum LodgingInputType {
  EMAIL = 'EMAIL',
  HIDDEN = 'HIDDEN',
  PASSWORD = 'PASSWORD',
  TEL = 'TEL',
  TEXT = 'TEXT',
  URL = 'URL'
}
















/** Theme information for a message. */
export enum LodgingMessageTheme {
  /** To be used for warnings/errors; typically red. */
  AGGRESSIVE = 'AGGRESSIVE',
  /** To be used for success/perks; typically green. */
  HIGHLIGHT = 'HIGHLIGHT',
  /** To be used for emphasis; typically bold. */
  STRONG = 'STRONG'
}























































export enum LodgingStepperState {
  COMPLETE = 'COMPLETE',
  CURRENT = 'CURRENT',
  INCOMPLETE = 'INCOMPLETE'
}







export enum LodgingTrackPosition {
  END = 'END',
  STANDARD = 'STANDARD',
  START = 'START'
}

























export enum LoyaltyExperienceStrategy {
  HIDE_TRAVELER_INFO_AND_REWARDS_LINK = 'HIDE_TRAVELER_INFO_AND_REWARDS_LINK',
  SHOW_TRAVELER_INFO_AND_REWARDS_LINK = 'SHOW_TRAVELER_INFO_AND_REWARDS_LINK'
}




























/** Enumeration for 2fa/mfa verification method */
export enum MfaVerificationMethod {
  SMS = 'SMS',
  CALL = 'CALL'
}

export enum Moderation_Rule {
  BLOCK = 'BLOCK',
  ADVISE = 'ADVISE'
}

export enum Moderation_Type {
  WORD = 'WORD',
  CHARACTER = 'CHARACTER'
}






















/** The UDS icon used for the map marker */
export enum MapIconType {
  AIRPORT = 'AIRPORT',
  CIRCLE = 'CIRCLE',
  GROCERY = 'GROCERY',
  HOTEL = 'HOTEL',
  LANDMARK = 'LANDMARK',
  METRO = 'METRO',
  RESTAURANT = 'RESTAURANT',
  SOLD_OUT = 'SOLD_OUT',
  TRAIN = 'TRAIN',
  VACATION_RENTAL = 'VACATION_RENTAL'
}



/** Toolbar action type */
export enum MapToolbarActionsType {
  /** Show filters button in the toolbar */
  FILTERS = 'FILTERS'
}




/** The type of map marker */
export enum MarkerType {
  HOTEL = 'HOTEL',
  POI = 'POI'
}




/** Used to indicate what type of markup a field contains */
export enum MarkupTextType {
  /** Hypertext markup language */
  HTML = 'HTML'
}



export enum MealPlanFilterAmenity {
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FULL_BOARD = 'FULL_BOARD',
  HALF_BOARD = 'HALF_BOARD'
}




export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}


export interface MemberPricingInput {
  /** Discount percentage */
  discountPercentage?: Maybe<Scalars['Int']>;
  /** Is lead in offer MOD */
  leadInMemberOffer?: Maybe<Scalars['Boolean']>;
  /** Is any offer MOD */
  memberOfferAvailable?: Maybe<Scalars['Boolean']>;
}




export enum MemberWalletBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER'
}





















/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = 'ADDON',
  BRANDED_THEME_ACCENT = 'BRANDED_THEME_ACCENT',
  BRANDED_THEME_DARK = 'BRANDED_THEME_DARK',
  BRANDED_THEME_LIGHT = 'BRANDED_THEME_LIGHT',
  COMPRESSION = 'COMPRESSION',
  COUPON = 'COUPON',
  DOUBLE_POINTS = 'DOUBLE_POINTS',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  FREE_LX = 'FREE_LX',
  HOTRATE = 'HOTRATE',
  LEGAL = 'LEGAL',
  LOGIN = 'LOGIN',
  LOYALTY = 'LOYALTY',
  NO_CC = 'NO_CC',
  OVERFILTERED = 'OVERFILTERED',
  PARTNER_LINKOFF = 'PARTNER_LINKOFF',
  VACATION_RENTALS = 'VACATION_RENTALS'
}












/** Product natural keys required for session recovery */
export interface MishopRecoveryNaturalKeysInput {
  flightNaturalKeys: Array<FlightNaturalKeyInput>;
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}















/** Change Package Search Form Primer */
export interface MishopUiChangePackageFormPrimerInput {
  multiItemSessionId: Scalars['String'];
}













/** The type of button to display */
export enum MishopUiDialogButtonType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}






































/** Contains the necessary data for calling packageSummaryContent query */
export interface MishopUiPackageSummaryContentPrimerInput {
  naturalKey: PackageNaturalKeyInput;
}






/** Contains the necessary data for rendering to the customer a placard describing announcements relevant to their trip */
export interface MishopUiPlacardNotificationInput {
  multiItemPriceToken?: Maybe<Scalars['String']>;
  placardType: MishopUiPlacardType;
  priceDetailsOptions?: Maybe<PriceDetailsOptionsInput>;
  shoppedProducts: Array<ShoppedProductInput>;
}

export enum MishopUiPlacardType {
  PRICE_CHANGE = 'PRICE_CHANGE'
}

















export enum MishopUiProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  GROUND_TRANSFER = 'GROUND_TRANSFER',
  PROPERTY = 'PROPERTY'
}






/** Contains necessary data for fetching property content */
export interface MishopUiPropertyContentPrimerInput {
  changePropertyAction: PropertySearchMultiItemShoppingActionInput;
  changeRoomAction: PropertyDetailsMultiItemShoppingActionInput;
  naturalKey: PropertyNaturalKeyInput;
  propertyChangeLink?: Maybe<Scalars['String']>;
  relativeChangePropertyLink: Scalars['String'];
  relativeChangeRoomLink: Scalars['String'];
}






















export enum MobilitySearchDialogsId {
  /** This represents a dialog to display price summary details */
  PRICE_SUMMARY_DETAILS = 'PRICE_SUMMARY_DETAILS'
}




/** Pricing information */
export interface MoneyInput {
  /** DEPRECATED: Use platform formatters and return localized strings instead. Numeric portion of the price */
  amount: Scalars['Float'];
  /** DEPRECATED: The currency should be specified from the context instead. The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: Maybe<Scalars['String']>;
}


/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER'
}









/** The multi-item context used for package searches, contains information needed for package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: Scalars['String'];
  /** The package type for this search */
  packageType: PackageType;
}
























/** All natural keys for the products that the customer has already selected on the shopping path */
export interface MultiItemProductsInput {
  activities?: Maybe<Array<ActivityNaturalKeyInput>>;
  cars?: Maybe<Array<CarNaturalKeyInput>>;
  flights?: Maybe<Array<FlightNaturalKeyInput>>;
  groundTransfers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  packages?: Maybe<Array<PackageNaturalKeyInput>>;
  properties?: Maybe<Array<PropertyNaturalKeyInput>>;
}






/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: Maybe<Array<CarSearchCriteriaInput>>;
  flights?: Maybe<Array<FlightSearchCriteriaInput>>;
  properties?: Maybe<Array<PropertySearchCriteriaInput>>;
  /** Filter and sort for package level */
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}

















/** Enum class to represent the type of no cancel fee */
export enum NoCancelFeeType {
  NO_CANCEL_FEE = 'NO_CANCEL_FEE'
}

/** Enum class to represent the type of no change fee */
export enum NoChangeFeeType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE'
}
































/** The button type of the Customer notification submit button */
export enum NotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  /** Type of primary button */
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  /** Type of secondary button */
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  /** Type of tertiary button */
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}





/** Represents the target of the link */
export enum NotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB'
}

/** Represents the link type */
export enum NotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

export enum NotificationLocation {
  AFTER_HEADER = 'AFTER_HEADER',
  AFTER_WIZARD = 'AFTER_WIZARD',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  LEGAL = 'LEGAL',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER'
}

export enum NotificationLocationOnPage {
  AFTER_HEADER = 'AFTER_HEADER',
  AFTER_WIZARD = 'AFTER_WIZARD',
  ERROR = 'ERROR',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  LEGAL = 'LEGAL',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER'
}




/** Enumeration of possible layout types */
export enum NotificationMessageCardLayout {
  ICON_ON_SIDE = 'ICON_ON_SIDE',
  ICON_ON_TOP = 'ICON_ON_TOP'
}

/** The display type of the Customer notification message */
export enum NotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum NotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of info for the message */
  INFO = 'INFO',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}

export enum NotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = 'INVALID_INPUT',
  /** SERVICE_ERROR message */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** SUCCESS message */
  SUCCESS = 'SUCCESS'
}


/** Optional information to get a better contextual customer notification */
export interface NotificationOptionalContextInput {
  /** the optional field containing an error token, triggering the retrieval of an error message */
  errorToken?: Maybe<Scalars['String']>;
  /** itinerary number */
  itineraryNumber?: Maybe<Scalars['String']>;
  /** list of journey criteria items */
  journeyCriterias?: Maybe<Array<NotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: Maybe<Scalars['URL']>;
  /** the optional field containing the checkout session id to be able to measure key metrics */
  sessionId?: Maybe<Scalars['String']>;
  /** the optional field containing the token to retrieve the travel information */
  travelApiId?: Maybe<Scalars['String']>;
  /** trip folder id */
  tripFolderId?: Maybe<Scalars['String']>;
  /** trip item id */
  tripItemId?: Maybe<Scalars['String']>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaFiltersInput {
  /** airport code */
  airlinesFilter?: Maybe<Array<Scalars['String']>>;
  /** flight amenities */
  amenitiesFilter?: Maybe<Array<AmenityFilter>>;
  /** arrival time */
  arrivalTimeFilter?: Maybe<Array<FlightsTimePeriodOfDay>>;
  /** departure time */
  departureTimeFilter?: Maybe<Array<FlightsTimePeriodOfDay>>;
  /** number of stops */
  numberOfStopsFilter?: Maybe<Array<Scalars['Int']>>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaInput {
  /** cabin class */
  cabinClass?: Maybe<FlightsCabinClass>;
  /** start date and end date of the trip */
  dateRange?: Maybe<DateRangeInput>;
  /** destination information */
  destination?: Maybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** trip filters */
  filter?: Maybe<Array<NotificationOptionalContextJourneyCriteriaFiltersInput>>;
  /** origin information */
  origin?: Maybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** trip schedule changes status */
  scheduleChangeStatus?: Maybe<TripScheduleChangeStatus>;
  /** traveler details */
  travelerDetail?: Maybe<Array<TravelerDetailsInput>>;
  /** trip type */
  tripType?: Maybe<FlightsTripType>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: Maybe<Scalars['String']>;
  /** property id */
  propertyId?: Maybe<Scalars['String']>;
  /** regionId number */
  regionId?: Maybe<Scalars['String']>;
}



/** The style to apply to phrase links */
export enum NotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

/** The theme to apply to phrase links */
export enum NotificationPhraseLinkTheme {
  DEFAULT = 'DEFAULT',
  INVERSE = 'INVERSE'
}


/** The text style to apply to strings */
export enum NotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}









/** Represents the attributes on a notification that could be changed after an interaction */
export interface NotificationSpecificationsInput {
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars['Boolean']>;
  /** Notification id */
  id?: Maybe<Scalars['String']>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars['Boolean']>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars['Boolean']>;
}

export enum NotificationState {
  READ = 'READ',
  SEEN = 'SEEN',
  UNKNOWN = 'UNKNOWN',
  UNSEEN = 'UNSEEN'
}

export enum NotificationSubType {
  COUPON_CAMPAIGN = 'COUPON_CAMPAIGN',
  DEFAULT = 'DEFAULT'
}





export enum NotificationType {
  ALERT = 'ALERT',
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  BOTTOM_SHEET = 'BOTTOM_SHEET',
  CENTERED_SHEET = 'CENTERED_SHEET',
  CITI_COBRAND = 'CITI_COBRAND',
  CITI_COBRAND_VERTICAL = 'CITI_COBRAND_VERTICAL',
  CLEANLINESS = 'CLEANLINESS',
  CONFIGURABLE = 'CONFIGURABLE',
  ERROR = 'ERROR',
  GENERIC = 'GENERIC',
  HEADER = 'HEADER',
  INBOX = 'INBOX',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  ONETRUST = 'ONETRUST',
  ONE_KEY = 'ONE_KEY',
  OSANO = 'OSANO',
  RAF_BANNER = 'RAF_BANNER',
  TAKEOVER = 'TAKEOVER',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY',
  TRUST_MSG_BANNER = 'TRUST_MSG_BANNER',
  UNRECOVERABLE_ERROR = 'UNRECOVERABLE_ERROR'
}


export enum NotificationUserActionType {
  DELETE = 'DELETE',
  MARK_AS_READ = 'MARK_AS_READ',
  MARK_AS_UNREAD = 'MARK_AS_UNREAD',
  UNKNOWN = 'UNKNOWN'
}

/** Represents the the user input for customer notification mutation */
export interface NotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<NotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface NotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars['String'];
  /** Represents the value of customer notification user input */
  value: Scalars['String'];
}

export enum NotificationsType {
  ALL = 'ALL'
}


/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: Scalars['String'];
  value: Scalars['Int'];
}




export enum OfferAttributeType {
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CC_REQUIRED = 'NO_CC_REQUIRED',
  PAYMENT_CHOICE = 'PAYMENT_CHOICE',
  VIP = 'VIP'
}








export interface OfferIdentityInput {
  /** Type of the offer details whether token or id */
  type: OfferIdentityType;
  /** The value of the identifier */
  value: Scalars['String'];
}

/** The identity to get or update insurtech offers could be both */
export enum OfferIdentityType {
  EG_OFFER_ID = 'EG_OFFER_ID',
  EG_OFFER_TOKEN = 'EG_OFFER_TOKEN'
}









/**
 * Represents EG Travel Platform API, consists of a productLine enumeration and a token.
 * https://confluence.expedia.biz/display/RPT/RFC-62-EG+-+OfferToken+-+guidelines+for+Product+Line+SPIs
 */
export interface OfferTokenInput {
  /** ProductLine associated with an Offer Token */
  lineOfBusiness: LineOfBusinessDomain;
  /** Encoded offer token string used to identify a specific product offer for purchase */
  token: Scalars['String'];
}







export interface OffersRecommendationAvailabilityFilterInput {
  dates?: Maybe<OptionalDateTimeRangeInput>;
  destination?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  travelMemberGroups?: Maybe<Array<TravelMemberGroupInput>>;
}







export enum OffersRecommendationContainerType {
  CAROUSEL = 'CAROUSEL',
  GRID = 'GRID'
}



export interface OffersRecommendationProductIdentifierInput {
  lineOfBusiness: LineOfBusinessDomain;
  productId: Scalars['String'];
}

export enum OffersRecommendationStrategy {
  ALTERNATE = 'ALTERNATE',
  ATTACH = 'ATTACH',
  CO_CLICK = 'CO_CLICK',
  NEARBY = 'NEARBY',
  POPULAR = 'POPULAR',
  TRENDING = 'TRENDING'
}



export interface OnboardingContext {
  onboardingSource: Scalars['String'];
}














export enum OneKeyOnboardingOperationStatus {
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED',
  TIMED_OUT = 'TIMED_OUT'
}








export enum Operation {
  ADDITION = 'ADDITION',
  MULTIPLICATION = 'MULTIPLICATION'
}

export enum OperationStatus {
  FAILURE = 'FAILURE',
  INVALID_INPUT = 'INVALID_INPUT',
  SUCCESS = 'SUCCESS'
}



/** In order to pass any additional parameters */
export interface OptionalContextInput {
  /** Indicates if user is on desktop dropdown view */
  dropdownView?: Maybe<Scalars['Boolean']>;
  /** Indicates if client is in dark mode */
  isDarkMode?: Maybe<Scalars['Boolean']>;
  /** If app user has enabled push notification in the device */
  pushEnabled?: Maybe<Scalars['Boolean']>;
}


/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export interface OptionalDateTimeRangeInput {
  /** Optional terminal date & time in this range */
  end?: Maybe<DateTimeInput>;
  /** Optional starting date & time in this range */
  start?: Maybe<DateTimeInput>;
}

export interface OrderInfoInput {
  orderId: Scalars['String'];
  orderLine?: Maybe<Scalars['String']>;
}

/** Possible values for UITK mark's orientation prop */
export enum Orientation {
  /** Landscape orientation */
  LANDSCAPE = 'LANDSCAPE',
  /** Portrait orientation */
  PORTRAIT = 'PORTRAIT'
}














/** Package location */
export interface PackageLocationInput {
  airportCode: Scalars['String'];
  /** The Geo location of the region to search */
  coordinates?: Maybe<CoordinatesInput>;
  regionId?: Maybe<Scalars['String']>;
  /** The name of the region */
  regionName?: Maybe<Scalars['String']>;
}


/** Minimum set of data used to retrieve content about a package */
export interface PackageNaturalKeyInput {
  offerToken: Scalars['String'];
}




/** Represents the search criteria with which customers searched for packages */
export interface PackageSearchCriteriaInput {
  primary: PrimaryPackageSearchCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}







export enum PackageSort {
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED'
}

export enum PackageType {
  FLIGHT_CAR = 'FLIGHT_CAR',
  FLIGHT_HOTEL = 'FLIGHT_HOTEL',
  FLIGHT_HOTEL_CAR = 'FLIGHT_HOTEL_CAR',
  HOTEL_CAR = 'HOTEL_CAR'
}






export interface PackageUiActivityHeaderPrimerInput {
  productType: MishopUiProductType;
}





















export interface PackageUiFlightHeaderPrimerInput {
  productType: MishopUiProductType;
}



export interface PackageUiGroundTransferHeaderPrimerInput {
  productType: MishopUiProductType;
}
























/** Contains the necessary data to render banner for a changed product */
export interface PackageUiProductChangedBannerPrimerInput {
  currentPackageOfferId: PackageNaturalKeyInput;
  previousOffers: MultiItemProductsInput;
  previousPackageOfferId: PackageNaturalKeyInput;
}




/** Information needed to render the prebundle package product header */
export interface PackageUiProductHeaderPrimerInput {
  activityHeaderPrimer?: Maybe<PackageUiActivityHeaderPrimerInput>;
  flightHeaderPrimer?: Maybe<PackageUiFlightHeaderPrimerInput>;
  groundTransferHeaderPrimer?: Maybe<PackageUiGroundTransferHeaderPrimerInput>;
  propertyHeaderPrimer?: Maybe<PackageUiPropertyHeaderPrimerInput>;
}



export interface PackageUiPropertyHeaderPrimerInput {
  productType: MishopUiProductType;
}











/** Optional custom context information about the page where the query results will eventually be rendered */
export interface PageContextInput {
  propertySearch?: Maybe<PropertySearchCriteriaInput>;
}


/** Page identity */
export enum PageLocation {
  /** All checkout related pages */
  CHECKOUT = 'CHECKOUT',
  /** Checkout error pages for all LOBs */
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  /** Order confirmation pages for all LOBs */
  CONFIRMATION = 'CONFIRMATION',
  /** All product detail pages are identified as DETAILS */
  DETAILS = 'DETAILS',
  /** All landing, launch, published and any other page that will lead a user down to a search or detail page regardless of LOB */
  ENTRY = 'ENTRY',
  /** Pages that are not in the main shopping flow or that show up all across the flow such as Ads, Recommendation, Urgency, Scratchpad, etc. */
  FEATURES = 'FEATURES',
  /** Payment error pages for all LOBs */
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  /** Post booking pages including itin, trip summary, trip details, customer service etc */
  POST_BOOKING = 'POST_BOOKING',
  /** All LOB search result pages are identified as SEARCH_RESULTS */
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  /** All pages that are not customer facing, that are for internal system or monitoring such as isWorking, health check, dev tools page, etc */
  SYSTEM = 'SYSTEM',
  /** User pages including sign-in, my account and rewards */
  USER = 'USER'
}

export enum PageState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}

/** Input for travelGuidePageContextInput pageType parameter */
export enum PageType {
  HOME_PAGE = 'HOME_PAGE',
  TRAVEL_GUIDE = 'TRAVEL_GUIDE'
}



export interface PaginationDetailsInput {
  next?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  previous?: Maybe<Scalars['Int']>;
}

/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: Maybe<Scalars['Int']>;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: Maybe<Scalars['Int']>;
}


/** Represents input data related to a participant */
export interface ParticipantInput {
  /** Represents subscriptionId received from experience-api-conversation, it will be passed in conversation attributes to publish messages. */
  subscriptionId?: Maybe<Scalars['String']>;
}

export interface PartnerContextInput {
  detailsSiteConfiguration?: Maybe<TravelStoreV1CarDetailsInput>;
  partnerAccountId: Scalars['String'];
  searchSiteConfiguration?: Maybe<TravelStoreV1CarSearchInput>;
}












export enum PasswordWithStrengthMeterInputStrength {
  STRONG = 'STRONG',
  VERY_STRONG = 'VERY_STRONG',
  WEAK = 'WEAK'
}



export enum PasswordWithStrengthMeterProgressBarTheme {
  MUTED = 'MUTED',
  POSITIVE = 'POSITIVE'
}

















export interface PaymentCheckoutIdentifierInput {
  sessionId?: Maybe<Scalars['String']>;
  sessionToken?: Maybe<Scalars['String']>;
}




export interface PaymentContextualInfoInput {
  bin?: Maybe<Scalars['String']>;
  etzToken?: Maybe<Scalars['String']>;
  providerConfirmationStatus?: Maybe<Scalars['String']>;
}






































export enum PaymentMethodType {
  AFFIRM = 'AFFIRM',
  CREDIT_CARD = 'CREDIT_CARD',
  INVALID = 'INVALID',
  UNRECOGNIZED = 'UNRECOGNIZED'
}








export interface PaymentPrepareFopRequestInput {
  fopItems: Array<FopItemInput>;
  paymentSessionId: Scalars['String'];
  userInfo: PaymentUserInfoInput;
}




export interface PaymentSelectFopRequestInput {
  checkoutIdentifier: PaymentCheckoutIdentifierInput;
  fopItems: Array<FopItemInput>;
  paymentSessionId: Scalars['String'];
}

export enum PaymentState {
  STATE_CANCELLED = 'STATE_CANCELLED',
  STATE_DISABLED = 'STATE_DISABLED',
  STATE_INVALID = 'STATE_INVALID',
  STATE_REMOVED = 'STATE_REMOVED',
  STATE_SELECTED = 'STATE_SELECTED',
  STATE_UNSELECTED = 'STATE_UNSELECTED',
  UNRECOGNIZED = 'UNRECOGNIZED'
}




export enum PaymentType {
  COUPON_ELIGIBLE = 'COUPON_ELIGIBLE',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  GIFT_CARD = 'GIFT_CARD',
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_WITHOUT_CREDITCARD = 'PAY_WITHOUT_CREDITCARD'
}



/** Represents the logo size used by the client to render */
export enum PaymentTypeLogoSize {
  LARGE = 'LARGE',
  SMALL = 'SMALL'
}



export interface PaymentUpdateFopRequestInput {
  checkoutIdentifier: PaymentCheckoutIdentifierInput;
  fopItems: Array<FopItemInput>;
  paymentSessionId: Scalars['String'];
}


export interface PaymentUserInfoInput {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
}





export enum PickerTriggerDisplayType {
  GLOBAL_NAV_BUTTON = 'GLOBAL_NAV_BUTTON',
  GLOBAL_NAV_LINK = 'GLOBAL_NAV_LINK'
}

export enum PickerTriggerPlacementType {
  MENU_ITEM = 'MENU_ITEM',
  NAV_LINK = 'NAV_LINK'
}





export enum Placement {
  /** Horizontal Orientation of Images in the List */
  HORIZONTAL = 'Horizontal',
  /** Vertical Orientation of Images in the List */
  VERTICAL = 'Vertical'
}








/**
 * Languages vary in how they handle plurals of nouns or unit expressions ("hour" vs "hours", and so on).
 * Some languages have two forms, like English; some languages have only a single form; and some languages have multiple forms. CLDR uses short, mnemonic tags for these plural categories.
 * http://cldr.unicode.org/index/cldr-spec/plural-rules
 */
export enum PluralCategory {
  FEW = 'FEW',
  MANY = 'MANY',
  ONE = 'ONE',
  OTHER = 'OTHER',
  TWO = 'TWO',
  ZERO = 'ZERO'
}



/** Points related property search options  */
export enum Points {
  /** Don't use loyalty points to calculate the strikeout price. */
  SHOP_WITHOUT_POINTS = 'SHOP_WITHOUT_POINTS',
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}







export interface PolicyFetchParamsInput {
  cartId?: Maybe<Scalars['String']>;
  offerToken?: Maybe<OfferTokenInput>;
  orderInfo?: Maybe<OrderInfoInput>;
}























/** Options that alter behavior of mutation - for backward compatibility */
export enum PrepareCheckoutResponseOption {
  ALTERNATIVE_ACTION_ON_FAILURE = 'ALTERNATIVE_ACTION_ON_FAILURE'
}






export interface PriceDetailsOptionsInput {
  metaDeeplink: Scalars['Boolean'];
}






export interface PriceFilterInput {
  facetValuesSize: Scalars['Int'];
  max: Scalars['Int'];
  maxIndex: Scalars['Int'];
  min: Scalars['Int'];
}
















export interface PriceInsightsCreateMutationDataInput {
  lowestPredictedPrice?: Maybe<Scalars['Float']>;
  lowestPredictedPriceDate?: Maybe<Scalars['String']>;
  priceTrend?: Maybe<Scalars['String']>;
  timeSeriesTierShown: Scalars['Int'];
}

/** Represents a query parameter in the deep link. */
export interface PriceInsightsDeepLinkQueryParamInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

export interface PriceInsightsDisableMutationDataInput {
  lowestPredictedPrice?: Maybe<Scalars['Float']>;
  lowestPredictedPriceDate?: Maybe<Scalars['String']>;
  priceTrend?: Maybe<Scalars['String']>;
  timeSeriesTierShown: Scalars['Int'];
}
















/** Represent search context for all product lines */
export interface PriceInsightsSearchContextInput {
  carSearchCriteria?: Maybe<CarSearchCriteriaInput>;
  flightSearchCriteria?: Maybe<FlightSearchCriteriaInput>;
  propertySearchCriteria?: Maybe<PropertySearchCriteriaInput>;
}












export interface PriceInsightsUpdateMutationDataInput {
  lowestPredictedPrice?: Maybe<Scalars['Float']>;
  lowestPredictedPriceDate?: Maybe<Scalars['String']>;
  priceTrend?: Maybe<Scalars['String']>;
  timeSeriesTierShown: Scalars['Int'];
}




export enum PriceMatchPromiseChartType {
  BAR = 'BAR',
  LINE = 'LINE'
}














export enum PriceMatchPromiseScaleType {
  DATE = 'DATE',
  LABEL = 'LABEL',
  TIME = 'TIME'
}



/** Represents the state for the PMP module */
export enum PriceMatchPromiseState {
  /** Represents when the PMP module is removable */
  REMOVABLE = 'REMOVABLE',
  /** Represents when the PMP module is selectable */
  SELECTABLE = 'SELECTABLE',
  /** Represents when the PMP module is static */
  STATIC = 'STATIC',
  /** Represents when the PMP module is toggleable */
  TOGGLEABLE = 'TOGGLEABLE'
}



















/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: Maybe<Scalars['Float']>;
  /** The minimum price, e.g. 50.00 */
  min?: Maybe<Scalars['Float']>;
}
















export enum PricingSchemeType {
  DAILY_RATE = 'DAILY_RATE',
  TOTAL_RATE = 'TOTAL_RATE'
}


/** Core criteria needed for an activities search */
export interface PrimaryActivitySearchCriteriaInput {
  dateRange?: Maybe<ActivitySearchCriteriaDateRangeInput>;
  destination?: Maybe<ActivitySearchCriteriaLocationInput>;
}


/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;
  dropOffLocation?: Maybe<CarRentalLocationInput>;
  pickUpDateTime: DateTimeInput;
  pickUpLocation: CarRentalLocationInput;
}

/** The core criteria needed for a cruise search */
export interface PrimaryCruiseCriteriaInput {
  adultCount?: Maybe<Scalars['Int']>;
  childCount?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<CruiseChildInput>>;
  departureDateRange?: Maybe<DateRangeInput>;
  destinations?: Maybe<Array<Scalars['String']>>;
  durationRange?: Maybe<CruiseDurationRangeInput>;
}


/** Represents the core criteria needed for a flight search */
export interface PrimaryFlightCriteriaInput {
  journeyCriterias: Array<FlightsJourneyCriteriaInput>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  travelers: Array<TravelerDetailsInput>;
  tripType: FlightsTripType;
}


/** The core criteria needed for a ground transfers or air transportation search */
export interface PrimaryGroundTransfersCriteriaInput {
  dateRange: OptionalDateTimeRangeInput;
  direction: GroundTransfersDirection;
  journeyCriteria?: Maybe<Array<GroundTransfersJourneyCriteriaInput>>;
  locations: Array<GroundTransfersLocationInput>;
  pinnedOffers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  pinnedProductIds?: Maybe<Array<Scalars['String']>>;
  selectedOffers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  shoppingPath?: Maybe<ShoppingPathType>;
  travelerDetails: Array<GroundTransfersTravelerDetailsInput>;
}




export interface PrimaryPackageSearchCriteriaInput {
  /** Cabin class chosen for flight */
  cabinClass?: Maybe<FlightsCabinClass>;
  /** If not provided, packages returned will be for different duration and popular advance purchase window based on the themes */
  dateRange?: Maybe<DateRangeInput>;
  /** If not provided, packages returned will be for different popular destinations based on the themes */
  destination?: Maybe<PackageLocationInput>;
  /** If not provided, it will be resolved using user profile or ip sniffing */
  origin?: Maybe<PackageLocationInput>;
  /** If not provided, it will be defaulted to 1 occupancy unit for 2 adults */
  travelerOccupancyGroups?: Maybe<Array<TravelerOccupancyGroupInput>>;
}


/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: Maybe<PropertyDateRangeInput>;
  destination: DestinationInput;
  flexSearchCriteria?: Maybe<FlexibleSearchCriteriaInput>;
  rooms: Array<RoomInput>;
}

/** User preference for data sharing with third parties which users may update */
export enum PrivacySellState {
  CAN_NOT_SELL = 'CAN_NOT_SELL',
  CAN_SELL = 'CAN_SELL'
}

/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = 'CAN_NOT_TRACK',
  CAN_TRACK = 'CAN_TRACK'
}










export enum ProductEntityAssetSelection {
  AMENITY = 'AMENITY',
  HEADLINE = 'HEADLINE',
  RELEVANT_AMENITY_DETAILS = 'RELEVANT_AMENITY_DETAILS',
  REVIEW_SUMMARY = 'REVIEW_SUMMARY'
}

/** Product Entity Input params */
export interface ProductEntityInput {
  /** product line */
  assetSelectionList: Array<ProductEntityAssetSelection>;
  /** Product Identifier */
  productIdentifier: ProductIdentifierInput;
}

/** Product Identifier wrapping type */
export interface ProductIdentifierInput {
  /** Id */
  id: Scalars['String'];
  /** product line */
  productLine?: Maybe<ProductLine>;
  /** search context */
  searchCriteriaSelections?: Maybe<Array<SearchCriteriaSelectionsInput>>;
  /** Identifier Type of Input */
  type: IdentifierType;
}


/** Enum to specify image width for product image */
export enum ProductImageWidth {
  FULL_WIDTH = 'FULL_WIDTH',
  HALF_WIDTH = 'HALF_WIDTH',
  QUARTER_WIDTH = 'QUARTER_WIDTH',
  THIRD_WIDTH = 'THIRD_WIDTH'
}



export enum ProductLine {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  GROUND_TRANSFER = 'GROUND_TRANSFER',
  INSURANCE = 'INSURANCE',
  LODGING = 'LODGING',
  PACKAGE = 'PACKAGE',
  PRODUCT_LINE_INVALID = 'PRODUCT_LINE_INVALID',
  RAIL = 'RAIL',
  UNRECOGNIZED = 'UNRECOGNIZED'
}







/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: Maybe<Scalars['String']>;
}

export enum ProductQuestionTopic {
  HOTEL = 'HOTEL'
}









/** Input to productSummary Query */
export interface ProductSummaryInput {
  /** Identifier String of Input */
  id: Scalars['String'];
  /** Identifier Type of Input */
  idType: IdentifierType;
}




export enum ProductType {
  ARTICLE = 'ARTICLE',
  CAR_DETAILS = 'CAR_DETAILS',
  DESTINATION = 'DESTINATION',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  EXPERIENCE = 'EXPERIENCE',
  EXPERT_TIP = 'EXPERT_TIP',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LX_DETAILS = 'LX_DETAILS',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI_GAIA = 'POI_GAIA',
  PROPERTY_DETAILS = 'PROPERTY_DETAILS'
}




















/** Represents layout of buttons. */
export enum ProfileButtonLayout {
  /** Horizontally stacked buttons. */
  INLINE = 'INLINE',
  /** Vertically stacked buttons. */
  STACKED = 'STACKED'
}






















/** Specifies whether to open the link in the same user interface context or in a different context */
export enum ProfileLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}





















/** Represents where a wizard will be displayed */
export interface ProfileWizardContextInput {
  lineOfBusiness: LineOfBusinessDomain;
  pageLocation: PageLocation;
}




/** Possible actions for the Activities Cross Sell links that will be shown as a sticky card on PDP  */
export enum PropertyActivitiesCrossSellActionType {
  DISMISS = 'DISMISS',
  EDIT = 'EDIT',
  OPEN = 'OPEN',
  REMOVE = 'REMOVE'
}








/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  PARKING = 'PARKING',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WATERSLIDE = 'WATERSLIDE'
}


export enum PropertyAmenityType {
  ACCESSIBILITY = 'ACCESSIBILITY',
  BATHROOM = 'BATHROOM',
  BEDROOM = 'BEDROOM',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CONVENIENCES = 'CONVENIENCES',
  ENTERTAINMENT = 'ENTERTAINMENT',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FOOD_DRINK = 'FOOD_DRINK',
  GUEST_SERVICES = 'GUEST_SERVICES',
  INTERNET = 'INTERNET',
  MORE = 'MORE',
  OUTDOOR = 'OUTDOOR',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PROPERTY = 'PROPERTY',
  ROOM = 'ROOM',
  SPA = 'SPA',
  THINGS_TO_DO = 'THINGS_TO_DO'
}





export enum PropertyCalendarPriceTrend {
  /** Negative price trend */
  NEGATIVE = 'NEGATIVE',
  /** Positive price trend */
  POSITIVE = 'POSITIVE'
}




export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  REFUNDABLE_WITH_NO_PENALTY = 'REFUNDABLE_WITH_NO_PENALTY',
  REFUNDABLE_WITH_PENALTY = 'REFUNDABLE_WITH_PENALTY'
}




















export enum PropertyContentType {
  /** Detailed view that appears in expanded modal. */
  DETAILED = 'DETAILED',
  /** Simplified view that appears flat on page. */
  SUMMARY = 'SUMMARY'
}

export interface PropertyContext {
  propertyId: Scalars['String'];
}


export interface PropertyDateRangeInput {
  checkInDate: DateInput;
  checkOutDate: DateInput;
}






export interface PropertyDetailsMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

export enum PropertyDetailsPropertyType {
  HOTEL = 'HOTEL',
  VACATION_RENTAL = 'VACATION_RENTAL'
}







export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = 'ACCESSIBLE_BATHROOM',
  ACCESSIBLE_PARKING = 'ACCESSIBLE_PARKING',
  ELEVATOR = 'ELEVATOR',
  IN_ROOM_ACCESSIBLE = 'IN_ROOM_ACCESSIBLE',
  ROLL_IN_SHOWER = 'ROLL_IN_SHOWER',
  SERVICE_ANIMAL = 'SERVICE_ANIMAL',
  SIGN_LANGUAGE_INTERPRETER = 'SIGN_LANGUAGE_INTERPRETER',
  STAIR_FREE_PATH = 'STAIR_FREE_PATH'
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  BALCONY_OR_TERRACE = 'BALCONY_OR_TERRACE',
  BAR = 'BAR',
  BEACH = 'BEACH',
  CASINO = 'CASINO',
  CRIB = 'CRIB',
  ELECTRIC_CAR = 'ELECTRIC_CAR',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  GOLF = 'GOLF',
  GYM = 'GYM',
  HOT_SPRING = 'HOT_SPRING',
  HOT_TUB = 'HOT_TUB',
  KITCHEN_KITCHEN = 'KITCHEN_KITCHEN',
  KITCHEN_KITCHENETTE = 'KITCHEN_KITCHENETTE',
  OCEAN_VIEW = 'OCEAN_VIEW',
  PARKING = 'PARKING',
  PETS = 'PETS',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  SPA_ON_SITE = 'SPA_ON_SITE',
  WASHER_DRYER = 'WASHER_DRYER',
  WATER_PARK = 'WATER_PARK',
  WIFI = 'WIFI'
}




















/** Options that are not filters. Refer @code { SearchOptions } */
export enum PropertyInfoOptions {
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}








/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta affcid channel code */
  affcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afflid channel code */
  afflid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afmcid channel code */
  afmcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta brandcid channel code */
  brandcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emlcid channel code */
  emlcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emldtl channel code */
  emldtl?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta gclid channel code */
  gclid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmcid channel code */
  icmcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmdtl channel code */
  icmdtl?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta k_user_id channel code */
  k_user_id?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta kword channel code */
  kword?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta lnkloc channel code */
  lnkloc?: Maybe<Scalars['String']>;
  /**
   * A consolidated list of marketing channels in key/value pairs.
   * Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}]
   */
  marketingChannels?: Maybe<Array<PropertyMarketingTagInput>>;
  /**
   * A consolidated list of marketing prices in key/value pairs.
   * Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}]
   */
  marketingPrices?: Maybe<Array<PropertyMarketingTagInput>>;
  /** Deprecated: Don't get/set value from this field , ReplaceWith("marketingChannels") ,Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: Maybe<Scalars['Int']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta mdpcid channel code */
  mdpcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field,ReplaceWith("marketingChannels"),  Meta mdpdtl channel code */
  mdpdtl?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta olacid channel code */
  olacid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta oladtl channel code */
  oladtl?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semcid channel code */
  semcid?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semdtl channel code */
  semdtl?: Maybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta seocid channel code */
  seocid?: Maybe<Scalars['String']>;
}


/**
 * An object with simple key/value combination for a marketing channel or price.
 * Example: {"key": "mctc", "value": "3"}
 */
export interface PropertyMarketingTagInput {
  key: Scalars['String'];
  value: Scalars['String'];
}


/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  businessModelType?: Maybe<BusinessModelType>;
  checkIn: DateInput;
  checkOut: DateInput;
  id: Scalars['String'];
  inventoryType: InventoryType;
  noCreditCard?: Maybe<Scalars['Boolean']>;
  /** Pet permissibility & inclusion at property. Necessary when pets are used in primary search criteria */
  petsIncluded?: Maybe<Scalars['Boolean']>;
  ratePlanId: Scalars['String'];
  ratePlanType?: Maybe<Scalars['String']>;
  roomTypeId: Scalars['String'];
  rooms: Array<PropertyRoomInput>;
  shoppingPath?: Maybe<ShoppingPathType>;
}



/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  /** Sometimes, 1 room's offer needs to be represented by more than 1 Property Natural Key, e.g: Mixed Rate Plan */
  naturalKeys: Array<PropertyNaturalKeyInput>;
  /** The index of the room user is adding */
  offerIndex: Scalars['Int'];
}





export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = 'ARTIFICIALLY_FENCED_RATE',
  MIXED_RATE_PLAN = 'MIXED_RATE_PLAN',
  NO_CREDIT_CARD = 'NO_CREDIT_CARD'
}

export enum PropertyPaymentModel {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}



/** Indicate what are the payment options for a given offer */
export enum PropertyPaymentType {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}






export enum PropertyRecommendationStrategy {
  NEARBY_PROPERTIES = 'NEARBY_PROPERTIES',
  SIMILAR_PROPERTIES = 'SIMILAR_PROPERTIES'
}





/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = 'BUSINESS_TRAVELERS',
  COUPLES = 'COUPLES',
  EVERYONE = 'EVERYONE',
  FAMILIES = 'FAMILIES',
  GETAWAY_WITH_FRIENDS = 'GETAWAY_WITH_FRIENDS',
  GOLF = 'GOLF',
  OTHER = 'OTHER',
  OVERNIGHT_STAY = 'OVERNIGHT_STAY',
  PERSONAL_EVENT = 'PERSONAL_EVENT',
  SHOPPING = 'SHOPPING',
  SPA = 'SPA',
  STUDENTS = 'STUDENTS'
}



/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: Maybe<PropertyReviewCategory>;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: Maybe<Scalars['Boolean']>;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: Maybe<Scalars['Boolean']>;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: Maybe<Scalars['String']>;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: Maybe<Scalars['Locale']>;
  /** Filter review results by a list of review ratings */
  ratings?: Maybe<Array<Scalars['Float']>>;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: Maybe<PropertyReviewType>;
  /** Filter review results by room type */
  roomTypeId?: Maybe<Scalars['Int']>;
  /** Filter review results by user provided keyword */
  searchTerm?: Maybe<Scalars['String']>;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED - Replaced by travelerType param. Filter review results by travel companions */
  travelCompanion?: Maybe<Array<Scalars['String']>>;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED - Replaced by travelerType param. Filter review results by trip reasons */
  tripReason?: Maybe<Array<Scalars['String']>>;
}








/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  NEWEST_TO_OLDEST_BY_LANGUAGE = 'NEWEST_TO_OLDEST_BY_LANGUAGE',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST',
  OLDEST_TO_NEWEST_BY_LANGUAGE = 'OLDEST_TO_NEWEST_BY_LANGUAGE'
}




/** [Optional] Review filter type */
export enum PropertyReviewType {
  /** filter reviews by rating <= 2 */
  CRITICAL = 'CRITICAL',
  /** filter reviews by rating >= 3 */
  POSITIVE = 'POSITIVE',
  /** filter reviews by latest date */
  RECENT = 'RECENT'
}





/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: Array<Scalars['Int']>;
  numberOfAdults: Scalars['Int'];
}



/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}



/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER] will return properties with a roll in shower */
  accessibility?: Maybe<Array<PropertyFilterAccessibility>>;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: Maybe<Array<AgencyBusinessModel>>;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: Maybe<Array<PropertyFilterAmenity>>;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: Maybe<Array<Scalars['Int']>>;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: Maybe<Scalars['String']>;
  /** Filter results by property cleanliness attribute */
  cleaningAndSafetyPractices?: Maybe<Array<CleaningAndSafetyPractice>>;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: Maybe<Array<CommissionTier>>;
  /** Filter results by Deals */
  deals?: Maybe<Array<DealType>>;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: Maybe<Array<MealPlanFilterAmenity>>;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: Maybe<Scalars['String']>;
  /** Filter results by the payment type. */
  paymentType?: Maybe<Array<PaymentType>>;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: Maybe<Scalars['String']>;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: Maybe<PriceRangeInput>;
  /** Deprecated: Legacy input is now combined", ReplaceWith("LegacyPropertySearchCriteria", PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: Maybe<Array<Scalars['Int']>>;
  /** Filter results by user provided string */
  propertyName?: Maybe<Scalars['String']>;
  /** Property syle filters */
  propertyStyles?: Maybe<Array<PropertyStyle>>;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: Maybe<ReviewScoreRangeInput>;
  /** Rewards Type filters */
  rewards?: Maybe<Array<Scalars['String']>>;
  /** Filter results by availability */
  showAvailableOnly?: Maybe<Scalars['Boolean']>;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: Maybe<Array<Scalars['Float']>>;
  /** Deprecated - ReplaceWith("starList") , Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: Maybe<StarRangeInput>;
  /** Deprecated: TNL 42683 - BEX_VR_STAY_FILTER, Filter results by Stay Type. Example: Hotels and Resorts, Vacation Rentals */
  stayTypes?: Maybe<Array<StayType>>;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: Maybe<Array<StructureType>>;
  /** An SEM theme that needs to be passed through to other services */
  theme?: Maybe<Scalars['String']>;
  /** Filter results by the type of traveler. */
  travelerType?: Maybe<Array<TravelerType>>;
  /** Filter results by VIP only properties */
  vipOnly?: Maybe<Scalars['Boolean']>;
}







export interface PropertySearchMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export enum PropertySearchOptions {
  /** Only return travelAds, excluding this will result in a mixed set of organic listings and ads */
  ADS_ONLY = 'ADS_ONLY',
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}



export enum PropertySectionRef {
  AVAILABILITY_CALENDAR_START_DATE = 'AVAILABILITY_CALENDAR_START_DATE',
  PRICE_DISPLAY_SERVICE_RESPONSE = 'PRICE_DISPLAY_SERVICE_RESPONSE',
  RECOMMENDED_OFFER = 'RECOMMENDED_OFFER',
  ROOMS_AND_RATES = 'ROOMS_AND_RATES'
}



/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: Maybe<Listings>;
  /** Paandi redirection to white label */
  paandiRedirection?: Maybe<Scalars['String']>;
  /** Points related property search option */
  points?: Maybe<Points>;
  /** DEPRECATED. regionType only used for EG-Typeahead url params */
  typeaheadRegionType?: Maybe<Scalars['Int']>;
}

/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = 'AARP_MEMBER_DISCOUNT',
  BEST_DEAL = 'BEST_DEAL',
  DISTANCE = 'DISTANCE',
  MAXIMUM_SAVINGS = 'MAXIMUM_SAVINGS',
  MAXIMUM_SAVINGS_PERCENT = 'MAXIMUM_SAVINGS_PERCENT',
  MEMBER_PRICING = 'MEMBER_PRICING',
  PACKAGE_SAVINGS = 'PACKAGE_SAVINGS',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  PRICE_RELEVANT = 'PRICE_RELEVANT',
  PROPERTY_CLASS = 'PROPERTY_CLASS',
  PROPERTY_NAME = 'PROPERTY_NAME',
  RECOMMENDED = 'RECOMMENDED',
  REVIEW = 'REVIEW',
  REVIEW_COUNT = 'REVIEW_COUNT',
  REVIEW_RELEVANT = 'REVIEW_RELEVANT',
  VACATION_RENTAL = 'VACATION_RENTAL'
}



export enum PropertyStyle {
  BOUTIQUE = 'BOUTIQUE',
  HOMES = 'HOMES',
  HOTELS = 'HOTELS',
  LGBT = 'LGBT',
  LUXURY = 'LUXURY',
  OUTDOOR = 'OUTDOOR',
  UNIQUE = 'UNIQUE'
}







/** Data used for travelAd click tracking */
export interface PropertyTravelAdTrackingInfoInput {
  beaconIssued?: Maybe<Scalars['String']>;
  candidateHmGuid?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
  slots?: Maybe<Scalars['String']>;
  testVersionOverride?: Maybe<Scalars['String']>;
  trackingData: Scalars['String'];
}










export enum QuestionSortType {
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST'
}





/** Type used during a product search to specify a given numeric range like the price of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
}


export enum RateDiscountType {
  MEMBER_DEAL = 'MEMBER_DEAL',
  MOBILE_EXCLUSIVE = 'MOBILE_EXCLUSIVE',
  REGULAR = 'REGULAR',
  TONIGHT_ONLY = 'TONIGHT_ONLY'
}











export enum RecentActivityType {
  BROWSING_HISTORY = 'BROWSING_HISTORY',
  RECENT_SEARCHES = 'RECENT_SEARCHES',
  VIEWED_OFFERS = 'VIEWED_OFFERS',
  VIEWED_PRODUCTS = 'VIEWED_PRODUCTS'
}








export enum RecommendedType {
  BESPOKE = 'BESPOKE',
  DESTINATIONS = 'DESTINATIONS',
  OFFERS = 'OFFERS'
}




/** Enumerated Gaia geographic region types */
export enum RegionType {
  ADDRESS = 'ADDRESS',
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  CONTINENT = 'CONTINENT',
  COUNTRY = 'COUNTRY',
  HIGH_LEVEL_REGION = 'HIGH_LEVEL_REGION',
  METRO_STATION = 'METRO_STATION',
  MULTI_CITY_VICINITY = 'MULTI_CITY_VICINITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  PROVINCE_STATE = 'PROVINCE_STATE',
  TRAIN_STATION = 'TRAIN_STATION',
  UNKNOWN = 'UNKNOWN'
}



export interface RemoveInsuranceRequestInput {
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars['String']>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars['String'];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars['String'];
}

export interface RemoveInsuranceRequestOldInput {
  insuranceSearchId: Scalars['String'];
  offerTypeId?: Maybe<Scalars['Int']>;
}










export interface ReservationContext {
  reservationId: Scalars['String'];
  conversationId?: Maybe<Scalars['String']>;
  reservationStatus?: Maybe<SupplyReservationStatusType>;
}


export interface ResidencyDetailsInput {
  /** Country code Selection */
  countryCode?: Maybe<Scalars['String']>;
  /** Region code Selection */
  regionCode?: Maybe<Scalars['String']>;
}

export enum ResidencyState {
  APPLIED = 'APPLIED',
  AVAILABLE = 'AVAILABLE'
}


/** Tags Associated with the response */
export enum ResponseTagType {
  CACHE_SOURCE_AIRBLAZE = 'CACHE_SOURCE_AIRBLAZE',
  CACHE_SOURCE_BYOT_AIRBLAZE = 'CACHE_SOURCE_BYOT_AIRBLAZE',
  EXPERIENCE_SEARCH_CACHE_HYDRATOR = 'EXPERIENCE_SEARCH_CACHE_HYDRATOR',
  LISTINGS_PAGINATED_SLICED = 'LISTINGS_PAGINATED_SLICED',
  LISTING_CACHE_SOURCE = 'LISTING_CACHE_SOURCE',
  LISTING_DOWNLEVEL_SOURCE = 'LISTING_DOWNLEVEL_SOURCE',
  MAIN_SEARCH_STACK = 'MAIN_SEARCH_STACK',
  RESPONSE_SUMMARY_CACHED_CONFIG = 'RESPONSE_SUMMARY_CACHED_CONFIG',
  RESPONSE_SUMMARY_CACHED_ML = 'RESPONSE_SUMMARY_CACHED_ML',
  RESPONSE_SUMMARY_HYBRID = 'RESPONSE_SUMMARY_HYBRID',
  RESPONSE_SUMMARY_LIVE = 'RESPONSE_SUMMARY_LIVE',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum Result {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}











export interface ReviewAnswerInput {
  answer?: Maybe<ReviewsFormRatingValueInput>;
  questionUrn: Scalars['String'];
}




/** Enum of types of review interactions */
export enum ReviewInteractionType {
  HELPFUL_REVIEW = 'HELPFUL_REVIEW',
  REVIEW_REPORT_FLAG = 'REVIEW_REPORT_FLAG'
}


/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: Maybe<Scalars['Float']>;
  /** The minimum review score, e.g. 1.0 */
  min?: Maybe<Scalars['Float']>;
}


















export interface ReviewsFormRatingValueInput {
  boolValue?: Maybe<Scalars['Boolean']>;
  numberValue?: Maybe<Scalars['Int']>;
  stringValue?: Maybe<Scalars['String']>;
  tagValue?: Maybe<ReviewsFormTagValueInput>;
}


export interface ReviewsFormTagValueInput {
  customValue?: Maybe<Scalars['String']>;
  tagUrns: Array<Scalars['String']>;
}

export enum RewardsOption {
  ALTAIR = 'ALTAIR',
  AVION = 'AVION',
  NONAVION = 'NONAVION'
}

export enum RewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS'
}





/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: Scalars['Int'];
  /** The number of children in the room */
  children?: Maybe<Array<ChildInput>>;
}






export enum RouteType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}




















/** SearchCriteriaSelections */
export interface SearchCriteriaSelectionsInput {
  /** Id */
  id: Scalars['String'];
  /** value */
  value: Scalars['String'];
}





/** Search form product types */
export enum SearchFormProductType {
  ACTIVITIES = 'ACTIVITIES',
  CARS = 'CARS',
  CRUISES = 'CRUISES',
  FLIGHTS = 'FLIGHTS',
  LODGING = 'LODGING',
  PACKAGES = 'PACKAGES'
}



/** Search history grouping day range. */
export enum SearchHistoryDayRange {
  /** Grouping using searches made 7 days from most recent search in same region */
  SEVEN_DAYS = 'SEVEN_DAYS',
  /** Grouping using searches made 3 days from most recent search in same region */
  THREE_DAYS = 'THREE_DAYS'
}

/** Search history grouping destination type. */
export enum SearchHistoryDestinationType {
  /** Grouping using multi_city_vicinity destination type for searches. */
  METRO_CITY = 'METRO_CITY'
}



/** Filter criteria details for the searchHistory query. */
export interface SearchHistoryFilterCriteriaInput {
  /** Search item end date in yyyy-MM-dd format. */
  endDate: Scalars['String'];
  /** Search item regionId. */
  regionId: Scalars['String'];
  /** Search item region type. */
  regionType?: Maybe<Scalars['String']>;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: Scalars['String'];
}

/** Criteria based on search history groups are created. */
export interface SearchHistoryGroupingCriteriaInput {
  /** Search history grouping based on specified day range. */
  dayRange?: Maybe<SearchHistoryDayRange>;
  /** Search history grouping based on specified destination type. */
  destinationType?: Maybe<SearchHistoryDestinationType>;
}


/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** DEPRECATED: Customer spinner call no longer made before property search. List of interests coming from Customer Spinner */
  interests?: Maybe<Array<InterestInput>>;
  /** DEPRECATED. Use semdtl. SEM param, fetch from URL */
  semDtl?: Maybe<Scalars['String']>;
  /** SEM param, fetch from URL */
  semdtl?: Maybe<Scalars['String']>;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: Maybe<Scalars['String']>;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: Maybe<Scalars['String']>;
}

/** The offer details from the search results page */
export interface SearchOfferInput {
  /** Used to pass selected offer data from SRP to PDP */
  offerDetails?: Maybe<Array<SelectedValueInput>>;
  /** The price of the search results offer */
  offerPrice?: Maybe<SearchOfferPriceInput>;
  ratePlanId?: Maybe<Scalars['String']>;
  roomTypeId?: Maybe<Scalars['String']>;
}

/** The offer price from the search results page */
export interface SearchOfferPriceInput {
  /** The encoded multi-item price token */
  multiItemPriceToken?: Maybe<Scalars['String']>;
  /** The timestamp of when the SRP offer price was generated */
  offerTimestamp?: Maybe<Scalars['String']>;
  /** The total price of the search offer */
  price?: Maybe<MoneyInput>;
}


/** Enum class to represent the type of seat choice */
export enum SeatChoiceType {
  SEAT_CHOICE = 'SEAT_CHOICE'
}




/** Represents seat segment for which seat map is to be shown. */
export interface SeatSegmentInput {
  /** Fare Basis Code required for traveler */
  fareBasisCode: Scalars['String'];
  /** This will be used for unique identification of segment */
  identifier: Scalars['String'];
  /** Operating Carrier Code for each segment */
  operatingCarrierCode: Scalars['String'];
}

/** Enum class to represent the seat type variant. */
export enum SeatVariant {
  ACCESSIBLE = 'ACCESSIBLE',
  AISLE = 'AISLE',
  AVAILABLE = 'AVAILABLE',
  COLUMN = 'COLUMN',
  EXIT = 'EXIT',
  GALLEY = 'GALLEY',
  PREFERRED = 'PREFERRED',
  RESTROOM = 'RESTROOM',
  ROW = 'ROW',
  SELECTED = 'SELECTED',
  UNAVAILABLE = 'UNAVAILABLE'
}






















/** Type for Selected Baggage template */
export enum SelectedAncillaryTemplateType {
  MULTIPLE = 'MULTIPLE',
  NONE = 'NONE',
  ONE = 'ONE'
}


/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: Scalars['String'];
  value: Scalars['String'];
}














export enum ServiceAutomationToolbarElevation {
  FLAT = 'FLAT',
  FLOATING = 'FLOATING'
}

export enum ServiceAutomationToolbarNavType {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
  EXPAND_UP = 'EXPAND_UP'
}
















export interface ShopInsurtechOffersRequestInput {
  /** The cart ID */
  cartId?: Maybe<Scalars['String']>;
  /** Optional for explicitly passing the offeritem that we possibly want to provide insurance coverage  */
  coveredOfferItemsId?: Maybe<Scalars['String']>;
  /** Client id that refer to the page the user reach out to the module from, e.g.: eg_checkout, car_info_site. */
  insurtechClientId: InsurtechClientId;
  /** Residency details to get details according to country and region */
  residencyDetails?: Maybe<ResidencyDetailsInput>;
  /** identify whether the residency already applied or available */
  residencyState?: Maybe<ResidencyState>;
  /** Session ID */
  sessionIdentifier?: Maybe<Scalars['String']>;
}



export interface ShoppedProductInput {
  products: MultiItemProductsInput;
  shoppingPath: ShoppingPathType;
}



/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: Maybe<MultiItemContextInput>;
}












/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = 'ATTACH',
  PACKAGE = 'PACKAGE',
  STANDALONE = 'STANDALONE'
}









/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: Maybe<Array<BooleanValueInput>>;
  counts?: Maybe<Array<NumberValueInput>>;
  dates?: Maybe<Array<DateValueInput>>;
  ranges?: Maybe<Array<RangeValueInput>>;
  selections?: Maybe<Array<SelectedValueInput>>;
}







/** Valid actions on Sort and Filter Modal */
export enum ShoppingSortAndFilterActionType {
  /** Stay on the Sort & Filter Modal but set to default state. Eg used for clear button */
  CLEAR_DATA = 'CLEAR_DATA',
  /** Close Sort & Filter Modal and apply user selected filters. Eg used for Apply/Done buttons */
  CLOSE_AND_APPLY = 'CLOSE_AND_APPLY',
  /** Close Sort & Filter Modal. Eg used for Back/Cross buttons */
  CLOSE_AND_DO_NOT_APPLY = 'CLOSE_AND_DO_NOT_APPLY',
  /**
   * Open the modal window associated with the component on which action has been performed.
   * Example: on click of Sort & Filter reveal button it should open Sort & Filter Modal and
   *        on click of Input Field it should open Typeahead Modal
   */
  OPEN_MODAL = 'OPEN_MODAL'
}



















export interface ShortlistDestinationFilterInput {
  /** Region type that will ultimately determined filtered results. Default is MULTI_CITY_VICINITY */
  destinationType: RegionType;
  /** Gaia region ID for which we want to filter shortlisted results. Does not have to match region type, but will be used to find the relevant destination type based on region type provided */
  regionId: Scalars['String'];
}





/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: Scalars['String'];
  value: Scalars['String'];
}






/** Context for Side Sheet */
export interface SideSheetQueryContextInput {
  addOnRequested: Array<AddOnRequested>;
  isFirstLoad?: Maybe<Scalars['Boolean']>;
  journeyContinuationId: Scalars['String'];
}

export enum SignalType {
  BOOKING_SUCCESS = 'BOOKING_SUCCESS',
  CONFIGURATION_ADDED = 'CONFIGURATION_ADDED',
  DUPLICATE_REQUEST = 'DUPLICATE_REQUEST',
  OFFER_ADDED = 'OFFER_ADDED',
  OFFER_REMOVED = 'OFFER_REMOVED',
  OPERATION_FAILED = 'OPERATION_FAILED',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_METHOD_UPDATED = 'PAYMENT_METHOD_UPDATED',
  PRICE_ADJUSTED = 'PRICE_ADJUSTED',
  PRICE_CHANGED = 'PRICE_CHANGED',
  SIGNAL_TYPE_INVALID = 'SIGNAL_TYPE_INVALID',
  UNRECOGNIZED = 'UNRECOGNIZED',
  UNRECOVERABLE_FAILURE = 'UNRECOVERABLE_FAILURE'
}

export interface SimilarFlightsContextInput {
  offerIdentifier?: Maybe<Scalars['String']>;
}














/** Input argument for Sites configurations request */
export interface SiteConfigurationsRequestInput {
  /** List of Site IDs to retrieve site information for */
  siteIds: Array<Scalars['Int']>;
}














export interface SmartFormDataInput {
  /** Timestamp at which this mutation was sent by the client. */
  timestamp: Scalars['String'];
  userInput: SmartFormUserInput;
}




export enum SmartFormHeadingSizeInput {
  EIGHT = 'EIGHT',
  FIVE = 'FIVE',
  FOUR = 'FOUR',
  ONE = 'ONE',
  SEVEN = 'SEVEN',
  SIX = 'SIX',
  THREE = 'THREE',
  TWO = 'TWO'
}

export enum SmartFormHeadingTagInput {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6'
}


























/** To define which type of keystrokes will be considered by this input. */
export enum SmartFormTextInputVariant {
  EMAIL = 'EMAIL',
  NUMERIC = 'NUMERIC',
  TEL = 'TEL',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA'
}



/** Value collected corresponding to a field represented by inputId */
export interface SmartFormUserFieldInput {
  inputId: Scalars['String'];
  value: Array<Scalars['String']>;
}

/** Collection of the values collected corresponding to fields */
export interface SmartFormUserInput {
  userFieldInputs: Array<SmartFormUserFieldInput>;
}







/**
 * "
 *     Type of operation to perform.
 */
export enum SortAndFilterBasicFilterPayloadType {
  /** Check selected filter option */
  OPTION = 'OPTION',
  /** Remove selected filter */
  REMOVE = 'REMOVE'
}




/** Specifies when a signal should be emitted */
export enum SortAndFilterSignalCondition {
  /** When a filter value changes from the default value to a non default value */
  DEFAULT_TO_NON_DEFAULT = 'DEFAULT_TO_NON_DEFAULT',
  /** When a filter value changes from a non default value to the default value */
  NON_DEFAULT_TO_DEFAULT = 'NON_DEFAULT_TO_DEFAULT',
  /** When a filter value changes from a non default value to a different non default value */
  NON_DEFAULT_TO_NON_DEFAULT = 'NON_DEFAULT_TO_NON_DEFAULT',
  /** When a filter state changes from unselected to selected */
  SELECTED = 'SELECTED',
  /** When a filter state changes from selected to unselected */
  UNSELECTED = 'UNSELECTED'
}






/** Contains the different views for Sort and Filters, where each of them is meant to be on a specific page section or viewport. */
export enum SortAndFiltersViewType {
  /**
   * Represent a view where it's displayed applied filters as removable pills.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  APPLIED_FILTERS = 'APPLIED_FILTERS',
  /**
   * Represent a view where it's only displayed a list of filters.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, in the left side of the results on a Search Results Page.
   */
  FILTERS = 'FILTERS',
  /**
   * Represent a view where the list of filters are displayed as pills.
   * Used for all viewport sizes, on top of the results on a Search Results Page.
   */
  FILTERS_PILLS = 'FILTERS_PILLS',
  /**
   * Represent a view where it displays a filter bar with an All Filters button.
   * Used for all viewport sizes, above the results in the Vrbex SRP split view template.
   */
  FILTER_BAR = 'FILTER_BAR',
  /**
   * Represent a view where it displays a dialog with only `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for all viewport sizes, inside toolbars.
   */
  FILTER_DIALOG = 'FILTER_DIALOG',
  /**
   * Represent a view where it's only displayed a list of sort fields, it usually contains a single section with a sort field.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, above the results in a Search Results Page.
   */
  SORT = 'SORT',
  /**
   * Represent a view of a combined list of the `sort` and `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  SORT_AND_FILTERS = 'SORT_AND_FILTERS',
  /**
   * Represent a view where sort options are displayed as tabs with each tab displaying the sorted results based on the selected tab.
   * Used for all viewport sizes.
   */
  SORT_TABS = 'SORT_TABS'
}


export enum SourceType {
  ESR = 'ESR',
  GDS = 'GDS'
}






/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = 'ADDITIONAL_DRIVER',
  BICYCLE_RACK = 'BICYCLE_RACK',
  BOOSTER_SEAT = 'BOOSTER_SEAT',
  INFANT_SEAT = 'INFANT_SEAT',
  LEFT_HAND_CONTROL = 'LEFT_HAND_CONTROL',
  LUGGAGE_RACK = 'LUGGAGE_RACK',
  NAV_SYSTEM = 'NAV_SYSTEM',
  RIGHT_HAND_CONTROL = 'RIGHT_HAND_CONTROL',
  ROAD_CONGESTION_PAYMENT_SCHEME = 'ROAD_CONGESTION_PAYMENT_SCHEME',
  SATELLITE_RADIO = 'SATELLITE_RADIO',
  SKI_RACK = 'SKI_RACK',
  SNOW_CHAINS = 'SNOW_CHAINS',
  SNOW_TIRES = 'SNOW_TIRES',
  TODDLER_SEAT = 'TODDLER_SEAT',
  TOLL_PAYMENT_TAG_PASS = 'TOLL_PAYMENT_TAG_PASS',
  TRAILER_HITCH = 'TRAILER_HITCH',
  WIFI_ACCESS = 'WIFI_ACCESS',
  WINTER_PACKAGE = 'WINTER_PACKAGE'
}








/** Context needed to request sponsored content */
export interface SponsoredContentContextInput {
  /** Page name Eg. page.Hotels.Infosite.Information */
  pageName: Scalars['String'];
  /** Unique identifier for sponsored content placements */
  sponsoredContentId: Scalars['String'];
  /** Model for ad targeting input */
  targeting?: Maybe<SponsoredContentTargetingInput>;
  /** Target variant. Eg. pwa */
  variant?: Maybe<Scalars['String']>;
}


/** Location resolution by type */
export enum SponsoredContentLocationResolver {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  GAIA = 'GAIA',
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  TLA = 'TLA'
}

/** Location resolution by type */
export enum SponsoredContentLocationResolverInput {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  GAIA = 'GAIA',
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  TLA = 'TLA'
}






/** The type of the ad placement */
export enum SponsoredContentProductType {
  BRAND_RESULT_LISTING = 'BRAND_RESULT_LISTING',
  BRAND_RESULT_LISTING_CARS = 'BRAND_RESULT_LISTING_CARS',
  BRAND_RESULT_LISTING_CRUISES = 'BRAND_RESULT_LISTING_CRUISES',
  BRAND_RESULT_LISTING_FLIGHTS = 'BRAND_RESULT_LISTING_FLIGHTS',
  BRAND_RESULT_LISTING_LODGING = 'BRAND_RESULT_LISTING_LODGING',
  BRAND_RESULT_LISTING_LX = 'BRAND_RESULT_LISTING_LX',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  MULTI_LISTING_AD = 'MULTI_LISTING_AD'
}



/** Input model to hold targeting params for queries. */
export interface SponsoredContentTargetingInput {
  /** number of adults included in the search */
  adults?: Maybe<Scalars['Int']>;
  /** End date of trip. Optional for dateless searches */
  dateEnd?: Maybe<DateInput>;
  /** Start date of trip. Optional for dateless searches */
  dateStart?: Maybe<DateInput>;
  /** Destination for the trip. */
  destination?: Maybe<Scalars['String']>;
  /** number of kids included in the search */
  kids?: Maybe<Scalars['Int']>;
  /** Type of location for origin and dest. */
  locationResolver?: Maybe<SponsoredContentLocationResolverInput>;
  /** Origin for the trip. */
  origin?: Maybe<Scalars['String']>;
}


export interface StackingOptionInput {
  promotionId: Scalars['String'];
  allowStacking?: Maybe<Scalars['Boolean']>;
}


export interface StarRangeInput {
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
}









/** Property search filtering options */
export enum StayType {
  CONVENTIONAL = 'CONVENTIONAL',
  VACATION_RENTALS = 'VACATION_RENTALS'
}














export enum StepReviewInlineEditingSheetButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}









export enum StrikeOutType {
  ATTACH = 'ATTACH',
  INVALID = 'INVALID',
  LOYALTY = 'LOYALTY',
  PACKAGE = 'PACKAGE',
  PRICE_SURVEY = 'PRICE_SURVEY',
  STANDALONE = 'STANDALONE'
}

export enum StructureType {
  AGRITOURISM = 'AGRITOURISM',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  APARTMENT = 'APARTMENT',
  APART_HOTEL = 'APART_HOTEL',
  BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
  CABIN = 'CABIN',
  CAPSULE_HOTEL = 'CAPSULE_HOTEL',
  CARAVAN_PARK = 'CARAVAN_PARK',
  CASTLE = 'CASTLE',
  CHALET = 'CHALET',
  CONDO = 'CONDO',
  CONDO_RESORT = 'CONDO_RESORT',
  COTTAGE = 'COTTAGE',
  COUNTRY_HOUSE = 'COUNTRY_HOUSE',
  CRUISE = 'CRUISE',
  ECO_HOTEL = 'ECO_HOTEL',
  GUEST_HOUSE = 'GUEST_HOUSE',
  HOLIDAY_PARK = 'HOLIDAY_PARK',
  HOSTAL = 'HOSTAL',
  HOSTEL = 'HOSTEL',
  HOTEL = 'HOTEL',
  HOTEL_RESORT = 'HOTEL_RESORT',
  HOUSE_BOAT = 'HOUSE_BOAT',
  INN = 'INN',
  LODGE = 'LODGE',
  LONGHOUSE = 'LONGHOUSE',
  MOTEL = 'MOTEL',
  OVERWATER = 'OVERWATER',
  PALACE = 'PALACE',
  PENSION = 'PENSION',
  POUSADA_BRAZIL = 'POUSADA_BRAZIL',
  POUSADA_PORTUGAL = 'POUSADA_PORTUGAL',
  RANCH = 'RANCH',
  RESIDENCE = 'RESIDENCE',
  RIAD = 'RIAD',
  RYOKAN = 'RYOKAN',
  SAFARI = 'SAFARI',
  SERVICED_APARTMENT = 'SERVICED_APARTMENT',
  TOWNHOUSE = 'TOWNHOUSE',
  TRADITIONAL_BUILDING = 'TRADITIONAL_BUILDING',
  TREE_HOUSE = 'TREE_HOUSE',
  UNKNOWN = 'UNKNOWN',
  VACATION_HOME = 'VACATION_HOME',
  VILLA = 'VILLA',
  VIP = 'VIP'
}










export interface SupplyAmenitiesGroupInput {
  groupId: Scalars['String'];
  roomTypeId?: Maybe<Scalars['String']>;
  spaceId?: Maybe<Scalars['String']>;
}




export interface SupplyAmenitiesUpdateInput {
  groupId: Scalars['String'];
  roomTypeId?: Maybe<Scalars['String']>;
  amenities: Array<SupplyAmenityInput>;
}


export interface SupplyAmenityInput {
  elementId: Scalars['String'];
  value?: Maybe<Scalars['String']>;
}







export interface SupplyCancellationWaiverApprovalRequestContext {
  bookingItemId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
}







export interface SupplyCancellationWaiverReservationContext {
  bookingItemId: Scalars['String'];
}














export interface SupplyContentAdditionalInfoUpdateInput {
  bathrooms?: Maybe<Scalars['String']>;
  bedrooms?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
}


export interface SupplyContentAmenityInput {
  uuid: Scalars['String'];
  value: Scalars['String'];
}








export enum SupplyContentDescriptionSectionName {
  PROPERTY_NAME = 'PROPERTY_NAME',
  HEADLINE = 'HEADLINE',
  DESCRIPTION = 'DESCRIPTION',
  MANUAL_TRANSLATION = 'MANUAL_TRANSLATION',
  ABOUT_YOU = 'ABOUT_YOU',
  WHY_THIS_PROPERTY = 'WHY_THIS_PROPERTY',
  UNIQUE_BENEFITS = 'UNIQUE_BENEFITS',
  BATHROOMS_ADDITIONAL_INFO = 'BATHROOMS_ADDITIONAL_INFO',
  BEDROOMS_ADDITIONAL_INFO = 'BEDROOMS_ADDITIONAL_INFO',
  PROPERTY_ADDITIONAL_INFO = 'PROPERTY_ADDITIONAL_INFO',
  PROPERTY_TYPE = 'PROPERTY_TYPE',
  INTERIOR_SIZE = 'INTERIOR_SIZE',
  SUITABILITY_AMENITY = 'SUITABILITY_AMENITY'
}









export interface SupplyContentHeadlineDescriptionUpdateInput {
  propertyName?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
}

















export enum SupplyContentManualTranslationOperation {
  ADD = 'ADD',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE'
}





export interface SupplyContentManualTranslationUpdateInput {
  locale: Scalars['String'];
  optOutAutoTranslation: Scalars['Boolean'];
  headline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  operation: SupplyContentManualTranslationOperation;
}



















export interface SupplyContentUpdateLocationInput {
  showExactLocation: Scalars['Boolean'];
}



export interface SupplyContentYourPropertyUpdateInput {
  propertyTypeId?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  amenities?: Maybe<Array<SupplyContentAmenityInput>>;
}


export interface SupplyContentYourStoryUpdateInput {
  aboutYou?: Maybe<Scalars['String']>;
  whyThisProperty?: Maybe<Scalars['String']>;
  uniqueBenefits?: Maybe<Scalars['String']>;
}












export interface SupplyCurrentPageContext {
  /** The current relative path for the page */
  path?: Maybe<Scalars['String']>;
  /** specifies any query params the current page has like htid */
  search?: Maybe<Scalars['String']>;
  /** field for native , defining the current native view- like reservations/inbox */
  view?: Maybe<Scalars['String']>;
}





export enum SupplyDashboardType {
  DASHBOARD = 'DASHBOARD',
  LEGACY = 'LEGACY'
}


export interface SupplyFeeFilterInput {
  includedFees?: Maybe<Array<Scalars['String']>>;
}




export interface SupplyFeesInput {
  productCode: Scalars['String'];
  type: Scalars['String'];
  amount: Scalars['Float'];
}
















export interface SupplyIndirectTaxInput {
  taxDetails: Array<SupplyIndirectTaxInputDetail>;
}

export interface SupplyIndirectTaxInputDetail {
  taxationCountry: Scalars['String'];
  taxJurisdictionType: Scalars['String'];
  taxJurisdictionName: Scalars['String'];
  legalName: Scalars['String'];
  registrationStatus: Scalars['String'];
  taxId: Scalars['String'];
}

























export interface SupplyMarketplaceFeedInput {
  feedItemActionType: Scalars['String'];
  feedItemId: Scalars['String'];
}







/** Input for generating mfa code */
export interface SupplyMultiFactorCodeGenerationInput {
  /** Country code for the phone number */
  countryCode: Scalars['String'];
  /** Phone number of the user */
  phoneNumber: Scalars['String'];
  /** MFA Verification type */
  verifyMethod: MfaVerificationMethod;
  /** Optional challenge ticket in case use tries to request for a new code via `send me a new code` operation */
  challengeTicket?: Maybe<Scalars['String']>;
}

/** Input for verifying mfa code */
export interface SupplyMultiFactorCodeVerificationInput {
  /** 6 digit Code sent to user */
  code: Scalars['String'];
  /** Challenge ticket associated with the mfa flow */
  challengeTicket: Scalars['String'];
  /** MFA verification method */
  verifyMethod: MfaVerificationMethod;
  /** Country code for the phone number */
  countryCode: Scalars['String'];
  /** Phone number of the user */
  phoneNumber: Scalars['String'];
}










export interface SupplyNavigationContext {
  showSidebarTrigger: Scalars['Boolean'];
  fallbackUrls?: Maybe<SupplyNavigationContextFallbackUrls>;
}

export interface SupplyNavigationContextFallbackUrls {
  signInUrl?: Maybe<Scalars['String']>;
  helpAndSupportUrl?: Maybe<Scalars['String']>;
  termsOfUseUrl?: Maybe<Scalars['String']>;
}







export enum SupplyNavigationHeaderMenuType {
  PROPERTY_DETAILS = 'PROPERTY_DETAILS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  PROPERTY_FILTER = 'PROPERTY_FILTER',
  SEARCH = 'SEARCH'
}



































export interface SupplyNewListingOfferEnrollmentInput {
  enrolled: Scalars['Boolean'];
}









export enum SupplyOnboardingAvailabilityType {
  OPEN = 'OPEN',
  BLOCK = 'BLOCK'
}





export enum SupplyOnboardingButtonType {
  BACK = 'BACK',
  SKIP = 'SKIP',
  NEXT = 'NEXT',
  LINK = 'LINK',
  DONE = 'DONE'
}










export interface SupplyOnboardingPartnerBillingAddressInput {
  /** Flag for removing or adding address */
  isAddingAddress: Scalars['Boolean'];
  streetAddress: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  stateProvince: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
}


export interface SupplyOnboardingPartnerBusinessNameInput {
  businessName: Scalars['String'];
}





export interface SupplyOnboardingPartnerLegalNameInput {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}

























export enum SupplyOnboardingTipCardId {
  AMENITIES = 'AMENITIES',
  REGULATORY = 'REGULATORY',
  PHOTOS = 'PHOTOS',
  HEADLINE = 'HEADLINE',
  DESCRIPTION = 'DESCRIPTION'
}





















export enum SupplyPartnerLifeCycleStage {
  LIFE_CYCLE_STAGE_BABY = 'LIFE_CYCLE_STAGE_BABY',
  LIFE_CYCLE_STAGE_KID = 'LIFE_CYCLE_STAGE_KID',
  LIFE_CYCLE_STAGE_TEENAGER = 'LIFE_CYCLE_STAGE_TEENAGER',
  LIFE_CYCLE_STAGE_YOUNG_ADULT = 'LIFE_CYCLE_STAGE_YOUNG_ADULT',
  LIFE_CYCLE_STAGE_ALL_GROWN_UP = 'LIFE_CYCLE_STAGE_ALL_GROWN_UP',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export interface SupplyPartnerPayoutDeferredAccountInput {
  currency: Scalars['String'];
  bankingCountry: Scalars['String'];
}






export enum SupplyPaymentDetailsExpandoPositioning {
  TRAILING = 'TRAILING',
  LEADING = 'LEADING'
}









export enum SupplyPaymentDisplayToolbarIcon {
  CLOSE = 'CLOSE',
  BACK = 'BACK'
}



































export enum SupplyPhotosActionType {
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TOOL_BAR_BUTTON = 'TOOL_BAR_BUTTON',
  LINK_BUTTON = 'LINK_BUTTON',
  LINK = 'LINK'
}


export interface SupplyPhotosAddPhotoInput {
  fileUrl: Scalars['String'];
  fileName: Scalars['String'];
  rank?: Maybe<Scalars['Int']>;
  roomIds: Array<Scalars['String']>;
  spaceIds: Array<Scalars['String']>;
}





/** The experience varies by the view (UFO, PE, EPC) & photo category */
export interface SupplyPhotosExperienceContext {
  view: Scalars['String'];
  category?: Maybe<Scalars['String']>;
}







export enum SupplyPhotosPhotoStatus {
  ACTIVE = 'ACTIVE',
  PROCESSING = 'PROCESSING'
}








export interface SupplyProductCreationExperienceInputParam {
  step: Scalars['String'];
  workflow?: Maybe<Scalars['String']>;
}




















export interface SupplyPromotionCreateMembersOnlyDealsTiersInput {
  name: Scalars['String'];
  memberTiersDiscounts: SupplyPromotionMemberTiersDiscountsInput;
  canStackToOtherPromotions?: Maybe<Scalars['Boolean']>;
  promotionRunDates?: Maybe<SupplyPromotionDateRangeInput>;
  blockoutDates?: Maybe<Array<SupplyPromotionDateRangeInput>>;
  ratePlanIds?: Maybe<Array<Scalars['String']>>;
  bookingDates?: Maybe<SupplyPromotionDateRangeInput>;
  stayDates?: Maybe<SupplyPromotionDateRangeInput>;
}




export interface SupplyPromotionDateRangeInput {
  startDate: DateInput;
  endDate?: Maybe<DateInput>;
}









export interface SupplyPromotionMemberTiersDiscountsInput {
  baseMemberDiscount: Scalars['Int'];
  middleMemberDiscount?: Maybe<Scalars['Int']>;
  topMemberDiscount?: Maybe<Scalars['Int']>;
}







export enum SupplyPromotionNotificationType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}


export interface SupplyPromotionPlaygroundInputs {
  reservationDate: DateInput;
  travelDates: SupplyPromotionDateRangeInput;
  roomRatePlanId: Scalars['String'];
  memberLevel: Scalars['Int'];
}




export enum SupplyPromotionReservationMode {
  ADVANCED = 'ADVANCED',
  STANDARD = 'STANDARD'
}

export enum SupplyPromotionResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS'
}













export interface SupplyPromotionUpdateMembersOnlyDealsTiersInput {
  name: Scalars['String'];
  memberTiersDiscounts: SupplyPromotionMemberTiersDiscountsInput;
  canStackToOtherPromotions?: Maybe<Scalars['Boolean']>;
  ratePlanIds?: Maybe<Array<Scalars['String']>>;
  promotionRunDates?: Maybe<SupplyPromotionDateRangeInput>;
  blockoutDates?: Maybe<Array<SupplyPromotionDateRangeInput>>;
  bookingDates?: Maybe<SupplyPromotionDateRangeInput>;
  stayDates?: Maybe<SupplyPromotionDateRangeInput>;
}









export interface SupplyPropertyRateInput {
  currencyCode: Scalars['String'];
  language: Scalars['String'];
  baseRate: Scalars['Float'];
}














export enum SupplyQuickActionComparisonType {
  LESSER_THAN = 'LESSER_THAN',
  GREATER_THAN = 'GREATER_THAN'
}




/** Allowed operations on subscribe event */
export enum SupplyQuickActionElementVisibility {
  HIDE_SELF = 'HIDE_SELF',
  SHOW_SELF = 'SHOW_SELF'
}




/** Allowed operations on subscribe event */
export enum SupplyQuickActionFieldProcessorOperation {
  PLAIN_REPLACE = 'PLAIN_REPLACE',
  PERCENT_CALC_AND_REPLACE = 'PERCENT_CALC_AND_REPLACE',
  SUBTRACT_AND_REPLACE = 'SUBTRACT_AND_REPLACE'
}


export enum SupplyQuickActionFieldSetDirection {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL'
}




export interface SupplyQuickActionFormContextInput {
  key: Scalars['String'];
  values: Array<Scalars['String']>;
}














/**
 * SupplyQuickActionSpacingSize
 * Note: only 0X_HALF, 1X, 2X, 3X, 4X, 6X, 12X, 16X are supported for desktop.
 * Using other sizes may render differently different on mobile and desktop
 */
export enum SupplyQuickActionSpacingSize {
  SPACING__0X__HALF = 'SPACING__0X__HALF',
  SPACING__10X = 'SPACING__10X',
  SPACING__11X = 'SPACING__11X',
  SPACING__12X = 'SPACING__12X',
  SPACING__14X = 'SPACING__14X',
  SPACING__16X = 'SPACING__16X',
  SPACING__1X = 'SPACING__1X',
  SPACING__2X = 'SPACING__2X',
  SPACING__3X = 'SPACING__3X',
  SPACING__4X = 'SPACING__4X',
  SPACING__5X = 'SPACING__5X',
  SPACING__6X = 'SPACING__6X',
  SPACING__8X = 'SPACING__8X'
}
















export enum SupplyQuickActionTableItemCellType {
  NORMAL = 'NORMAL',
  STRIKETHROUGH = 'STRIKETHROUGH'
}



















export interface SupplyRegulatoryFlowThirdPartyValidationInput {
  /** The Third party validation rule */
  rule: Scalars['String'];
  /** The field to validate */
  field: Scalars['String'];
  /** The field value to validate */
  value: Scalars['String'];
  /** other possible parameters for the Third party validation */
  options: Array<SupplyRegulatoryFlowThirdPartyValidationOption>;
}

export interface SupplyRegulatoryFlowThirdPartyValidationOption {
  name: Scalars['String'];
  value: Scalars['String'];
}













export interface SupplyRegulatorySettingInput {
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
}

export enum SupplyRegulatoryStatus {
  COMPLIANT = 'COMPLIANT',
  NOT_COMPLIANT = 'NOT_COMPLIANT',
  NONE = 'NONE'
}

export enum SupplyReservationDetailsComponentType {
  STAY_DETAILS = 'STAY_DETAILS',
  PARTNER_NOTES = 'PARTNER_NOTES',
  RENTAL_AGREEMENT = 'RENTAL_AGREEMENT',
  PAYMENT_SUMMARY = 'PAYMENT_SUMMARY',
  PAYMENT_SCHEDULE = 'PAYMENT_SCHEDULE',
  TRAVELER_INFO = 'TRAVELER_INFO',
  DAMAGE_DEPOSIT = 'DAMAGE_DEPOSIT',
  PAYMENT_DETAILS = 'PAYMENT_DETAILS',
  ACCESS_INSTRUCTIONS = 'ACCESS_INSTRUCTIONS',
  CANCELLATION_POLICY = 'CANCELLATION_POLICY',
  MINI_AVAILABILITY_CALENDAR = 'MINI_AVAILABILITY_CALENDAR'
}

export enum SupplyReservationStatusType {
  BOOKED = 'BOOKED',
  INQUIRY = 'INQUIRY',
  CANCELED = 'CANCELED',
  ARRIVING_TODAY = 'ARRIVING_TODAY',
  CURRENT_STAY = 'CURRENT_STAY',
  POST_STAY = 'POST_STAY',
  CANCELLATION_REQUEST = 'CANCELLATION_REQUEST',
  PRE_APPROVED = 'PRE_APPROVED',
  BOOKING_REQUEST = 'BOOKING_REQUEST',
  BOOKING_REQUEST_EXPIRED = 'BOOKING_REQUEST_EXPIRED',
  PRE_APPROVAL_EXPIRED = 'PRE_APPROVAL_EXPIRED'
}

export interface SupplyReservationsAccessIdentifierInput {
  id: Scalars['String'];
  idType: Scalars['String'];
}


export interface SupplyReservationsAccessInstructionPhotoInput {
  imageId: Scalars['UUID'];
  photoUrl: Scalars['String'];
  title?: Maybe<Scalars['String']>;
}



export interface SupplyReservationsAccessInstructionsInput {
  accessType: SupplyReservationsAccessTypes;
  accessCode?: Maybe<Scalars['String']>;
  instructions: Scalars['String'];
  gallery?: Maybe<Array<Maybe<SupplyReservationsAccessInstructionPhotoInput>>>;
}


export enum SupplyReservationsAccessTypes {
  SMART_LOCK = 'SMART_LOCK',
  LOCKBOX = 'LOCKBOX',
  KEYPAD = 'KEYPAD',
  PICKUP = 'PICKUP',
  DOORMAN = 'DOORMAN',
  OTHER = 'OTHER'
}


export enum SupplyReservationsActionType {
  ACCESS_INSTRUCTIONS_ADD = 'ACCESS_INSTRUCTIONS_ADD',
  ACCESS_INSTRUCTIONS_EDIT = 'ACCESS_INSTRUCTIONS_EDIT',
  HEADER_MARK_AS_UNREAD = 'HEADER_MARK_AS_UNREAD',
  HEADER_MARK_AS_SPAM = 'HEADER_MARK_AS_SPAM',
  HEADER_ARCHIVE = 'HEADER_ARCHIVE',
  HEADER_UNARCHIVE = 'HEADER_UNARCHIVE',
  HEADER_PRINT = 'HEADER_PRINT',
  HEADER_SHARE = 'HEADER_SHARE',
  HEADER_FEEDBACK = 'HEADER_FEEDBACK',
  HEADER_HELP_CENTER = 'HEADER_HELP_CENTER',
  HEADER_DETAILS = 'HEADER_DETAILS',
  DAMAGE_PROTECTION_REPORT_DAMAGE = 'DAMAGE_PROTECTION_REPORT_DAMAGE',
  DAMAGE_PROTECTION_REFUND_DEPOSIT = 'DAMAGE_PROTECTION_REFUND_DEPOSIT',
  DAMAGE_PROTECTION_SEE_POLICY = 'DAMAGE_PROTECTION_SEE_POLICY',
  DAMAGE_PROTECTION_SEE_DAMAGE_REPORT = 'DAMAGE_PROTECTION_SEE_DAMAGE_REPORT',
  DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL = 'DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL',
  PAYMENT_SCHEDULE_MARK_PAID = 'PAYMENT_SCHEDULE_MARK_PAID',
  PAYMENT_SCHEDULE_RESEND_REQUEST = 'PAYMENT_SCHEDULE_RESEND_REQUEST',
  PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST = 'PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST',
  PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE = 'PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE',
  PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE = 'PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE',
  PAYMENT_SCHEDULE_SEND_A_REFUND = 'PAYMENT_SCHEDULE_SEND_A_REFUND',
  GUEST_INFO_EMAIL = 'GUEST_INFO_EMAIL',
  GUEST_INFO_PHONE = 'GUEST_INFO_PHONE',
  GUEST_INFO_VIEW_PROFILE = 'GUEST_INFO_VIEW_PROFILE',
  RENTAL_AGREEMENT_VIEW = 'RENTAL_AGREEMENT_VIEW',
  PAYMENT_SUMMARY_VIEW = 'PAYMENT_SUMMARY_VIEW',
  NOTES_EDIT = 'NOTES_EDIT',
  NOTES_ADD = 'NOTES_ADD',
  NOTES_CANCEL = 'NOTES_CANCEL',
  NOTES_SAVE = 'NOTES_SAVE',
  STAY_DETAILS_CHANGE_DATES = 'STAY_DETAILS_CHANGE_DATES',
  STAY_DETAILS_EDIT_RESERVATION = 'STAY_DETAILS_EDIT_RESERVATION',
  STAY_DETAILS_CHANGE_TIME = 'STAY_DETAILS_CHANGE_TIME',
  STAY_DETAILS_ADD_REMOVE_GUESTS = 'STAY_DETAILS_ADD_REMOVE_GUESTS',
  STAY_DETAILS_CANCEL_RESERVATION = 'STAY_DETAILS_CANCEL_RESERVATION',
  STAY_DETAILS_CONFIRM_CANCELLATION = 'STAY_DETAILS_CONFIRM_CANCELLATION',
  STAY_DETAILS_SEND_PRE_APPROVAL = 'STAY_DETAILS_SEND_PRE_APPROVAL',
  STAY_DETAILS_EDIT_QUOTE = 'STAY_DETAILS_EDIT_QUOTE',
  STAY_DETAILS_ACCEPT = 'STAY_DETAILS_ACCEPT',
  STAY_DETAILS_DECLINE = 'STAY_DETAILS_DECLINE',
  STAY_DETAILS_EDIT_DATES = 'STAY_DETAILS_EDIT_DATES',
  STAY_DETAILS_CANCEL_PRE_APPROVAL = 'STAY_DETAILS_CANCEL_PRE_APPROVAL'
}



















export enum SupplyReservationsInteractionChatImageSize {
  SMALL = 'SMALL',
  LARGE = 'LARGE'
}











export enum SupplyReservationsInteractionListActionDialogFooterActionType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}




export enum SupplyReservationsInteractionListColumnHorizontalAlign {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  CENTER = 'CENTER',
  JUSTIFY = 'JUSTIFY',
  JUSTIFY_ALL = 'JUSTIFY_ALL',
  START = 'START',
  END = 'END',
  MATCH_PARENT = 'MATCH_PARENT'
}

export enum SupplyReservationsInteractionListColumnVerticalAlign {
  BASELINE = 'BASELINE',
  SUB = 'SUB',
  SUPER = 'SUPER',
  TEXT_TOP = 'TEXT_TOP',
  TEXT_BOTTOM = 'TEXT_BOTTOM',
  MIDDLE = 'MIDDLE',
  TOP = 'TOP',
  BOTTOM = 'BOTTOM'
}

export enum SupplyReservationsInteractionListItemAction {
  UNREAD = 'UNREAD',
  READ = 'READ',
  SPAM = 'SPAM',
  ARCHIVE = 'ARCHIVE',
  UNARCHIVE = 'UNARCHIVE'
}









export enum SupplyReservationsInteractionListSwipeActionEdge {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}




export enum SupplyReservationsInteractionMessageMode {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING'
}























export interface SupplyReservationsInteractionsClientDataInput {
  timezone: Scalars['String'];
}




export interface SupplyReservationsInteractionsFilterInput {
  /**
   * List of selected filters
   * Should be the value of "options.name"
   * Examples:
   *     "message.unread"
   *     "guest.requests.inquiry"
   */
  filters?: Maybe<Array<Scalars['String']>>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
}









export interface SupplyReservationsInteractionsPageInput {
  pageNumber?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
}










export enum SupplyReservationsInteractionsSort {
  GUEST_ASC = 'GUEST_ASC',
  GUEST_DESC = 'GUEST_DESC',
  CHECKIN_DATE_ASC = 'CHECKIN_DATE_ASC',
  CHECKIN_DATE_DESC = 'CHECKIN_DATE_DESC',
  RECEIVED_ON_ASC = 'RECEIVED_ON_ASC',
  RECEIVED_ON_DESC = 'RECEIVED_ON_DESC'
}
















export enum SupplyReservationsPaymentDetailsExpandoPositioning {
  TRAILING = 'TRAILING',
  LEADING = 'LEADING'
}









export enum SupplyReservationsPaymentDisplayToolbarIcon {
  CLOSE = 'CLOSE',
  BACK = 'BACK'
}







export enum SupplyReservationsRenderHint {
  COLLAPSED = 'COLLAPSED',
  LIST = 'LIST'
}






























































export enum SupplyScoreFactorBmlAuditItemObervationType {
  RATE = 'RATE',
  AVAILABILITY = 'AVAILABILITY'
}





export enum SupplyScoreFactorNotificationType {
  DOING_GREAT = 'DOING_GREAT',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION'
}





















/** Description of a SupplyScoreMessaging's card */
export enum SupplyScoreMessagingTheme {
  MESSAGE = 'MESSAGE',
  INFO = 'INFO',
  WARNING = 'WARNING'
}













export interface SupplyTaxesAmountInput {
  amount: Scalars['Float'];
  age: Scalars['Int'];
}


export interface SupplyTaxesInput {
  type: SupplyTaxesType;
  taxesPercent?: Maybe<SupplyTaxesPercentInput>;
  taxesAmount?: Maybe<SupplyTaxesAmountInput>;
}







export interface SupplyTaxesPercentInput {
  percent: Scalars['Float'];
}

export enum SupplyTaxesType {
  AMOUNT = 'AMOUNT',
  PERCENT = 'PERCENT',
  NOT_INCLUDED = 'NOT_INCLUDED'
}




















/** Represents the selection status of a tab */
export enum TabStatus {
  /** Represents the status of not being selected */
  NOT_SELECTED = 'NOT_SELECTED',
  /** Represents the status of being selected */
  SELECTED = 'SELECTED'
}










/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = 'LTR',
  RTL = 'RTL'
}

/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export enum TextTheme {
  EMPHASIS = 'EMPHASIS',
  INVERSE = 'INVERSE',
  LOYALTY = 'LOYALTY',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export enum TextWeight {
  BOLD = 'BOLD',
  MEDIUM = 'MEDIUM',
  REGULAR = 'REGULAR'
}



export enum Theme {
  BRAND = 'BRAND',
  BRANDED_DEAL = 'BRANDED_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO = 'INFO',
  LINK = 'LINK',
  LOYALTY = 'LOYALTY',
  LOYALTY_EXTRA_HIGH_TIER = 'LOYALTY_EXTRA_HIGH_TIER',
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  NOTIFICATION = 'NOTIFICATION',
  PROMOTED = 'PROMOTED',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  STANDARD = 'STANDARD',
  SUCCESS = 'SUCCESS',
  SUCCESS_MEDIUM = 'SUCCESS_MEDIUM',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  URGENT = 'URGENT',
  VIEWED = 'VIEWED',
  VIP = 'VIP',
  VIP_ACCESS = 'VIP_ACCESS'
}





export interface TopTaskCardAction {
  cardAction: CardActions;
  topTaskType: TopTaskTypes;
  taskId: Scalars['String'];
}

export enum TopTaskTypes {
  BOOKING_REQUEST = 'BOOKING_REQUEST',
  INQUIRY = 'INQUIRY',
  CURRENT_STAY = 'CURRENT_STAY',
  ARRIVING = 'ARRIVING',
  CANCELLATION_REQUEST = 'CANCELLATION_REQUEST',
  RATE_TRAVELER = 'RATE_TRAVELER',
  CANCELLATION = 'CANCELLATION',
  BANK_DETAILS = 'BANK_DETAILS',
  TAX_FORM = 'TAX_FORM',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  CONFIRM_IDENTITY = 'CONFIRM_IDENTITY',
  OPPORTUNITY = 'OPPORTUNITY',
  VRPAYMENTS_TIP = 'VRPAYMENTS_TIP'
}














/** Optional inputs for custom flex content */
export interface TravelContentAttributesInput {
  /** content Id */
  contentId: Scalars['String'];
  /** preview */
  preview: Scalars['Boolean'];
}










/** URI context to get flex content. */
export interface TravelContentUriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes: UriContextAttributesInput;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers: UriContextIdentifiersInput;
}





export interface TravelGuidePageContextInput {
  pageType: PageType;
  placeId?: Maybe<Scalars['String']>;
}

export interface TravelMemberGroupInput {
  adults: Scalars['Int'];
  childrenAges?: Maybe<Array<Scalars['Int']>>;
}


export interface TravelStoreV1CarDetailsInput {
  cleaningSafetyInformation: Scalars['Boolean'];
  periodPricing: Scalars['Boolean'];
  showAds: Scalars['Boolean'];
}

export interface TravelStoreV1CarSearchInput {
  cleaningSafetyInformation: Scalars['Boolean'];
  defaultSortOption: Scalars['String'];
  filterOptions: Array<Scalars['String']>;
  messagingOptions: Array<Scalars['String']>;
  periodPricing: Scalars['Boolean'];
  showAds: Scalars['Boolean'];
  sortOptions: Array<Scalars['String']>;
}












/** Represents the traveler details */
export interface TravelerDetailsInput {
  age?: Maybe<Scalars['Int']>;
  type: TravelerDetailsType;
}

/** Possible traveler details types */
export enum TravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}


/** Package traveler occupancy group */
export interface TravelerOccupancyGroupInput {
  travelers: Array<TravelerDetailsInput>;
}


export enum TravelerType {
  BUSINESS = 'BUSINESS',
  FAMILY = 'FAMILY',
  LGBT = 'LGBT',
  ROMANTIC = 'ROMANTIC'
}

/** Represents per traveller ancillary selection */
export interface TravellerAncillarySelectionInput {
  /** Represents the list of encoded AncillaryToken for each selection made */
  ancillaryTokens: Array<Scalars['String']>;
  /** Represents the traveler index for which the selection is applicable */
  travelerIndex: Scalars['Int'];
}





export enum TripCareButtonAction {
  BACK = 'BACK',
  CANCEL_POLICY = 'CANCEL_POLICY',
  DISMISS_POPUP = 'DISMISS_POPUP',
  POPUP = 'POPUP',
  RELOAD = 'RELOAD'
}

export enum TripCareButtonState {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}














export enum TripCareLayoutStyle {
  CARD_BORDER_TOP = 'CARD_BORDER_TOP'
}



export enum TripCareListType {
  BULLET = 'BULLET',
  NO_BULLET = 'NO_BULLET',
  NUMBERED = 'NUMBERED'
}




export enum TripCarePhraseStyle {
  BOLD = 'BOLD',
  HR_DIVIDER_BOTTOM = 'HR_DIVIDER_BOTTOM',
  HR_DIVIDER_TOP = 'HR_DIVIDER_TOP',
  SIZE_100 = 'SIZE_100',
  SIZE_200 = 'SIZE_200',
  SIZE_300 = 'SIZE_300',
  SIZE_400 = 'SIZE_400',
  SIZE_500 = 'SIZE_500',
  SIZE_600 = 'SIZE_600',
  SIZE_700 = 'SIZE_700',
  SIZE_800 = 'SIZE_800',
  SIZE_900 = 'SIZE_900',
  SMALL = 'SMALL',
  SPACING_FOUR = 'SPACING_FOUR',
  SPACING_HALF = 'SPACING_HALF',
  SPACING_ONE = 'SPACING_ONE',
  SPACING_SIX = 'SPACING_SIX',
  SPACING_THREE = 'SPACING_THREE',
  SPACING_TWO = 'SPACING_TWO',
  THEME_EMPHASIS = 'THEME_EMPHASIS',
  THEME_NEGATIVE = 'THEME_NEGATIVE',
  THEME_POSITIVE = 'THEME_POSITIVE',
  WEIGHT_BOLD = 'WEIGHT_BOLD',
  WEIGHT_MEDIUM = 'WEIGHT_MEDIUM',
  WEIGHT_REGULAR = 'WEIGHT_REGULAR'
}

export enum TripCarePhraseType {
  BUTTON = 'BUTTON',
  LINK = 'LINK',
  TEXT = 'TEXT'
}








export enum TripCreationEntryPoint {
  HOTEL_SEARCH_RESULTS = 'HOTEL_SEARCH_RESULTS',
  TRIPS_LIST = 'TRIPS_LIST',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW'
}


/** Metadata which can be provided when creating a new trip. */
export interface TripCreationMetadataInput {
  entryPoint?: Maybe<TripCreationEntryPoint>;
  itemId?: Maybe<Scalars['String']>;
  /** An input provided when creating a new trip as part of moving an item to a trip */
  moveItemInput?: Maybe<TripItemInput>;
  /** Trip planning inputs provided when creating a new trip as part of saving an item to a trip */
  saveItemInput?: Maybe<TripsPlanInput>;
}

export interface TripDetailsSupportRequestsInput {
  buttonStyle: EgdsButtonStyle;
  itineraryNumber: Scalars['String'];
  lineOfBusiness: Scalars['String'];
  orderLineId: Scalars['String'];
}

/** The TripEntity defines a list of supported items which can be can be saved to a trip. */
export enum TripEntity {
  ACTIVITY_PRODUCT = 'ACTIVITY_PRODUCT',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LODGING_PRODUCT = 'LODGING_PRODUCT'
}





export enum TripIntentPersonType {
  ADULT = 'ADULT',
  CHILD = 'CHILD'
}






/**
 * The `TripInviteInput` complex type contains a `inviteId` known by the Trip Domain.
 * The inviteId is invitation identifier to be opened from trips overview screen or redirected to by invite deep link.
 * The server will construct all the necessary information based on invite that has back reference to trip with all needed information to populate view
 * It also provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripInviteInput {
  inviteId: Scalars['String'];
}




/**
 * "The `TripItemInput` contains a tripViewId and tripItemId known by the Trip Domain, plus an optional filter known to the Trips Graph.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Item Details view for functions such as back navigation.
 */
export interface TripItemInput {
  filter?: Maybe<Scalars['String']>;
  tripEntity?: Maybe<TripEntity>;
  tripItemId: Scalars['String'];
  tripViewId: Scalars['String'];
}





/**
 * The `TripOverviewInput` complex type contains a `tripViewId` known by the Trip Domain and an optional `filter` known by the Trips Graph Service.
 * The tripViewId identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.
 * The server will determine how much of the trip and which actions to return based on the sharing rules associated with the TripViewId.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripOverviewInput {
  filter?: Maybe<Scalars['String']>;
  inviteId?: Maybe<Scalars['String']>;
  segments?: Maybe<Array<Scalars['String']>>;
  tripViewId: Scalars['String'];
}



export enum TripScheduleChangeStatus {
  FLIGHT_SCHEDULE_CHANGE = 'FLIGHT_SCHEDULE_CHANGE',
  NO_CHANGE = 'NO_CHANGE'
}














/** Represents different avatar sizes. */
export enum TripsAvatarSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}


/** Supported Trips badge themes */
export enum TripsBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  SAVED = 'SAVED',
  STATUS_NEGATIVE = 'STATUS_NEGATIVE',
  STATUS_POSITIVE = 'STATUS_POSITIVE',
  UTILITY_STANDARD = 'UTILITY_STANDARD',
  VIP = 'VIP'
}





export enum TripsButtonWidth {
  MATCH_PARENT_CONTAINER = 'MATCH_PARENT_CONTAINER',
  WRAP_CONTENT = 'WRAP_CONTENT'
}

export enum TripsCalendarSelectionType {
  SINGLE = 'SINGLE',
  START_AND_END = 'START_AND_END',
  START_AND_END_WITH_SAME_DATE = 'START_AND_END_WITH_SAME_DATE'
}








/** Contains attributes for trip cancellation */
export interface TripsCancellationAttributesInput {
  orderLineNumbers?: Maybe<Array<Scalars['String']>>;
  orderNumber?: Maybe<Scalars['String']>;
  /** Formatted string. This is optional attribute. In case of partial refund, we are passing this value to the backend. */
  penaltyAmount?: Maybe<Scalars['String']>;
  /** Formatted string. This is optional attribute for displayed refund amount to user. If this value set then compare between displayed amount and actual amount from backend. */
  refundAmount?: Maybe<Scalars['String']>;
  /** Formatted string. This is optional attribute for displayed cash refund amount to user, we are passing this value to the backend. */
  refundInCash?: Maybe<Scalars['String']>;
  /** Formatted string. This is optional attribute for displayed points refund amount to user, we are passing this value to the backend. */
  refundInPoints?: Maybe<Scalars['String']>;
}

export enum TripsCancellationType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  HOTEL = 'HOTEL',
  INSURANCE = 'INSURANCE'
}


/** Represents a TripsCard's selection/active state */
export enum TripsCardState {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}










/** Type of the drawer/sheet we want the client to render. CENTER is for desktop where we want to show the drawer as a center sheet/dialogBOTTOM is for app and mweb where the drawer comes from the bottom of the screenSIDE is for desktop where the sheet comes from the right of the screen. eg. plan, moveFULL is equivalent to sidesheet on mweb where the sheet will cover the whole page */
export enum TripsComposableDrawerType {
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER',
  FULL = 'FULL',
  SIDE = 'SIDE'
}













/** Display theme for trips content */
export enum TripsContentTheme {
  /** The Unordered List should be displayed with bullets */
  BULLETS = 'BULLETS',
  /** The Unordered List should be displayed with no bullets */
  NO_BULLETS = 'NO_BULLETS',
  /** The ordered list should always be displayed with numbers */
  ORDERED = 'ORDERED',
  /** Paragraph type list */
  PARAGRAPH = 'PARAGRAPH'
}

export enum TripsContentType {
  PDF = 'PDF'
}


export enum TripsContentUnorderedListTheme {
  /** The Unordered List should be displayed with bullets */
  BULLETS = 'BULLETS',
  /** The Unordered List should be displayed with no bullets */
  NO_BULLETS = 'NO_BULLETS'
}













export enum TripsCustomerNotificationTripScheduleChangeStatus {
  FLIGHT_SCHEDULE_CHANGE = 'FLIGHT_SCHEDULE_CHANGE',
  NO_CHANGE = 'NO_CHANGE'
}





/** Represents layout of buttons on a modal dialog */
export enum TripsDialogButtonLayout {
  /** Dialog with horizontally stacked buttons */
  INLINE = 'INLINE',
  /** Dialog with vertically stacked buttons */
  STACKED = 'STACKED'
}



export enum TripsDisplayMode {
  DEFAULT = 'DEFAULT',
  MODAL = 'MODAL'
}











/**
 * The `TripsFilterInput` contains a filter identifier.
 * The set of supported filter identifiers is defined by the Trips Graph Service and may represent a simple filter like Upcoming or Past or an arbitrarily complex filter defined by an ML algorithm.
 * See the Trips Graph team for a list of reserved values.
 */
export interface TripsFilterInput {
  filter: Scalars['String'];
}

export enum TripsFindItineraryNumberView {
  FIND_ITINERARY_OTHER_EMAIL = 'FIND_ITINERARY_OTHER_EMAIL',
  FIND_ITINERARY_USER_EMAIL = 'FIND_ITINERARY_USER_EMAIL',
  RESULT = 'RESULT'
}


/** This enum is to indicate what type of image is being placed into TripsFittedImageCard. UitkLayoutGrid would apply onto BARCODE */
export enum TripsFittedImageType {
  BARCODE = 'BARCODE',
  E_FRANKING_STAMP = 'E_FRANKING_STAMP',
  QR_CODE = 'QR_CODE'
}













/** This enum is to indicate whether the form container should have padding or it should fit right inside the parent component */
export enum TripsFormContainerTheme {
  MATCH_PARENT = 'MATCH_PARENT',
  WRAP_CONTENT = 'WRAP_CONTENT'
}




export enum TripsFormType {
  CREATE_NEW_TRIP_FROM_ITEM = 'CREATE_NEW_TRIP_FROM_ITEM',
  FIND_ITINERARY_NUMBER = 'FIND_ITINERARY_NUMBER',
  INVITE = 'INVITE',
  SAVE_NEW_TRIP = 'SAVE_NEW_TRIP',
  SEARCH_BOOKING = 'SEARCH_BOOKING',
  SEND_ITINERARY_EMAIL = 'SEND_ITINERARY_EMAIL',
  UPDATE_TRIP = 'UPDATE_TRIP'
}













/** Enum to represent the number of lines that the text field supports. Defaulted to one line (single) if no changes are made. */
export enum TripsInputType {
  MULTIPLE = 'MULTIPLE',
  SINGLE = 'SINGLE'
}








export interface TripsItemsGroupFilterInput {
  type: Scalars['String'];
  value: Scalars['String'];
}

/** Contains filters and sort fields to control how the items appear in groups. */
export interface TripsItemsGroupInput {
  filters: Array<TripsItemsGroupFilterInput>;
  sort?: Maybe<Scalars['String']>;
}



export enum TripsLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}












/** The type of map marker */
export enum TripsMarkerType {
  ACTIVITYEVENTMARKER = 'ActivityEventMarker',
  ACTIVITYGUESTPICKUPMARKER = 'ActivityGuestPickupMarker',
  ACTIVITYLOCATIONMARKER = 'ActivityLocationMarker',
  ACTIVITYREDEMPTIONMARKER = 'ActivityRedemptionMarker',
  AIRPORTMARKER = 'AirportMarker',
  CARMARKER = 'CarMarker',
  CRUISEMARKER = 'CruiseMarker',
  HOTELMARKER = 'HotelMarker',
  PLACEMARKER = 'PlaceMarker'
}
































export interface TripsNotAuthorizedInput {
  filter?: Maybe<Scalars['String']>;
  inviteId?: Maybe<Scalars['String']>;
  screen?: Maybe<TripsScreen>;
  tripItemId?: Maybe<Scalars['String']>;
  tripViewId?: Maybe<Scalars['String']>;
}


















/** Input to the trips.plan query. */
export interface TripsPlanInput {
  /** Provides LOB specific search context */
  attributes?: Maybe<TripsSaveItemAttributesInput>;
  /** The id of the item being saved, e.g property id */
  itemId: Scalars['String'];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: Maybe<PageLocation>;
  /** Composes PropertySearch and FlightSearch inputs */
  productSearchCriteria?: Maybe<TripsProductSearchCriteriaInput>;
  source?: Maybe<TripsPlanSourceType>;
  /** Attributes needed to create or update trip items subscription data */
  subscriptionAttributes?: Maybe<TripsSubscriptionAttributesInput>;
}

/** The `TripsPlanSourceType` defines a list of supported pages or views from which an item can be saved to a trip. */
export enum TripsPlanSourceType {
  ACTIVITY_DETAILS = 'ACTIVITY_DETAILS',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  HOTEL_SEARCH = 'HOTEL_SEARCH',
  LODGING_DETAILS = 'LODGING_DETAILS',
  LODGING_SEARCH = 'LODGING_SEARCH',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW'
}









/** Input to the trips.screenshot query. */
export interface TripsProductSearchCriteriaInput {
  flightSearchCriteria?: Maybe<FlightSearchCriteriaInput>;
  propertySearchCriteria?: Maybe<PropertySearchCriteriaInput>;
  tripsFlightSearchCriteria?: Maybe<TripsSaveFlightSearchCriteriaInput>;
}





export enum TripsResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS'
}



/** Save activity input details */
export interface TripsSaveActivityAttributesInput {
  /** Date range representing activity search, if absent the default [today, today+14d] is used */
  dateRange?: Maybe<DateRangeInput>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
}



/** Input type representing primary and filters flight search criteria */
export interface TripsSaveFlightSearchCriteriaInput {
  flightSearchFilters: Array<FlightsSearchFilterValuesInput>;
  primary: PrimaryFlightCriteriaInput;
}



/** Type grouping all the optional additional information that's required when saving an item. */
export interface TripsSaveItemAttributesInput {
  /** Activity input details */
  activityAttributes?: Maybe<TripsSaveActivityAttributesInput>;
  /** Flight input details */
  flightAttributes?: Maybe<FlightSearchCriteriaInput>;
  /** Stay input details */
  stayAttributes?: Maybe<TripsSaveStayAttributesInput>;
}


export interface TripsSaveItemInput {
  anchorPrice?: Maybe<Scalars['String']>;
  productSearchCriteria: TripsProductSearchCriteriaInput;
}






/** Save stay input details */
export interface TripsSaveStayAttributesInput {
  /** The check-in date for the property */
  checkInDate?: Maybe<DateInput>;
  /** The check-out date for the property */
  checkoutDate?: Maybe<DateInput>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
  /** Provides Stay traveler information */
  roomConfiguration?: Maybe<Array<PropertyRoomInput>>;
}

/** Stay input details */
export interface TripsSaveStayInput {
  checkInDate?: Maybe<DateTimeInput>;
  checkoutDate?: Maybe<DateTimeInput>;
  propertyId: Scalars['String'];
  regionId?: Maybe<Scalars['String']>;
  roomConfiguration?: Maybe<Array<TripsStayRoomTravelerInfoInput>>;
  sourceType?: Maybe<TripsPlanSourceType>;
}



export enum TripsScreen {
  INVITE_LANDING_PAGE = 'INVITE_LANDING_PAGE',
  TRIP_ITEM_ITINERARY = 'TRIP_ITEM_ITINERARY',
  TRIP_ITEM_MANAGE_BOOKING = 'TRIP_ITEM_MANAGE_BOOKING',
  TRIP_ITEM_PRICING_REWARDS = 'TRIP_ITEM_PRICING_REWARDS',
  TRIP_ITEM_RECEIPT = 'TRIP_ITEM_RECEIPT',
  TRIP_MANAGE_GUESTS = 'TRIP_MANAGE_GUESTS',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW',
  TRIP_OVERVIEW_ITINERARY = 'TRIP_OVERVIEW_ITINERARY'
}

/** Input to the trips.screenshot query. */
export interface TripsScreenshotInput {
  /** The id of the item being saved, e.g property id */
  itemId: Scalars['String'];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: Maybe<PageLocation>;
  /** Provides LOB specific search context */
  saveItemAttributes: TripsSaveItemAttributesInput;
}

export enum TripsSearchBookingView {
  SEARCH_BY_ITINERARY_NUMBER = 'SEARCH_BY_ITINERARY_NUMBER',
  SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL = 'SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL',
  SEARCH_RESULT = 'SEARCH_RESULT'
}












/** This enum represents the different fields that a TripsSignalPair relates to. */
export enum TripsSignalPairKey {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  STATUS = 'STATUS'
}


/** This enum represents the different category types of signals registered within the platform. */
export enum TripsSignalType {
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}






/** Stay room traveler information */
export interface TripsStayRoomTravelerInfoInput {
  childrenAges: Array<Scalars['Int']>;
  numberOfAdults: Scalars['Int'];
}


/** Attributes needed to create or update trip items subscription data */
export interface TripsSubscriptionAttributesInput {
  anchorPrice?: Maybe<Scalars['String']>;
  subscriptionInputs?: Maybe<Array<GraphQlPairInput>>;
}




/** Represents a toggle's state. */
export enum TripsToggleStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}







/** Alignment for the buttons in a dialog's footer */
export enum TripsUiDialogFooterButtonLayout {
  INLINE = 'INLINE',
  STACKED = 'STACKED'
}








































export enum TripsViewType {
  ACTIVITIES_SEARCH_RESULTS = 'ACTIVITIES_SEARCH_RESULTS',
  CAMPAIGNS = 'CAMPAIGNS',
  CARS_SEARCH_RESULTS = 'CARS_SEARCH_RESULTS',
  FILTERED = 'FILTERED',
  FIND_ITINERARY_BY_OTHER_EMAIL = 'FIND_ITINERARY_BY_OTHER_EMAIL',
  FIND_ITINERARY_BY_USER_EMAIL = 'FIND_ITINERARY_BY_USER_EMAIL',
  FLIGHTS_SEARCH_RESULTS = 'FLIGHTS_SEARCH_RESULTS',
  ITEM_DETAILS = 'ITEM_DETAILS',
  ITEM_ESSENTIAL_INFO = 'ITEM_ESSENTIAL_INFO',
  ITEM_PRICING_AND_REWARDS = 'ITEM_PRICING_AND_REWARDS',
  ITEM_VOUCHER = 'ITEM_VOUCHER',
  LOB_SELECTION_VIEW = 'LOB_SELECTION_VIEW',
  LODGING_SEARCH_RESULTS = 'LODGING_SEARCH_RESULTS',
  LOGIN_PROMPT = 'LOGIN_PROMPT',
  MANAGE_BOOKING = 'MANAGE_BOOKING',
  MANAGE_GUESTS = 'MANAGE_GUESTS',
  OVERVIEW = 'OVERVIEW',
  PACKAGES_FC_SEARCH_RESULTS = 'PACKAGES_FC_SEARCH_RESULTS',
  PACKAGES_FHC_SEARCH_RESULTS = 'PACKAGES_FHC_SEARCH_RESULTS',
  PACKAGES_HC_SEARCH_RESULTS = 'PACKAGES_HC_SEARCH_RESULTS',
  PACKAGES_HF_SEARCH_RESULTS = 'PACKAGES_HF_SEARCH_RESULTS',
  PENDING_INVITE = 'PENDING_INVITE',
  SEARCH_BY_ITINERARY_NUMBER = 'SEARCH_BY_ITINERARY_NUMBER',
  SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL = 'SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL',
  TRIPS_LIST = 'TRIPS_LIST'
}




/**
 * Contains fields that will be used to build the correct trips view URL. For the most accurate result,
 *     supply as many of the fields as possible. If input is not supplied, the Url will navigate to /trips"
 */
export interface TripsWebViewInput {
  filter?: Maybe<Scalars['String']>;
  inviteId?: Maybe<Scalars['String']>;
  screen?: Maybe<TripsScreen>;
  tripItemId?: Maybe<Scalars['String']>;
  tripViewId?: Maybe<Scalars['String']>;
}









/** Represents a typing indicator event's content */
export interface TypingIndicatorEventContentInput {
  /** Represents if the user is typing or not - isTyping: true equals start: true */
  isTyping?: Maybe<Scalars['Boolean']>;
}











/** Specifies whether to open the link in the same user interface context or in a different context */
export enum UiLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}









export enum UiSignal {
  BOOKING_SUCCESS = 'BOOKING_SUCCESS',
  DUPLICATE_REQUEST = 'DUPLICATE_REQUEST',
  GENERIC_DOWNSTREAM_ERROR = 'GENERIC_DOWNSTREAM_ERROR',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PRICE_ADJUSTED = 'PRICE_ADJUSTED',
  PRICE_CHANGED = 'PRICE_CHANGED',
  UNKNOWN = 'UNKNOWN',
  UNRECOVERABLE_FAILURE = 'UNRECOVERABLE_FAILURE'
}













/** Type to select a category of action for an UnescoPledge */
export enum UnescoPledgeCategory {
  /** Category to support local communities */
  COMMUNITY_ENGAGEMENT = 'COMMUNITY_ENGAGEMENT',
  /** Category to save energy consumption */
  CONSERVE_ENERGY = 'CONSERVE_ENERGY',
  /** Category to save water consumption */
  CONSERVE_WATER = 'CONSERVE_WATER',
  /** Category to add additional information about sustainability */
  OTHER = 'OTHER',
  /** Category to reduce plastic usage */
  REDUCE_PLASTIC = 'REDUCE_PLASTIC',
  /** Category to reduce waste */
  REDUCE_WASTE = 'REDUCE_WASTE'
}

/** Type to specify a filter related UnescoPledges */
export interface UnescoPledgeFilterInput {
  /** Categories to filter */
  category?: Maybe<Array<Maybe<UnescoPledgeCategory>>>;
  /** Number of UnescoPledge to visualize */
  pledgesNumber?: Maybe<Scalars['Int']>;
  /** Number of the starting index of UnescoPledge list */
  startingIndex?: Maybe<Scalars['Int']>;
}






export enum UniversalProfileAccountManagementOptionType {
  TRAVELER_ARRANGER = 'TRAVELER_ARRANGER'
}







export interface UniversalProfileAccountTakeOverWidgetRequestInput {
  content?: Maybe<Scalars['String']>;
  type: UniversalProfileAccountTakeOverWidgetTypeRequest;
}

export enum UniversalProfileAccountTakeOverWidgetTypeRequest {
  CAPTCHA = 'CAPTCHA',
  CSRF = 'CSRF'
}








export interface UniversalProfileAddressInput {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
}



export enum UniversalProfileAnalyticsEventSubType {
  BLURRED = 'BLURRED',
  FOCUSED = 'FOCUSED',
  INPUTTED = 'INPUTTED',
  SUCCEEDED = 'SUCCEEDED'
}




export interface UniversalProfileBasicInformationDateOfBirthInput {
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
}



export interface UniversalProfileBasicInformationNameInput {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
}

export interface UniversalProfileBasicInformationRequestInput {
  accessibilityNeeds?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  dateOfBirth: UniversalProfileBasicInformationDateOfBirthInput;
  gender?: Maybe<Scalars['String']>;
  name: UniversalProfileBasicInformationNameInput;
}








export enum UniversalProfileCategorySwitchOperator {
  OFF = 'OFF',
  ON = 'ON'
}

export interface UniversalProfileChangeEmailRequestInput {
  cmsToken: Scalars['String'];
  email: Scalars['String'];
}



/** EG Universal profile input for accessing client type */
export interface UniversalProfileClientInfoInput {
  appVersion?: Maybe<Scalars['String']>;
  channelType: UniversalProfileClientType;
}

export enum UniversalProfileClientType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB'
}


export interface UniversalProfileCommunicationPreferenceEmailRequestInput {
  categoryConsent: Array<UniversalProfileEmailCommunicationPreferenceUpdateInput>;
  unsubscribeFromAll: Scalars['Boolean'];
}

export interface UniversalProfileCommunicationPreferenceRequestInput {
  updates: Array<UniversalProfileCommunicationPreferenceUpdateInput>;
}

export interface UniversalProfileCommunicationPreferenceUnsubRequestInput {
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
  emlCid?: Maybe<Scalars['String']>;
  emlDtl?: Maybe<Scalars['String']>;
}

export interface UniversalProfileCommunicationPreferenceUnsubscribeCategoriesRequestInput {
  categoryTypes: Array<UniversalProfileCommunicationPreferencesCategoryType>;
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
  isStrict: Scalars['Boolean'];
}

export interface UniversalProfileCommunicationPreferenceUnsubscribePreferenceRequestInput {
  categoryType: UniversalProfileCommunicationPreferencesCategoryType;
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
  emlCid?: Maybe<Scalars['String']>;
  emlDtl?: Maybe<Scalars['String']>;
}

export interface UniversalProfileCommunicationPreferenceUpdateInput {
  category: UniversalProfileCommunicationPreferencesCategoryType;
  selectedChannels?: Maybe<Array<CommunicationChannel>>;
}



export enum UniversalProfileCommunicationPreferencesCategoryType {
  ACCOUNT_SUPPORT = 'ACCOUNT_SUPPORT',
  CONFIRMATION_AND_CRITICAL_UPDATES = 'CONFIRMATION_AND_CRITICAL_UPDATES',
  OFFERS_AND_INSPIRATION = 'OFFERS_AND_INSPIRATION',
  ONE_KEY = 'ONE_KEY',
  ONE_KEY_MONTHLY_STATEMENTS = 'ONE_KEY_MONTHLY_STATEMENTS',
  ONE_KEY_REWARD_ACCOUNT_UPDATES = 'ONE_KEY_REWARD_ACCOUNT_UPDATES',
  PARTNERS_OFFERS_WITH_US = 'PARTNERS_OFFERS_WITH_US',
  PERSONALIZED_TRIP_RECOMMENDATIONS = 'PERSONALIZED_TRIP_RECOMMENDATIONS',
  REVIEWS = 'REVIEWS',
  SURVEYS = 'SURVEYS',
  THE_TRAVEL_EDIT = 'THE_TRAVEL_EDIT',
  TRIP_BOARD_ACTIVITY = 'TRIP_BOARD_ACTIVITY',
  TRIP_PLANNING_ASSISTANCE = 'TRIP_PLANNING_ASSISTANCE'
}




export enum UniversalProfileCommunicationPreferencesFormType {
  COMMUNICATION_PREFERENCE_CATEGORY_FORM = 'COMMUNICATION_PREFERENCE_CATEGORY_FORM',
  COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM = 'COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM',
  COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM = 'COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM',
  COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM = 'COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM'
}













export interface UniversalProfileContactInformationRequestInput {
  address: UniversalProfileAddressInput;
  emergencyContact: UniversalProfileEmergencyContactInput;
  phone: UniversalProfilePhoneInput;
}



export interface UniversalProfileContextInput {
  accountTakeOverWidgets?: Maybe<Array<UniversalProfileAccountTakeOverWidgetRequestInput>>;
  additionalTravelerIdentifier?: Maybe<Scalars['String']>;
  cmsToken?: Maybe<Scalars['String']>;
  communicationPreferencesCategoryType?: Maybe<UniversalProfileCommunicationPreferencesCategoryType>;
  communicationPreferencesFormType?: Maybe<UniversalProfileCommunicationPreferencesFormType>;
  communicationPreferencesUnsubscribeContext?: Maybe<UniversalProfileCommunicationPreferenceUnsubRequestInput>;
  experienceType?: Maybe<UniversalProfileExperienceType>;
  informationFormType?: Maybe<UniversalProfileInformationFormType>;
  settingsFormType?: Maybe<UniversalProfileSettingsFormType>;
  subExperienceType?: Maybe<UniversalProfileSubExperienceType>;
}










export enum UniversalProfileDashboardOptionType {
  COMMUNICATIONS = 'COMMUNICATIONS',
  COUPONS = 'COUPONS',
  CREDITS = 'CREDITS',
  HELP = 'HELP',
  PAYMENTS = 'PAYMENTS',
  PROFILE = 'PROFILE',
  REVIEWS = 'REVIEWS',
  SETTINGS = 'SETTINGS'
}








export enum UniversalProfileDependsOnFieldIdentificationCriteriaOperator {
  EXCLUDES = 'EXCLUDES',
  INCLUDES = 'INCLUDES'
}


export interface UniversalProfileEmailCommunicationPreferenceUpdateInput {
  category: UniversalProfileCommunicationPreferencesCategoryType;
  emailOptIn: Scalars['Boolean'];
}






export interface UniversalProfileEmergencyContactInput {
  contactName?: Maybe<Scalars['String']>;
  phone: UniversalProfilePhoneInput;
}






export enum UniversalProfileExperienceType {
  COMMUNICATION_PREFERENCES = 'COMMUNICATION_PREFERENCES',
  HELP = 'HELP',
  PROFILE = 'PROFILE',
  SETTINGS = 'SETTINGS'
}
















export enum UniversalProfileInformationFormType {
  COMMUNICATION_PREFERENCE_UNSUB = 'COMMUNICATION_PREFERENCE_UNSUB',
  UPDATE_BASIC_INFORMATION = 'UPDATE_BASIC_INFORMATION',
  UPDATE_COMMUNICATION_PREFERENCE = 'UPDATE_COMMUNICATION_PREFERENCE',
  UPDATE_CONTACT_INFORMATION = 'UPDATE_CONTACT_INFORMATION',
  UPDATE_CONTACT_INFORMATION_EMAIL = 'UPDATE_CONTACT_INFORMATION_EMAIL',
  UPDATE_CONTACT_INFORMATION_PHONE_NUMBER = 'UPDATE_CONTACT_INFORMATION_PHONE_NUMBER'
}











export enum UniversalProfileLocationAndLanguageOptionType {
  COUNTY = 'COUNTY',
  CURRENCY = 'CURRENCY',
  LANGUAGE = 'LANGUAGE'
}



export enum UniversalProfileLoginInformationSettingsOptionType {
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CONNECTED_DEVICES = 'CONNECTED_DEVICES',
  EMAIL = 'EMAIL'
}



export enum UniversalProfileMoreDetailsOptionType {
  AIRPORT_SECURITY = 'AIRPORT_SECURITY',
  FLIGHT_PREFERENCES = 'FLIGHT_PREFERENCES',
  REWARD_PROGRAM = 'REWARD_PROGRAM',
  TRAVELER_DOCUMENTS = 'TRAVELER_DOCUMENTS'
}









export interface UniversalProfilePhoneInput {
  countryCode?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  smsInfo?: Maybe<Scalars['Boolean']>;
}



export enum UniversalProfilePreferencesOptionType {
  COUNTRY = 'COUNTRY',
  CURRENCY = 'CURRENCY',
  DISPLAY_APPEARANCE = 'DISPLAY_APPEARANCE',
  LANGUAGE = 'LANGUAGE'
}









export enum UniversalProfileSettingsFormType {
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
  UPDATE_COUNTRY = 'UPDATE_COUNTRY',
  UPDATE_EMAIL = 'UPDATE_EMAIL',
  UPDATE_LANGUAGE = 'UPDATE_LANGUAGE',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD'
}







export interface UniversalProfileSmsContactInformationRequestInput {
  phone: UniversalProfilePhoneInput;
}



export enum UniversalProfileSubExperienceType {
  COMMUNICATION_PREFERENCES_EXPEDIA = 'COMMUNICATION_PREFERENCES_EXPEDIA',
  COMMUNICATION_PREFERENCES_HOTELS = 'COMMUNICATION_PREFERENCES_HOTELS',
  COMMUNICATION_PREFERENCES_VRBO = 'COMMUNICATION_PREFERENCES_VRBO'
}













/** Enum for holding values with reference to page stack history */
export enum UpdateHistory {
  REMOVE = 'REMOVE'
}

export interface UpdateInsurtechOfferRequestInput {
  cartId: Scalars['String'];
  /** list of covered offer tokens to be added to the main offer */
  coveredOfferTokens?: Maybe<Array<OfferIdentityInput>>;
  /** The offer token of the offer to be updated */
  offersToAdd: Array<OfferIdentityInput>;
  /** list of Covered offer item ids to be removed from the main offer */
  offersToRemove: Array<OfferIdentityInput>;
  /** Session Id */
  sessionIdentifier?: Maybe<Scalars['String']>;
  targetOfferIdentity: OfferIdentityInput;
}




export enum UpdateTripType {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}



export interface UriAttributesInput {
  /**
   * Used to specify the GAIA feature TYPE
   * Example Value: Multi-City
   */
  gaiaType?: Maybe<Scalars['String']>;
  lodgingUrlCode?: Maybe<Scalars['String']>;
}

export enum UriClassification {
  CLASSIFICATION_DEALS = 'CLASSIFICATION_DEALS',
  CLASSIFICATION_INVALID = 'CLASSIFICATION_INVALID'
}

export interface UriContextAttributesInput {
  affinity?: Maybe<Scalars['String']>;
  airCarrierCode?: Maybe<Scalars['String']>;
  carClass?: Maybe<Scalars['String']>;
  carSupplier?: Maybe<Scalars['String']>;
  gaiaType?: Maybe<Scalars['String']>;
  lodgingUrlCode?: Maybe<Scalars['String']>;
  starRating?: Maybe<Scalars['String']>;
}

export interface UriContextIdentifiersInput {
  destination: Scalars['String'];
  /** Only for PDP pages */
  hotelId?: Maybe<Scalars['Int']>;
  origin?: Maybe<Scalars['String']>;
}

/**
 * A context that can be used to retrieve targeted flex content
 * with combination of attributes and identifiers that uniquely identify a URI.
 */
export interface UriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes?: Maybe<UriAttributesInput>;
  /**
   * Specifies the labelled category of a URL
   * Example Value: CLASSIFICATION_DEALS
   * Values align with the UriContext proto definitions
   */
  classification?: Maybe<UriClassification>;
  /**
   * Used to specify the GAIA feature ID of destination
   * Example Value: 178279
   */
  destination?: Maybe<Scalars['String']>;
  /**
   * Used to specify current location of user in the conversion funnel.
   * Example Value: ENTRY
   * Values do NOT align with the UriContext proto definitions
   */
  funnelLocation?: Maybe<PageLocation>;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers?: Maybe<UriIdentifiersInput>;
}

/** A identifiers list that can be used to uniquely identify a URI. */
export interface UriIdentifiersInput {
  /**
   * Used to specify the accommodation type.
   * Example Value: Apartments
   */
  accommodationType?: Maybe<Scalars['String']>;
  /**
   * Used to specify airports city GAIA feature ID
   * Example Value: 178279
   */
  airport?: Maybe<Scalars['String']>;
  /**
   * Used to specify the brand.
   * Example Value: Travelodge UK
   */
  brand?: Maybe<Scalars['String']>;
  /**
   * Used to specify the car class.
   * Example Value: Economy
   */
  carClass?: Maybe<Scalars['String']>;
  /**
   * Used to specify the car supplier location ID (aka CVL ID).
   * Example Value: 12245
   */
  carSupplierLocation?: Maybe<Scalars['String']>;
  /**
   * Used to specify the carrier code.
   * Example Value: BA
   */
  carrierCode?: Maybe<Scalars['String']>;
  /**
   * Used to specify vendor ID
   * Example Value: ET
   */
  company?: Maybe<Scalars['String']>;
  /**
   * Used to specify the cruise line ID
   * Example Value: CV
   */
  cruiseLine?: Maybe<Scalars['String']>;
  /**
   * Used to specify the GAIA feature ID of destination
   * Example Value:
   */
  destination?: Maybe<Scalars['String']>;
  /**
   * Used to specify the discriminator for hotel landing pages
   * Example Value: ho
   */
  discriminator?: Maybe<Scalars['String']>;
  /**
   * Used to specify current screen feature displayed to user
   * Example Value: reviews, lodgingDiscovery, destinationDiscovery
   */
  feature?: Maybe<Scalars['String']>;
  /**
   * Used to specify the flight route type
   * Example Value: open / fixed
   */
  flightRoute?: Maybe<Scalars['String']>;
  /**
   * Used to specify current location of user in the conversion funnel
   * Example Value: entry
   */
  funnelLocation?: Maybe<Scalars['String']>;
  /**
   * Used to specify the hotel ID
   * Example Value: 1
   */
  hotel?: Maybe<Scalars['String']>;
  /**
   * Used to specify hotel PCS ID for HCOM pages
   * Example Value: 456469
   */
  id?: Maybe<Scalars['String']>;
  /**
   * Used to specify the line of business
   * Example Value: flight
   */
  lineOfBusiness?: Maybe<Scalars['String']>;
  /**
   * Used to specify the type of lodging
   * Example Value: alternative
   */
  lodgingType?: Maybe<Scalars['String']>;
  /**
   * Used to specify the GAIA feature ID of origin
   * Example Value: 178286
   */
  origin?: Maybe<Scalars['String']>;
  /**
   * Used to specify the ship code of the ship
   * Example Value: AVW
   */
  ship?: Maybe<Scalars['String']>;
  /**
   * Used to specify the hotel's star rating
   * Source of truth is flex-hotels-service
   * Example Value: 5
   */
  starRating?: Maybe<Scalars['String']>;
  /**
   * Used to specify the hotel's theme
   * Source of truth is affinity prime
   * Example Value: romantic
   */
  theme?: Maybe<Scalars['String']>;
  /**
   * Used to specify the url mapping path, without leading '/'
   * Example Value: lp/deals
   */
  url?: Maybe<Scalars['String']>;
}




export interface UserContextInput {
  siteId: Scalars['Int'];
  tuid: Scalars['Int'];
}




export interface UserLocationInput {
  userCountryCode?: Maybe<Scalars['String']>;
  userLatitude?: Maybe<Scalars['BigDecimal']>;
  userLongitude?: Maybe<Scalars['BigDecimal']>;
  userSelectedOrigin?: Maybe<Scalars['String']>;
}














/** Represents the status of response */
export enum VirtualAgentCheckoutStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

/** Represents the virtual agent context */
export interface VirtualAgentContextInput {
  /** Represents the intended itinerary number to change */
  itineraryNumber: Scalars['String'];
  /** Represents the token which is used in exchange of information */
  opaqueToken: Scalars['String'];
}










/** Represents a new input type, used by the new mutation to send event data */
export interface VirtualAgentControlConversationEventInput {
  /** Represents a typing indicator event's content */
  typingIndicator?: Maybe<TypingIndicatorEventContentInput>;
}



















/** Represents VAC input message data */
export interface VirtualAgentControlMessageInput {
  /** Represents an optional payload of message input */
  payload?: Maybe<Scalars['String']>;
  /** Represents the text of message input */
  text?: Maybe<Scalars['String']>;
  /** Represents a unique identifier on the UI */
  umid: Scalars['String'];
}
































export type CarDetailQueryVariables = Exact<{
  context: ContextInput;
  carDetailContext: CarDetailContextInput;
}>;


export type CarDetailQuery = { __typename: 'Query', carDetail: { __typename: 'CarDetailsResult', carOfferToken?: Maybe<string>, detailsNavTabs?: Maybe<{ __typename: 'DetailsNavTabs', navTabs: Array<{ __typename: 'NavTab', name: string, analytics: (
          { __typename: 'CarAnalytics' }
          & DetailAnalyticsFragment
        ) }> }>, reviewsSummary?: Maybe<{ __typename: 'CarReviewsSummary', title: string, recommendedRate: string, recommendedText: string, topReviews: Array<string>, dialogTrigger?: Maybe<(
        { __typename: 'CarActionableItem' }
        & DetailActionableItemFragment
      )>, dialogContent?: Maybe<{ __typename: 'CarReviewDialogContent', description: string, totalRatings: string, disclaimerTitle: string, disclaimerFullDescription: string, disclaimerLink?: Maybe<(
          { __typename: 'CarActionableItem' }
          & DetailActionableItemFragment
        )>, userFeedback: (
          { __typename: 'UserFeedback' }
          & UserFeedbackFragment
        ), reviewBreakdown: Array<{ __typename: 'ReviewBreakdown', heading: string, description: string, percentage: number, score?: Maybe<string> }>, reviewsSeeMoreAction?: Maybe<{ __typename: 'CarButton', text: string, analytics?: Maybe<(
            { __typename: 'CarAnalytics' }
            & DetailAnalyticsFragment
          )> }>, reviews?: Maybe<Array<{ __typename: 'CarReview', text: string, rentalDuration?: Maybe<string>, author?: Maybe<string>, classificationName: string, submissionTime: string, expandButton: { __typename: 'ExpandButton', expandButton: string, collapseButton: string }, themes?: Maybe<Array<{ __typename: 'CarReviewThemes', label?: Maybe<string>, icon?: Maybe<{ __typename: 'Icon', id: string }> }>> }>> }> }>, deal?: Maybe<(
      { __typename: 'CarMessagingCard' }
      & DetailsMessagingCardFragment
    )>, easeCancel?: Maybe<(
      { __typename: 'CarMessagingCard' }
      & DetailsMessagingCardFragment
    )>, oneKeyInfo?: Maybe<(
      { __typename: 'CarOfferBadge' }
      & DetailBadgeFragment
    )>, oneKeyDetails?: Maybe<{ __typename: 'OneKeyDetails', isOfferEligibleForBurn: boolean, isOneKeyEnrolled: boolean, earnBanner?: Maybe<(
        { __typename: 'CarOfferBadge' }
        & DetailBadgeFragment
      )>, analytics?: Maybe<(
        { __typename: 'CarAnalytics' }
        & DetailAnalyticsFragment
      )> }>, priceAlert?: Maybe<(
      { __typename: 'CarMessagingCard' }
      & DetailsMessagingCardFragment
    )>, saleUnlocked?: Maybe<(
      { __typename: 'CarMessagingCard' }
      & DetailsMessagingCardFragment
    )>, dropOffCharge?: Maybe<(
      { __typename: 'CarMessagingCard' }
      & DetailsMessagingCardFragment
    )>, vehicle?: Maybe<{ __typename: 'VehicleDetails', category: string, description?: Maybe<string>, image?: Maybe<(
        { __typename: 'Image' }
        & DetailImageFragment
      )>, categoryIcon?: Maybe<(
        { __typename: 'Icon' }
        & DetailIconFragment
      )>, attributes: Array<(
        { __typename: 'VehicleFeature' }
        & DetailFeatureFragment
      )>, features: Array<(
        { __typename: 'VehicleFeature' }
        & DetailFeatureFragment
      )>, fuelInfo: Array<(
        { __typename: 'VehicleFeature' }
        & DetailFeatureFragment
      )> }>, vendor: { __typename: 'CarVendor', image?: Maybe<(
        { __typename: 'Image' }
        & DetailImageFragment
      )> }, rentalLocations: { __typename: 'CarRentalLocations', title: string, isLocationDataMerged: boolean, pickUpLocation: (
        { __typename: 'CarRentalLocationDetail' }
        & CarRentalLocationDetailFragment
      ), dropOffLocation: (
        { __typename: 'CarRentalLocationDetail' }
        & CarRentalLocationDetailFragment
      ) }, telesales?: Maybe<{ __typename: 'CarTelesales', label: string, phoneNumberLink: (
        { __typename: 'CarActionableItem' }
        & DetailActionableItemFragment
      ) }>, promotions: Array<{ __typename: 'CarPromotion', text: string, additionalInfo?: Maybe<string>, icon: (
        { __typename: 'Icon' }
        & DetailIconFragment
      ) }>, inclusionsDetail?: Maybe<{ __typename: 'CarInclusionsDetail', title: string, text: string, inclusions: Array<{ __typename: 'CarInclusion', title: string, summary?: Maybe<string>, description?: Maybe<string>, icon?: Maybe<(
          { __typename: 'Icon' }
          & DetailIconFragment
        )>, analytics: (
          { __typename: 'CarAnalytics' }
          & DetailAnalyticsFragment
        ) }> }>, availableAccessories?: Maybe<{ __typename: 'CarAvailableAccessories', title: string, description: string, accessories: Array<{ __typename: 'CarAccessory', id: string, name: string, price?: Maybe<string>, pricePeriod?: Maybe<string>, selectionState: CarAccessorySelectionState, accessibility: string, token?: Maybe<string>, analytics: (
          { __typename: 'CarAnalytics' }
          & DetailAnalyticsFragment
        ) }> }>, importantInfo: { __typename: 'CarImportantInfo', title: string, infos: Array<string>, importantInfoItems: Array<{ __typename: 'CarImportantInfoItems', name: string, subtext: string, description: Array<string>, analytics: (
          { __typename: 'CarAnalytics' }
          & DetailAnalyticsFragment
        ) }>, rulesAndRestrictions: (
        { __typename: 'CarActionableItem' }
        & DetailActionableItemFragment
      ) }, actionableConfidenceMessages: Array<(
      { __typename: 'CarActionableItem' }
      & DetailCarPhrase_CarActionableItem_Fragment
    ) | (
      { __typename: 'CarDialogConfidenceMessage' }
      & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
    ) | (
      { __typename: 'CarOfferBadge' }
      & DetailCarPhrase_CarOfferBadge_Fragment
    ) | (
      { __typename: 'CarPhraseHTMLText' }
      & DetailCarPhrase_CarPhraseHtmlText_Fragment
    ) | (
      { __typename: 'CarPhraseIconText' }
      & DetailCarPhrase_CarPhraseIconText_Fragment
    ) | (
      { __typename: 'CarPhraseMark' }
      & DetailCarPhrase_CarPhraseMark_Fragment
    ) | (
      { __typename: 'CarPhrasePairText' }
      & DetailCarPhrase_CarPhrasePairText_Fragment
    ) | (
      { __typename: 'CarPhraseText' }
      & DetailCarPhrase_CarPhraseText_Fragment
    ) | (
      { __typename: 'CarsRichText' }
      & DetailCarPhrase_CarsRichText_Fragment
    )>, pairConfidenceMessages?: Maybe<Array<(
      { __typename: 'CarActionableItem' }
      & DetailCarPhrase_CarActionableItem_Fragment
    ) | (
      { __typename: 'CarDialogConfidenceMessage' }
      & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
    ) | (
      { __typename: 'CarOfferBadge' }
      & DetailCarPhrase_CarOfferBadge_Fragment
    ) | (
      { __typename: 'CarPhraseHTMLText' }
      & DetailCarPhrase_CarPhraseHtmlText_Fragment
    ) | (
      { __typename: 'CarPhraseIconText' }
      & DetailCarPhrase_CarPhraseIconText_Fragment
    ) | (
      { __typename: 'CarPhraseMark' }
      & DetailCarPhrase_CarPhraseMark_Fragment
    ) | (
      { __typename: 'CarPhrasePairText' }
      & DetailCarPhrase_CarPhrasePairText_Fragment
    ) | (
      { __typename: 'CarPhraseText' }
      & DetailCarPhrase_CarPhraseText_Fragment
    ) | (
      { __typename: 'CarsRichText' }
      & DetailCarPhrase_CarsRichText_Fragment
    )>>, additionalBenefits?: Maybe<{ __typename: 'CarAdditionalBenefits', headingText: string, benefits: Array<(
        { __typename: 'CarPhraseIconText' }
        & DetailCarPhrase_CarPhraseIconText_Fragment
      )> }>, priceDetails?: Maybe<{ __typename: 'CarPriceDetails', title: string, closeAction: (
        { __typename: 'CarAction' }
        & DetailActionFragment
      ), closeIcon: (
        { __typename: 'Icon' }
        & DetailIconFragment
      ), breakupSection: Array<(
        { __typename: 'CarBreakupComponent' }
        & CarBreakupComponentFragment
      )>, summary: { __typename: 'CarBreakupSummarySection', title: string, total: string, lineItems: Array<(
          { __typename: 'CarBreakupLineItem' }
          & CarBreakupLineItemFragment
        )>, notIncludedInTotal?: Maybe<(
          { __typename: 'CarBreakupComponent' }
          & CarBreakupComponentFragment
        )> }, priceDetailsButton: (
        { __typename: 'CarActionableItem' }
        & DetailActionableItemFragment
      ) }>, priceSummary: { __typename: 'CarPriceSummary', strikeThroughFirst?: Maybe<boolean>, priceAdditionalInfo?: Maybe<Array<string>>, accessibility?: Maybe<string>, lead?: Maybe<(
        { __typename: 'CarPriceInfo' }
        & DetailPriceInfoFragment
      )>, total: (
        { __typename: 'CarPriceInfo' }
        & DetailPriceInfoFragment
      ), loyaltyPointsOption?: Maybe<{ __typename: 'LoyaltyPointsOption', formattedPoints?: Maybe<string>, leadingCaption: string, pointsFirst: boolean }>, reference?: Maybe<{ __typename: 'CarReferencePriceInfo', additionalInfo?: Maybe<string>, qualifier?: Maybe<string>, price: (
          { __typename: 'Money' }
          & DetailMoneyFragment
        ) }>, paymentInfo?: Maybe<{ __typename: 'CarPaymentInfo', text: string, additionalPaymentInfo?: Maybe<Array<string>>, icon: (
          { __typename: 'Icon' }
          & DetailIconFragment
        ) }>, discountBadge?: Maybe<(
        { __typename: 'CarOfferBadge' }
        & DetailBadgeFragment
      )>, floatingCTAPriceDetailsAnalytics?: Maybe<(
        { __typename: 'CarAnalytics' }
        & DetailAnalyticsFragment
      )>, floatingCTAReserveButtonAnalytics?: Maybe<(
        { __typename: 'CarAnalytics' }
        & DetailAnalyticsFragment
      )> }, reserveAction: (
      { __typename: 'CarActionableItem' }
      & DetailActionableItemFragment
    ), shareFeedbackAction?: Maybe<{ __typename: 'CarShareFeedbackAction', text: string, button: (
        { __typename: 'CarActionableItem' }
        & DetailActionableItemFragment
      ) }>, loyaltyInfo?: Maybe<Array<(
      { __typename: 'CarActionableItem' }
      & DetailCarPhrase_CarActionableItem_Fragment
    ) | (
      { __typename: 'CarDialogConfidenceMessage' }
      & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
    ) | (
      { __typename: 'CarOfferBadge' }
      & DetailCarPhrase_CarOfferBadge_Fragment
    ) | (
      { __typename: 'CarPhraseHTMLText' }
      & DetailCarPhrase_CarPhraseHtmlText_Fragment
    ) | (
      { __typename: 'CarPhraseIconText' }
      & DetailCarPhrase_CarPhraseIconText_Fragment
    ) | (
      { __typename: 'CarPhraseMark' }
      & DetailCarPhrase_CarPhraseMark_Fragment
    ) | (
      { __typename: 'CarPhrasePairText' }
      & DetailCarPhrase_CarPhrasePairText_Fragment
    ) | (
      { __typename: 'CarPhraseText' }
      & DetailCarPhrase_CarPhraseText_Fragment
    ) | (
      { __typename: 'CarsRichText' }
      & DetailCarPhrase_CarsRichText_Fragment
    )>>, variantsSummary?: Maybe<{ __typename: 'CarVariantsSummary', title: string, variants: Array<{ __typename: 'CarVariant', title: string }> }>, carSearchLink?: Maybe<(
      { __typename: 'CarActionableItem' }
      & DetailActionableItemFragment
    )>, offerBadges?: Maybe<Array<(
      { __typename: 'CarOfferBadge' }
      & DetailBadgeFragment
    )>>, detailSummary: { __typename: 'CarDetailsSummary', pageTitle: string }, onlineCheckInInfo?: Maybe<{ __typename: 'CarOnlineCheckIn', title: string, infos: Array<(
        { __typename: 'CarActionableItem' }
        & DetailCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DetailCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DetailCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DetailCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DetailCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DetailCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DetailCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DetailCarPhrase_CarsRichText_Fragment
      )> }>, skipTheCounterInfo?: Maybe<{ __typename: 'CarSkipTheCounterInfo', title: string, infos: Array<(
        { __typename: 'CarActionableItem' }
        & DetailCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DetailCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DetailCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DetailCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DetailCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DetailCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DetailCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DetailCarPhrase_CarsRichText_Fragment
      )> }>, enhancedCleanlinessInfo?: Maybe<{ __typename: 'EnhancedCleanlinessInfo', title: string, infoProviderText: string, infos: Array<{ __typename: 'EnhancedCleanlinessInfoLineItem', text: string, icon: (
          { __typename: 'Icon' }
          & DetailIconFragment
        ) }>, seeAllAction: (
        { __typename: 'CarActionableItem' }
        & DetailActionableItemFragment
      ), vendorCleanlinessBadge: { __typename: 'HttpURI', value: string }, dialog: { __typename: 'EnhancedCleanlinessDialog', title: string, description: string, carouselButtonAllyStrings?: Maybe<Array<string>>, images?: Maybe<Array<{ __typename: 'HttpURI', value: string }>>, content: Array<{ __typename: 'EnhancedCleanlinessDialogContent', infos: Array<string>, title: { __typename: 'EnhancedCleanlinessInfoLineItem', text: string, icon: (
              { __typename: 'Icon' }
              & DetailIconFragment
            ) } }> } }>, adsTargetingData?: Maybe<{ __typename: 'AdsTargetingData', uuid: string, siteId: number, pageName: string, origin?: Maybe<string>, dest?: Maybe<string>, locResolver?: Maybe<string>, dateStart?: Maybe<string>, dateEnd?: Maybe<string>, adProvider: string }>, rentalProtectionInfo?: Maybe<{ __typename: 'RentalProtectionInfo', title: string, rentalProtectionCard: Array<(
        { __typename: 'RentalProtectionCard' }
        & RentalProtectionCardFragment
      )> }> } };

export type RentalProtectionCardFragment = { __typename: 'RentalProtectionCard', title: string, priceSummary?: Maybe<string>, pricePeriod?: Maybe<string>, selected: boolean, infos: Array<{ __typename: 'RentalProtectionInfoLineItem', text: string, icon?: Maybe<(
      { __typename: 'Icon' }
      & DetailIconFragment
    )> }>, seeDetailsAction: (
    { __typename: 'CarActionableItem' }
    & DetailActionableItemFragment
  ), offerBadge?: Maybe<(
    { __typename: 'CarOfferBadge' }
    & DetailBadgeFragment
  )>, dialog: { __typename: 'RentalProtectionDialog', title: string, description: Array<string>, content: Array<{ __typename: 'RentalProtectionDialogContent', title: string, description: Array<{ __typename: 'RentalProtectionInfoLineItem', text: string, icon?: Maybe<(
          { __typename: 'Icon' }
          & DetailIconFragment
        )> }> }> }, clickAction: (
    { __typename: 'CarActionableItem' }
    & DetailActionableItemFragment
  ) };

export type DetailsMessagingCardFragment = { __typename: 'CarMessagingCard', title?: Maybe<string>, description: string, descriptions: Array<string>, mark?: Maybe<string>, cardTitle?: Maybe<(
    { __typename: 'CarsRichText' }
    & DetailCarPhrase_CarsRichText_Fragment
  )>, cardDescriptions: Array<(
    { __typename: 'CarPhraseText' }
    & DetailCarPhrase_CarPhraseText_Fragment
  )>, image?: Maybe<{ __typename: 'Image', description: string, url: any }>, illustrationURL?: Maybe<{ __typename: 'HttpURI', value: string }>, icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
  )>, links: Array<{ __typename: 'CarActionableItem', text: string, url?: Maybe<{ __typename: 'HttpURI', value: string, relativePath: string }>, icon?: Maybe<(
      { __typename: 'Icon' }
      & DetailIconFragment
    )>, action: { __typename: 'CarAction', actionType: CarActionType, analytics?: Maybe<{ __typename: 'CarAnalytics', linkName: string, referrerId: string }> } }>, dialog?: Maybe<{ __typename: 'CarsDialog', title: string, buttonText: string, text: Array<string>, type?: Maybe<CarsDialogType>, content?: Maybe<{ __typename: 'CarsDialogContent', header: (
        { __typename: 'CarActionableItem' }
        & DetailCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DetailCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DetailCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DetailCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DetailCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DetailCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DetailCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DetailCarPhrase_CarsRichText_Fragment
      ), body: Array<{ __typename: 'CarsDialogBody', title: (
          { __typename: 'CarActionableItem' }
          & DetailCarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & DetailCarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & DetailCarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & DetailCarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & DetailCarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & DetailCarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & DetailCarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & DetailCarPhrase_CarsRichText_Fragment
        ), body: Array<(
          { __typename: 'CarActionableItem' }
          & DetailCarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & DetailCarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & DetailCarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & DetailCarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & DetailCarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & DetailCarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & DetailCarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & DetailCarPhrase_CarsRichText_Fragment
        )> }>, footer?: Maybe<Array<(
        { __typename: 'CarActionableItem' }
        & DetailCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DetailCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DetailCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DetailCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DetailCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DetailCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DetailCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DetailCarPhrase_CarsRichText_Fragment
      )>> }> }>, carRecommendations?: Maybe<Array<Maybe<(
    { __typename: 'CarRecommendations' }
    & DetailCarRecommendationsFragment
  )>>>, analytics?: Maybe<(
    { __typename: 'CarAnalytics' }
    & DetailAnalyticsFragment
  )> };

export type DetailCarRecommendationsFragment = { __typename: 'CarRecommendations', heading?: Maybe<string>, analytics?: Maybe<Array<{ __typename: 'CarAnalytics', linkName: string, referrerId: string }>>, carRecommendationsCards?: Maybe<Array<(
    { __typename: 'AlternateRecommendationCard' }
    & DetailCarRecommendationCard_AlternateRecommendationCard_Fragment
  ) | (
    { __typename: 'DateTimeRecommendationCard' }
    & DetailCarRecommendationCard_DateTimeRecommendationCard_Fragment
  ) | (
    { __typename: 'LimitedResultMessageOnRecommendationCard' }
    & DetailCarRecommendationCard_LimitedResultMessageOnRecommendationCard_Fragment
  ) | (
    { __typename: 'LocationRecommendationCard' }
    & DetailCarRecommendationCard_LocationRecommendationCard_Fragment
  ) | (
    { __typename: 'PartnerRecommendationCard' }
    & DetailCarRecommendationCard_PartnerRecommendationCard_Fragment
  )>> };

type DetailCarRecommendationCard_AlternateRecommendationCard_Fragment = { __typename: 'AlternateRecommendationCard', icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
  )>, action?: Maybe<(
    { __typename: 'CarAction' }
    & DetailActionFragment
  )> };

type DetailCarRecommendationCard_DateTimeRecommendationCard_Fragment = { __typename: 'DateTimeRecommendationCard', icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
    & DetailIconFragment
  )>, text?: Maybe<(
    { __typename: 'CarsRichText' }
    & DetailsRichTextFragment
  )>, subText?: Maybe<(
    { __typename: 'CarPhraseText' }
    & DetailCarPhrase_CarPhraseText_Fragment
  )>, action?: Maybe<(
    { __typename: 'CarAction' }
    & DetailActionFragment
    & DetailActionFragment
  )> };

type DetailCarRecommendationCard_LimitedResultMessageOnRecommendationCard_Fragment = { __typename: 'LimitedResultMessageOnRecommendationCard', icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
    & DetailIconFragment
  )>, action?: Maybe<(
    { __typename: 'CarAction' }
    & DetailActionFragment
    & DetailActionFragment
  )>, recommendationDialog?: Maybe<{ __typename: 'CarsDialog', title: string, buttonText: string, text: Array<string>, content?: Maybe<{ __typename: 'CarsDialogContent', header: (
        { __typename: 'CarActionableItem' }
        & DetailCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DetailCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DetailCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DetailCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DetailCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DetailCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DetailCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DetailCarPhrase_CarsRichText_Fragment
      ), body: Array<{ __typename: 'CarsDialogBody', title: (
          { __typename: 'CarActionableItem' }
          & DetailCarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & DetailCarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & DetailCarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & DetailCarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & DetailCarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & DetailCarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & DetailCarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & DetailCarPhrase_CarsRichText_Fragment
        ), body: Array<(
          { __typename: 'CarActionableItem' }
          & DetailCarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & DetailCarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & DetailCarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & DetailCarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & DetailCarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & DetailCarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & DetailCarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & DetailCarPhrase_CarsRichText_Fragment
        )> }>, footer?: Maybe<Array<(
        { __typename: 'CarActionableItem' }
        & DetailCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DetailCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DetailCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DetailCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DetailCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DetailCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DetailCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DetailCarPhrase_CarsRichText_Fragment
      )>> }> }> };

type DetailCarRecommendationCard_LocationRecommendationCard_Fragment = { __typename: 'LocationRecommendationCard', icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
    & DetailIconFragment
  )>, location?: Maybe<(
    { __typename: 'CarsRichText' }
    & DetailsRichTextFragment
  )>, city?: Maybe<(
    { __typename: 'CarPhraseText' }
    & DetailCarPhrase_CarPhraseText_Fragment
  )>, distanceText?: Maybe<(
    { __typename: 'CarPhraseText' }
    & DetailCarPhrase_CarPhraseText_Fragment
  )>, action?: Maybe<(
    { __typename: 'CarAction' }
    & DetailActionFragment
    & DetailActionFragment
  )>, pickUpLocation?: Maybe<(
    { __typename: 'CarSearchLocation' }
    & DetailCarSearchLocationFragment
  )> };

type DetailCarRecommendationCard_PartnerRecommendationCard_Fragment = { __typename: 'PartnerRecommendationCard', icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
    & DetailIconFragment
  )>, action?: Maybe<(
    { __typename: 'CarAction' }
    & DetailActionFragment
    & DetailActionFragment
  )>, analytics?: Maybe<(
    { __typename: 'CarAnalytics' }
    & DetailAnalyticsFragment
  )>, image?: Maybe<(
    { __typename: 'Image' }
    & DetailImageFragment
  )>, title?: Maybe<(
    { __typename: 'CarActionableItem' }
    & DetailCarPhrase_CarActionableItem_Fragment
  ) | (
    { __typename: 'CarDialogConfidenceMessage' }
    & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
  ) | (
    { __typename: 'CarOfferBadge' }
    & DetailCarPhrase_CarOfferBadge_Fragment
  ) | (
    { __typename: 'CarPhraseHTMLText' }
    & DetailCarPhrase_CarPhraseHtmlText_Fragment
  ) | (
    { __typename: 'CarPhraseIconText' }
    & DetailCarPhrase_CarPhraseIconText_Fragment
  ) | (
    { __typename: 'CarPhraseMark' }
    & DetailCarPhrase_CarPhraseMark_Fragment
  ) | (
    { __typename: 'CarPhrasePairText' }
    & DetailCarPhrase_CarPhrasePairText_Fragment
  ) | (
    { __typename: 'CarPhraseText' }
    & DetailCarPhrase_CarPhraseText_Fragment
  ) | (
    { __typename: 'CarsRichText' }
    & DetailCarPhrase_CarsRichText_Fragment
  )>, subText?: Maybe<(
    { __typename: 'CarActionableItem' }
    & DetailCarPhrase_CarActionableItem_Fragment
  ) | (
    { __typename: 'CarDialogConfidenceMessage' }
    & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
  ) | (
    { __typename: 'CarOfferBadge' }
    & DetailCarPhrase_CarOfferBadge_Fragment
  ) | (
    { __typename: 'CarPhraseHTMLText' }
    & DetailCarPhrase_CarPhraseHtmlText_Fragment
  ) | (
    { __typename: 'CarPhraseIconText' }
    & DetailCarPhrase_CarPhraseIconText_Fragment
  ) | (
    { __typename: 'CarPhraseMark' }
    & DetailCarPhrase_CarPhraseMark_Fragment
  ) | (
    { __typename: 'CarPhrasePairText' }
    & DetailCarPhrase_CarPhrasePairText_Fragment
  ) | (
    { __typename: 'CarPhraseText' }
    & DetailCarPhrase_CarPhraseText_Fragment
  ) | (
    { __typename: 'CarsRichText' }
    & DetailCarPhrase_CarsRichText_Fragment
  )>, button?: Maybe<(
    { __typename: 'CarActionableItem' }
    & DetailActionableItemFragment
  )>, dialog?: Maybe<{ __typename: 'PartnerRecommendationDialog', title: (
      { __typename: 'CarActionableItem' }
      & DetailCarPhrase_CarActionableItem_Fragment
    ) | (
      { __typename: 'CarDialogConfidenceMessage' }
      & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
    ) | (
      { __typename: 'CarOfferBadge' }
      & DetailCarPhrase_CarOfferBadge_Fragment
    ) | (
      { __typename: 'CarPhraseHTMLText' }
      & DetailCarPhrase_CarPhraseHtmlText_Fragment
    ) | (
      { __typename: 'CarPhraseIconText' }
      & DetailCarPhrase_CarPhraseIconText_Fragment
    ) | (
      { __typename: 'CarPhraseMark' }
      & DetailCarPhrase_CarPhraseMark_Fragment
    ) | (
      { __typename: 'CarPhrasePairText' }
      & DetailCarPhrase_CarPhrasePairText_Fragment
    ) | (
      { __typename: 'CarPhraseText' }
      & DetailCarPhrase_CarPhraseText_Fragment
    ) | (
      { __typename: 'CarsRichText' }
      & DetailCarPhrase_CarsRichText_Fragment
    ), subTitle: (
      { __typename: 'CarActionableItem' }
      & DetailCarPhrase_CarActionableItem_Fragment
    ) | (
      { __typename: 'CarDialogConfidenceMessage' }
      & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
    ) | (
      { __typename: 'CarOfferBadge' }
      & DetailCarPhrase_CarOfferBadge_Fragment
    ) | (
      { __typename: 'CarPhraseHTMLText' }
      & DetailCarPhrase_CarPhraseHtmlText_Fragment
    ) | (
      { __typename: 'CarPhraseIconText' }
      & DetailCarPhrase_CarPhraseIconText_Fragment
    ) | (
      { __typename: 'CarPhraseMark' }
      & DetailCarPhrase_CarPhraseMark_Fragment
    ) | (
      { __typename: 'CarPhrasePairText' }
      & DetailCarPhrase_CarPhrasePairText_Fragment
    ) | (
      { __typename: 'CarPhraseText' }
      & DetailCarPhrase_CarPhraseText_Fragment
    ) | (
      { __typename: 'CarsRichText' }
      & DetailCarPhrase_CarsRichText_Fragment
    ), text: Array<Array<(
      { __typename: 'CarActionableItem' }
      & DetailCarPhrase_CarActionableItem_Fragment
    ) | (
      { __typename: 'CarDialogConfidenceMessage' }
      & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
    ) | (
      { __typename: 'CarOfferBadge' }
      & DetailCarPhrase_CarOfferBadge_Fragment
    ) | (
      { __typename: 'CarPhraseHTMLText' }
      & DetailCarPhrase_CarPhraseHtmlText_Fragment
    ) | (
      { __typename: 'CarPhraseIconText' }
      & DetailCarPhrase_CarPhraseIconText_Fragment
    ) | (
      { __typename: 'CarPhraseMark' }
      & DetailCarPhrase_CarPhraseMark_Fragment
    ) | (
      { __typename: 'CarPhrasePairText' }
      & DetailCarPhrase_CarPhrasePairText_Fragment
    ) | (
      { __typename: 'CarPhraseText' }
      & DetailCarPhrase_CarPhraseText_Fragment
    ) | (
      { __typename: 'CarsRichText' }
      & DetailCarPhrase_CarsRichText_Fragment
    )>>, button: (
      { __typename: 'CarActionableItem' }
      & DetailActionableItemFragment
    ), closeDialog: (
      { __typename: 'CarAction' }
      & DetailActionFragment
    ), content: { __typename: 'PartnerRecommendationDialogContent', title: (
        { __typename: 'CarActionableItem' }
        & DetailCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DetailCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DetailCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DetailCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DetailCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DetailCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DetailCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DetailCarPhrase_CarsRichText_Fragment
      ), body: Array<Array<(
        { __typename: 'CarActionableItem' }
        & DetailCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DetailCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DetailCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DetailCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DetailCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DetailCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DetailCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DetailCarPhrase_CarsRichText_Fragment
      )>>, confidenceMessage: Array<(
        { __typename: 'CarActionableItem' }
        & DetailCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DetailCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DetailCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DetailCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DetailCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DetailCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DetailCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DetailCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DetailCarPhrase_CarsRichText_Fragment
      )> }, image: (
      { __typename: 'Image' }
      & DetailImageFragment
    ) }> };

export type DetailCarRecommendationCardFragment = DetailCarRecommendationCard_AlternateRecommendationCard_Fragment | DetailCarRecommendationCard_DateTimeRecommendationCard_Fragment | DetailCarRecommendationCard_LimitedResultMessageOnRecommendationCard_Fragment | DetailCarRecommendationCard_LocationRecommendationCard_Fragment | DetailCarRecommendationCard_PartnerRecommendationCard_Fragment;

export type DetailCarSearchLocationFragment = { __typename: 'CarSearchLocation', shortName: string, fullName: string, regionId?: Maybe<string> };

export type DetailFeatureFragment = { __typename: 'VehicleFeature', text: string, icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
  )>, info?: Maybe<{ __typename: 'VehicleFeatureInfo', vehicleFeatureDialog: { __typename: 'CarsDialog', title: string, text: Array<string>, buttonText: string }, carActionableItem: (
      { __typename: 'CarActionableItem' }
      & DetailActionableItemFragment
    ) }> };

export type DetailPriceInfoFragment = { __typename: 'CarPriceInfo', accessibility?: Maybe<string>, qualifier: string, formattedValue?: Maybe<string>, price: (
    { __typename: 'Money' }
    & DetailMoneyFragment
  ) };

export type DetailIconFragment = { __typename: 'Icon', description: string, id: string, size?: Maybe<IconSize>, withBackground?: Maybe<boolean> };

export type DetailImageFragment = { __typename: 'Image', description: string, url: any };

export type DetailMoneyFragment = { __typename: 'Money', amount: number, formatted: string, currencyInfo?: Maybe<{ __typename: 'Currency', code: string, name: string, symbol: string }> };

export type DetailAnalyticsFragment = { __typename: 'CarAnalytics', linkName: string, referrerId: string };

export type DetailActionFragment = { __typename: 'CarAction', actionType: CarActionType, accessibility?: Maybe<string>, analytics?: Maybe<(
    { __typename: 'CarAnalytics' }
    & DetailAnalyticsFragment
  )> };

export type DetailBadgeFragment = { __typename: 'CarOfferBadge', text: string, theme: string, icon?: Maybe<{ __typename: 'Icon', id: string }>, mark?: Maybe<{ __typename: 'Mark', id: string, url?: Maybe<{ __typename: 'HttpURI', value: string }> }> };

export type DetailActionableItemFragment = { __typename: 'CarActionableItem', text: string, url?: Maybe<{ __typename: 'HttpURI', value: string, relativePath: string }>, action: (
    { __typename: 'CarAction' }
    & DetailActionFragment
  ), icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
  )>, tel?: Maybe<{ __typename: 'TelURI', phoneNumber: string, value: string }> };

export type DetailCarDialogConfidenceMessageFragment = { __typename: 'CarDialogConfidenceMessage', text: string, iconMobileRender: boolean, icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
  )>, openDialogAction?: Maybe<(
    { __typename: 'CarAction' }
    & DetailActionFragment
  )>, dialogContent?: Maybe<{ __typename: 'CarsDialog', title: string, text: Array<string>, buttonText: string }> };

export type CarVendorLocationInfoFragment = { __typename: 'CarVendorLocationInfo', text: string, locationSubInfo?: Maybe<Array<string>>, icon: (
    { __typename: 'Icon' }
    & DetailIconFragment
  ) };

export type CarRentalLocationDetailFragment = { __typename: 'CarRentalLocationDetail', title: string, dateTime: (
    { __typename: 'CarVendorLocationInfo' }
    & CarVendorLocationInfoFragment
  ), address: (
    { __typename: 'CarVendorLocationInfo' }
    & CarVendorLocationInfoFragment
  ), hoursOfOperation?: Maybe<(
    { __typename: 'CarVendorLocationInfo' }
    & CarVendorLocationInfoFragment
  )>, instruction?: Maybe<(
    { __typename: 'CarVendorLocationInfo' }
    & CarVendorLocationInfoFragment
  )> };

type DetailCarPhrase_CarActionableItem_Fragment = (
  { __typename: 'CarActionableItem' }
  & DetailActionableItemFragment
);

type DetailCarPhrase_CarDialogConfidenceMessage_Fragment = (
  { __typename: 'CarDialogConfidenceMessage' }
  & DetailCarDialogConfidenceMessageFragment
);

type DetailCarPhrase_CarOfferBadge_Fragment = { __typename: 'CarOfferBadge' };

type DetailCarPhrase_CarPhraseHtmlText_Fragment = { __typename: 'CarPhraseHTMLText' };

type DetailCarPhrase_CarPhraseIconText_Fragment = { __typename: 'CarPhraseIconText', text: string, icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
  )> };

type DetailCarPhrase_CarPhraseMark_Fragment = { __typename: 'CarPhraseMark', text: string, name: string, description: string, url?: Maybe<{ __typename: 'HttpURI', value: string, relativePath: string }> };

type DetailCarPhrase_CarPhrasePairText_Fragment = { __typename: 'CarPhrasePairText', richText?: Maybe<(
    { __typename: 'CarsRichText' }
    & DetailsRichTextFragment
  )>, richSubText?: Maybe<(
    { __typename: 'CarsRichText' }
    & DetailsRichTextFragment
  )> };

type DetailCarPhrase_CarPhraseText_Fragment = { __typename: 'CarPhraseText', text: string };

type DetailCarPhrase_CarsRichText_Fragment = { __typename: 'CarsRichText', value: string, style?: Maybe<CarsRichTextStyle>, theme?: Maybe<string> };

export type DetailCarPhraseFragment = DetailCarPhrase_CarActionableItem_Fragment | DetailCarPhrase_CarDialogConfidenceMessage_Fragment | DetailCarPhrase_CarOfferBadge_Fragment | DetailCarPhrase_CarPhraseHtmlText_Fragment | DetailCarPhrase_CarPhraseIconText_Fragment | DetailCarPhrase_CarPhraseMark_Fragment | DetailCarPhrase_CarPhrasePairText_Fragment | DetailCarPhrase_CarPhraseText_Fragment | DetailCarPhrase_CarsRichText_Fragment;

export type DetailsRichTextFragment = { __typename: 'CarsRichText', value: string, theme?: Maybe<string>, style?: Maybe<CarsRichTextStyle> };

export type CarBreakupComponentFragment = { __typename: 'CarBreakupComponent', id: string, title: string, lineItems: Array<(
    { __typename: 'CarBreakupLineItem' }
    & CarBreakupLineItemFragment
  )> };

export type CarBreakupLineItemFragment = { __typename: 'CarBreakupLineItem', text: string, accessibility?: Maybe<string>, subText?: Maybe<string>, value: string, icon?: Maybe<(
    { __typename: 'Icon' }
    & DetailIconFragment
  )>, mark?: Maybe<{ __typename: 'Mark', id: string }>, dialogContent?: Maybe<{ __typename: 'CarPriceBreakupDialog', commonDialog: { __typename: 'CarsDialog', title: string, text: Array<string>, buttonText: string }, breakupContent?: Maybe<Array<(
      { __typename: 'CarBreakupLineItem' }
      & CarPriceBreakupDialogLineItemFragment
    )>> }>, openDialogAction?: Maybe<(
    { __typename: 'CarAction' }
    & DetailActionFragment
  )>, richValue?: Maybe<(
    { __typename: 'CarsRichText' }
    & DetailsRichTextFragment
  )> };

export type CarPriceBreakupDialogLineItemFragment = { __typename: 'CarBreakupLineItem', text: string, value: string, subText?: Maybe<string> };

export type UserFeedbackFragment = { __typename: 'UserFeedback', userSurveyTitle: string, submitConfirmation: string, options: Array<{ __typename: 'UserFeedbackOption', inputHeading: string, inputTextPlaceholder: string, option: (
      { __typename: 'CarActionableItem' }
      & DetailActionableItemFragment
    ) }>, submit: (
    { __typename: 'CarActionableItem' }
    & DetailActionableItemFragment
  ) };

export type CarDropOffSearchQueryVariables = Exact<{
  context: ContextInput;
  primaryCarSearchCriteria: PrimaryCarCriteriaInput;
  secondaryCriteria: ShoppingSearchCriteriaInput;
}>;


export type CarDropOffSearchQuery = { __typename: 'Query', carDropOffSearch: { __typename: 'DropOffSearchResults', carDropOffOfferCardTitle: string, carDropOffTitle: { __typename: 'CarDropOffTitle', url?: Maybe<string>, text: string, icon: (
        { __typename: 'Icon' }
        & DropOffIconFragment
      ), action: (
        { __typename: 'CarAction' }
        & DropOffActionFragment
      ) }, carDropOffOfferCard: Array<{ __typename: 'CarDropOffOfferCard', vehicle: { __typename: 'VehicleDetails', category: string, description?: Maybe<string>, image?: Maybe<(
          { __typename: 'Image' }
          & DropOffImageFragment
        )>, attributes: Array<{ __typename: 'VehicleFeature', text: string, icon?: Maybe<(
            { __typename: 'Icon' }
            & DropOffIconFragment
          )> }>, features: Array<(
          { __typename: 'VehicleFeature' }
          & DropOffFeatureFragment
        )>, fuelInfo: Array<(
          { __typename: 'VehicleFeature' }
          & DropOffFeatureFragment
        )> }, vendor: { __typename: 'CarVendor', image?: Maybe<(
          { __typename: 'Image' }
          & DropOffImageFragment
        )> }, tripLocations: { __typename: 'CarOfferVendorLocations', pickUpLocation: (
          { __typename: 'CarOfferVendorLocationInfo' }
          & DropOffCarOfferVendorLocationInfoFragment
        ), dropOffLocation?: Maybe<(
          { __typename: 'CarOfferVendorLocationInfo' }
          & DropOffCarOfferVendorLocationInfoFragment
        )> }, detailsContext: { __typename: 'CarDetailContext', carOfferToken: string, selectedAccessories?: Maybe<Array<string>>, rewardPointsSelection?: Maybe<RewardsPointSelectionEnum>, continuationContextualId?: Maybe<string> }, carPriceDetail: { __typename: 'CarPriceDetail', priceTitle: string, priceSubInfo?: Maybe<Array<string>> }, selectButton: (
        { __typename: 'CarActionableItem' }
        & DropOffActionableItemFragment
      ), viewMap: (
        { __typename: 'CarActionableItem' }
        & DropOffActionableItemFragment
      ) }>, map?: Maybe<{ __typename: 'CarMap', title: string, text: string, zoomLevel: number, closeIcon: (
        { __typename: 'Icon' }
        & DropOffIconFragment
      ), closeAction: (
        { __typename: 'CarAction' }
        & DropOffActionFragment
      ), center: (
        { __typename: 'Coordinates' }
        & DropOffCoordinatesFragment
      ), bounds: { __typename: 'CarMapBounds', northeast: (
          { __typename: 'Coordinates' }
          & DropOffCoordinatesFragment
        ), southwest: (
          { __typename: 'Coordinates' }
          & DropOffCoordinatesFragment
        ) }, markers: Array<{ __typename: 'CarItemCardMapMarker', type: CarMapMarkerType, itemCard: { __typename: 'CarMapDropOffLocationCard', vendorLocationId: string, address: string, distance: string, superlative: string, vendorImage: (
            { __typename: 'Image' }
            & DropOffImageFragment
          ), carPriceDetail: { __typename: 'CarPriceDetail', priceTitle: string, priceSubInfo?: Maybe<Array<string>> }, selectButton: (
            { __typename: 'CarActionableItem' }
            & DropOffActionableItemFragment
          ), detailsContext: { __typename: 'CarDetailContext', carOfferToken: string, selectedAccessories?: Maybe<Array<string>>, rewardPointsSelection?: Maybe<RewardsPointSelectionEnum>, continuationContextualId?: Maybe<string> } } | { __typename: 'CarMapPickupLocationCard' } | { __typename: 'CarMapSearchLocationCard', title: string, text: string }, action: (
          { __typename: 'CarAction' }
          & DropOffActionFragment
        ), coordinates: (
          { __typename: 'Coordinates' }
          & DropOffCoordinatesFragment
        ) }> }>, shareFeedbackAction?: Maybe<{ __typename: 'CarShareFeedbackAction', text: string, button: (
        { __typename: 'CarActionableItem' }
        & DropOffActionableItemFragment
      ) }> } };

export type DropOffActionableItemFragment = { __typename: 'CarActionableItem', text: string, url?: Maybe<{ __typename: 'HttpURI', value: string, relativePath: string }>, action: (
    { __typename: 'CarAction' }
    & DropOffActionFragment
  ) };

export type DropOffAnalyticsFragment = { __typename: 'CarAnalytics', linkName: string, referrerId: string };

export type DropOffActionFragment = { __typename: 'CarAction', actionType: CarActionType, accessibility?: Maybe<string>, analytics?: Maybe<(
    { __typename: 'CarAnalytics' }
    & DropOffAnalyticsFragment
  )> };

export type DropOffFeatureFragment = { __typename: 'VehicleFeature', text: string, icon?: Maybe<(
    { __typename: 'Icon' }
    & DropOffIconFragment
  )>, info?: Maybe<{ __typename: 'VehicleFeatureInfo', vehicleFeatureDialog: { __typename: 'CarsDialog', title: string, text: Array<string>, buttonText: string } }> };

export type DropOffIconFragment = { __typename: 'Icon', description: string, id: string, withBackground?: Maybe<boolean>, size?: Maybe<IconSize> };

export type DropOffImageFragment = { __typename: 'Image', description: string, url: any };

export type DropOffCoordinatesFragment = { __typename: 'Coordinates', latitude: number, longitude: number };

export type DropOffCarOfferVendorLocationInfoFragment = { __typename: 'CarOfferVendorLocationInfo', text: string, locationSubInfo?: Maybe<Array<string>>, icon: (
    { __typename: 'Icon' }
    & DropOffIconFragment
  ) };

export type CarSearchV3QueryVariables = Exact<{
  context: ContextInput;
  primaryCarSearchCriteria: PrimaryCarCriteriaInput;
  secondaryCriteria: ShoppingSearchCriteriaInput;
  shoppingContext?: Maybe<ShoppingContextInput>;
}>;


export type CarSearchV3Query = { __typename: 'Query', carSearchOrRecommendations: { __typename: 'CarsSearchResultsWrapper', carSearchResults?: Maybe<{ __typename: 'CarSearchResults', multiItemAnchorPriceToken?: Maybe<string>, shoppingContext?: Maybe<{ __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string }> }>, carsShoppingContext: { __typename: 'CarsShoppingContext', searchId?: Maybe<string> }, multiItemPickUpDropOffMessage?: Maybe<{ __typename: 'MultiItemPickUpDropOffMessage', message: { __typename: 'CarActionableItem' } | { __typename: 'CarDialogConfidenceMessage' } | { __typename: 'CarOfferBadge' } | { __typename: 'CarPhraseHTMLText' } | { __typename: 'CarPhraseIconText' } | { __typename: 'CarPhraseMark' } | { __typename: 'CarPhrasePairText' } | { __typename: 'CarPhraseText', text: string } | { __typename: 'CarsRichText' } }>, multiItemPlayBackTitleBar?: Maybe<{ __typename: 'MultiItemPlayBackTitleBar', primary: { __typename: 'CarActionableItem' } | { __typename: 'CarDialogConfidenceMessage' } | { __typename: 'CarOfferBadge' } | { __typename: 'CarPhraseHTMLText' } | { __typename: 'CarPhraseIconText' } | { __typename: 'CarPhraseMark' } | { __typename: 'CarPhrasePairText' } | { __typename: 'CarPhraseText', text: string } | { __typename: 'CarsRichText' }, secondary: { __typename: 'MultiItemPlayBackSecondaryMessage', longMessage: { __typename: 'CarActionableItem' } | { __typename: 'CarDialogConfidenceMessage' } | { __typename: 'CarOfferBadge' } | { __typename: 'CarPhraseHTMLText' } | { __typename: 'CarPhraseIconText' } | { __typename: 'CarPhraseMark' } | { __typename: 'CarPhrasePairText' } | { __typename: 'CarPhraseText', text: string } | { __typename: 'CarsRichText' }, shortMessage: { __typename: 'CarActionableItem' } | { __typename: 'CarDialogConfidenceMessage' } | { __typename: 'CarOfferBadge' } | { __typename: 'CarPhraseHTMLText' } | { __typename: 'CarPhraseIconText' } | { __typename: 'CarPhraseMark' } | { __typename: 'CarPhrasePairText' } | { __typename: 'CarPhraseText', text: string } | { __typename: 'CarsRichText' }, accessibilityMessage: { __typename: 'CarActionableItem' } | { __typename: 'CarDialogConfidenceMessage' } | { __typename: 'CarOfferBadge' } | { __typename: 'CarPhraseHTMLText' } | { __typename: 'CarPhraseIconText' } | { __typename: 'CarPhraseMark' } | { __typename: 'CarPhrasePairText' } | { __typename: 'CarPhraseText', text: string } | { __typename: 'CarsRichText' } } }>, listings: Array<(
        { __typename: 'CarMessagingCard' }
        & MessagingCardFragment
      ) | { __typename: 'CarOfferCard', accessibilityString?: Maybe<string>, reserveButtonText: string, offerHeading?: Maybe<string>, multiItemPriceToken?: Maybe<string>, isFareComparisonTestEnabled?: Maybe<boolean>, priceSummaryText?: Maybe<string>, offerBadges: Array<(
          { __typename: 'CarOfferBadge' }
          & BadgeFragment
        )>, vehicle: { __typename: 'VehicleDetails', category: string, description?: Maybe<string>, image?: Maybe<(
            { __typename: 'Image' }
            & ImageFragment
          )>, categoryIcon?: Maybe<(
            { __typename: 'Icon' }
            & IconFragment
          )>, attributes: Array<{ __typename: 'VehicleFeature', text: string, icon?: Maybe<(
              { __typename: 'Icon' }
              & IconFragment
            )> }>, features: Array<(
            { __typename: 'VehicleFeature' }
            & FeatureFragment
          )>, fuelInfo: Array<(
            { __typename: 'VehicleFeature' }
            & FeatureFragment
          )> }, tripLocations: { __typename: 'CarOfferVendorLocations', pickUpLocation: (
            { __typename: 'CarOfferVendorLocationInfo' }
            & CarOfferVendorLocationInfoFragment
          ), dropOffLocation?: Maybe<(
            { __typename: 'CarOfferVendorLocationInfo' }
            & CarOfferVendorLocationInfoFragment
          )> }, vendor: { __typename: 'CarVendor', image?: Maybe<(
            { __typename: 'Image' }
            & ImageFragment
          )> }, detailsContext: { __typename: 'CarDetailContext', carOfferToken: string, selectedAccessories?: Maybe<Array<string>>, rewardPointsSelection?: Maybe<RewardsPointSelectionEnum>, continuationContextualId?: Maybe<string> }, priceBadges: Array<(
          { __typename: 'CarOfferBadge' }
          & BadgeFragment
        )>, actionableConfidenceMessages: Array<(
          { __typename: 'CarActionableItem' }
          & CarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & CarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & CarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & CarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & CarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & CarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & CarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & CarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & CarPhrase_CarsRichText_Fragment
        )>, review?: Maybe<{ __typename: 'CarOfferReview', rating: string, superlative: string, totalCount?: Maybe<string>, richRatingText?: Maybe<(
            { __typename: 'CarsRichText' }
            & DetailsRichTextFragment
          )> }>, priceSummary: (
          { __typename: 'CarPriceSummary' }
          & OfferPriceSummaryFragment
        ), shortList: { __typename: 'CarShortList', favorited: boolean, saveUrl: string, removeUrl: string }, action: (
          { __typename: 'CarAction' }
          & CarActionFragment
        ), infositeURL: { __typename: 'HttpURI', relativePath: string }, additionalBenefits?: Maybe<Array<(
          { __typename: 'CarPhraseIconText' }
          & CarPhrase_CarPhraseIconText_Fragment
        )>>, cancellationAndPaymentMessages?: Maybe<Array<(
          { __typename: 'CarActionableItem' }
          & CarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & CarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & CarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & CarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & CarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & CarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & CarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & CarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & CarPhrase_CarsRichText_Fragment
        )>>, clubbedPriceOptions?: Maybe<{ __typename: 'ClubbedPriceOptions', dialogTrigger: (
            { __typename: 'CarActionableItem' }
            & CarActionableItemFragment
          ), dialogContent: { __typename: 'ClubbedPriceOptionsDialog', title: string, vehicleCategory: string, vehicleDescription?: Maybe<string>, modalFooter: string, vendor: { __typename: 'CarVendor', image?: Maybe<(
                { __typename: 'Image' }
                & ImageFragment
              )> }, optionsSummary: Array<(
              { __typename: 'CarActionableItem' }
              & CarPhrase_CarActionableItem_Fragment
            ) | (
              { __typename: 'CarDialogConfidenceMessage' }
              & CarPhrase_CarDialogConfidenceMessage_Fragment
            ) | (
              { __typename: 'CarOfferBadge' }
              & CarPhrase_CarOfferBadge_Fragment
            ) | (
              { __typename: 'CarPhraseHTMLText' }
              & CarPhrase_CarPhraseHtmlText_Fragment
            ) | (
              { __typename: 'CarPhraseIconText' }
              & CarPhrase_CarPhraseIconText_Fragment
            ) | (
              { __typename: 'CarPhraseMark' }
              & CarPhrase_CarPhraseMark_Fragment
            ) | (
              { __typename: 'CarPhrasePairText' }
              & CarPhrase_CarPhrasePairText_Fragment
            ) | (
              { __typename: 'CarPhraseText' }
              & CarPhrase_CarPhraseText_Fragment
            ) | (
              { __typename: 'CarsRichText' }
              & CarPhrase_CarsRichText_Fragment
            )>, clubbedPrices: Array<{ __typename: 'ClubbedPrice', reserveButtonText: string, heading?: Maybe<(
                { __typename: 'CarActionableItem' }
                & CarPhrase_CarActionableItem_Fragment
              ) | (
                { __typename: 'CarDialogConfidenceMessage' }
                & CarPhrase_CarDialogConfidenceMessage_Fragment
              ) | (
                { __typename: 'CarOfferBadge' }
                & CarPhrase_CarOfferBadge_Fragment
              ) | (
                { __typename: 'CarPhraseHTMLText' }
                & CarPhrase_CarPhraseHtmlText_Fragment
              ) | (
                { __typename: 'CarPhraseIconText' }
                & CarPhrase_CarPhraseIconText_Fragment
              ) | (
                { __typename: 'CarPhraseMark' }
                & CarPhrase_CarPhraseMark_Fragment
              ) | (
                { __typename: 'CarPhrasePairText' }
                & CarPhrase_CarPhrasePairText_Fragment
              ) | (
                { __typename: 'CarPhraseText' }
                & CarPhrase_CarPhraseText_Fragment
              ) | (
                { __typename: 'CarsRichText' }
                & CarPhrase_CarsRichText_Fragment
              )>, title: (
                { __typename: 'CarActionableItem' }
                & CarPhrase_CarActionableItem_Fragment
              ) | (
                { __typename: 'CarDialogConfidenceMessage' }
                & CarPhrase_CarDialogConfidenceMessage_Fragment
              ) | (
                { __typename: 'CarOfferBadge' }
                & CarPhrase_CarOfferBadge_Fragment
              ) | (
                { __typename: 'CarPhraseHTMLText' }
                & CarPhrase_CarPhraseHtmlText_Fragment
              ) | (
                { __typename: 'CarPhraseIconText' }
                & CarPhrase_CarPhraseIconText_Fragment
              ) | (
                { __typename: 'CarPhraseMark' }
                & CarPhrase_CarPhraseMark_Fragment
              ) | (
                { __typename: 'CarPhrasePairText' }
                & CarPhrase_CarPhrasePairText_Fragment
              ) | (
                { __typename: 'CarPhraseText' }
                & CarPhrase_CarPhraseText_Fragment
              ) | (
                { __typename: 'CarsRichText' }
                & CarPhrase_CarsRichText_Fragment
              ), offerBadges: Array<(
                { __typename: 'CarOfferBadge' }
                & BadgeFragment
              )>, priceBadges: Array<(
                { __typename: 'CarOfferBadge' }
                & BadgeFragment
              )>, priceSummary: (
                { __typename: 'CarPriceSummary' }
                & OfferPriceSummaryFragment
              ), paymentMessages: Array<(
                { __typename: 'CarActionableItem' }
                & CarPhrase_CarActionableItem_Fragment
              ) | (
                { __typename: 'CarDialogConfidenceMessage' }
                & CarPhrase_CarDialogConfidenceMessage_Fragment
              ) | (
                { __typename: 'CarOfferBadge' }
                & CarPhrase_CarOfferBadge_Fragment
              ) | (
                { __typename: 'CarPhraseHTMLText' }
                & CarPhrase_CarPhraseHtmlText_Fragment
              ) | (
                { __typename: 'CarPhraseIconText' }
                & CarPhrase_CarPhraseIconText_Fragment
              ) | (
                { __typename: 'CarPhraseMark' }
                & CarPhrase_CarPhraseMark_Fragment
              ) | (
                { __typename: 'CarPhrasePairText' }
                & CarPhrase_CarPhrasePairText_Fragment
              ) | (
                { __typename: 'CarPhraseText' }
                & CarPhrase_CarPhraseText_Fragment
              ) | (
                { __typename: 'CarsRichText' }
                & CarPhrase_CarsRichText_Fragment
              )>, additionalPaymentMessages?: Maybe<Array<(
                { __typename: 'CarActionableItem' }
                & CarPhrase_CarActionableItem_Fragment
              ) | (
                { __typename: 'CarDialogConfidenceMessage' }
                & CarPhrase_CarDialogConfidenceMessage_Fragment
              ) | (
                { __typename: 'CarOfferBadge' }
                & CarPhrase_CarOfferBadge_Fragment
              ) | (
                { __typename: 'CarPhraseHTMLText' }
                & CarPhrase_CarPhraseHtmlText_Fragment
              ) | (
                { __typename: 'CarPhraseIconText' }
                & CarPhrase_CarPhraseIconText_Fragment
              ) | (
                { __typename: 'CarPhraseMark' }
                & CarPhrase_CarPhraseMark_Fragment
              ) | (
                { __typename: 'CarPhrasePairText' }
                & CarPhrase_CarPhrasePairText_Fragment
              ) | (
                { __typename: 'CarPhraseText' }
                & CarPhrase_CarPhraseText_Fragment
              ) | (
                { __typename: 'CarsRichText' }
                & CarPhrase_CarsRichText_Fragment
              )>>, cancellationMessages?: Maybe<Array<(
                { __typename: 'CarActionableItem' }
                & CarPhrase_CarActionableItem_Fragment
              ) | (
                { __typename: 'CarDialogConfidenceMessage' }
                & CarPhrase_CarDialogConfidenceMessage_Fragment
              ) | (
                { __typename: 'CarOfferBadge' }
                & CarPhrase_CarOfferBadge_Fragment
              ) | (
                { __typename: 'CarPhraseHTMLText' }
                & CarPhrase_CarPhraseHtmlText_Fragment
              ) | (
                { __typename: 'CarPhraseIconText' }
                & CarPhrase_CarPhraseIconText_Fragment
              ) | (
                { __typename: 'CarPhraseMark' }
                & CarPhrase_CarPhraseMark_Fragment
              ) | (
                { __typename: 'CarPhrasePairText' }
                & CarPhrase_CarPhrasePairText_Fragment
              ) | (
                { __typename: 'CarPhraseText' }
                & CarPhrase_CarPhraseText_Fragment
              ) | (
                { __typename: 'CarsRichText' }
                & CarPhrase_CarsRichText_Fragment
              )>>, additionalBenefits?: Maybe<Array<(
                { __typename: 'CarPhraseIconText' }
                & CarPhrase_CarPhraseIconText_Fragment
              )>>, reserveButtonAction: (
                { __typename: 'CarAction' }
                & CarActionFragment
              ), infositeURL: { __typename: 'HttpURI', relativePath: string } }>, commonAdditionalBenefits?: Maybe<Array<(
              { __typename: 'CarPhraseIconText' }
              & CarPhrase_CarPhraseIconText_Fragment
            )>> } }>, enhancedCleanlinessDialog?: Maybe<{ __typename: 'EnhancedCleanlinessDialog', title: string, description: string, carouselButtonAllyStrings?: Maybe<Array<string>>, images?: Maybe<Array<{ __typename: 'HttpURI', value: string }>>, content: Array<{ __typename: 'EnhancedCleanlinessDialogContent', infos: Array<string>, title: { __typename: 'EnhancedCleanlinessInfoLineItem', text: string, icon: (
                { __typename: 'Icon' }
                & IconFragment
              ) } }> }>, guaranteedAnalytics?: Maybe<(
          { __typename: 'CarAnalytics' }
          & AnalyticsFragment
        )>, personalisedDeal?: Maybe<(
          { __typename: 'CarPhraseText' }
          & CarPhrase_CarPhraseText_Fragment
        )> } | { __typename: 'CarSaleCard' }>, carRentalLocations: { __typename: 'CarSearchLocations', routeType: CarRouteType, pickUpLocation: (
          { __typename: 'CarSearchLocation' }
          & CarSearchLocationFragment
        ), dropOffLocation?: Maybe<(
          { __typename: 'CarSearchLocation' }
          & CarSearchLocationFragment
        )> }, changeRentalLocation?: Maybe<{ __typename: 'ChangeRentalLocation', link: { __typename: 'CarActionableItem', text: string } | { __typename: 'CarDialogConfidenceMessage' } | { __typename: 'CarOfferBadge' } | { __typename: 'CarPhraseHTMLText' } | { __typename: 'CarPhraseIconText' } | { __typename: 'CarPhraseMark' } | { __typename: 'CarPhrasePairText' } | { __typename: 'CarPhraseText' } | { __typename: 'CarsRichText' }, placeHolder: { __typename: 'CarActionableItem' } | { __typename: 'CarDialogConfidenceMessage' } | { __typename: 'CarOfferBadge' } | { __typename: 'CarPhraseHTMLText' } | { __typename: 'CarPhraseIconText' } | { __typename: 'CarPhraseMark' } | { __typename: 'CarPhrasePairText' } | { __typename: 'CarPhraseText', text: string } | { __typename: 'CarsRichText' }, primary: { __typename: 'CarActionableItem' } | { __typename: 'CarDialogConfidenceMessage' } | { __typename: 'CarOfferBadge' } | { __typename: 'CarPhraseHTMLText' } | { __typename: 'CarPhraseIconText' } | { __typename: 'CarPhraseMark' } | { __typename: 'CarPhrasePairText' } | { __typename: 'CarPhraseText', text: string } | { __typename: 'CarsRichText' }, secondary: { __typename: 'CarActionableItem' } | { __typename: 'CarDialogConfidenceMessage' } | { __typename: 'CarOfferBadge' } | { __typename: 'CarPhraseHTMLText' } | { __typename: 'CarPhraseIconText' } | { __typename: 'CarPhraseMark' } | { __typename: 'CarPhrasePairText' } | { __typename: 'CarPhraseText', text: string } | { __typename: 'CarsRichText' } }>, summary: { __typename: 'CarSearchSummary', title: string, pageTitle: string, dynamicTitle: Array<Array<(
          { __typename: 'CarActionableItem' }
          & CarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & CarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & CarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & CarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & CarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & CarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & CarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & CarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & CarPhrase_CarsRichText_Fragment
        )>>, includedFeeFooter?: Maybe<{ __typename: 'IncludedFeeFooter', title: string, description: string }>, carRecommendations?: Maybe<Array<Maybe<(
          { __typename: 'CarRecommendations' }
          & CarRecommendationsFragment
        )>>> }, filterNoMatchMessage?: Maybe<{ __typename: 'CarSearchFilterNoMatchMessage', allOffersTextSeparator: string, messagingCard: (
          { __typename: 'CarMessagingCard' }
          & MessagingCardFragment
        ) }>, loadMoreAction?: Maybe<{ __typename: 'CarLoadMoreAction', text: string, action: (
          { __typename: 'CarAction' }
          & CarActionFragment
        ), icon: (
          { __typename: 'Icon' }
          & IconFragment
        ), searchPagination: { __typename: 'CarSearchPagination', size: number, startingIndex: number } }>, loyaltyInfo?: Maybe<Array<(
        { __typename: 'CarActionableItem' }
        & CarActionableItemFragment
      ) | { __typename: 'CarDialogConfidenceMessage' } | { __typename: 'CarOfferBadge' } | { __typename: 'CarPhraseHTMLText' } | { __typename: 'CarPhraseIconText' } | { __typename: 'CarPhraseMark', text: string, name: string, description: string, url?: Maybe<{ __typename: 'HttpURI', value: string, relativePath: string }> } | { __typename: 'CarPhrasePairText' } | { __typename: 'CarPhraseText', text: string } | { __typename: 'CarsRichText' }>>, oneKeyInfo?: Maybe<{ __typename: 'OneKeyInfo', isOneKeyEnrolled: boolean }>, sortAndFilter: { __typename: 'ShoppingSortAndFilters', title: string, appliedFilterCount: number, clearButtonTitle: string, close: (
          { __typename: 'Icon' }
          & IconFragment
        ), sections: Array<{ __typename: 'ShoppingSortAndFilterSection', title?: Maybe<string>, fields: Array<{ __typename: 'AgencyButtonField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'AgencyCheckboxField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'AgencyRadioField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'AgencySliderField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'GroundTransfersDropdownField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'ShoppingDateField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'ShoppingDropdownField', primary?: Maybe<string>, secondary?: Maybe<string> } | (
            { __typename: 'ShoppingMultiSelectionField', primary?: Maybe<string>, secondary?: Maybe<string> }
            & MultiSelectionFragmentFragment
          ) | { __typename: 'ShoppingMultiSelectionStackedTileField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'ShoppingMultiSelectionTileField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'ShoppingMutexField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'ShoppingPillSelectionField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'ShoppingRangeField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'ShoppingRangeTextInputField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'ShoppingSelectedFiltersField', primary?: Maybe<string>, secondary?: Maybe<string> } | (
            { __typename: 'ShoppingSelectionField', primary?: Maybe<string>, secondary?: Maybe<string> }
            & SingleSelectionFragmentFragment
          ) | { __typename: 'ShoppingStepInputField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'ShoppingTabSelectionField', primary?: Maybe<string>, secondary?: Maybe<string> } | { __typename: 'ShoppingTextInputField', primary?: Maybe<string>, secondary?: Maybe<string> }> }> }, carAppliedSortAndFilters: { __typename: 'CarAppliedSortAndFilters', appliedSortAndFilters: Array<{ __typename: 'CarAppliedSortAndFilter', id: string, text: string, value: string, crossIcon: (
            { __typename: 'Icon' }
            & IconFragment
          ), analytics: (
            { __typename: 'ClientSideAnalytics' }
            & ClientSideAnalyticsFragment
          ) }> }, shareFeedbackAction?: Maybe<{ __typename: 'CarShareFeedbackAction', text: string, button: (
          { __typename: 'CarActionableItem' }
          & CarActionableItemFragment
        ) }>, adsTargetingData?: Maybe<{ __typename: 'AdsTargetingData', uuid: string, siteId: number, pageName: string, origin?: Maybe<string>, dest?: Maybe<string>, locResolver?: Maybe<string>, dateStart?: Maybe<string>, dateEnd?: Maybe<string>, adProvider: string }>, recommendedSortDisclaimer?: Maybe<(
        { __typename: 'CarActionableItem' }
        & CarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & CarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & CarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & CarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & CarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & CarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & CarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & CarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & CarPhrase_CarsRichText_Fragment
      )>, recommendedSortExplanation: { __typename: 'CarDisclaimerDialog', content: Array<(
          { __typename: 'CarActionableItem' }
          & CarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & CarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & CarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & CarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & CarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & CarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & CarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & CarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & CarPhrase_CarsRichText_Fragment
        )>, feedback?: Maybe<(
          { __typename: 'UserFeedback' }
          & SearchUserFeedbackFragment
        )>, closeAnalytics: (
          { __typename: 'CarAnalytics' }
          & AnalyticsFragment
        ) }, makeModelDisclaimer: (
        { __typename: 'CarActionableItem' }
        & CarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & CarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & CarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & CarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & CarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & CarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & CarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & CarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & CarPhrase_CarsRichText_Fragment
      ), map?: Maybe<{ __typename: 'CarMap', title: string, text: string, zoomLevel: number, filterTitle?: Maybe<string>, closeIcon: (
          { __typename: 'Icon' }
          & IconFragment
        ), closeAction: (
          { __typename: 'CarAction' }
          & CarActionFragment
        ), center: (
          { __typename: 'Coordinates' }
          & CoordinatesFragment
        ), bounds: { __typename: 'CarMapBounds', northeast: (
            { __typename: 'Coordinates' }
            & CoordinatesFragment
          ), southwest: (
            { __typename: 'Coordinates' }
            & CoordinatesFragment
          ) }, markers: Array<{ __typename: 'CarItemCardMapMarker', type: CarMapMarkerType, itemCard: { __typename: 'CarMapDropOffLocationCard' } | { __typename: 'CarMapPickupLocationCard', vendorLocationId: string, address: string, distance: string, superlative: string, seeCarsButtonText: string, vendorImage: (
              { __typename: 'Image' }
              & ImageFragment
            ), priceSummary: { __typename: 'CarPriceSummary', strikeThroughFirst?: Maybe<boolean>, accessibility?: Maybe<string>, lead?: Maybe<(
                { __typename: 'CarPriceInfo' }
                & PriceInfoFragment
              )>, total: (
                { __typename: 'CarPriceInfo' }
                & PriceInfoFragment
              ), loyaltyPointsOption?: Maybe<{ __typename: 'LoyaltyPointsOption', formattedPoints?: Maybe<string>, leadingCaption: string, pointsFirst: boolean }> }, action: (
              { __typename: 'CarAction' }
              & CarActionFragment
            ) } | { __typename: 'CarMapSearchLocationCard', title: string, text: string }, action: (
            { __typename: 'CarAction' }
            & CarActionFragment
          ), coordinates: (
            { __typename: 'Coordinates' }
            & CoordinatesFragment
          ) }>, mapButton: { __typename: 'CarActionableItem', text: string, url?: Maybe<{ __typename: 'HttpURI', value: string }>, action: (
            { __typename: 'CarAction' }
            & CarActionFragment
          ) }, mapSearchThisAreaButton?: Maybe<{ __typename: 'CarActionableItem', text: string, action: (
            { __typename: 'CarAction' }
            & CarActionFragment
          ) }> }> }>, carsErrorContent?: Maybe<{ __typename: 'CarsErrorContent', heading: string, subText: string, errorEventName?: Maybe<string>, icon?: Maybe<(
        { __typename: 'Icon' }
        & IconFragment
      )>, analytics: { __typename: 'CarAnalytics', linkName: string, referrerId: string }, locationAnalytics?: Maybe<{ __typename: 'CarAnalytics', linkName: string, referrerId: string }> }>, carRecommendationContent?: Maybe<Array<(
      { __typename: 'CarRecommendations' }
      & CarRecommendationsFragment
    )>> } };

export type MessagingCardFragment = { __typename: 'CarMessagingCard', title?: Maybe<string>, description: string, descriptions: Array<string>, mark?: Maybe<string>, cardTitle?: Maybe<(
    { __typename: 'CarsRichText' }
    & CarPhrase_CarsRichText_Fragment
  )>, cardDescriptions: Array<(
    { __typename: 'CarPhraseText' }
    & CarPhrase_CarPhraseText_Fragment
  )>, image?: Maybe<{ __typename: 'Image', description: string, url: any }>, illustrationURL?: Maybe<{ __typename: 'HttpURI', value: string }>, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
  )>, links: Array<{ __typename: 'CarActionableItem', text: string, url?: Maybe<{ __typename: 'HttpURI', value: string, relativePath: string }>, icon?: Maybe<(
      { __typename: 'Icon' }
      & IconFragment
    )>, action: { __typename: 'CarAction', actionType: CarActionType, analytics?: Maybe<{ __typename: 'CarAnalytics', linkName: string, referrerId: string }> } }>, dialog?: Maybe<{ __typename: 'CarsDialog', title: string, buttonText: string, text: Array<string>, type?: Maybe<CarsDialogType>, content?: Maybe<{ __typename: 'CarsDialogContent', header: (
        { __typename: 'CarActionableItem' }
        & CarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & CarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & CarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & CarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & CarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & CarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & CarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & CarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & CarPhrase_CarsRichText_Fragment
      ), body: Array<{ __typename: 'CarsDialogBody', title: (
          { __typename: 'CarActionableItem' }
          & CarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & CarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & CarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & CarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & CarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & CarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & CarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & CarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & CarPhrase_CarsRichText_Fragment
        ), body: Array<(
          { __typename: 'CarActionableItem' }
          & CarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & CarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & CarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & CarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & CarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & CarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & CarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & CarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & CarPhrase_CarsRichText_Fragment
        )> }>, footer?: Maybe<Array<(
        { __typename: 'CarActionableItem' }
        & CarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & CarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & CarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & CarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & CarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & CarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & CarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & CarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & CarPhrase_CarsRichText_Fragment
      )>> }> }>, carRecommendations?: Maybe<Array<Maybe<(
    { __typename: 'CarRecommendations' }
    & CarRecommendationsFragment
  )>>>, analytics?: Maybe<(
    { __typename: 'CarAnalytics' }
    & AnalyticsFragment
  )> };

export type BadgeFragment = { __typename: 'CarOfferBadge', text: string, theme: string, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
  )>, mark?: Maybe<{ __typename: 'Mark', id: string, url?: Maybe<{ __typename: 'HttpURI', value: string }> }> };

export type FeatureFragment = { __typename: 'VehicleFeature', text: string, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
  )>, info?: Maybe<{ __typename: 'VehicleFeatureInfo', vehicleFeatureDialog: { __typename: 'CarsDialog', title: string, text: Array<string>, buttonText: string }, carActionableItem: (
      { __typename: 'CarActionableItem' }
      & CarActionableItemFragment
    ) }> };

export type PriceInfoFragment = { __typename: 'CarPriceInfo', accessibility?: Maybe<string>, qualifier: string, formattedValue?: Maybe<string>, price: (
    { __typename: 'Money' }
    & MoneyFragment
  ) };

export type CarActionableItemFragment = { __typename: 'CarActionableItem', text: string, url?: Maybe<{ __typename: 'HttpURI', value: string, relativePath: string }>, action: (
    { __typename: 'CarAction' }
    & CarActionFragment
  ), icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
  )> };

type DialogContentCarPhrase_CarActionableItem_Fragment = (
  { __typename: 'CarActionableItem' }
  & CarActionableItemFragment
);

type DialogContentCarPhrase_CarDialogConfidenceMessage_Fragment = { __typename: 'CarDialogConfidenceMessage' };

type DialogContentCarPhrase_CarOfferBadge_Fragment = { __typename: 'CarOfferBadge' };

type DialogContentCarPhrase_CarPhraseHtmlText_Fragment = { __typename: 'CarPhraseHTMLText' };

type DialogContentCarPhrase_CarPhraseIconText_Fragment = { __typename: 'CarPhraseIconText', text: string, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
  )> };

type DialogContentCarPhrase_CarPhraseMark_Fragment = { __typename: 'CarPhraseMark' };

type DialogContentCarPhrase_CarPhrasePairText_Fragment = { __typename: 'CarPhrasePairText' };

type DialogContentCarPhrase_CarPhraseText_Fragment = { __typename: 'CarPhraseText', text: string };

type DialogContentCarPhrase_CarsRichText_Fragment = { __typename: 'CarsRichText', value: string, style?: Maybe<CarsRichTextStyle> };

export type DialogContentCarPhraseFragment = DialogContentCarPhrase_CarActionableItem_Fragment | DialogContentCarPhrase_CarDialogConfidenceMessage_Fragment | DialogContentCarPhrase_CarOfferBadge_Fragment | DialogContentCarPhrase_CarPhraseHtmlText_Fragment | DialogContentCarPhrase_CarPhraseIconText_Fragment | DialogContentCarPhrase_CarPhraseMark_Fragment | DialogContentCarPhrase_CarPhrasePairText_Fragment | DialogContentCarPhrase_CarPhraseText_Fragment | DialogContentCarPhrase_CarsRichText_Fragment;

export type CarDialogConfidenceMessageFragment = { __typename: 'CarDialogConfidenceMessage', text: string, iconMobileRender: boolean, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
  )>, openDialogAction?: Maybe<(
    { __typename: 'CarAction' }
    & CarActionFragment
  )>, dialogContent?: Maybe<{ __typename: 'CarsDialog', title: string, text: Array<string>, buttonText: string, type?: Maybe<CarsDialogType>, content?: Maybe<{ __typename: 'CarsDialogContent', header: (
        { __typename: 'CarActionableItem' }
        & DialogContentCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DialogContentCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DialogContentCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DialogContentCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DialogContentCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DialogContentCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DialogContentCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DialogContentCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DialogContentCarPhrase_CarsRichText_Fragment
      ), body: Array<{ __typename: 'CarsDialogBody', title: (
          { __typename: 'CarActionableItem' }
          & DialogContentCarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & DialogContentCarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & DialogContentCarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & DialogContentCarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & DialogContentCarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & DialogContentCarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & DialogContentCarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & DialogContentCarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & DialogContentCarPhrase_CarsRichText_Fragment
        ), body: Array<(
          { __typename: 'CarActionableItem' }
          & DialogContentCarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & DialogContentCarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & DialogContentCarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & DialogContentCarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & DialogContentCarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & DialogContentCarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & DialogContentCarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & DialogContentCarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & DialogContentCarPhrase_CarsRichText_Fragment
        )> }>, footer?: Maybe<Array<(
        { __typename: 'CarActionableItem' }
        & DialogContentCarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & DialogContentCarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & DialogContentCarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & DialogContentCarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & DialogContentCarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & DialogContentCarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & DialogContentCarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & DialogContentCarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & DialogContentCarPhrase_CarsRichText_Fragment
      )>> }> }> };

export type CarActionFragment = { __typename: 'CarAction', actionType: CarActionType, accessibility?: Maybe<string>, analytics?: Maybe<(
    { __typename: 'CarAnalytics' }
    & AnalyticsFragment
  )> };

export type IconFragment = { __typename: 'Icon', description: string, id: string, withBackground?: Maybe<boolean>, size?: Maybe<IconSize> };

export type ImageFragment = { __typename: 'Image', description: string, url: any };

export type MoneyFragment = { __typename: 'Money', amount: number, formatted: string, currencyInfo?: Maybe<{ __typename: 'Currency', code: string, name: string, symbol: string }> };

export type AnalyticsFragment = { __typename: 'CarAnalytics', linkName: string, referrerId: string };

export type ClientSideAnalyticsFragment = { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string };

export type ExpandoFragment = { __typename: 'ShoppingSelectionExpando', expandLabel: string, collapseLabel: string, visible?: Maybe<boolean>, threshold?: Maybe<number>, minimalHeight?: Maybe<number>, analytics: (
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  ) };

export type MultiSelectionFragmentFragment = { __typename: 'ShoppingMultiSelectionField', primary?: Maybe<string>, secondary?: Maybe<string>, primaryIcon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
  )>, options?: Maybe<Array<(
    { __typename: 'ShoppingSelectableFilterOption' }
    & FilterOptionFragment
  )>>, expando?: Maybe<(
    { __typename: 'ShoppingSelectionExpando' }
    & ExpandoFragment
  )> };

export type SingleSelectionFragmentFragment = { __typename: 'ShoppingSelectionField', primary?: Maybe<string>, secondary?: Maybe<string>, options?: Maybe<Array<(
    { __typename: 'ShoppingSelectableFilterOption' }
    & FilterOptionFragment
  )>>, expando?: Maybe<(
    { __typename: 'ShoppingSelectionExpando' }
    & ExpandoFragment
  )> };

export type FilterOptionFragment = { __typename: 'ShoppingSelectableFilterOption', id: string, value: string, primary: string, secondary?: Maybe<string>, description?: Maybe<string>, accessibility?: Maybe<string>, selected: boolean, disabled: boolean, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
  )>, analytics: (
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragment
  ) };

export type CoordinatesFragment = { __typename: 'Coordinates', latitude: number, longitude: number };

export type CarOfferVendorLocationInfoFragment = { __typename: 'CarOfferVendorLocationInfo', text: string, locationSubInfo?: Maybe<Array<string>>, icon: (
    { __typename: 'Icon' }
    & IconFragment
  ) };

export type CarRecommendationsFragment = { __typename: 'CarRecommendations', heading?: Maybe<string>, analytics?: Maybe<Array<{ __typename: 'CarAnalytics', linkName: string, referrerId: string }>>, carRecommendationsCards?: Maybe<Array<(
    { __typename: 'AlternateRecommendationCard' }
    & CarRecommendationCard_AlternateRecommendationCard_Fragment
  ) | (
    { __typename: 'DateTimeRecommendationCard' }
    & CarRecommendationCard_DateTimeRecommendationCard_Fragment
  ) | (
    { __typename: 'LimitedResultMessageOnRecommendationCard' }
    & CarRecommendationCard_LimitedResultMessageOnRecommendationCard_Fragment
  ) | (
    { __typename: 'LocationRecommendationCard' }
    & CarRecommendationCard_LocationRecommendationCard_Fragment
  ) | (
    { __typename: 'PartnerRecommendationCard' }
    & CarRecommendationCard_PartnerRecommendationCard_Fragment
  )>> };

type CarRecommendationCard_AlternateRecommendationCard_Fragment = { __typename: 'AlternateRecommendationCard', icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
    & IconFragment
  )>, action?: Maybe<(
    { __typename: 'CarAction' }
    & CarActionFragment
    & CarActionFragment
  )>, analytics?: Maybe<(
    { __typename: 'CarAnalytics' }
    & AnalyticsFragment
  )>, image?: Maybe<(
    { __typename: 'Image' }
    & ImageFragment
  )>, title?: Maybe<(
    { __typename: 'CarActionableItem' }
    & CarPhrase_CarActionableItem_Fragment
  ) | (
    { __typename: 'CarDialogConfidenceMessage' }
    & CarPhrase_CarDialogConfidenceMessage_Fragment
  ) | (
    { __typename: 'CarOfferBadge' }
    & CarPhrase_CarOfferBadge_Fragment
  ) | (
    { __typename: 'CarPhraseHTMLText' }
    & CarPhrase_CarPhraseHtmlText_Fragment
  ) | (
    { __typename: 'CarPhraseIconText' }
    & CarPhrase_CarPhraseIconText_Fragment
  ) | (
    { __typename: 'CarPhraseMark' }
    & CarPhrase_CarPhraseMark_Fragment
  ) | (
    { __typename: 'CarPhrasePairText' }
    & CarPhrase_CarPhrasePairText_Fragment
  ) | (
    { __typename: 'CarPhraseText' }
    & CarPhrase_CarPhraseText_Fragment
  ) | (
    { __typename: 'CarsRichText' }
    & CarPhrase_CarsRichText_Fragment
  )>, subText?: Maybe<(
    { __typename: 'CarActionableItem' }
    & CarPhrase_CarActionableItem_Fragment
  ) | (
    { __typename: 'CarDialogConfidenceMessage' }
    & CarPhrase_CarDialogConfidenceMessage_Fragment
  ) | (
    { __typename: 'CarOfferBadge' }
    & CarPhrase_CarOfferBadge_Fragment
  ) | (
    { __typename: 'CarPhraseHTMLText' }
    & CarPhrase_CarPhraseHtmlText_Fragment
  ) | (
    { __typename: 'CarPhraseIconText' }
    & CarPhrase_CarPhraseIconText_Fragment
  ) | (
    { __typename: 'CarPhraseMark' }
    & CarPhrase_CarPhraseMark_Fragment
  ) | (
    { __typename: 'CarPhrasePairText' }
    & CarPhrase_CarPhrasePairText_Fragment
  ) | (
    { __typename: 'CarPhraseText' }
    & CarPhrase_CarPhraseText_Fragment
  ) | (
    { __typename: 'CarsRichText' }
    & CarPhrase_CarsRichText_Fragment
  )>, button?: Maybe<(
    { __typename: 'CarActionableItem' }
    & CarActionableItemFragment
  )> };

type CarRecommendationCard_DateTimeRecommendationCard_Fragment = { __typename: 'DateTimeRecommendationCard', icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
    & IconFragment
  )>, text?: Maybe<(
    { __typename: 'CarsRichText' }
    & DetailsRichTextFragment
  )>, subText?: Maybe<(
    { __typename: 'CarPhraseText' }
    & CarPhrase_CarPhraseText_Fragment
  )>, action?: Maybe<(
    { __typename: 'CarAction' }
    & CarActionFragment
    & CarActionFragment
  )> };

type CarRecommendationCard_LimitedResultMessageOnRecommendationCard_Fragment = { __typename: 'LimitedResultMessageOnRecommendationCard', icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
    & IconFragment
  )>, action?: Maybe<(
    { __typename: 'CarAction' }
    & CarActionFragment
    & CarActionFragment
  )>, recommendationDialog?: Maybe<{ __typename: 'CarsDialog', title: string, buttonText: string, text: Array<string>, content?: Maybe<{ __typename: 'CarsDialogContent', header: (
        { __typename: 'CarActionableItem' }
        & CarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & CarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & CarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & CarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & CarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & CarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & CarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & CarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & CarPhrase_CarsRichText_Fragment
      ), body: Array<{ __typename: 'CarsDialogBody', title: (
          { __typename: 'CarActionableItem' }
          & CarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & CarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & CarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & CarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & CarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & CarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & CarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & CarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & CarPhrase_CarsRichText_Fragment
        ), body: Array<(
          { __typename: 'CarActionableItem' }
          & CarPhrase_CarActionableItem_Fragment
        ) | (
          { __typename: 'CarDialogConfidenceMessage' }
          & CarPhrase_CarDialogConfidenceMessage_Fragment
        ) | (
          { __typename: 'CarOfferBadge' }
          & CarPhrase_CarOfferBadge_Fragment
        ) | (
          { __typename: 'CarPhraseHTMLText' }
          & CarPhrase_CarPhraseHtmlText_Fragment
        ) | (
          { __typename: 'CarPhraseIconText' }
          & CarPhrase_CarPhraseIconText_Fragment
        ) | (
          { __typename: 'CarPhraseMark' }
          & CarPhrase_CarPhraseMark_Fragment
        ) | (
          { __typename: 'CarPhrasePairText' }
          & CarPhrase_CarPhrasePairText_Fragment
        ) | (
          { __typename: 'CarPhraseText' }
          & CarPhrase_CarPhraseText_Fragment
        ) | (
          { __typename: 'CarsRichText' }
          & CarPhrase_CarsRichText_Fragment
        )> }>, footer?: Maybe<Array<(
        { __typename: 'CarActionableItem' }
        & CarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & CarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & CarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & CarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & CarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & CarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & CarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & CarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & CarPhrase_CarsRichText_Fragment
      )>> }> }> };

type CarRecommendationCard_LocationRecommendationCard_Fragment = { __typename: 'LocationRecommendationCard', icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
    & IconFragment
  )>, location?: Maybe<(
    { __typename: 'CarsRichText' }
    & DetailsRichTextFragment
  )>, city?: Maybe<(
    { __typename: 'CarPhraseText' }
    & CarPhrase_CarPhraseText_Fragment
  )>, distanceText?: Maybe<(
    { __typename: 'CarPhraseText' }
    & CarPhrase_CarPhraseText_Fragment
  )>, action?: Maybe<(
    { __typename: 'CarAction' }
    & CarActionFragment
    & CarActionFragment
  )>, pickUpLocation?: Maybe<(
    { __typename: 'CarSearchLocation' }
    & CarSearchLocationFragment
  )> };

type CarRecommendationCard_PartnerRecommendationCard_Fragment = { __typename: 'PartnerRecommendationCard', icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
    & IconFragment
  )>, action?: Maybe<(
    { __typename: 'CarAction' }
    & CarActionFragment
    & CarActionFragment
  )>, analytics?: Maybe<(
    { __typename: 'CarAnalytics' }
    & AnalyticsFragment
  )>, image?: Maybe<(
    { __typename: 'Image' }
    & ImageFragment
  )>, title?: Maybe<(
    { __typename: 'CarActionableItem' }
    & CarPhrase_CarActionableItem_Fragment
  ) | (
    { __typename: 'CarDialogConfidenceMessage' }
    & CarPhrase_CarDialogConfidenceMessage_Fragment
  ) | (
    { __typename: 'CarOfferBadge' }
    & CarPhrase_CarOfferBadge_Fragment
  ) | (
    { __typename: 'CarPhraseHTMLText' }
    & CarPhrase_CarPhraseHtmlText_Fragment
  ) | (
    { __typename: 'CarPhraseIconText' }
    & CarPhrase_CarPhraseIconText_Fragment
  ) | (
    { __typename: 'CarPhraseMark' }
    & CarPhrase_CarPhraseMark_Fragment
  ) | (
    { __typename: 'CarPhrasePairText' }
    & CarPhrase_CarPhrasePairText_Fragment
  ) | (
    { __typename: 'CarPhraseText' }
    & CarPhrase_CarPhraseText_Fragment
  ) | (
    { __typename: 'CarsRichText' }
    & CarPhrase_CarsRichText_Fragment
  )>, subText?: Maybe<(
    { __typename: 'CarActionableItem' }
    & CarPhrase_CarActionableItem_Fragment
  ) | (
    { __typename: 'CarDialogConfidenceMessage' }
    & CarPhrase_CarDialogConfidenceMessage_Fragment
  ) | (
    { __typename: 'CarOfferBadge' }
    & CarPhrase_CarOfferBadge_Fragment
  ) | (
    { __typename: 'CarPhraseHTMLText' }
    & CarPhrase_CarPhraseHtmlText_Fragment
  ) | (
    { __typename: 'CarPhraseIconText' }
    & CarPhrase_CarPhraseIconText_Fragment
  ) | (
    { __typename: 'CarPhraseMark' }
    & CarPhrase_CarPhraseMark_Fragment
  ) | (
    { __typename: 'CarPhrasePairText' }
    & CarPhrase_CarPhrasePairText_Fragment
  ) | (
    { __typename: 'CarPhraseText' }
    & CarPhrase_CarPhraseText_Fragment
  ) | (
    { __typename: 'CarsRichText' }
    & CarPhrase_CarsRichText_Fragment
  )>, button?: Maybe<(
    { __typename: 'CarActionableItem' }
    & CarActionableItemFragment
  )>, dialog?: Maybe<{ __typename: 'PartnerRecommendationDialog', title: (
      { __typename: 'CarActionableItem' }
      & CarPhrase_CarActionableItem_Fragment
    ) | (
      { __typename: 'CarDialogConfidenceMessage' }
      & CarPhrase_CarDialogConfidenceMessage_Fragment
    ) | (
      { __typename: 'CarOfferBadge' }
      & CarPhrase_CarOfferBadge_Fragment
    ) | (
      { __typename: 'CarPhraseHTMLText' }
      & CarPhrase_CarPhraseHtmlText_Fragment
    ) | (
      { __typename: 'CarPhraseIconText' }
      & CarPhrase_CarPhraseIconText_Fragment
    ) | (
      { __typename: 'CarPhraseMark' }
      & CarPhrase_CarPhraseMark_Fragment
    ) | (
      { __typename: 'CarPhrasePairText' }
      & CarPhrase_CarPhrasePairText_Fragment
    ) | (
      { __typename: 'CarPhraseText' }
      & CarPhrase_CarPhraseText_Fragment
    ) | (
      { __typename: 'CarsRichText' }
      & CarPhrase_CarsRichText_Fragment
    ), subTitle: (
      { __typename: 'CarActionableItem' }
      & CarPhrase_CarActionableItem_Fragment
    ) | (
      { __typename: 'CarDialogConfidenceMessage' }
      & CarPhrase_CarDialogConfidenceMessage_Fragment
    ) | (
      { __typename: 'CarOfferBadge' }
      & CarPhrase_CarOfferBadge_Fragment
    ) | (
      { __typename: 'CarPhraseHTMLText' }
      & CarPhrase_CarPhraseHtmlText_Fragment
    ) | (
      { __typename: 'CarPhraseIconText' }
      & CarPhrase_CarPhraseIconText_Fragment
    ) | (
      { __typename: 'CarPhraseMark' }
      & CarPhrase_CarPhraseMark_Fragment
    ) | (
      { __typename: 'CarPhrasePairText' }
      & CarPhrase_CarPhrasePairText_Fragment
    ) | (
      { __typename: 'CarPhraseText' }
      & CarPhrase_CarPhraseText_Fragment
    ) | (
      { __typename: 'CarsRichText' }
      & CarPhrase_CarsRichText_Fragment
    ), text: Array<Array<(
      { __typename: 'CarActionableItem' }
      & CarPhrase_CarActionableItem_Fragment
    ) | (
      { __typename: 'CarDialogConfidenceMessage' }
      & CarPhrase_CarDialogConfidenceMessage_Fragment
    ) | (
      { __typename: 'CarOfferBadge' }
      & CarPhrase_CarOfferBadge_Fragment
    ) | (
      { __typename: 'CarPhraseHTMLText' }
      & CarPhrase_CarPhraseHtmlText_Fragment
    ) | (
      { __typename: 'CarPhraseIconText' }
      & CarPhrase_CarPhraseIconText_Fragment
    ) | (
      { __typename: 'CarPhraseMark' }
      & CarPhrase_CarPhraseMark_Fragment
    ) | (
      { __typename: 'CarPhrasePairText' }
      & CarPhrase_CarPhrasePairText_Fragment
    ) | (
      { __typename: 'CarPhraseText' }
      & CarPhrase_CarPhraseText_Fragment
    ) | (
      { __typename: 'CarsRichText' }
      & CarPhrase_CarsRichText_Fragment
    )>>, button: (
      { __typename: 'CarActionableItem' }
      & CarActionableItemFragment
    ), closeDialog: (
      { __typename: 'CarAction' }
      & CarActionFragment
    ), content: { __typename: 'PartnerRecommendationDialogContent', title: (
        { __typename: 'CarActionableItem' }
        & CarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & CarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & CarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & CarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & CarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & CarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & CarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & CarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & CarPhrase_CarsRichText_Fragment
      ), body: Array<Array<(
        { __typename: 'CarActionableItem' }
        & CarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & CarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & CarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & CarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & CarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & CarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & CarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & CarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & CarPhrase_CarsRichText_Fragment
      )>>, confidenceMessage: Array<(
        { __typename: 'CarActionableItem' }
        & CarPhrase_CarActionableItem_Fragment
      ) | (
        { __typename: 'CarDialogConfidenceMessage' }
        & CarPhrase_CarDialogConfidenceMessage_Fragment
      ) | (
        { __typename: 'CarOfferBadge' }
        & CarPhrase_CarOfferBadge_Fragment
      ) | (
        { __typename: 'CarPhraseHTMLText' }
        & CarPhrase_CarPhraseHtmlText_Fragment
      ) | (
        { __typename: 'CarPhraseIconText' }
        & CarPhrase_CarPhraseIconText_Fragment
      ) | (
        { __typename: 'CarPhraseMark' }
        & CarPhrase_CarPhraseMark_Fragment
      ) | (
        { __typename: 'CarPhrasePairText' }
        & CarPhrase_CarPhrasePairText_Fragment
      ) | (
        { __typename: 'CarPhraseText' }
        & CarPhrase_CarPhraseText_Fragment
      ) | (
        { __typename: 'CarsRichText' }
        & CarPhrase_CarsRichText_Fragment
      )> }, image: (
      { __typename: 'Image' }
      & ImageFragment
    ) }> };

export type CarRecommendationCardFragment = CarRecommendationCard_AlternateRecommendationCard_Fragment | CarRecommendationCard_DateTimeRecommendationCard_Fragment | CarRecommendationCard_LimitedResultMessageOnRecommendationCard_Fragment | CarRecommendationCard_LocationRecommendationCard_Fragment | CarRecommendationCard_PartnerRecommendationCard_Fragment;

type CarPhrase_CarActionableItem_Fragment = (
  { __typename: 'CarActionableItem' }
  & CarActionableItemFragment
);

type CarPhrase_CarDialogConfidenceMessage_Fragment = (
  { __typename: 'CarDialogConfidenceMessage' }
  & CarDialogConfidenceMessageFragment
);

type CarPhrase_CarOfferBadge_Fragment = { __typename: 'CarOfferBadge', text: string, badgeTheme: string, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
  )>, mark?: Maybe<{ __typename: 'Mark', id: string, url?: Maybe<{ __typename: 'HttpURI', value: string }> }> };

type CarPhrase_CarPhraseHtmlText_Fragment = { __typename: 'CarPhraseHTMLText' };

type CarPhrase_CarPhraseIconText_Fragment = { __typename: 'CarPhraseIconText', text: string, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragment
  )> };

type CarPhrase_CarPhraseMark_Fragment = { __typename: 'CarPhraseMark', text: string, name: string, description: string, url?: Maybe<{ __typename: 'HttpURI', value: string, relativePath: string }> };

type CarPhrase_CarPhrasePairText_Fragment = { __typename: 'CarPhrasePairText', richText?: Maybe<(
    { __typename: 'CarsRichText' }
    & DetailsRichTextFragment
  )>, richSubText?: Maybe<(
    { __typename: 'CarsRichText' }
    & DetailsRichTextFragment
  )> };

type CarPhrase_CarPhraseText_Fragment = { __typename: 'CarPhraseText', text: string };

type CarPhrase_CarsRichText_Fragment = { __typename: 'CarsRichText', value: string, style?: Maybe<CarsRichTextStyle>, theme?: Maybe<string> };

export type CarPhraseFragment = CarPhrase_CarActionableItem_Fragment | CarPhrase_CarDialogConfidenceMessage_Fragment | CarPhrase_CarOfferBadge_Fragment | CarPhrase_CarPhraseHtmlText_Fragment | CarPhrase_CarPhraseIconText_Fragment | CarPhrase_CarPhraseMark_Fragment | CarPhrase_CarPhrasePairText_Fragment | CarPhrase_CarPhraseText_Fragment | CarPhrase_CarsRichText_Fragment;

export type CarSearchLocationFragment = { __typename: 'CarSearchLocation', shortName: string, fullName: string, regionId?: Maybe<string> };

export type OfferPriceSummaryFragment = { __typename: 'CarPriceSummary', strikeThroughFirst?: Maybe<boolean>, accessibility?: Maybe<string>, priceAdditionalInfo?: Maybe<Array<string>>, discountBadge?: Maybe<(
    { __typename: 'CarOfferBadge' }
    & BadgeFragment
  )>, lead?: Maybe<(
    { __typename: 'CarPriceInfo' }
    & PriceInfoFragment
  )>, total: (
    { __typename: 'CarPriceInfo' }
    & PriceInfoFragment
  ), loyaltyPointsOption?: Maybe<{ __typename: 'LoyaltyPointsOption', formattedPoints?: Maybe<string>, leadingCaption: string, pointsFirst: boolean }>, reference?: Maybe<{ __typename: 'CarReferencePriceInfo', additionalInfo?: Maybe<string>, qualifier?: Maybe<string>, price: (
      { __typename: 'Money' }
      & MoneyFragment
    ) }>, paymentInfo?: Maybe<{ __typename: 'CarPaymentInfo', text: string, additionalPaymentInfo?: Maybe<Array<string>>, icon: (
      { __typename: 'Icon' }
      & IconFragment
    ) }> };

export type SearchUserFeedbackFragment = { __typename: 'UserFeedback', userSurveyTitle: string, submitConfirmation: string, options: Array<{ __typename: 'UserFeedbackOption', inputHeading: string, inputTextPlaceholder: string, option: (
      { __typename: 'CarActionableItem' }
      & CarActionableItemFragment
    ) }>, submit: (
    { __typename: 'CarActionableItem' }
    & CarActionableItemFragment
  ) };

type DiscriminateUnion<T, U> = T extends U ? T : never;

export namespace CarDetail {
  export type Variables = CarDetailQueryVariables;
  export type Query = CarDetailQuery;
  export type CarDetail = (NonNullable<CarDetailQuery['carDetail']>);
  export type DetailsNavTabs = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['detailsNavTabs']>);
  export type NavTabs = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['detailsNavTabs']>)['navTabs']>)[number]>;
  export type Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['detailsNavTabs']>)['navTabs']>)[number]>['analytics']>);
  export type ReviewsSummary = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>);
  export type DialogTrigger = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogTrigger']>);
  export type DialogContent = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogContent']>);
  export type DisclaimerLink = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogContent']>)['disclaimerLink']>);
  export type UserFeedback = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogContent']>)['userFeedback']>);
  export type ReviewBreakdown = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogContent']>)['reviewBreakdown']>)[number]>;
  export type ReviewsSeeMoreAction = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogContent']>)['reviewsSeeMoreAction']>);
  export type _Analytics = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogContent']>)['reviewsSeeMoreAction']>)['analytics']>);
  export type Reviews = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogContent']>)['reviews']>)[number]>;
  export type ExpandButton = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogContent']>)['reviews']>)[number]>['expandButton']>);
  export type Themes = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogContent']>)['reviews']>)[number]>['themes']>)[number]>;
  export type Icon = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reviewsSummary']>)['dialogContent']>)['reviews']>)[number]>['themes']>)[number]>['icon']>);
  export type Deal = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['deal']>);
  export type EaseCancel = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['easeCancel']>);
  export type OneKeyInfo = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['oneKeyInfo']>);
  export type OneKeyDetails = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['oneKeyDetails']>);
  export type EarnBanner = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['oneKeyDetails']>)['earnBanner']>);
  export type __Analytics = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['oneKeyDetails']>)['analytics']>);
  export type PriceAlert = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceAlert']>);
  export type SaleUnlocked = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['saleUnlocked']>);
  export type DropOffCharge = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['dropOffCharge']>);
  export type Vehicle = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['vehicle']>);
  export type Image = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['vehicle']>)['image']>);
  export type CategoryIcon = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['vehicle']>)['categoryIcon']>);
  export type Attributes = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['vehicle']>)['attributes']>)[number]>;
  export type Features = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['vehicle']>)['features']>)[number]>;
  export type FuelInfo = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['vehicle']>)['fuelInfo']>)[number]>;
  export type Vendor = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['vendor']>);
  export type _Image = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['vendor']>)['image']>);
  export type RentalLocations = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['rentalLocations']>);
  export type PickUpLocation = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['rentalLocations']>)['pickUpLocation']>);
  export type DropOffLocation = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['rentalLocations']>)['dropOffLocation']>);
  export type Telesales = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['telesales']>);
  export type PhoneNumberLink = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['telesales']>)['phoneNumberLink']>);
  export type Promotions = NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['promotions']>)[number]>;
  export type _Icon = (NonNullable<NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['promotions']>)[number]>['icon']>);
  export type InclusionsDetail = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['inclusionsDetail']>);
  export type Inclusions = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['inclusionsDetail']>)['inclusions']>)[number]>;
  export type __Icon = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['inclusionsDetail']>)['inclusions']>)[number]>['icon']>);
  export type ___Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['inclusionsDetail']>)['inclusions']>)[number]>['analytics']>);
  export type AvailableAccessories = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['availableAccessories']>);
  export type Accessories = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['availableAccessories']>)['accessories']>)[number]>;
  export type ____Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['availableAccessories']>)['accessories']>)[number]>['analytics']>);
  export type ImportantInfo = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['importantInfo']>);
  export type ImportantInfoItems = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['importantInfo']>)['importantInfoItems']>)[number]>;
  export type _____Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['importantInfo']>)['importantInfoItems']>)[number]>['analytics']>);
  export type RulesAndRestrictions = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['importantInfo']>)['rulesAndRestrictions']>);
  export type ActionableConfidenceMessages = NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['actionableConfidenceMessages']>)[number]>;
  export type PairConfidenceMessages = NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['pairConfidenceMessages']>)[number]>;
  export type AdditionalBenefits = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['additionalBenefits']>);
  export type Benefits = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['additionalBenefits']>)['benefits']>)[number]>;
  export type PriceDetails = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceDetails']>);
  export type CloseAction = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceDetails']>)['closeAction']>);
  export type CloseIcon = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceDetails']>)['closeIcon']>);
  export type BreakupSection = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceDetails']>)['breakupSection']>)[number]>;
  export type Summary = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceDetails']>)['summary']>);
  export type LineItems = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceDetails']>)['summary']>)['lineItems']>)[number]>;
  export type NotIncludedInTotal = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceDetails']>)['summary']>)['notIncludedInTotal']>);
  export type PriceDetailsButton = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceDetails']>)['priceDetailsButton']>);
  export type PriceSummary = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>);
  export type Lead = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>)['lead']>);
  export type Total = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>)['total']>);
  export type LoyaltyPointsOption = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>)['loyaltyPointsOption']>);
  export type Reference = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>)['reference']>);
  export type Price = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>)['reference']>)['price']>);
  export type PaymentInfo = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>)['paymentInfo']>);
  export type ___Icon = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>)['paymentInfo']>)['icon']>);
  export type DiscountBadge = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>)['discountBadge']>);
  export type FloatingCtaPriceDetailsAnalytics = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>)['floatingCTAPriceDetailsAnalytics']>);
  export type FloatingCtaReserveButtonAnalytics = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['priceSummary']>)['floatingCTAReserveButtonAnalytics']>);
  export type ReserveAction = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['reserveAction']>);
  export type ShareFeedbackAction = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['shareFeedbackAction']>);
  export type Button = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['shareFeedbackAction']>)['button']>);
  export type LoyaltyInfo = NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['loyaltyInfo']>)[number]>;
  export type VariantsSummary = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['variantsSummary']>);
  export type Variants = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['variantsSummary']>)['variants']>)[number]>;
  export type CarSearchLink = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['carSearchLink']>);
  export type OfferBadges = NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['offerBadges']>)[number]>;
  export type DetailSummary = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['detailSummary']>);
  export type OnlineCheckInInfo = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['onlineCheckInInfo']>);
  export type Infos = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['onlineCheckInInfo']>)['infos']>)[number]>;
  export type SkipTheCounterInfo = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['skipTheCounterInfo']>);
  export type _Infos = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['skipTheCounterInfo']>)['infos']>)[number]>;
  export type EnhancedCleanlinessInfo = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['enhancedCleanlinessInfo']>);
  export type __Infos = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['enhancedCleanlinessInfo']>)['infos']>)[number]>;
  export type ____Icon = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['enhancedCleanlinessInfo']>)['infos']>)[number]>['icon']>);
  export type SeeAllAction = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['enhancedCleanlinessInfo']>)['seeAllAction']>);
  export type VendorCleanlinessBadge = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['enhancedCleanlinessInfo']>)['vendorCleanlinessBadge']>);
  export type Dialog = (NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['enhancedCleanlinessInfo']>)['dialog']>);
  export type Images = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['enhancedCleanlinessInfo']>)['dialog']>)['images']>)[number]>;
  export type Content = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['enhancedCleanlinessInfo']>)['dialog']>)['content']>)[number]>;
  export type Title = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['enhancedCleanlinessInfo']>)['dialog']>)['content']>)[number]>['title']>);
  export type _____Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['enhancedCleanlinessInfo']>)['dialog']>)['content']>)[number]>['title']>)['icon']>);
  export type AdsTargetingData = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['adsTargetingData']>);
  export type RentalProtectionInfo = (NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['rentalProtectionInfo']>);
  export type RentalProtectionCard = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDetailQuery['carDetail']>)['rentalProtectionInfo']>)['rentalProtectionCard']>)[number]>;
}

export namespace RentalProtectionCard {
  export type Fragment = RentalProtectionCardFragment;
  export type Infos = NonNullable<(NonNullable<RentalProtectionCardFragment['infos']>)[number]>;
  export type Icon = (NonNullable<NonNullable<(NonNullable<RentalProtectionCardFragment['infos']>)[number]>['icon']>);
  export type SeeDetailsAction = (NonNullable<RentalProtectionCardFragment['seeDetailsAction']>);
  export type OfferBadge = (NonNullable<RentalProtectionCardFragment['offerBadge']>);
  export type Dialog = (NonNullable<RentalProtectionCardFragment['dialog']>);
  export type Content = NonNullable<(NonNullable<(NonNullable<RentalProtectionCardFragment['dialog']>)['content']>)[number]>;
  export type Description = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<RentalProtectionCardFragment['dialog']>)['content']>)[number]>['description']>)[number]>;
  export type _Icon = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<RentalProtectionCardFragment['dialog']>)['content']>)[number]>['description']>)[number]>['icon']>);
  export type ClickAction = (NonNullable<RentalProtectionCardFragment['clickAction']>);
}

export namespace DetailsMessagingCard {
  export type Fragment = DetailsMessagingCardFragment;
  export type CardTitle = (NonNullable<DetailsMessagingCardFragment['cardTitle']>);
  export type CardDescriptions = NonNullable<(NonNullable<DetailsMessagingCardFragment['cardDescriptions']>)[number]>;
  export type Image = (NonNullable<DetailsMessagingCardFragment['image']>);
  export type IllustrationUrl = (NonNullable<DetailsMessagingCardFragment['illustrationURL']>);
  export type Icon = (NonNullable<DetailsMessagingCardFragment['icon']>);
  export type Links = NonNullable<(NonNullable<DetailsMessagingCardFragment['links']>)[number]>;
  export type Url = (NonNullable<NonNullable<(NonNullable<DetailsMessagingCardFragment['links']>)[number]>['url']>);
  export type _Icon = (NonNullable<NonNullable<(NonNullable<DetailsMessagingCardFragment['links']>)[number]>['icon']>);
  export type Action = (NonNullable<NonNullable<(NonNullable<DetailsMessagingCardFragment['links']>)[number]>['action']>);
  export type Analytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<DetailsMessagingCardFragment['links']>)[number]>['action']>)['analytics']>);
  export type Dialog = (NonNullable<DetailsMessagingCardFragment['dialog']>);
  export type Content = (NonNullable<(NonNullable<DetailsMessagingCardFragment['dialog']>)['content']>);
  export type Header = (NonNullable<(NonNullable<(NonNullable<DetailsMessagingCardFragment['dialog']>)['content']>)['header']>);
  export type Body = NonNullable<(NonNullable<(NonNullable<(NonNullable<DetailsMessagingCardFragment['dialog']>)['content']>)['body']>)[number]>;
  export type Title = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<DetailsMessagingCardFragment['dialog']>)['content']>)['body']>)[number]>['title']>);
  export type _Body = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<DetailsMessagingCardFragment['dialog']>)['content']>)['body']>)[number]>['body']>)[number]>;
  export type Footer = NonNullable<(NonNullable<(NonNullable<(NonNullable<DetailsMessagingCardFragment['dialog']>)['content']>)['footer']>)[number]>;
  export type CarRecommendations = NonNullable<(NonNullable<DetailsMessagingCardFragment['carRecommendations']>)[number]>;
  export type _Analytics = (NonNullable<DetailsMessagingCardFragment['analytics']>);
}

export namespace DetailCarRecommendations {
  export type Fragment = DetailCarRecommendationsFragment;
  export type Analytics = NonNullable<(NonNullable<DetailCarRecommendationsFragment['analytics']>)[number]>;
  export type CarRecommendationsCards = NonNullable<(NonNullable<DetailCarRecommendationsFragment['carRecommendationsCards']>)[number]>;
}

export namespace DetailCarRecommendationCard {
  export type Fragment = DetailCarRecommendationCardFragment;
  export type Icon = (NonNullable<DetailCarRecommendationCardFragment['icon']>);
  export type Action = (NonNullable<DetailCarRecommendationCardFragment['action']>);
  export type DateTimeRecommendationCardInlineFragment = (DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'DateTimeRecommendationCard' }>);
  export type _Icon = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'DateTimeRecommendationCard' }>)['icon']>);
  export type Text = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'DateTimeRecommendationCard' }>)['text']>);
  export type SubText = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'DateTimeRecommendationCard' }>)['subText']>);
  export type _Action = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'DateTimeRecommendationCard' }>)['action']>);
  export type LocationRecommendationCardInlineFragment = (DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>);
  export type __Icon = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['icon']>);
  export type Location = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['location']>);
  export type City = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['city']>);
  export type DistanceText = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['distanceText']>);
  export type __Action = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['action']>);
  export type PickUpLocation = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['pickUpLocation']>);
  export type PartnerRecommendationCardInlineFragment = (DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>);
  export type ___Icon = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['icon']>);
  export type ___Action = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['action']>);
  export type Analytics = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['analytics']>);
  export type Image = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['image']>);
  export type Title = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['title']>);
  export type _SubText = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['subText']>);
  export type Button = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['button']>);
  export type Dialog = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>);
  export type PartnerRecommendationDialogInlineFragment = ({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>);
  export type _Title = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['title']>);
  export type SubTitle = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['subTitle']>);
  export type _Text = NonNullable<NonNullable<(NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['text']>)[number]>[number]>;
  export type _Button = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['button']>);
  export type CloseDialog = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['closeDialog']>);
  export type Content = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['content']>);
  export type PartnerRecommendationDialogContentInlineFragment = ({ __typename: 'PartnerRecommendationDialogContent' } & Pick<(NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['content']>), 'title' | 'body' | 'confidenceMessage'>);
  export type __Title = (NonNullable<({ __typename: 'PartnerRecommendationDialogContent' } & Pick<(NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['content']>), 'title' | 'body' | 'confidenceMessage'>)['title']>);
  export type Body = NonNullable<NonNullable<(NonNullable<({ __typename: 'PartnerRecommendationDialogContent' } & Pick<(NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['content']>), 'title' | 'body' | 'confidenceMessage'>)['body']>)[number]>[number]>;
  export type ConfidenceMessage = NonNullable<(NonNullable<({ __typename: 'PartnerRecommendationDialogContent' } & Pick<(NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['content']>), 'title' | 'body' | 'confidenceMessage'>)['confidenceMessage']>)[number]>;
  export type _Image = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['image']>);
  export type LimitedResultMessageOnRecommendationCardInlineFragment = (DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>);
  export type ____Icon = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['icon']>);
  export type ____Action = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['action']>);
  export type RecommendationDialog = (NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>);
  export type _Content = (NonNullable<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>);
  export type Header = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>)['header']>);
  export type _Body = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>)['body']>)[number]>;
  export type ___Title = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>)['body']>)[number]>['title']>);
  export type __Body = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>)['body']>)[number]>['body']>)[number]>;
  export type Footer = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<DetailCarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>)['footer']>)[number]>;
}

export namespace DetailCarSearchLocation {
  export type Fragment = DetailCarSearchLocationFragment;
}

export namespace DetailFeature {
  export type Fragment = DetailFeatureFragment;
  export type Icon = (NonNullable<DetailFeatureFragment['icon']>);
  export type Info = (NonNullable<DetailFeatureFragment['info']>);
  export type VehicleFeatureDialog = (NonNullable<(NonNullable<DetailFeatureFragment['info']>)['vehicleFeatureDialog']>);
  export type CarActionableItem = (NonNullable<(NonNullable<DetailFeatureFragment['info']>)['carActionableItem']>);
}

export namespace DetailPriceInfo {
  export type Fragment = DetailPriceInfoFragment;
  export type Price = (NonNullable<DetailPriceInfoFragment['price']>);
}

export namespace DetailIcon {
  export type Fragment = DetailIconFragment;
}

export namespace DetailImage {
  export type Fragment = DetailImageFragment;
}

export namespace DetailMoney {
  export type Fragment = DetailMoneyFragment;
  export type CurrencyInfo = (NonNullable<DetailMoneyFragment['currencyInfo']>);
}

export namespace DetailAnalytics {
  export type Fragment = DetailAnalyticsFragment;
}

export namespace DetailAction {
  export type Fragment = DetailActionFragment;
  export type Analytics = (NonNullable<DetailActionFragment['analytics']>);
}

export namespace DetailBadge {
  export type Fragment = DetailBadgeFragment;
  export type Icon = (NonNullable<DetailBadgeFragment['icon']>);
  export type Mark = (NonNullable<DetailBadgeFragment['mark']>);
  export type Url = (NonNullable<(NonNullable<DetailBadgeFragment['mark']>)['url']>);
}

export namespace DetailActionableItem {
  export type Fragment = DetailActionableItemFragment;
  export type Url = (NonNullable<DetailActionableItemFragment['url']>);
  export type Action = (NonNullable<DetailActionableItemFragment['action']>);
  export type Icon = (NonNullable<DetailActionableItemFragment['icon']>);
  export type Tel = (NonNullable<DetailActionableItemFragment['tel']>);
}

export namespace DetailCarDialogConfidenceMessage {
  export type Fragment = DetailCarDialogConfidenceMessageFragment;
  export type Icon = (NonNullable<DetailCarDialogConfidenceMessageFragment['icon']>);
  export type OpenDialogAction = (NonNullable<DetailCarDialogConfidenceMessageFragment['openDialogAction']>);
  export type DialogContent = (NonNullable<DetailCarDialogConfidenceMessageFragment['dialogContent']>);
}

export namespace CarVendorLocationInfo {
  export type Fragment = CarVendorLocationInfoFragment;
  export type Icon = (NonNullable<CarVendorLocationInfoFragment['icon']>);
}

export namespace CarRentalLocationDetail {
  export type Fragment = CarRentalLocationDetailFragment;
  export type DateTime = (NonNullable<CarRentalLocationDetailFragment['dateTime']>);
  export type Address = (NonNullable<CarRentalLocationDetailFragment['address']>);
  export type HoursOfOperation = (NonNullable<CarRentalLocationDetailFragment['hoursOfOperation']>);
  export type Instruction = (NonNullable<CarRentalLocationDetailFragment['instruction']>);
}

export namespace DetailCarPhrase {
  export type Fragment = DetailCarPhraseFragment;
  export type CarPhraseTextInlineFragment = (DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarPhraseText' }>);
  export type CarPhrasePairTextInlineFragment = (DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarPhrasePairText' }>);
  export type RichText = (NonNullable<(DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarPhrasePairText' }>)['richText']>);
  export type RichSubText = (NonNullable<(DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarPhrasePairText' }>)['richSubText']>);
  export type CarPhraseIconTextInlineFragment = (DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarPhraseIconText' }>);
  export type Icon = (NonNullable<(DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarPhraseIconText' }>)['icon']>);
  export type CarActionableItemInlineFragment = (DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarActionableItem' }>);
  export type CarDialogConfidenceMessageInlineFragment = (DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarDialogConfidenceMessage' }>);
  export type CarsRichTextInlineFragment = (DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarsRichText' }>);
  export type CarPhraseMarkInlineFragment = (DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarPhraseMark' }>);
  export type Url = (NonNullable<(DiscriminateUnion<DetailCarPhraseFragment, { __typename: 'CarPhraseMark' }>)['url']>);
}

export namespace DetailsRichText {
  export type Fragment = DetailsRichTextFragment;
}

export namespace CarBreakupComponent {
  export type Fragment = CarBreakupComponentFragment;
  export type LineItems = NonNullable<(NonNullable<CarBreakupComponentFragment['lineItems']>)[number]>;
}

export namespace CarBreakupLineItem {
  export type Fragment = CarBreakupLineItemFragment;
  export type Icon = (NonNullable<CarBreakupLineItemFragment['icon']>);
  export type Mark = (NonNullable<CarBreakupLineItemFragment['mark']>);
  export type DialogContent = (NonNullable<CarBreakupLineItemFragment['dialogContent']>);
  export type CommonDialog = (NonNullable<(NonNullable<CarBreakupLineItemFragment['dialogContent']>)['commonDialog']>);
  export type BreakupContent = NonNullable<(NonNullable<(NonNullable<CarBreakupLineItemFragment['dialogContent']>)['breakupContent']>)[number]>;
  export type OpenDialogAction = (NonNullable<CarBreakupLineItemFragment['openDialogAction']>);
  export type RichValue = (NonNullable<CarBreakupLineItemFragment['richValue']>);
}

export namespace CarPriceBreakupDialogLineItem {
  export type Fragment = CarPriceBreakupDialogLineItemFragment;
}

export namespace UserFeedback {
  export type Fragment = UserFeedbackFragment;
  export type Options = NonNullable<(NonNullable<UserFeedbackFragment['options']>)[number]>;
  export type Option = (NonNullable<NonNullable<(NonNullable<UserFeedbackFragment['options']>)[number]>['option']>);
  export type Submit = (NonNullable<UserFeedbackFragment['submit']>);
}

export namespace CarDropOffSearch {
  export type Variables = CarDropOffSearchQueryVariables;
  export type Query = CarDropOffSearchQuery;
  export type CarDropOffSearch = (NonNullable<CarDropOffSearchQuery['carDropOffSearch']>);
  export type CarDropOffTitle = (NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffTitle']>);
  export type Icon = (NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffTitle']>)['icon']>);
  export type Action = (NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffTitle']>)['action']>);
  export type CarDropOffOfferCard = NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>;
  export type Vehicle = (NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['vehicle']>);
  export type Image = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['vehicle']>)['image']>);
  export type Attributes = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['vehicle']>)['attributes']>)[number]>;
  export type _Icon = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['vehicle']>)['attributes']>)[number]>['icon']>);
  export type Features = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['vehicle']>)['features']>)[number]>;
  export type FuelInfo = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['vehicle']>)['fuelInfo']>)[number]>;
  export type Vendor = (NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['vendor']>);
  export type _Image = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['vendor']>)['image']>);
  export type TripLocations = (NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['tripLocations']>);
  export type PickUpLocation = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['tripLocations']>)['pickUpLocation']>);
  export type DropOffLocation = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['tripLocations']>)['dropOffLocation']>);
  export type DetailsContext = (NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['detailsContext']>);
  export type CarPriceDetail = (NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['carPriceDetail']>);
  export type SelectButton = (NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['selectButton']>);
  export type ViewMap = (NonNullable<NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['carDropOffOfferCard']>)[number]>['viewMap']>);
  export type Map = (NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>);
  export type CloseIcon = (NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['closeIcon']>);
  export type CloseAction = (NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['closeAction']>);
  export type Center = (NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['center']>);
  export type Bounds = (NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['bounds']>);
  export type Northeast = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['bounds']>)['northeast']>);
  export type Southwest = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['bounds']>)['southwest']>);
  export type Markers = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>;
  export type _Action = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>['action']>);
  export type Coordinates = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>['coordinates']>);
  export type CarItemCardMapMarkerInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>);
  export type ItemCard = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>);
  export type CarMapSearchLocationCardInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapSearchLocationCard' }>);
  export type CarMapDropOffLocationCardInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapDropOffLocationCard' }>);
  export type VendorImage = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapDropOffLocationCard' }>)['vendorImage']>);
  export type _CarPriceDetail = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapDropOffLocationCard' }>)['carPriceDetail']>);
  export type _SelectButton = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapDropOffLocationCard' }>)['selectButton']>);
  export type _DetailsContext = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapDropOffLocationCard' }>)['detailsContext']>);
  export type ShareFeedbackAction = (NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['shareFeedbackAction']>);
  export type Button = (NonNullable<(NonNullable<(NonNullable<CarDropOffSearchQuery['carDropOffSearch']>)['shareFeedbackAction']>)['button']>);
}

export namespace DropOffActionableItem {
  export type Fragment = DropOffActionableItemFragment;
  export type Url = (NonNullable<DropOffActionableItemFragment['url']>);
  export type Action = (NonNullable<DropOffActionableItemFragment['action']>);
}

export namespace DropOffAnalytics {
  export type Fragment = DropOffAnalyticsFragment;
}

export namespace DropOffAction {
  export type Fragment = DropOffActionFragment;
  export type Analytics = (NonNullable<DropOffActionFragment['analytics']>);
}

export namespace DropOffFeature {
  export type Fragment = DropOffFeatureFragment;
  export type Icon = (NonNullable<DropOffFeatureFragment['icon']>);
  export type Info = (NonNullable<DropOffFeatureFragment['info']>);
  export type VehicleFeatureDialog = (NonNullable<(NonNullable<DropOffFeatureFragment['info']>)['vehicleFeatureDialog']>);
}

export namespace DropOffIcon {
  export type Fragment = DropOffIconFragment;
}

export namespace DropOffImage {
  export type Fragment = DropOffImageFragment;
}

export namespace DropOffCoordinates {
  export type Fragment = DropOffCoordinatesFragment;
}

export namespace DropOffCarOfferVendorLocationInfo {
  export type Fragment = DropOffCarOfferVendorLocationInfoFragment;
  export type Icon = (NonNullable<DropOffCarOfferVendorLocationInfoFragment['icon']>);
}

export namespace CarSearchV3 {
  export type Variables = CarSearchV3QueryVariables;
  export type Query = CarSearchV3Query;
  export type CarSearchOrRecommendations = (NonNullable<CarSearchV3Query['carSearchOrRecommendations']>);
  export type CarSearchResults = (NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>);
  export type ShoppingContext = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['shoppingContext']>)['multiItem']>);
  export type CarsShoppingContext = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['carsShoppingContext']>);
  export type MultiItemPickUpDropOffMessage = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPickUpDropOffMessage']>);
  export type Message = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPickUpDropOffMessage']>)['message']>);
  export type CarPhraseTextInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPickUpDropOffMessage']>)['message']>), { __typename: 'CarPhraseText' }>);
  export type MultiItemPlayBackTitleBar = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPlayBackTitleBar']>);
  export type Primary = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPlayBackTitleBar']>)['primary']>);
  export type _CarPhraseTextInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPlayBackTitleBar']>)['primary']>), { __typename: 'CarPhraseText' }>);
  export type Secondary = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPlayBackTitleBar']>)['secondary']>);
  export type LongMessage = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPlayBackTitleBar']>)['secondary']>)['longMessage']>);
  export type __CarPhraseTextInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPlayBackTitleBar']>)['secondary']>)['longMessage']>), { __typename: 'CarPhraseText' }>);
  export type ShortMessage = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPlayBackTitleBar']>)['secondary']>)['shortMessage']>);
  export type ___CarPhraseTextInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPlayBackTitleBar']>)['secondary']>)['shortMessage']>), { __typename: 'CarPhraseText' }>);
  export type AccessibilityMessage = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPlayBackTitleBar']>)['secondary']>)['accessibilityMessage']>);
  export type ____CarPhraseTextInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['multiItemPlayBackTitleBar']>)['secondary']>)['accessibilityMessage']>), { __typename: 'CarPhraseText' }>);
  export type Listings = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>;
  export type CarMessagingCardInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarMessagingCard' }>);
  export type CarOfferCardInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>);
  export type OfferBadges = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['offerBadges']>)[number]>;
  export type Vehicle = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['vehicle']>);
  export type Image = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['vehicle']>)['image']>);
  export type CategoryIcon = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['vehicle']>)['categoryIcon']>);
  export type Attributes = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['vehicle']>)['attributes']>)[number]>;
  export type Icon = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['vehicle']>)['attributes']>)[number]>['icon']>);
  export type Features = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['vehicle']>)['features']>)[number]>;
  export type FuelInfo = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['vehicle']>)['fuelInfo']>)[number]>;
  export type TripLocations = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['tripLocations']>);
  export type PickUpLocation = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['tripLocations']>)['pickUpLocation']>);
  export type DropOffLocation = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['tripLocations']>)['dropOffLocation']>);
  export type Vendor = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['vendor']>);
  export type _Image = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['vendor']>)['image']>);
  export type DetailsContext = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['detailsContext']>);
  export type PriceBadges = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['priceBadges']>)[number]>;
  export type ActionableConfidenceMessages = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['actionableConfidenceMessages']>)[number]>;
  export type Review = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['review']>);
  export type RichRatingText = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['review']>)['richRatingText']>);
  export type PriceSummary = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['priceSummary']>);
  export type ShortList = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['shortList']>);
  export type Action = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['action']>);
  export type InfositeUrl = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['infositeURL']>);
  export type AdditionalBenefits = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['additionalBenefits']>)[number]>;
  export type CancellationAndPaymentMessages = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['cancellationAndPaymentMessages']>)[number]>;
  export type ClubbedPriceOptions = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>);
  export type DialogTrigger = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogTrigger']>);
  export type DialogContent = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>);
  export type _Vendor = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['vendor']>);
  export type __Image = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['vendor']>)['image']>);
  export type OptionsSummary = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['optionsSummary']>)[number]>;
  export type ClubbedPrices = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>;
  export type Heading = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['heading']>);
  export type Title = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['title']>);
  export type _OfferBadges = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['offerBadges']>)[number]>;
  export type _PriceBadges = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['priceBadges']>)[number]>;
  export type _PriceSummary = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['priceSummary']>);
  export type PaymentMessages = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['paymentMessages']>)[number]>;
  export type AdditionalPaymentMessages = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['additionalPaymentMessages']>)[number]>;
  export type CancellationMessages = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['cancellationMessages']>)[number]>;
  export type _AdditionalBenefits = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['additionalBenefits']>)[number]>;
  export type ReserveButtonAction = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['reserveButtonAction']>);
  export type _InfositeUrl = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['clubbedPrices']>)[number]>['infositeURL']>);
  export type CommonAdditionalBenefits = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['clubbedPriceOptions']>)['dialogContent']>)['commonAdditionalBenefits']>)[number]>;
  export type EnhancedCleanlinessDialog = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['enhancedCleanlinessDialog']>);
  export type Images = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['enhancedCleanlinessDialog']>)['images']>)[number]>;
  export type Content = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['enhancedCleanlinessDialog']>)['content']>)[number]>;
  export type _Title = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['enhancedCleanlinessDialog']>)['content']>)[number]>['title']>);
  export type _Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['enhancedCleanlinessDialog']>)['content']>)[number]>['title']>)['icon']>);
  export type GuaranteedAnalytics = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['guaranteedAnalytics']>);
  export type PersonalisedDeal = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['listings']>)[number]>, { __typename: 'CarOfferCard' }>)['personalisedDeal']>);
  export type CarRentalLocations = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['carRentalLocations']>);
  export type _PickUpLocation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['carRentalLocations']>)['pickUpLocation']>);
  export type _DropOffLocation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['carRentalLocations']>)['dropOffLocation']>);
  export type ChangeRentalLocation = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['changeRentalLocation']>);
  export type Link = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['changeRentalLocation']>)['link']>);
  export type CarActionableItemInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['changeRentalLocation']>)['link']>), { __typename: 'CarActionableItem' }>);
  export type PlaceHolder = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['changeRentalLocation']>)['placeHolder']>);
  export type _____CarPhraseTextInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['changeRentalLocation']>)['placeHolder']>), { __typename: 'CarPhraseText' }>);
  export type _Primary = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['changeRentalLocation']>)['primary']>);
  export type ______CarPhraseTextInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['changeRentalLocation']>)['primary']>), { __typename: 'CarPhraseText' }>);
  export type _Secondary = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['changeRentalLocation']>)['secondary']>);
  export type _______CarPhraseTextInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['changeRentalLocation']>)['secondary']>), { __typename: 'CarPhraseText' }>);
  export type Summary = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['summary']>);
  export type DynamicTitle = NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['summary']>)['dynamicTitle']>)[number]>[number]>;
  export type IncludedFeeFooter = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['summary']>)['includedFeeFooter']>);
  export type CarRecommendations = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['summary']>)['carRecommendations']>)[number]>;
  export type FilterNoMatchMessage = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['filterNoMatchMessage']>);
  export type MessagingCard = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['filterNoMatchMessage']>)['messagingCard']>);
  export type LoadMoreAction = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['loadMoreAction']>);
  export type _Action = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['loadMoreAction']>)['action']>);
  export type __Icon = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['loadMoreAction']>)['icon']>);
  export type SearchPagination = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['loadMoreAction']>)['searchPagination']>);
  export type LoyaltyInfo = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['loyaltyInfo']>)[number]>;
  export type ________CarPhraseTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['loyaltyInfo']>)[number]>, { __typename: 'CarPhraseText' }>);
  export type _CarActionableItemInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['loyaltyInfo']>)[number]>, { __typename: 'CarActionableItem' }>);
  export type CarPhraseMarkInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['loyaltyInfo']>)[number]>, { __typename: 'CarPhraseMark' }>);
  export type Url = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['loyaltyInfo']>)[number]>, { __typename: 'CarPhraseMark' }>)['url']>);
  export type OneKeyInfo = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['oneKeyInfo']>);
  export type SortAndFilter = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['sortAndFilter']>);
  export type Close = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['sortAndFilter']>)['close']>);
  export type Sections = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['sortAndFilter']>)['sections']>)[number]>;
  export type Fields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['sortAndFilter']>)['sections']>)[number]>['fields']>)[number]>;
  export type CarAppliedSortAndFilters = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['carAppliedSortAndFilters']>);
  export type AppliedSortAndFilters = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['carAppliedSortAndFilters']>)['appliedSortAndFilters']>)[number]>;
  export type CrossIcon = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['carAppliedSortAndFilters']>)['appliedSortAndFilters']>)[number]>['crossIcon']>);
  export type Analytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['carAppliedSortAndFilters']>)['appliedSortAndFilters']>)[number]>['analytics']>);
  export type ShareFeedbackAction = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['shareFeedbackAction']>);
  export type Button = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['shareFeedbackAction']>)['button']>);
  export type AdsTargetingData = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['adsTargetingData']>);
  export type RecommendedSortDisclaimer = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['recommendedSortDisclaimer']>);
  export type RecommendedSortExplanation = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['recommendedSortExplanation']>);
  export type _Content = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['recommendedSortExplanation']>)['content']>)[number]>;
  export type Feedback = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['recommendedSortExplanation']>)['feedback']>);
  export type CloseAnalytics = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['recommendedSortExplanation']>)['closeAnalytics']>);
  export type MakeModelDisclaimer = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['makeModelDisclaimer']>);
  export type Map = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>);
  export type CloseIcon = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['closeIcon']>);
  export type CloseAction = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['closeAction']>);
  export type Center = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['center']>);
  export type Bounds = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['bounds']>);
  export type Northeast = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['bounds']>)['northeast']>);
  export type Southwest = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['bounds']>)['southwest']>);
  export type Markers = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>;
  export type __Action = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>['action']>);
  export type Coordinates = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>['coordinates']>);
  export type CarItemCardMapMarkerInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>);
  export type ItemCard = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>);
  export type CarMapSearchLocationCardInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapSearchLocationCard' }>);
  export type CarMapPickupLocationCardInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapPickupLocationCard' }>);
  export type VendorImage = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapPickupLocationCard' }>)['vendorImage']>);
  export type __PriceSummary = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapPickupLocationCard' }>)['priceSummary']>);
  export type Lead = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapPickupLocationCard' }>)['priceSummary']>)['lead']>);
  export type Total = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapPickupLocationCard' }>)['priceSummary']>)['total']>);
  export type LoyaltyPointsOption = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapPickupLocationCard' }>)['priceSummary']>)['loyaltyPointsOption']>);
  export type ___Action = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['markers']>)[number]>, { __typename: 'CarItemCardMapMarker' }>)['itemCard']>), { __typename: 'CarMapPickupLocationCard' }>)['action']>);
  export type MapButton = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['mapButton']>);
  export type _Url = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['mapButton']>)['url']>);
  export type ____Action = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['mapButton']>)['action']>);
  export type MapSearchThisAreaButton = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['mapSearchThisAreaButton']>);
  export type _____Action = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carSearchResults']>)['map']>)['mapSearchThisAreaButton']>)['action']>);
  export type CarsErrorContent = (NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carsErrorContent']>);
  export type ___Icon = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carsErrorContent']>)['icon']>);
  export type _Analytics = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carsErrorContent']>)['analytics']>);
  export type LocationAnalytics = (NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carsErrorContent']>)['locationAnalytics']>);
  export type CarRecommendationContent = NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carRecommendationContent']>)[number]>;
  export type CarRecommendationsInlineFragment = ({ __typename: 'CarRecommendations' } & Pick<NonNullable<(NonNullable<(NonNullable<CarSearchV3Query['carSearchOrRecommendations']>)['carRecommendationContent']>)[number]>, keyof CarRecommendationsFragment>);
}

export namespace MessagingCard {
  export type Fragment = MessagingCardFragment;
  export type CardTitle = (NonNullable<MessagingCardFragment['cardTitle']>);
  export type CardDescriptions = NonNullable<(NonNullable<MessagingCardFragment['cardDescriptions']>)[number]>;
  export type Image = (NonNullable<MessagingCardFragment['image']>);
  export type IllustrationUrl = (NonNullable<MessagingCardFragment['illustrationURL']>);
  export type Icon = (NonNullable<MessagingCardFragment['icon']>);
  export type Links = NonNullable<(NonNullable<MessagingCardFragment['links']>)[number]>;
  export type Url = (NonNullable<NonNullable<(NonNullable<MessagingCardFragment['links']>)[number]>['url']>);
  export type _Icon = (NonNullable<NonNullable<(NonNullable<MessagingCardFragment['links']>)[number]>['icon']>);
  export type Action = (NonNullable<NonNullable<(NonNullable<MessagingCardFragment['links']>)[number]>['action']>);
  export type Analytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<MessagingCardFragment['links']>)[number]>['action']>)['analytics']>);
  export type Dialog = (NonNullable<MessagingCardFragment['dialog']>);
  export type Content = (NonNullable<(NonNullable<MessagingCardFragment['dialog']>)['content']>);
  export type Header = (NonNullable<(NonNullable<(NonNullable<MessagingCardFragment['dialog']>)['content']>)['header']>);
  export type Body = NonNullable<(NonNullable<(NonNullable<(NonNullable<MessagingCardFragment['dialog']>)['content']>)['body']>)[number]>;
  export type Title = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MessagingCardFragment['dialog']>)['content']>)['body']>)[number]>['title']>);
  export type _Body = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MessagingCardFragment['dialog']>)['content']>)['body']>)[number]>['body']>)[number]>;
  export type Footer = NonNullable<(NonNullable<(NonNullable<(NonNullable<MessagingCardFragment['dialog']>)['content']>)['footer']>)[number]>;
  export type CarRecommendations = NonNullable<(NonNullable<MessagingCardFragment['carRecommendations']>)[number]>;
  export type _Analytics = (NonNullable<MessagingCardFragment['analytics']>);
}

export namespace Badge {
  export type Fragment = BadgeFragment;
  export type Icon = (NonNullable<BadgeFragment['icon']>);
  export type Mark = (NonNullable<BadgeFragment['mark']>);
  export type Url = (NonNullable<(NonNullable<BadgeFragment['mark']>)['url']>);
}

export namespace Feature {
  export type Fragment = FeatureFragment;
  export type Icon = (NonNullable<FeatureFragment['icon']>);
  export type Info = (NonNullable<FeatureFragment['info']>);
  export type VehicleFeatureDialog = (NonNullable<(NonNullable<FeatureFragment['info']>)['vehicleFeatureDialog']>);
  export type CarActionableItem = (NonNullable<(NonNullable<FeatureFragment['info']>)['carActionableItem']>);
}

export namespace PriceInfo {
  export type Fragment = PriceInfoFragment;
  export type Price = (NonNullable<PriceInfoFragment['price']>);
}

export namespace CarActionableItem {
  export type Fragment = CarActionableItemFragment;
  export type Url = (NonNullable<CarActionableItemFragment['url']>);
  export type Action = (NonNullable<CarActionableItemFragment['action']>);
  export type Icon = (NonNullable<CarActionableItemFragment['icon']>);
}

export namespace DialogContentCarPhrase {
  export type Fragment = DialogContentCarPhraseFragment;
  export type CarPhraseTextInlineFragment = (DiscriminateUnion<DialogContentCarPhraseFragment, { __typename: 'CarPhraseText' }>);
  export type CarPhraseIconTextInlineFragment = (DiscriminateUnion<DialogContentCarPhraseFragment, { __typename: 'CarPhraseIconText' }>);
  export type Icon = (NonNullable<(DiscriminateUnion<DialogContentCarPhraseFragment, { __typename: 'CarPhraseIconText' }>)['icon']>);
  export type CarsRichTextInlineFragment = (DiscriminateUnion<DialogContentCarPhraseFragment, { __typename: 'CarsRichText' }>);
  export type CarActionableItemInlineFragment = (DiscriminateUnion<DialogContentCarPhraseFragment, { __typename: 'CarActionableItem' }>);
}

export namespace CarDialogConfidenceMessage {
  export type Fragment = CarDialogConfidenceMessageFragment;
  export type Icon = (NonNullable<CarDialogConfidenceMessageFragment['icon']>);
  export type OpenDialogAction = (NonNullable<CarDialogConfidenceMessageFragment['openDialogAction']>);
  export type DialogContent = (NonNullable<CarDialogConfidenceMessageFragment['dialogContent']>);
  export type Content = (NonNullable<(NonNullable<CarDialogConfidenceMessageFragment['dialogContent']>)['content']>);
  export type Header = (NonNullable<(NonNullable<(NonNullable<CarDialogConfidenceMessageFragment['dialogContent']>)['content']>)['header']>);
  export type Body = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDialogConfidenceMessageFragment['dialogContent']>)['content']>)['body']>)[number]>;
  export type Title = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDialogConfidenceMessageFragment['dialogContent']>)['content']>)['body']>)[number]>['title']>);
  export type _Body = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDialogConfidenceMessageFragment['dialogContent']>)['content']>)['body']>)[number]>['body']>)[number]>;
  export type Footer = NonNullable<(NonNullable<(NonNullable<(NonNullable<CarDialogConfidenceMessageFragment['dialogContent']>)['content']>)['footer']>)[number]>;
}

export namespace CarAction {
  export type Fragment = CarActionFragment;
  export type Analytics = (NonNullable<CarActionFragment['analytics']>);
}

export namespace Icon {
  export type Fragment = IconFragment;
}

export namespace Image {
  export type Fragment = ImageFragment;
}

export namespace Money {
  export type Fragment = MoneyFragment;
  export type CurrencyInfo = (NonNullable<MoneyFragment['currencyInfo']>);
}

export namespace Analytics {
  export type Fragment = AnalyticsFragment;
}

export namespace ClientSideAnalytics {
  export type Fragment = ClientSideAnalyticsFragment;
}

export namespace Expando {
  export type Fragment = ExpandoFragment;
  export type Analytics = (NonNullable<ExpandoFragment['analytics']>);
}

export namespace MultiSelectionFragment {
  export type Fragment = MultiSelectionFragmentFragment;
  export type PrimaryIcon = (NonNullable<MultiSelectionFragmentFragment['primaryIcon']>);
  export type Options = NonNullable<(NonNullable<MultiSelectionFragmentFragment['options']>)[number]>;
  export type Expando = (NonNullable<MultiSelectionFragmentFragment['expando']>);
}

export namespace SingleSelectionFragment {
  export type Fragment = SingleSelectionFragmentFragment;
  export type Options = NonNullable<(NonNullable<SingleSelectionFragmentFragment['options']>)[number]>;
  export type Expando = (NonNullable<SingleSelectionFragmentFragment['expando']>);
}

export namespace FilterOption {
  export type Fragment = FilterOptionFragment;
  export type Icon = (NonNullable<FilterOptionFragment['icon']>);
  export type Analytics = (NonNullable<FilterOptionFragment['analytics']>);
}

export namespace Coordinates {
  export type Fragment = CoordinatesFragment;
}

export namespace CarOfferVendorLocationInfo {
  export type Fragment = CarOfferVendorLocationInfoFragment;
  export type Icon = (NonNullable<CarOfferVendorLocationInfoFragment['icon']>);
}

export namespace CarRecommendations {
  export type Fragment = CarRecommendationsFragment;
  export type Analytics = NonNullable<(NonNullable<CarRecommendationsFragment['analytics']>)[number]>;
  export type CarRecommendationsCards = NonNullable<(NonNullable<CarRecommendationsFragment['carRecommendationsCards']>)[number]>;
}

export namespace CarRecommendationCard {
  export type Fragment = CarRecommendationCardFragment;
  export type Icon = (NonNullable<CarRecommendationCardFragment['icon']>);
  export type Action = (NonNullable<CarRecommendationCardFragment['action']>);
  export type DateTimeRecommendationCardInlineFragment = (DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'DateTimeRecommendationCard' }>);
  export type _Icon = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'DateTimeRecommendationCard' }>)['icon']>);
  export type Text = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'DateTimeRecommendationCard' }>)['text']>);
  export type SubText = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'DateTimeRecommendationCard' }>)['subText']>);
  export type _Action = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'DateTimeRecommendationCard' }>)['action']>);
  export type LocationRecommendationCardInlineFragment = (DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>);
  export type __Icon = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['icon']>);
  export type Location = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['location']>);
  export type City = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['city']>);
  export type DistanceText = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['distanceText']>);
  export type __Action = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['action']>);
  export type PickUpLocation = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LocationRecommendationCard' }>)['pickUpLocation']>);
  export type PartnerRecommendationCardInlineFragment = (DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>);
  export type ___Icon = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['icon']>);
  export type ___Action = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['action']>);
  export type Analytics = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['analytics']>);
  export type Image = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['image']>);
  export type Title = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['title']>);
  export type _SubText = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['subText']>);
  export type Button = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['button']>);
  export type Dialog = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>);
  export type PartnerRecommendationDialogInlineFragment = ({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>);
  export type _Title = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['title']>);
  export type SubTitle = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['subTitle']>);
  export type _Text = NonNullable<NonNullable<(NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['text']>)[number]>[number]>;
  export type _Button = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['button']>);
  export type CloseDialog = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['closeDialog']>);
  export type Content = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['content']>);
  export type PartnerRecommendationDialogContentInlineFragment = ({ __typename: 'PartnerRecommendationDialogContent' } & Pick<(NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['content']>), 'title' | 'body' | 'confidenceMessage'>);
  export type __Title = (NonNullable<({ __typename: 'PartnerRecommendationDialogContent' } & Pick<(NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['content']>), 'title' | 'body' | 'confidenceMessage'>)['title']>);
  export type Body = NonNullable<NonNullable<(NonNullable<({ __typename: 'PartnerRecommendationDialogContent' } & Pick<(NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['content']>), 'title' | 'body' | 'confidenceMessage'>)['body']>)[number]>[number]>;
  export type ConfidenceMessage = NonNullable<(NonNullable<({ __typename: 'PartnerRecommendationDialogContent' } & Pick<(NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['content']>), 'title' | 'body' | 'confidenceMessage'>)['confidenceMessage']>)[number]>;
  export type _Image = (NonNullable<({ __typename: 'PartnerRecommendationDialog' } & Pick<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'PartnerRecommendationCard' }>)['dialog']>), 'title' | 'subTitle' | 'text' | 'button' | 'closeDialog' | 'content' | 'image'>)['image']>);
  export type AlternateRecommendationCardInlineFragment = (DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'AlternateRecommendationCard' }>);
  export type ____Icon = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'AlternateRecommendationCard' }>)['icon']>);
  export type ____Action = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'AlternateRecommendationCard' }>)['action']>);
  export type _Analytics = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'AlternateRecommendationCard' }>)['analytics']>);
  export type __Image = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'AlternateRecommendationCard' }>)['image']>);
  export type ___Title = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'AlternateRecommendationCard' }>)['title']>);
  export type __SubText = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'AlternateRecommendationCard' }>)['subText']>);
  export type __Button = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'AlternateRecommendationCard' }>)['button']>);
  export type LimitedResultMessageOnRecommendationCardInlineFragment = (DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>);
  export type _____Icon = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['icon']>);
  export type _____Action = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['action']>);
  export type RecommendationDialog = (NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>);
  export type _Content = (NonNullable<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>);
  export type Header = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>)['header']>);
  export type _Body = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>)['body']>)[number]>;
  export type ____Title = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>)['body']>)[number]>['title']>);
  export type __Body = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>)['body']>)[number]>['body']>)[number]>;
  export type Footer = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<CarRecommendationCardFragment, { __typename: 'LimitedResultMessageOnRecommendationCard' }>)['recommendationDialog']>)['content']>)['footer']>)[number]>;
}

export namespace CarPhrase {
  export type Fragment = CarPhraseFragment;
  export type CarPhraseTextInlineFragment = (DiscriminateUnion<CarPhraseFragment, { __typename: 'CarPhraseText' }>);
  export type CarPhrasePairTextInlineFragment = (DiscriminateUnion<CarPhraseFragment, { __typename: 'CarPhrasePairText' }>);
  export type RichText = (NonNullable<(DiscriminateUnion<CarPhraseFragment, { __typename: 'CarPhrasePairText' }>)['richText']>);
  export type RichSubText = (NonNullable<(DiscriminateUnion<CarPhraseFragment, { __typename: 'CarPhrasePairText' }>)['richSubText']>);
  export type CarPhraseIconTextInlineFragment = (DiscriminateUnion<CarPhraseFragment, { __typename: 'CarPhraseIconText' }>);
  export type Icon = (NonNullable<(DiscriminateUnion<CarPhraseFragment, { __typename: 'CarPhraseIconText' }>)['icon']>);
  export type CarActionableItemInlineFragment = (DiscriminateUnion<CarPhraseFragment, { __typename: 'CarActionableItem' }>);
  export type CarDialogConfidenceMessageInlineFragment = (DiscriminateUnion<CarPhraseFragment, { __typename: 'CarDialogConfidenceMessage' }>);
  export type CarsRichTextInlineFragment = (DiscriminateUnion<CarPhraseFragment, { __typename: 'CarsRichText' }>);
  export type CarPhraseMarkInlineFragment = (DiscriminateUnion<CarPhraseFragment, { __typename: 'CarPhraseMark' }>);
  export type Url = (NonNullable<(DiscriminateUnion<CarPhraseFragment, { __typename: 'CarPhraseMark' }>)['url']>);
  export type CarOfferBadgeInlineFragment = (DiscriminateUnion<CarPhraseFragment, { __typename: 'CarOfferBadge' }>);
  export type _Icon = (NonNullable<(DiscriminateUnion<CarPhraseFragment, { __typename: 'CarOfferBadge' }>)['icon']>);
  export type Mark = (NonNullable<(DiscriminateUnion<CarPhraseFragment, { __typename: 'CarOfferBadge' }>)['mark']>);
  export type _Url = (NonNullable<(NonNullable<(DiscriminateUnion<CarPhraseFragment, { __typename: 'CarOfferBadge' }>)['mark']>)['url']>);
}

export namespace CarSearchLocation {
  export type Fragment = CarSearchLocationFragment;
}

export namespace OfferPriceSummary {
  export type Fragment = OfferPriceSummaryFragment;
  export type DiscountBadge = (NonNullable<OfferPriceSummaryFragment['discountBadge']>);
  export type Lead = (NonNullable<OfferPriceSummaryFragment['lead']>);
  export type Total = (NonNullable<OfferPriceSummaryFragment['total']>);
  export type LoyaltyPointsOption = (NonNullable<OfferPriceSummaryFragment['loyaltyPointsOption']>);
  export type Reference = (NonNullable<OfferPriceSummaryFragment['reference']>);
  export type Price = (NonNullable<(NonNullable<OfferPriceSummaryFragment['reference']>)['price']>);
  export type PaymentInfo = (NonNullable<OfferPriceSummaryFragment['paymentInfo']>);
  export type Icon = (NonNullable<(NonNullable<OfferPriceSummaryFragment['paymentInfo']>)['icon']>);
}

export namespace SearchUserFeedback {
  export type Fragment = SearchUserFeedbackFragment;
  export type Options = NonNullable<(NonNullable<SearchUserFeedbackFragment['options']>)[number]>;
  export type Option = (NonNullable<NonNullable<(NonNullable<SearchUserFeedbackFragment['options']>)[number]>['option']>);
  export type Submit = (NonNullable<SearchUserFeedbackFragment['submit']>);
}
